let itemsList = [
    {
        itemName: "Healing Potion",
        itemId: "T4_POTION_HEAL",
        canEnchant: true
    },
{
        itemName: "Major Healing Potion",
        itemId: "T6_POTION_HEAL",
        canEnchant: true
    },
{
        itemName: "Major Gigantify Potion",
        itemId: "T7_POTION_REVIVE",
        canEnchant: true
    },
{
        itemName: "Major Energy Potion",
        itemId: "T6_POTION_ENERGY",
        canEnchant: true
    },
{
        itemName: "Energy Potion",
        itemId: "T4_POTION_ENERGY",
        canEnchant: true
    },
{
        itemName: "Gigantify Potion",
        itemId: "T5_POTION_REVIVE",
        canEnchant: true
    },
{
        itemName: "Resistance Potion",
        itemId: "T5_POTION_STONESKIN",
        canEnchant: true
    },
{
        itemName: "Major Resistance Potion",
        itemId: "T7_POTION_STONESKIN",
        canEnchant: true
    },
{
        itemName: "Minor Poison Potion",
        itemId: "T4_POTION_COOLDOWN",
        canEnchant: true
    },
{
        itemName: "Major Sticky Potion",
        itemId: "T7_POTION_SLOWFIELD",
        canEnchant: true
    },
{
        itemName: "Sticky Potion",
        itemId: "T5_POTION_SLOWFIELD",
        canEnchant: true
    },
{
        itemName: "Major Poison Potion",
        itemId: "T8_POTION_COOLDOWN",
        canEnchant: true
    },
{
        itemName: "Poison Potion",
        itemId: "T6_POTION_COOLDOWN",
        canEnchant: true
    },
{
        itemName: "Invisibility Potion",
        itemId: "T8_POTION_CLEANSE",
        canEnchant: true
    },
{
        itemName: "Carrot Soup",
        itemId: "T1_MEAL_SOUP",
        canEnchant: true
    },
{
        itemName: "Wheat Soup",
        itemId: "T3_MEAL_SOUP",
        canEnchant: true
    },
{
        itemName: "Cabbage Soup",
        itemId: "T5_MEAL_SOUP",
        canEnchant: true
    },
{
        itemName: "Greenmoor Clam Soup",
        itemId: "T1_MEAL_SOUP_FISH",
        canEnchant: true
    },
{
        itemName: "Murkwater Clam Soup",
        itemId: "T3_MEAL_SOUP_FISH",
        canEnchant: true
    },
{
        itemName: "Blackbog Clam Soup",
        itemId: "T5_MEAL_SOUP_FISH",
        canEnchant: true
    },
{
        itemName: "Bean Salad",
        itemId: "T2_MEAL_SALAD",
        canEnchant: true
    },
{
        itemName: "Potato Salad",
        itemId: "T6_MEAL_SALAD",
        canEnchant: true
    },
{
        itemName: "Shallowshore Squid Salad",
        itemId: "T2_MEAL_SALAD_FISH",
        canEnchant: true
    },
{
        itemName: "Turnip Salad",
        itemId: "T4_MEAL_SALAD",
        canEnchant: true
    },
{
        itemName: "Midwater Octopus Salad",
        itemId: "T4_MEAL_SALAD_FISH",
        canEnchant: true
    },
{
        itemName: "Deepwater Kraken Salad",
        itemId: "T6_MEAL_SALAD_FISH",
        canEnchant: true
    },
{
        itemName: "Chicken Pie",
        itemId: "T3_MEAL_PIE",
        canEnchant: true
    },
{
        itemName: "Goose Pie",
        itemId: "T5_MEAL_PIE",
        canEnchant: true
    },
{
        itemName: "Mountain Blindeye Pie",
        itemId: "T5_MEAL_PIE_FISH",
        canEnchant: true
    },
{
        itemName: "Pork Pie",
        itemId: "T7_MEAL_PIE",
        canEnchant: true
    },
{
        itemName: "Chicken Omelette",
        itemId: "T3_MEAL_OMELETTE",
        canEnchant: true
    },
{
        itemName: "Frostpeak Deadeye Pie",
        itemId: "T7_MEAL_PIE_FISH",
        canEnchant: true
    },
{
        itemName: "Lowriver Crab Omelette",
        itemId: "T3_MEAL_OMELETTE_FISH",
        canEnchant: true
    },
{
        itemName: "Goose Omelette",
        itemId: "T5_MEAL_OMELETTE",
        canEnchant: true
    },
{
        itemName: "Drybrook Crab Omelette",
        itemId: "T5_MEAL_OMELETTE_FISH",
        canEnchant: true
    },
{
        itemName: "Pork Omelette",
        itemId: "T7_MEAL_OMELETTE",
        canEnchant: true
    },
{
        itemName: "Dusthole Crab Omelette",
        itemId: "T7_MEAL_OMELETTE_FISH",
        canEnchant: true
    },
{
        itemName: "Avalonian Chicken Omelette",
        itemId: "T3_MEAL_OMELETTE_AVALON",
        canEnchant: true
    },
{
        itemName: "Goat Stew",
        itemId: "T4_MEAL_STEW",
        canEnchant: true
    },
{
        itemName: "Avalonian Goose Omelette",
        itemId: "T5_MEAL_OMELETTE_AVALON",
        canEnchant: true
    },
{
        itemName: "Avalonian Pork Omelette",
        itemId: "T7_MEAL_OMELETTE_AVALON",
        canEnchant: true
    },
{
        itemName: "Mutton Stew",
        itemId: "T6_MEAL_STEW",
        canEnchant: true
    },
{
        itemName: "Greenriver Eel Stew",
        itemId: "T4_MEAL_STEW_FISH",
        canEnchant: true
    },
{
        itemName: "Upland Coldeye Pie",
        itemId: "T3_MEAL_PIE_FISH",
        canEnchant: true
    },
{
        itemName: "Redspring Eel Stew",
        itemId: "T6_MEAL_STEW_FISH",
        canEnchant: true
    },
{
        itemName: "Avalonian Goat Stew",
        itemId: "T4_MEAL_STEW_AVALON",
        canEnchant: true
    },
{
        itemName: "Avalonian Mutton Stew",
        itemId: "T6_MEAL_STEW_AVALON",
        canEnchant: true
    },
{
        itemName: "Deadwater Eel Stew",
        itemId: "T8_MEAL_STEW_FISH",
        canEnchant: true
    },
{
        itemName: "Avalonian Beef Stew",
        itemId: "T8_MEAL_STEW_AVALON",
        canEnchant: true
    },
{
        itemName: "Beef Stew",
        itemId: "T8_MEAL_STEW",
        canEnchant: true
    },
{
        itemName: "Goat Sandwich",
        itemId: "T4_MEAL_SANDWICH",
        canEnchant: true
    },
{
        itemName: "Mutton Sandwich",
        itemId: "T6_MEAL_SANDWICH",
        canEnchant: true
    },
{
        itemName: "Rushwater Lurcher Sandwich",
        itemId: "T6_MEAL_SANDWICH_FISH",
        canEnchant: true
    },
{
        itemName: "Stonestream Lurcher Sandwich",
        itemId: "T4_MEAL_SANDWICH_FISH",
        canEnchant: true
    },
{
        itemName: "Thunderfall Lurcher Sandwich",
        itemId: "T8_MEAL_SANDWICH_FISH",
        canEnchant: true
    },
{
        itemName: "Avalonian Mutton Sandwich",
        itemId: "T6_MEAL_SANDWICH_AVALON",
        canEnchant: true
    },
{
        itemName: "Avalonian Goat Sandwich",
        itemId: "T4_MEAL_SANDWICH_AVALON",
        canEnchant: true
    },
{
        itemName: "Avalonian Beef Sandwich",
        itemId: "T8_MEAL_SANDWICH_AVALON",
        canEnchant: true
    },
{
        itemName: "Beef Sandwich",
        itemId: "T8_MEAL_SANDWICH",
        canEnchant: true
    },
{
        itemName: "Roast Chicken",
        itemId: "T3_MEAL_ROAST",
        canEnchant: true
    },
{
        itemName: "Roasted Whitefog Snapper",
        itemId: "T3_MEAL_ROAST_FISH",
        canEnchant: true
    },
{
        itemName: "Roast Goose",
        itemId: "T5_MEAL_ROAST",
        canEnchant: true
    },
{
        itemName: "Roasted Clearhaze Snapper",
        itemId: "T5_MEAL_ROAST_FISH",
        canEnchant: true
    },
{
        itemName: "Roast Pork",
        itemId: "T7_MEAL_ROAST",
        canEnchant: true
    },
{
        itemName: "Uncommon Pine Logs",
        itemId: "T4_WOOD_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Whitewood Logs",
        itemId: "T8_WOOD_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Roasted Puremist Snapper",
        itemId: "T7_MEAL_ROAST_FISH",
        canEnchant: true
    },
{
        itemName: "Uncommon Cedar Logs",
        itemId: "T5_WOOD_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Bloodoak Logs",
        itemId: "T6_WOOD_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Ashenbark Logs",
        itemId: "T7_WOOD_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Whitewood Logs",
        itemId: "T8_WOOD_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Ashenbark Logs",
        itemId: "T7_WOOD_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Pine Logs",
        itemId: "T4_WOOD_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Rare Pine Logs",
        itemId: "T4_WOOD_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Bloodoak Logs",
        itemId: "T6_WOOD_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Bloodoak Logs",
        itemId: "T6_WOOD_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Ashenbark Logs",
        itemId: "T7_WOOD_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Cedar Logs",
        itemId: "T5_WOOD_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Whitewood Logs",
        itemId: "T8_WOOD_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Rare Cedar Logs",
        itemId: "T5_WOOD_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Travertine",
        itemId: "T4_ROCK_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Marble",
        itemId: "T8_ROCK_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Granite",
        itemId: "T5_ROCK_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Travertine",
        itemId: "T4_ROCK_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Basalt",
        itemId: "T7_ROCK_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Slate",
        itemId: "T6_ROCK_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Granite",
        itemId: "T5_ROCK_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Travertine",
        itemId: "T4_ROCK_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Rare Marble",
        itemId: "T8_ROCK_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Granite",
        itemId: "T5_ROCK_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Rare Slate",
        itemId: "T6_ROCK_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Basalt",
        itemId: "T7_ROCK_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Marble",
        itemId: "T8_ROCK_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Slate",
        itemId: "T6_ROCK_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Basalt",
        itemId: "T7_ROCK_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Uncommon Titanium Ore",
        itemId: "T5_ORE_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Runite Ore",
        itemId: "T6_ORE_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Iron Ore",
        itemId: "T4_ORE_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Adamantium Ore",
        itemId: "T8_ORE_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Meteorite Ore",
        itemId: "T7_ORE_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Meteorite Ore",
        itemId: "T7_ORE_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Titanium Ore",
        itemId: "T5_ORE_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Iron Ore",
        itemId: "T4_ORE_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Rare Runite Ore",
        itemId: "T6_ORE_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Adamantium Ore",
        itemId: "T8_ORE_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Runite Ore",
        itemId: "T6_ORE_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Titanium Ore",
        itemId: "T5_ORE_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Adamantium Ore",
        itemId: "T8_ORE_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Uncommon Thick Hide",
        itemId: "T7_HIDE_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Iron Ore",
        itemId: "T4_ORE_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Meteorite Ore",
        itemId: "T7_ORE_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Uncommon Medium Hide",
        itemId: "T4_HIDE_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Medium Hide",
        itemId: "T4_HIDE_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Robust Hide",
        itemId: "T6_HIDE_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Resilient Hide",
        itemId: "T8_HIDE_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Heavy Hide",
        itemId: "T5_HIDE_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Heavy Hide",
        itemId: "T5_HIDE_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Robust Hide",
        itemId: "T6_HIDE_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Resilient Hide",
        itemId: "T8_HIDE_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Thick Hide",
        itemId: "T7_HIDE_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Medium Hide",
        itemId: "T4_HIDE_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Resilient Hide",
        itemId: "T8_HIDE_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Heavy Hide",
        itemId: "T5_HIDE_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Thick Hide",
        itemId: "T7_HIDE_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Robust Hide",
        itemId: "T6_HIDE_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Uncommon Amberleaf Cotton",
        itemId: "T6_FIBER_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Sunflax",
        itemId: "T7_FIBER_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Skyflower",
        itemId: "T5_FIBER_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Ghost Hemp",
        itemId: "T8_FIBER_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Hemp",
        itemId: "T4_FIBER_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Skyflower",
        itemId: "T5_FIBER_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Hemp",
        itemId: "T4_FIBER_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Sunflax",
        itemId: "T7_FIBER_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Amberleaf Cotton",
        itemId: "T6_FIBER_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Skyflower",
        itemId: "T5_FIBER_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Ghost Hemp",
        itemId: "T8_FIBER_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Amberleaf Cotton",
        itemId: "T6_FIBER_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Sunflax",
        itemId: "T7_FIBER_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Hemp",
        itemId: "T4_FIBER_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Uncommon Cedar Planks",
        itemId: "T5_PLANKS_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Bloodoak Planks",
        itemId: "T6_PLANKS_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Ashenbark Planks",
        itemId: "T7_PLANKS_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Pine Planks",
        itemId: "T4_PLANKS_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Whitewood Planks",
        itemId: "T8_PLANKS_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Ghost Hemp",
        itemId: "T8_FIBER_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Pine Planks",
        itemId: "T4_PLANKS_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Bloodoak Planks",
        itemId: "T6_PLANKS_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Ashenbark Planks",
        itemId: "T7_PLANKS_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Bloodoak Planks",
        itemId: "T6_PLANKS_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Pine Planks",
        itemId: "T4_PLANKS_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Cedar Planks",
        itemId: "T5_PLANKS_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Ashenbark Planks",
        itemId: "T7_PLANKS_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Whitewood Planks",
        itemId: "T8_PLANKS_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Rare Cedar Planks",
        itemId: "T5_PLANKS_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Steel Bar",
        itemId: "T4_METALBAR_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Whitewood Planks",
        itemId: "T8_PLANKS_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Titanium Steel Bar",
        itemId: "T5_METALBAR_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Runite Steel Bar",
        itemId: "T6_METALBAR_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Meteorite Steel Bar",
        itemId: "T7_METALBAR_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Adamantium Steel Bar",
        itemId: "T8_METALBAR_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Titanium Steel Bar",
        itemId: "T5_METALBAR_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Meteorite Steel Bar",
        itemId: "T7_METALBAR_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Steel Bar",
        itemId: "T4_METALBAR_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Rare Steel Bar",
        itemId: "T4_METALBAR_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Runite Steel Bar",
        itemId: "T6_METALBAR_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Titanium Steel Bar",
        itemId: "T5_METALBAR_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Adamantium Steel Bar",
        itemId: "T8_METALBAR_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Uncommon Worked Leather",
        itemId: "T4_LEATHER_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Adamantium Steel Bar",
        itemId: "T8_METALBAR_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Meteorite Steel Bar",
        itemId: "T7_METALBAR_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Uncommon Hardened Leather",
        itemId: "T6_LEATHER_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Exceptional Runite Steel Bar",
        itemId: "T6_METALBAR_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Uncommon Reinforced Leather",
        itemId: "T7_LEATHER_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Fortified Leather",
        itemId: "T8_LEATHER_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Cured Leather",
        itemId: "T5_LEATHER_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Cured Leather",
        itemId: "T5_LEATHER_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Worked Leather",
        itemId: "T4_LEATHER_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Hardened Leather",
        itemId: "T6_LEATHER_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Reinforced Leather",
        itemId: "T7_LEATHER_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Worked Leather",
        itemId: "T4_LEATHER_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Hardened Leather",
        itemId: "T6_LEATHER_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Reinforced Leather",
        itemId: "T7_LEATHER_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Cured Leather",
        itemId: "T5_LEATHER_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Fortified Leather",
        itemId: "T8_LEATHER_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Rare Fortified Leather",
        itemId: "T8_LEATHER_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Fine Cloth",
        itemId: "T4_CLOTH_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Ornate Cloth",
        itemId: "T5_CLOTH_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Opulent Cloth",
        itemId: "T7_CLOTH_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Fine Cloth",
        itemId: "T4_CLOTH_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Uncommon Lavish Cloth",
        itemId: "T6_CLOTH_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Uncommon Baroque Cloth",
        itemId: "T8_CLOTH_LEVEL1",
        canEnchant: true
    },
{
        itemName: "Rare Opulent Cloth",
        itemId: "T7_CLOTH_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Fine Cloth",
        itemId: "T4_CLOTH_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Rare Baroque Cloth",
        itemId: "T8_CLOTH_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Rare Ornate Cloth",
        itemId: "T5_CLOTH_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Exceptional Opulent Cloth",
        itemId: "T7_CLOTH_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Ornate Cloth",
        itemId: "T5_CLOTH_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Exceptional Baroque Cloth",
        itemId: "T8_CLOTH_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Adept's Shield",
        itemId: "T4_OFF_SHIELD",
        canEnchant: true
    },
{
        itemName: "Exceptional Lavish Cloth",
        itemId: "T6_CLOTH_LEVEL3",
        canEnchant: true
    },
{
        itemName: "Rare Lavish Cloth",
        itemId: "T6_CLOTH_LEVEL2",
        canEnchant: true
    },
{
        itemName: "Expert's Shield",
        itemId: "T5_OFF_SHIELD",
        canEnchant: true
    },
{
        itemName: "Master's Shield",
        itemId: "T6_OFF_SHIELD",
        canEnchant: true
    },
{
        itemName: "Elder's Shield",
        itemId: "T8_OFF_SHIELD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Shield",
        itemId: "T7_OFF_SHIELD",
        canEnchant: true
    },
{
        itemName: "Adept's Sarcophagus",
        itemId: "T4_OFF_TOWERSHIELD_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Sarcophagus",
        itemId: "T6_OFF_TOWERSHIELD_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Sarcophagus",
        itemId: "T7_OFF_TOWERSHIELD_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Caitiff Shield",
        itemId: "T4_OFF_SHIELD_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Sarcophagus",
        itemId: "T5_OFF_TOWERSHIELD_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Caitiff Shield",
        itemId: "T7_OFF_SHIELD_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Sarcophagus",
        itemId: "T8_OFF_TOWERSHIELD_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Caitiff Shield",
        itemId: "T6_OFF_SHIELD_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Facebreaker",
        itemId: "T4_OFF_SPIKEDSHIELD_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Facebreaker",
        itemId: "T5_OFF_SPIKEDSHIELD_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Caitiff Shield",
        itemId: "T8_OFF_SHIELD_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Caitiff Shield",
        itemId: "T5_OFF_SHIELD_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Facebreaker",
        itemId: "T6_OFF_SPIKEDSHIELD_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Facebreaker",
        itemId: "T7_OFF_SPIKEDSHIELD_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Facebreaker",
        itemId: "T8_OFF_SPIKEDSHIELD_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Astral Aegis",
        itemId: "T4_OFF_SHIELD_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Astral Aegis",
        itemId: "T6_OFF_SHIELD_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Astral Aegis",
        itemId: "T7_OFF_SHIELD_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Astral Aegis",
        itemId: "T5_OFF_SHIELD_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Astral Aegis",
        itemId: "T8_OFF_SHIELD_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Tome of Spells",
        itemId: "T7_OFF_BOOK",
        canEnchant: true
    },
{
        itemName: "Expert's Tome of Spells",
        itemId: "T5_OFF_BOOK",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Eye of Secrets",
        itemId: "T7_OFF_ORB_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Tome of Spells",
        itemId: "T4_OFF_BOOK",
        canEnchant: true
    },
{
        itemName: "Master's Tome of Spells",
        itemId: "T6_OFF_BOOK",
        canEnchant: true
    },
{
        itemName: "Rosalia's Diary",
        itemId: "T8_OFF_BOOK",
        canEnchant: true
    },
{
        itemName: "Expert's Eye of Secrets",
        itemId: "T5_OFF_ORB_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Eye of Secrets",
        itemId: "T6_OFF_ORB_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Eye of Secrets",
        itemId: "T8_OFF_ORB_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Eye of Secrets",
        itemId: "T4_OFF_ORB_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Muisak",
        itemId: "T5_OFF_DEMONSKULL_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Muisak",
        itemId: "T7_OFF_DEMONSKULL_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Muisak",
        itemId: "T4_OFF_DEMONSKULL_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Muisak",
        itemId: "T6_OFF_DEMONSKULL_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Taproot",
        itemId: "T4_OFF_TOTEM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Muisak",
        itemId: "T8_OFF_DEMONSKULL_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Taproot",
        itemId: "T5_OFF_TOTEM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Taproot",
        itemId: "T7_OFF_TOTEM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Celestial Censer",
        itemId: "T4_OFF_CENSER_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Celestial Censer",
        itemId: "T5_OFF_CENSER_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Taproot",
        itemId: "T8_OFF_TOTEM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Taproot",
        itemId: "T6_OFF_TOTEM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Celestial Censer",
        itemId: "T6_OFF_CENSER_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Celestial Censer",
        itemId: "T7_OFF_CENSER_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Torch",
        itemId: "T4_OFF_TORCH",
        canEnchant: true
    },
{
        itemName: "Elder's Celestial Censer",
        itemId: "T8_OFF_CENSER_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Torch",
        itemId: "T5_OFF_TORCH",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Torch",
        itemId: "T7_OFF_TORCH",
        canEnchant: true
    },
{
        itemName: "Master's Torch",
        itemId: "T6_OFF_TORCH",
        canEnchant: true
    },
{
        itemName: "Adept's Mistcaller",
        itemId: "T4_OFF_HORN_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Mistcaller",
        itemId: "T7_OFF_HORN_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Torch",
        itemId: "T8_OFF_TORCH",
        canEnchant: true
    },
{
        itemName: "Master's Mistcaller",
        itemId: "T6_OFF_HORN_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Sacred Scepter",
        itemId: "T4_OFF_TALISMAN_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Sacred Scepter",
        itemId: "T5_OFF_TALISMAN_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Mistcaller",
        itemId: "T5_OFF_HORN_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Sacred Scepter",
        itemId: "T6_OFF_TALISMAN_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Sacred Scepter",
        itemId: "T7_OFF_TALISMAN_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Cryptcandle",
        itemId: "T4_OFF_LAMP_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Cryptcandle",
        itemId: "T6_OFF_LAMP_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Sacred Scepter",
        itemId: "T8_OFF_TALISMAN_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Mistcaller",
        itemId: "T8_OFF_HORN_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Cryptcandle",
        itemId: "T5_OFF_LAMP_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Cryptcandle",
        itemId: "T8_OFF_LAMP_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Cryptcandle",
        itemId: "T7_OFF_LAMP_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Leering Cane",
        itemId: "T4_OFF_JESTERCANE_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Leering Cane",
        itemId: "T5_OFF_JESTERCANE_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Leering Cane",
        itemId: "T6_OFF_JESTERCANE_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Leering Cane",
        itemId: "T7_OFF_JESTERCANE_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Cape",
        itemId: "T4_CAPE",
        canEnchant: true
    },
{
        itemName: "Elder's Leering Cane",
        itemId: "T8_OFF_JESTERCANE_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Cape",
        itemId: "T5_CAPE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Cape",
        itemId: "T7_CAPE",
        canEnchant: true
    },
{
        itemName: "Adept's Bridgewatch Cape",
        itemId: "T4_CAPEITEM_FW_BRIDGEWATCH",
        canEnchant: true
    },
{
        itemName: "Expert's Bridgewatch Cape",
        itemId: "T5_CAPEITEM_FW_BRIDGEWATCH",
        canEnchant: true
    },
{
        itemName: "Elder's Cape",
        itemId: "T8_CAPE",
        canEnchant: true
    },
{
        itemName: "Master's Cape",
        itemId: "T6_CAPE",
        canEnchant: true
    },
{
        itemName: "Master's Bridgewatch Cape",
        itemId: "T6_CAPEITEM_FW_BRIDGEWATCH",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Bridgewatch Cape",
        itemId: "T7_CAPEITEM_FW_BRIDGEWATCH",
        canEnchant: true
    },
{
        itemName: "Elder's Bridgewatch Cape",
        itemId: "T8_CAPEITEM_FW_BRIDGEWATCH",
        canEnchant: true
    },
{
        itemName: "Adept's Fort Sterling Cape",
        itemId: "T4_CAPEITEM_FW_FORTSTERLING",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Fort Sterling Cape",
        itemId: "T7_CAPEITEM_FW_FORTSTERLING",
        canEnchant: true
    },
{
        itemName: "Elder's Fort Sterling Cape",
        itemId: "T8_CAPEITEM_FW_FORTSTERLING",
        canEnchant: true
    },
{
        itemName: "Master's Fort Sterling Cape",
        itemId: "T6_CAPEITEM_FW_FORTSTERLING",
        canEnchant: true
    },
{
        itemName: "Expert's Fort Sterling Cape",
        itemId: "T5_CAPEITEM_FW_FORTSTERLING",
        canEnchant: true
    },
{
        itemName: "Adept's Lymhurst Cape",
        itemId: "T4_CAPEITEM_FW_LYMHURST",
        canEnchant: true
    },
{
        itemName: "Master's Lymhurst Cape",
        itemId: "T6_CAPEITEM_FW_LYMHURST",
        canEnchant: true
    },
{
        itemName: "Adept's Martlock Cape",
        itemId: "T4_CAPEITEM_FW_MARTLOCK",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Lymhurst Cape",
        itemId: "T7_CAPEITEM_FW_LYMHURST",
        canEnchant: true
    },
{
        itemName: "Master's Martlock Cape",
        itemId: "T6_CAPEITEM_FW_MARTLOCK",
        canEnchant: true
    },
{
        itemName: "Elder's Lymhurst Cape",
        itemId: "T8_CAPEITEM_FW_LYMHURST",
        canEnchant: true
    },
{
        itemName: "Expert's Lymhurst Cape",
        itemId: "T5_CAPEITEM_FW_LYMHURST",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Martlock Cape",
        itemId: "T7_CAPEITEM_FW_MARTLOCK",
        canEnchant: true
    },
{
        itemName: "Adept's Thetford Cape",
        itemId: "T4_CAPEITEM_FW_THETFORD",
        canEnchant: true
    },
{
        itemName: "Expert's Thetford Cape",
        itemId: "T5_CAPEITEM_FW_THETFORD",
        canEnchant: true
    },
{
        itemName: "Expert's Martlock Cape",
        itemId: "T5_CAPEITEM_FW_MARTLOCK",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Thetford Cape",
        itemId: "T7_CAPEITEM_FW_THETFORD",
        canEnchant: true
    },
{
        itemName: "Elder's Martlock Cape",
        itemId: "T8_CAPEITEM_FW_MARTLOCK",
        canEnchant: true
    },
{
        itemName: "Master's Thetford Cape",
        itemId: "T6_CAPEITEM_FW_THETFORD",
        canEnchant: true
    },
{
        itemName: "Elder's Thetford Cape",
        itemId: "T8_CAPEITEM_FW_THETFORD",
        canEnchant: true
    },
{
        itemName: "Expert's Caerleon Cape",
        itemId: "T5_CAPEITEM_FW_CAERLEON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Caerleon Cape",
        itemId: "T7_CAPEITEM_FW_CAERLEON",
        canEnchant: true
    },
{
        itemName: "Adept's Caerleon Cape",
        itemId: "T4_CAPEITEM_FW_CAERLEON",
        canEnchant: true
    },
{
        itemName: "Master's Caerleon Cape",
        itemId: "T6_CAPEITEM_FW_CAERLEON",
        canEnchant: true
    },
{
        itemName: "Adept's Heretic Cape",
        itemId: "T4_CAPEITEM_HERETIC",
        canEnchant: true
    },
{
        itemName: "Elder's Caerleon Cape",
        itemId: "T8_CAPEITEM_FW_CAERLEON",
        canEnchant: true
    },
{
        itemName: "Expert's Heretic Cape",
        itemId: "T5_CAPEITEM_HERETIC",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Heretic Cape",
        itemId: "T7_CAPEITEM_HERETIC",
        canEnchant: true
    },
{
        itemName: "Elder's Heretic Cape",
        itemId: "T8_CAPEITEM_HERETIC",
        canEnchant: true
    },
{
        itemName: "Master's Heretic Cape",
        itemId: "T6_CAPEITEM_HERETIC",
        canEnchant: true
    },
{
        itemName: "Adept's Undead Cape",
        itemId: "T4_CAPEITEM_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Undead Cape",
        itemId: "T5_CAPEITEM_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Undead Cape",
        itemId: "T7_CAPEITEM_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Keeper Cape",
        itemId: "T5_CAPEITEM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Undead Cape",
        itemId: "T8_CAPEITEM_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Undead Cape",
        itemId: "T6_CAPEITEM_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Keeper Cape",
        itemId: "T4_CAPEITEM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Keeper Cape",
        itemId: "T6_CAPEITEM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Keeper Cape",
        itemId: "T7_CAPEITEM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Morgana Cape",
        itemId: "T4_CAPEITEM_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Morgana Cape",
        itemId: "T5_CAPEITEM_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Morgana Cape",
        itemId: "T7_CAPEITEM_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Morgana Cape",
        itemId: "T6_CAPEITEM_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Keeper Cape",
        itemId: "T8_CAPEITEM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Morgana Cape",
        itemId: "T8_CAPEITEM_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Demon Cape",
        itemId: "T4_CAPEITEM_DEMON",
        canEnchant: true
    },
{
        itemName: "Expert's Demon Cape",
        itemId: "T5_CAPEITEM_DEMON",
        canEnchant: true
    },
{
        itemName: "Master's Demon Cape",
        itemId: "T6_CAPEITEM_DEMON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Demon Cape",
        itemId: "T7_CAPEITEM_DEMON",
        canEnchant: true
    },
{
        itemName: "Elder's Demon Cape",
        itemId: "T8_CAPEITEM_DEMON",
        canEnchant: true
    },
{
        itemName: "Expert's Bag",
        itemId: "T5_BAG",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Bag",
        itemId: "T7_BAG",
        canEnchant: true
    },
{
        itemName: "Adept's Satchel of Insight",
        itemId: "T4_BAG_INSIGHT",
        canEnchant: true
    },
{
        itemName: "Expert's Satchel of Insight",
        itemId: "T5_BAG_INSIGHT",
        canEnchant: true
    },
{
        itemName: "Master's Bag",
        itemId: "T6_BAG",
        canEnchant: true
    },
{
        itemName: "Master's Satchel of Insight",
        itemId: "T6_BAG_INSIGHT",
        canEnchant: true
    },
{
        itemName: "Adept's Bag",
        itemId: "T4_BAG",
        canEnchant: true
    },
{
        itemName: "Elder's Satchel of Insight",
        itemId: "T8_BAG_INSIGHT",
        canEnchant: true
    },
{
        itemName: "Elder's Command Mammoth",
        itemId: "T8_MOUNT_MAMMOTH_BATTLE",
        canEnchant: true
    },
{
        itemName: "Elder's Bag",
        itemId: "T8_BAG",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Satchel of Insight",
        itemId: "T7_BAG_INSIGHT",
        canEnchant: true
    },
{
        itemName: "Spectral Bonehorse",
        itemId: "T8_MOUNT_HORSE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Rageclaw",
        itemId: "T8_MOUNT_COUGAR_KEEPER",
        canEnchant: true
    },
{
        itemName: "Morgana Nightmare",
        itemId: "T8_MOUNT_ARMORED_HORSE_MORGANA",
        canEnchant: true
    },
{
        itemName: "Recruiter's Crate",
        itemId: "UNIQUE_FURNITUREITEM_TELLAFRIEND_CHEST_A",
        canEnchant: true
    },
{
        itemName: "Swiftclaw",
        itemId: "T5_MOUNT_COUGAR_KEEPER",
        canEnchant: true
    },
{
        itemName: "Recruiter's Chest",
        itemId: "UNIQUE_FURNITUREITEM_TELLAFRIEND_CHEST_B",
        canEnchant: true
    },
{
        itemName: "Recruiter's Wooden Chest",
        itemId: "UNIQUE_FURNITUREITEM_TELLAFRIEND_CHEST_C",
        canEnchant: true
    },
{
        itemName: "Recruiter's Merlyn Cube",
        itemId: "UNIQUE_FURNITUREITEM_TELLAFRIEND_CHEST_MERLINCUBE",
        canEnchant: true
    },
{
        itemName: "Recruiter's Storage-Barrel",
        itemId: "UNIQUE_FURNITUREITEM_TELLAFRIEND_CHEST_BARREL_B",
        canEnchant: true
    },
{
        itemName: "Raven Standard Flambeau (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_TORCH_C",
        canEnchant: true
    },
{
        itemName: "Recruiter's Companion Crate",
        itemId: "UNIQUE_FURNITUREITEM_TELLAFRIEND_CHEST_COMPANION",
        canEnchant: true
    },
{
        itemName: "Pentagram (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_PENTAGRAM",
        canEnchant: true
    },
{
        itemName: "Reinforced Brazier (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_FIREBOWL_C",
        canEnchant: true
    },
{
        itemName: "Recruiter's Barrel-crate",
        itemId: "UNIQUE_FURNITUREITEM_TELLAFRIEND_CHEST_BARREL",
        canEnchant: true
    },
{
        itemName: "Cauldron (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_CAMPFIRE_D",
        canEnchant: true
    },
{
        itemName: "Army Crate (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_WEAPONCRATE_A",
        canEnchant: true
    },
{
        itemName: "Siege Ballista (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_SIEGE_BALLISTA_A",
        canEnchant: true
    },
{
        itemName: "Prisoner Cage (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_PRISON_CELL_C",
        canEnchant: true
    },
{
        itemName: "Soldier's Tent (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_TENT_A",
        canEnchant: true
    },
{
        itemName: "Expert's Soldier Helmet",
        itemId: "T5_HEAD_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Soldier Helmet",
        itemId: "T7_HEAD_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Adept's Soldier Helmet",
        itemId: "T4_HEAD_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Elder's Soldier Helmet",
        itemId: "T8_HEAD_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Soldier Helmet",
        itemId: "T6_HEAD_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Adept's Soldier Armor",
        itemId: "T4_ARMOR_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Expert's Soldier Armor",
        itemId: "T5_ARMOR_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Soldier Armor",
        itemId: "T7_ARMOR_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Soldier Armor",
        itemId: "T6_ARMOR_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Expert's Soldier Boots",
        itemId: "T5_SHOES_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Soldier Boots",
        itemId: "T7_SHOES_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Adept's Soldier Boots",
        itemId: "T4_SHOES_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Elder's Soldier Armor",
        itemId: "T8_ARMOR_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Soldier Boots",
        itemId: "T6_SHOES_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Elder's Soldier Boots",
        itemId: "T8_SHOES_PLATE_SET1",
        canEnchant: true
    },
{
        itemName: "Adept's Knight Helmet",
        itemId: "T4_HEAD_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Expert's Knight Helmet",
        itemId: "T5_HEAD_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Knight Helmet",
        itemId: "T7_HEAD_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Elder's Knight Helmet",
        itemId: "T8_HEAD_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Master's Knight Helmet",
        itemId: "T6_HEAD_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Knight Armor",
        itemId: "T7_ARMOR_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Master's Knight Armor",
        itemId: "T6_ARMOR_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Expert's Knight Armor",
        itemId: "T5_ARMOR_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Adept's Knight Boots",
        itemId: "T4_SHOES_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Master's Knight Boots",
        itemId: "T6_SHOES_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Adept's Knight Armor",
        itemId: "T4_ARMOR_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Knight Boots",
        itemId: "T7_SHOES_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Expert's Knight Boots",
        itemId: "T5_SHOES_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Expert's Guardian Helmet",
        itemId: "T5_HEAD_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Adept's Guardian Helmet",
        itemId: "T4_HEAD_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Elder's Knight Armor",
        itemId: "T8_ARMOR_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Guardian Helmet",
        itemId: "T7_HEAD_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Elder's Knight Boots",
        itemId: "T8_SHOES_PLATE_SET2",
        canEnchant: true
    },
{
        itemName: "Master's Guardian Helmet",
        itemId: "T6_HEAD_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Expert's Guardian Armor",
        itemId: "T5_ARMOR_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Elder's Guardian Helmet",
        itemId: "T8_HEAD_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Adept's Guardian Armor",
        itemId: "T4_ARMOR_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Elder's Guardian Armor",
        itemId: "T8_ARMOR_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Guardian Armor",
        itemId: "T7_ARMOR_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Master's Guardian Armor",
        itemId: "T6_ARMOR_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Expert's Guardian Boots",
        itemId: "T5_SHOES_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Adept's Guardian Boots",
        itemId: "T4_SHOES_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Guardian Boots",
        itemId: "T7_SHOES_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Master's Guardian Boots",
        itemId: "T6_SHOES_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Adept's Graveguard Helmet",
        itemId: "T4_HEAD_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Graveguard Helmet",
        itemId: "T6_HEAD_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Graveguard Helmet",
        itemId: "T5_HEAD_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Graveguard Helmet",
        itemId: "T7_HEAD_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Graveguard Armor",
        itemId: "T5_ARMOR_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Graveguard Helmet",
        itemId: "T8_HEAD_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Graveguard Armor",
        itemId: "T4_ARMOR_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Guardian Boots",
        itemId: "T8_SHOES_PLATE_SET3",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Graveguard Armor",
        itemId: "T7_ARMOR_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Graveguard Armor",
        itemId: "T6_ARMOR_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Graveguard Boots",
        itemId: "T4_SHOES_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Graveguard Armor",
        itemId: "T8_ARMOR_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Graveguard Boots",
        itemId: "T5_SHOES_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Graveguard Boots",
        itemId: "T7_SHOES_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Graveguard Boots",
        itemId: "T8_SHOES_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Graveguard Boots",
        itemId: "T6_SHOES_PLATE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Demon Helmet",
        itemId: "T5_HEAD_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Demon Helmet",
        itemId: "T7_HEAD_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Demon Helmet",
        itemId: "T6_HEAD_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Demon Helmet",
        itemId: "T4_HEAD_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Demon Armor",
        itemId: "T5_ARMOR_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Demon Armor",
        itemId: "T4_ARMOR_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Demon Armor",
        itemId: "T6_ARMOR_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Demon Armor",
        itemId: "T7_ARMOR_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Demon Helmet",
        itemId: "T8_HEAD_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Demon Boots",
        itemId: "T6_SHOES_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Demon Boots",
        itemId: "T5_SHOES_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Demon Boots",
        itemId: "T4_SHOES_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Demon Boots",
        itemId: "T7_SHOES_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Demon Armor",
        itemId: "T8_ARMOR_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Judicator Helmet",
        itemId: "T5_HEAD_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Judicator Helmet",
        itemId: "T6_HEAD_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Demon Boots",
        itemId: "T8_SHOES_PLATE_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Judicator Helmet",
        itemId: "T7_HEAD_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Judicator Helmet",
        itemId: "T4_HEAD_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Judicator Armor",
        itemId: "T5_ARMOR_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Judicator Armor",
        itemId: "T7_ARMOR_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Judicator Helmet",
        itemId: "T8_HEAD_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Judicator Armor",
        itemId: "T6_ARMOR_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Judicator Boots",
        itemId: "T6_SHOES_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Judicator Armor",
        itemId: "T4_ARMOR_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Judicator Boots",
        itemId: "T5_SHOES_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Judicator Boots",
        itemId: "T7_SHOES_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Judicator Boots",
        itemId: "T4_SHOES_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Judicator Armor",
        itemId: "T8_ARMOR_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Helmet of Valor",
        itemId: "T4_HEAD_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Judicator Boots",
        itemId: "T8_SHOES_PLATE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Helmet of Valor",
        itemId: "T7_HEAD_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Helmet of Valor",
        itemId: "T8_HEAD_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Helmet of Valor",
        itemId: "T6_HEAD_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Armor of Valor",
        itemId: "T4_ARMOR_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Armor of Valor",
        itemId: "T6_ARMOR_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Helmet of Valor",
        itemId: "T5_HEAD_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Armor of Valor",
        itemId: "T7_ARMOR_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Armor of Valor",
        itemId: "T8_ARMOR_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Armor of Valor",
        itemId: "T5_ARMOR_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Boots of Valor",
        itemId: "T7_SHOES_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Boots of Valor",
        itemId: "T5_SHOES_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Boots of Valor",
        itemId: "T4_SHOES_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Boots of Valor",
        itemId: "T6_SHOES_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Mercenary Hood",
        itemId: "T4_HEAD_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Elder's Boots of Valor",
        itemId: "T8_SHOES_PLATE_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Mercenary Hood",
        itemId: "T7_HEAD_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Expert's Mercenary Hood",
        itemId: "T5_HEAD_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Adept's Mercenary Jacket",
        itemId: "T4_ARMOR_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Expert's Mercenary Jacket",
        itemId: "T5_ARMOR_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Mercenary Hood",
        itemId: "T6_HEAD_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Mercenary Jacket",
        itemId: "T6_ARMOR_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Mercenary Jacket",
        itemId: "T7_ARMOR_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Elder's Mercenary Hood",
        itemId: "T8_HEAD_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Elder's Mercenary Jacket",
        itemId: "T8_ARMOR_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Expert's Mercenary Shoes",
        itemId: "T5_SHOES_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Mercenary Shoes",
        itemId: "T6_SHOES_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Mercenary Shoes",
        itemId: "T7_SHOES_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Adept's Hunter Hood",
        itemId: "T4_HEAD_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Adept's Mercenary Shoes",
        itemId: "T4_SHOES_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hunter Hood",
        itemId: "T7_HEAD_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Elder's Mercenary Shoes",
        itemId: "T8_SHOES_LEATHER_SET1",
        canEnchant: true
    },
{
        itemName: "Expert's Hunter Hood",
        itemId: "T5_HEAD_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Adept's Hunter Jacket",
        itemId: "T4_ARMOR_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Master's Hunter Hood",
        itemId: "T6_HEAD_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Master's Hunter Jacket",
        itemId: "T6_ARMOR_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Elder's Hunter Jacket",
        itemId: "T8_ARMOR_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hunter Jacket",
        itemId: "T7_ARMOR_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Elder's Hunter Hood",
        itemId: "T8_HEAD_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Expert's Hunter Jacket",
        itemId: "T5_ARMOR_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Adept's Hunter Shoes",
        itemId: "T4_SHOES_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Master's Hunter Shoes",
        itemId: "T6_SHOES_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Elder's Hunter Shoes",
        itemId: "T8_SHOES_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hunter Shoes",
        itemId: "T7_SHOES_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Expert's Hunter Shoes",
        itemId: "T5_SHOES_LEATHER_SET2",
        canEnchant: true
    },
{
        itemName: "Expert's Assassin Hood",
        itemId: "T5_HEAD_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Assassin Hood",
        itemId: "T7_HEAD_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Master's Assassin Hood",
        itemId: "T6_HEAD_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Adept's Assassin Jacket",
        itemId: "T4_ARMOR_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Expert's Assassin Jacket",
        itemId: "T5_ARMOR_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Adept's Assassin Hood",
        itemId: "T4_HEAD_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Master's Assassin Jacket",
        itemId: "T6_ARMOR_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Elder's Assassin Hood",
        itemId: "T8_HEAD_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Assassin Jacket",
        itemId: "T7_ARMOR_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Elder's Assassin Jacket",
        itemId: "T8_ARMOR_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Master's Assassin Shoes",
        itemId: "T6_SHOES_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Assassin Shoes",
        itemId: "T7_SHOES_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Adept's Assassin Shoes",
        itemId: "T4_SHOES_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Expert's Assassin Shoes",
        itemId: "T5_SHOES_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Elder's Assassin Shoes",
        itemId: "T8_SHOES_LEATHER_SET3",
        canEnchant: true
    },
{
        itemName: "Expert's Stalker Hood",
        itemId: "T5_HEAD_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Stalker Hood",
        itemId: "T8_HEAD_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Stalker Hood",
        itemId: "T6_HEAD_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Stalker Hood",
        itemId: "T4_HEAD_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Stalker Jacket",
        itemId: "T5_ARMOR_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Stalker Hood",
        itemId: "T7_HEAD_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Stalker Jacket",
        itemId: "T7_ARMOR_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Stalker Jacket",
        itemId: "T6_ARMOR_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Stalker Shoes",
        itemId: "T4_SHOES_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Stalker Jacket",
        itemId: "T8_ARMOR_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Stalker Shoes",
        itemId: "T5_SHOES_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Stalker Shoes",
        itemId: "T7_SHOES_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Stalker Jacket",
        itemId: "T4_ARMOR_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Stalker Shoes",
        itemId: "T6_SHOES_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Stalker Shoes",
        itemId: "T8_SHOES_LEATHER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Hellion Hood",
        itemId: "T5_HEAD_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Hellion Hood",
        itemId: "T4_HEAD_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hellion Hood",
        itemId: "T7_HEAD_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Hellion Hood",
        itemId: "T6_HEAD_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Hellion Jacket",
        itemId: "T4_ARMOR_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Hellion Hood",
        itemId: "T8_HEAD_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Hellion Jacket",
        itemId: "T6_ARMOR_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hellion Jacket",
        itemId: "T7_ARMOR_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Hellion Jacket",
        itemId: "T5_ARMOR_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Hellion Jacket",
        itemId: "T8_ARMOR_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Hellion Shoes",
        itemId: "T5_SHOES_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hellion Shoes",
        itemId: "T7_SHOES_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Specter Hood",
        itemId: "T4_HEAD_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Hellion Shoes",
        itemId: "T6_SHOES_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Hellion Shoes",
        itemId: "T8_SHOES_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Specter Hood",
        itemId: "T6_HEAD_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Specter Hood",
        itemId: "T7_HEAD_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Specter Hood",
        itemId: "T5_HEAD_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Specter Jacket",
        itemId: "T4_ARMOR_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Hellion Shoes",
        itemId: "T4_SHOES_LEATHER_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Specter Jacket",
        itemId: "T5_ARMOR_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Specter Hood",
        itemId: "T8_HEAD_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Specter Jacket",
        itemId: "T7_ARMOR_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Specter Jacket",
        itemId: "T6_ARMOR_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Specter Shoes",
        itemId: "T5_SHOES_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Specter Jacket",
        itemId: "T8_ARMOR_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Specter Shoes",
        itemId: "T7_SHOES_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Specter Shoes",
        itemId: "T4_SHOES_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Specter Shoes",
        itemId: "T6_SHOES_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Hood of Tenacity",
        itemId: "T4_HEAD_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Hood of Tenacity",
        itemId: "T5_HEAD_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hood of Tenacity",
        itemId: "T7_HEAD_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Specter Shoes",
        itemId: "T8_SHOES_LEATHER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Hood of Tenacity",
        itemId: "T6_HEAD_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Jacket of Tenacity",
        itemId: "T5_ARMOR_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Jacket of Tenacity",
        itemId: "T4_ARMOR_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Jacket of Tenacity",
        itemId: "T6_ARMOR_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Jacket of Tenacity",
        itemId: "T7_ARMOR_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Jacket of Tenacity",
        itemId: "T8_ARMOR_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Shoes of Tenacity",
        itemId: "T4_SHOES_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Shoes of Tenacity",
        itemId: "T5_SHOES_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Shoes of Tenacity",
        itemId: "T7_SHOES_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Shoes of Tenacity",
        itemId: "T8_SHOES_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Shoes of Tenacity",
        itemId: "T6_SHOES_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Hood of Tenacity",
        itemId: "T8_HEAD_LEATHER_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Scholar Cowl",
        itemId: "T4_HEAD_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Scholar Cowl",
        itemId: "T7_HEAD_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Scholar Cowl",
        itemId: "T6_HEAD_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Expert's Scholar Robe",
        itemId: "T5_ARMOR_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Expert's Scholar Cowl",
        itemId: "T5_HEAD_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Elder's Scholar Cowl",
        itemId: "T8_HEAD_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Adept's Scholar Robe",
        itemId: "T4_ARMOR_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Scholar Robe",
        itemId: "T6_ARMOR_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Scholar Robe",
        itemId: "T7_ARMOR_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Expert's Scholar Sandals",
        itemId: "T5_SHOES_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Adept's Scholar Sandals",
        itemId: "T4_SHOES_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Scholar Sandals",
        itemId: "T7_SHOES_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Elder's Scholar Robe",
        itemId: "T8_ARMOR_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Elder's Scholar Sandals",
        itemId: "T8_SHOES_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Scholar Sandals",
        itemId: "T6_SHOES_CLOTH_SET1",
        canEnchant: true
    },
{
        itemName: "Adept's Cleric Cowl",
        itemId: "T4_HEAD_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Master's Cleric Cowl",
        itemId: "T6_HEAD_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Cleric Cowl",
        itemId: "T7_HEAD_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Elder's Cleric Cowl",
        itemId: "T8_HEAD_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Expert's Cleric Cowl",
        itemId: "T5_HEAD_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Expert's Cleric Robe",
        itemId: "T5_ARMOR_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Cleric Robe",
        itemId: "T7_ARMOR_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Adept's Cleric Robe",
        itemId: "T4_ARMOR_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Master's Cleric Robe",
        itemId: "T6_ARMOR_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Master's Cleric Sandals",
        itemId: "T6_SHOES_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Cleric Sandals",
        itemId: "T7_SHOES_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Elder's Cleric Robe",
        itemId: "T8_ARMOR_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Elder's Cleric Sandals",
        itemId: "T8_SHOES_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Adept's Cleric Sandals",
        itemId: "T4_SHOES_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Expert's Cleric Sandals",
        itemId: "T5_SHOES_CLOTH_SET2",
        canEnchant: true
    },
{
        itemName: "Expert's Mage Cowl",
        itemId: "T5_HEAD_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Mage Cowl",
        itemId: "T7_HEAD_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Adept's Mage Cowl",
        itemId: "T4_HEAD_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Master's Mage Cowl",
        itemId: "T6_HEAD_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Adept's Mage Robe",
        itemId: "T4_ARMOR_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Elder's Mage Robe",
        itemId: "T8_ARMOR_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Expert's Mage Robe",
        itemId: "T5_ARMOR_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Adept's Mage Sandals",
        itemId: "T4_SHOES_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Mage Robe",
        itemId: "T7_ARMOR_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Mage Sandals",
        itemId: "T7_SHOES_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Expert's Mage Sandals",
        itemId: "T5_SHOES_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Elder's Mage Cowl",
        itemId: "T8_HEAD_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Master's Mage Sandals",
        itemId: "T6_SHOES_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Druid Cowl",
        itemId: "T7_HEAD_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Mage Sandals",
        itemId: "T8_SHOES_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Expert's Druid Cowl",
        itemId: "T5_HEAD_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Druid Cowl",
        itemId: "T6_HEAD_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Druid Cowl",
        itemId: "T8_HEAD_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Mage Robe",
        itemId: "T6_ARMOR_CLOTH_SET3",
        canEnchant: true
    },
{
        itemName: "Adept's Druid Cowl",
        itemId: "T4_HEAD_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Druid Robe",
        itemId: "T4_ARMOR_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Druid Robe",
        itemId: "T5_ARMOR_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Druid Robe",
        itemId: "T6_ARMOR_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Druid Robe",
        itemId: "T7_ARMOR_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Druid Robe",
        itemId: "T8_ARMOR_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Druid Sandals",
        itemId: "T4_SHOES_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Druid Sandals",
        itemId: "T7_SHOES_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Druid Sandals",
        itemId: "T6_SHOES_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Druid Sandals",
        itemId: "T8_SHOES_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Druid Sandals",
        itemId: "T5_SHOES_CLOTH_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Fiend Cowl",
        itemId: "T5_HEAD_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Fiend Cowl",
        itemId: "T7_HEAD_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Fiend Cowl",
        itemId: "T8_HEAD_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Fiend Cowl",
        itemId: "T6_HEAD_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Fiend Cowl",
        itemId: "T4_HEAD_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Fiend Robe",
        itemId: "T4_ARMOR_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Fiend Robe",
        itemId: "T5_ARMOR_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Fiend Robe",
        itemId: "T7_ARMOR_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Fiend Sandals",
        itemId: "T4_SHOES_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Fiend Robe",
        itemId: "T6_ARMOR_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Fiend Sandals",
        itemId: "T5_SHOES_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Fiend Sandals",
        itemId: "T6_SHOES_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Fiend Sandals",
        itemId: "T7_SHOES_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Cultist Cowl",
        itemId: "T4_HEAD_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Cultist Cowl",
        itemId: "T5_HEAD_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Cultist Cowl",
        itemId: "T7_HEAD_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Fiend Sandals",
        itemId: "T8_SHOES_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Cultist Cowl",
        itemId: "T6_HEAD_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Cultist Robe",
        itemId: "T5_ARMOR_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Cultist Robe",
        itemId: "T4_ARMOR_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Cultist Robe",
        itemId: "T6_ARMOR_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Cultist Cowl",
        itemId: "T8_HEAD_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Cultist Robe",
        itemId: "T7_ARMOR_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Cultist Sandals",
        itemId: "T4_SHOES_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Cultist Robe",
        itemId: "T8_ARMOR_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Cultist Sandals",
        itemId: "T6_SHOES_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Cultist Sandals",
        itemId: "T7_SHOES_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Cultist Sandals",
        itemId: "T5_SHOES_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Cowl of Purity",
        itemId: "T4_HEAD_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Cultist Sandals",
        itemId: "T8_SHOES_CLOTH_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Cowl of Purity",
        itemId: "T5_HEAD_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Fiend Robe",
        itemId: "T8_ARMOR_CLOTH_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Cowl of Purity",
        itemId: "T6_HEAD_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Robe of Purity",
        itemId: "T4_ARMOR_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Robe of Purity",
        itemId: "T5_ARMOR_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Cowl of Purity",
        itemId: "T7_HEAD_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Robe of Purity",
        itemId: "T7_ARMOR_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Cowl of Purity",
        itemId: "T8_HEAD_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Sandals of Purity",
        itemId: "T5_SHOES_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Robe of Purity",
        itemId: "T6_ARMOR_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Sandals of Purity",
        itemId: "T4_SHOES_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Sandals of Purity",
        itemId: "T6_SHOES_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Sandals of Purity",
        itemId: "T7_SHOES_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Sandals of Purity",
        itemId: "T8_SHOES_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Royal Cowl",
        itemId: "T4_HEAD_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Elder's Robe of Purity",
        itemId: "T8_ARMOR_CLOTH_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Royal Cowl",
        itemId: "T7_HEAD_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Adept's Royal Robe",
        itemId: "T4_ARMOR_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Expert's Royal Cowl",
        itemId: "T5_HEAD_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Master's Royal Cowl",
        itemId: "T6_HEAD_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Expert's Royal Robe",
        itemId: "T5_ARMOR_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Elder's Royal Cowl",
        itemId: "T8_HEAD_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Elder's Royal Robe",
        itemId: "T8_ARMOR_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Adept's Royal Sandals",
        itemId: "T4_SHOES_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Royal Robe",
        itemId: "T7_ARMOR_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Royal Sandals",
        itemId: "T7_SHOES_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Master's Royal Robe",
        itemId: "T6_ARMOR_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Expert's Royal Sandals",
        itemId: "T5_SHOES_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Master's Royal Sandals",
        itemId: "T6_SHOES_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Elder's Royal Sandals",
        itemId: "T8_SHOES_CLOTH_ROYAL",
        canEnchant: true
    },
{
        itemName: "Adept's Royal Hood",
        itemId: "T4_HEAD_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Expert's Royal Hood",
        itemId: "T5_HEAD_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Adept's Royal Jacket",
        itemId: "T4_ARMOR_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Royal Hood",
        itemId: "T7_HEAD_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Expert's Royal Jacket",
        itemId: "T5_ARMOR_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Elder's Royal Hood",
        itemId: "T8_HEAD_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Master's Royal Jacket",
        itemId: "T6_ARMOR_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Royal Jacket",
        itemId: "T7_ARMOR_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Elder's Royal Jacket",
        itemId: "T8_ARMOR_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Master's Royal Shoes",
        itemId: "T6_SHOES_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Master's Royal Hood",
        itemId: "T6_HEAD_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Expert's Royal Shoes",
        itemId: "T5_SHOES_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Adept's Royal Shoes",
        itemId: "T4_SHOES_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Royal Shoes",
        itemId: "T7_SHOES_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Adept's Royal Helmet",
        itemId: "T4_HEAD_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Elder's Royal Shoes",
        itemId: "T8_SHOES_LEATHER_ROYAL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Royal Helmet",
        itemId: "T7_HEAD_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Expert's Royal Helmet",
        itemId: "T5_HEAD_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Master's Royal Helmet",
        itemId: "T6_HEAD_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Elder's Royal Helmet",
        itemId: "T8_HEAD_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Expert's Royal Armor",
        itemId: "T5_ARMOR_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Royal Armor",
        itemId: "T7_ARMOR_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Master's Royal Armor",
        itemId: "T6_ARMOR_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Elder's Royal Armor",
        itemId: "T8_ARMOR_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Expert's Royal Boots",
        itemId: "T5_SHOES_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Royal Boots",
        itemId: "T7_SHOES_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Adept's Royal Armor",
        itemId: "T4_ARMOR_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Master's Royal Boots",
        itemId: "T6_SHOES_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Adept's Harvester Cap",
        itemId: "T4_HEAD_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Adept's Royal Boots",
        itemId: "T4_SHOES_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Elder's Royal Boots",
        itemId: "T8_SHOES_PLATE_ROYAL",
        canEnchant: true
    },
{
        itemName: "Expert's Harvester Cap",
        itemId: "T5_HEAD_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Harvester Cap",
        itemId: "T7_HEAD_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Master's Harvester Cap",
        itemId: "T6_HEAD_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Adept's Harvester Garb",
        itemId: "T4_ARMOR_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Elder's Harvester Cap",
        itemId: "T8_HEAD_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Expert's Harvester Garb",
        itemId: "T5_ARMOR_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Elder's Harvester Garb",
        itemId: "T8_ARMOR_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Master's Harvester Garb",
        itemId: "T6_ARMOR_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Expert's Harvester Workboots",
        itemId: "T5_SHOES_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Harvester Garb",
        itemId: "T7_ARMOR_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Master's Harvester Workboots",
        itemId: "T6_SHOES_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Harvester Workboots",
        itemId: "T7_SHOES_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Adept's Harvester Workboots",
        itemId: "T4_SHOES_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Adept's Harvester Backpack",
        itemId: "T4_BACKPACK_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Expert's Harvester Backpack",
        itemId: "T5_BACKPACK_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Harvester Backpack",
        itemId: "T7_BACKPACK_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Master's Harvester Backpack",
        itemId: "T6_BACKPACK_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Elder's Harvester Workboots",
        itemId: "T8_SHOES_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Elder's Harvester Backpack",
        itemId: "T8_BACKPACK_GATHERER_FIBER",
        canEnchant: true
    },
{
        itemName: "Expert's Skinner Cap",
        itemId: "T5_HEAD_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Skinner Cap",
        itemId: "T7_HEAD_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Adept's Skinner Cap",
        itemId: "T4_HEAD_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Adept's Skinner Garb",
        itemId: "T4_ARMOR_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Master's Skinner Cap",
        itemId: "T6_HEAD_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Master's Skinner Garb",
        itemId: "T6_ARMOR_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Skinner Garb",
        itemId: "T7_ARMOR_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Elder's Skinner Cap",
        itemId: "T8_HEAD_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Expert's Skinner Garb",
        itemId: "T5_ARMOR_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Adept's Skinner Workboots",
        itemId: "T4_SHOES_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Expert's Skinner Workboots",
        itemId: "T5_SHOES_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Adept's Skinner Backpack",
        itemId: "T4_BACKPACK_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Master's Skinner Workboots",
        itemId: "T6_SHOES_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Elder's Skinner Workboots",
        itemId: "T8_SHOES_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Elder's Skinner Garb",
        itemId: "T8_ARMOR_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Skinner Workboots",
        itemId: "T7_SHOES_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Skinner Backpack",
        itemId: "T7_BACKPACK_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Expert's Skinner Backpack",
        itemId: "T5_BACKPACK_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Adept's Miner Cap",
        itemId: "T4_HEAD_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Elder's Skinner Backpack",
        itemId: "T8_BACKPACK_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Miner Cap",
        itemId: "T7_HEAD_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Expert's Miner Cap",
        itemId: "T5_HEAD_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Elder's Miner Cap",
        itemId: "T8_HEAD_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Master's Miner Cap",
        itemId: "T6_HEAD_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Adept's Miner Garb",
        itemId: "T4_ARMOR_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Expert's Miner Garb",
        itemId: "T5_ARMOR_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Master's Skinner Backpack",
        itemId: "T6_BACKPACK_GATHERER_HIDE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Miner Garb",
        itemId: "T7_ARMOR_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Elder's Miner Garb",
        itemId: "T8_ARMOR_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Master's Miner Garb",
        itemId: "T6_ARMOR_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Expert's Miner Workboots",
        itemId: "T5_SHOES_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Miner Workboots",
        itemId: "T7_SHOES_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Adept's Miner Workboots",
        itemId: "T4_SHOES_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Master's Miner Workboots",
        itemId: "T6_SHOES_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Adept's Miner Backpack",
        itemId: "T4_BACKPACK_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Expert's Miner Backpack",
        itemId: "T5_BACKPACK_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Elder's Miner Workboots",
        itemId: "T8_SHOES_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Elder's Miner Backpack",
        itemId: "T8_BACKPACK_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Miner Backpack",
        itemId: "T7_BACKPACK_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Master's Miner Backpack",
        itemId: "T6_BACKPACK_GATHERER_ORE",
        canEnchant: true
    },
{
        itemName: "Adept's Quarrier Cap",
        itemId: "T4_HEAD_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Expert's Quarrier Cap",
        itemId: "T5_HEAD_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Adept's Quarrier Garb",
        itemId: "T4_ARMOR_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Quarrier Cap",
        itemId: "T7_HEAD_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Elder's Quarrier Cap",
        itemId: "T8_HEAD_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Expert's Quarrier Garb",
        itemId: "T5_ARMOR_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Master's Quarrier Cap",
        itemId: "T6_HEAD_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Quarrier Garb",
        itemId: "T7_ARMOR_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Adept's Quarrier Workboots",
        itemId: "T4_SHOES_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Expert's Quarrier Workboots",
        itemId: "T5_SHOES_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Quarrier Workboots",
        itemId: "T7_SHOES_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Elder's Quarrier Garb",
        itemId: "T8_ARMOR_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Adept's Quarrier Backpack",
        itemId: "T4_BACKPACK_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Elder's Quarrier Workboots",
        itemId: "T8_SHOES_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Master's Quarrier Workboots",
        itemId: "T6_SHOES_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Expert's Quarrier Backpack",
        itemId: "T5_BACKPACK_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Quarrier Backpack",
        itemId: "T7_BACKPACK_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Master's Quarrier Backpack",
        itemId: "T6_BACKPACK_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Expert's Lumberjack Cap",
        itemId: "T5_HEAD_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Elder's Quarrier Backpack",
        itemId: "T8_BACKPACK_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Master's Lumberjack Cap",
        itemId: "T6_HEAD_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Lumberjack Cap",
        itemId: "T7_HEAD_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Elder's Lumberjack Cap",
        itemId: "T8_HEAD_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Adept's Lumberjack Cap",
        itemId: "T4_HEAD_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Adept's Lumberjack Garb",
        itemId: "T4_ARMOR_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Expert's Lumberjack Garb",
        itemId: "T5_ARMOR_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Master's Quarrier Garb",
        itemId: "T6_ARMOR_GATHERER_ROCK",
        canEnchant: true
    },
{
        itemName: "Master's Lumberjack Garb",
        itemId: "T6_ARMOR_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Adept's Lumberjack Workboots",
        itemId: "T4_SHOES_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Expert's Lumberjack Workboots",
        itemId: "T5_SHOES_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Lumberjack Garb",
        itemId: "T7_ARMOR_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Elder's Lumberjack Garb",
        itemId: "T8_ARMOR_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Lumberjack Workboots",
        itemId: "T7_SHOES_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Master's Lumberjack Workboots",
        itemId: "T6_SHOES_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Master's Lumberjack Backpack",
        itemId: "T6_BACKPACK_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Elder's Lumberjack Workboots",
        itemId: "T8_SHOES_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Adept's Lumberjack Backpack",
        itemId: "T4_BACKPACK_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Expert's Lumberjack Backpack",
        itemId: "T5_BACKPACK_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Lumberjack Backpack",
        itemId: "T7_BACKPACK_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Elder's Lumberjack Backpack",
        itemId: "T8_BACKPACK_GATHERER_WOOD",
        canEnchant: true
    },
{
        itemName: "Expert's Fisherman Cap",
        itemId: "T5_HEAD_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Adept's Fisherman Cap",
        itemId: "T4_HEAD_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Fisherman Cap",
        itemId: "T7_HEAD_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Elder's Fisherman Cap",
        itemId: "T8_HEAD_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Master's Fisherman Cap",
        itemId: "T6_HEAD_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Adept's Fisherman Garb",
        itemId: "T4_ARMOR_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Expert's Fisherman Garb",
        itemId: "T5_ARMOR_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Fisherman Garb",
        itemId: "T7_ARMOR_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Elder's Fisherman Garb",
        itemId: "T8_ARMOR_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Master's Fisherman Garb",
        itemId: "T6_ARMOR_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Adept's Fisherman Workboots",
        itemId: "T4_SHOES_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Expert's Fisherman Workboots",
        itemId: "T5_SHOES_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Master's Fisherman Workboots",
        itemId: "T6_SHOES_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Fisherman Workboots",
        itemId: "T7_SHOES_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Elder's Fisherman Workboots",
        itemId: "T8_SHOES_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Expert's Fisherman Backpack",
        itemId: "T5_BACKPACK_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Adept's Fisherman Backpack",
        itemId: "T4_BACKPACK_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Expert's Bow",
        itemId: "T5_2H_BOW",
        canEnchant: true
    },
{
        itemName: "Elder's Fisherman Backpack",
        itemId: "T8_BACKPACK_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Master's Fisherman Backpack",
        itemId: "T6_BACKPACK_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Fisherman Backpack",
        itemId: "T7_BACKPACK_GATHERER_FISH",
        canEnchant: true
    },
{
        itemName: "Master's Bow",
        itemId: "T6_2H_BOW",
        canEnchant: true
    },
{
        itemName: "Adept's Bow",
        itemId: "T4_2H_BOW",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Bow",
        itemId: "T7_2H_BOW",
        canEnchant: true
    },
{
        itemName: "Expert's Warbow",
        itemId: "T5_2H_WARBOW",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Warbow",
        itemId: "T7_2H_WARBOW",
        canEnchant: true
    },
{
        itemName: "Elder's Warbow",
        itemId: "T8_2H_WARBOW",
        canEnchant: true
    },
{
        itemName: "Elder's Bow",
        itemId: "T8_2H_BOW",
        canEnchant: true
    },
{
        itemName: "Master's Warbow",
        itemId: "T6_2H_WARBOW",
        canEnchant: true
    },
{
        itemName: "Expert's Longbow",
        itemId: "T5_2H_LONGBOW",
        canEnchant: true
    },
{
        itemName: "Adept's Longbow",
        itemId: "T4_2H_LONGBOW",
        canEnchant: true
    },
{
        itemName: "Master's Longbow",
        itemId: "T6_2H_LONGBOW",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Longbow",
        itemId: "T7_2H_LONGBOW",
        canEnchant: true
    },
{
        itemName: "Elder's Longbow",
        itemId: "T8_2H_LONGBOW",
        canEnchant: true
    },
{
        itemName: "Adept's Whispering Bow",
        itemId: "T4_2H_LONGBOW_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Whispering Bow",
        itemId: "T5_2H_LONGBOW_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Whispering Bow",
        itemId: "T6_2H_LONGBOW_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Whispering Bow",
        itemId: "T7_2H_LONGBOW_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Wailing Bow",
        itemId: "T4_2H_BOW_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Whispering Bow",
        itemId: "T8_2H_LONGBOW_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Wailing Bow",
        itemId: "T7_2H_BOW_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Wailing Bow",
        itemId: "T6_2H_BOW_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Warbow",
        itemId: "T4_2H_WARBOW",
        canEnchant: true
    },
{
        itemName: "Expert's Wailing Bow",
        itemId: "T5_2H_BOW_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Bow of Badon",
        itemId: "T5_2H_BOW_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Bow of Badon",
        itemId: "T4_2H_BOW_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Wailing Bow",
        itemId: "T8_2H_BOW_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Bow of Badon",
        itemId: "T6_2H_BOW_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Bow of Badon",
        itemId: "T7_2H_BOW_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Bow of Badon",
        itemId: "T8_2H_BOW_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Mistpiercer",
        itemId: "T6_2H_BOW_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Mistpiercer",
        itemId: "T4_2H_BOW_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Mistpiercer",
        itemId: "T7_2H_BOW_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Mistpiercer",
        itemId: "T5_2H_BOW_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Crossbow",
        itemId: "T4_2H_CROSSBOW",
        canEnchant: true
    },
{
        itemName: "Elder's Mistpiercer",
        itemId: "T8_2H_BOW_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Crossbow",
        itemId: "T6_2H_CROSSBOW",
        canEnchant: true
    },
{
        itemName: "Expert's Crossbow",
        itemId: "T5_2H_CROSSBOW",
        canEnchant: true
    },
{
        itemName: "Adept's Heavy Crossbow",
        itemId: "T4_2H_CROSSBOWLARGE",
        canEnchant: true
    },
{
        itemName: "Expert's Heavy Crossbow",
        itemId: "T5_2H_CROSSBOWLARGE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Crossbow",
        itemId: "T7_2H_CROSSBOW",
        canEnchant: true
    },
{
        itemName: "Elder's Crossbow",
        itemId: "T8_2H_CROSSBOW",
        canEnchant: true
    },
{
        itemName: "Master's Heavy Crossbow",
        itemId: "T6_2H_CROSSBOWLARGE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Heavy Crossbow",
        itemId: "T7_2H_CROSSBOWLARGE",
        canEnchant: true
    },
{
        itemName: "Adept's Light Crossbow",
        itemId: "T4_MAIN_1HCROSSBOW",
        canEnchant: true
    },
{
        itemName: "Elder's Heavy Crossbow",
        itemId: "T8_2H_CROSSBOWLARGE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Light Crossbow",
        itemId: "T7_MAIN_1HCROSSBOW",
        canEnchant: true
    },
{
        itemName: "Expert's Weeping Repeater",
        itemId: "T5_2H_REPEATINGCROSSBOW_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Light Crossbow",
        itemId: "T5_MAIN_1HCROSSBOW",
        canEnchant: true
    },
{
        itemName: "Adept's Weeping Repeater",
        itemId: "T4_2H_REPEATINGCROSSBOW_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Weeping Repeater",
        itemId: "T6_2H_REPEATINGCROSSBOW_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Light Crossbow",
        itemId: "T6_MAIN_1HCROSSBOW",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Weeping Repeater",
        itemId: "T7_2H_REPEATINGCROSSBOW_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Weeping Repeater",
        itemId: "T8_2H_REPEATINGCROSSBOW_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Light Crossbow",
        itemId: "T8_MAIN_1HCROSSBOW",
        canEnchant: true
    },
{
        itemName: "Adept's Boltcasters",
        itemId: "T4_2H_DUALCROSSBOW_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Boltcasters",
        itemId: "T5_2H_DUALCROSSBOW_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Boltcasters",
        itemId: "T7_2H_DUALCROSSBOW_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Boltcasters",
        itemId: "T6_2H_DUALCROSSBOW_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Boltcasters",
        itemId: "T8_2H_DUALCROSSBOW_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Siegebow",
        itemId: "T4_2H_CROSSBOWLARGE_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Siegebow",
        itemId: "T7_2H_CROSSBOWLARGE_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Siegebow",
        itemId: "T8_2H_CROSSBOWLARGE_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Siegebow",
        itemId: "T5_2H_CROSSBOWLARGE_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Energy Shaper",
        itemId: "T6_2H_CROSSBOW_CANNON_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Siegebow",
        itemId: "T6_2H_CROSSBOWLARGE_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Energy Shaper",
        itemId: "T4_2H_CROSSBOW_CANNON_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Energy Shaper",
        itemId: "T7_2H_CROSSBOW_CANNON_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Energy Shaper",
        itemId: "T5_2H_CROSSBOW_CANNON_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Cursed Staff",
        itemId: "T4_MAIN_CURSEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Energy Shaper",
        itemId: "T8_2H_CROSSBOW_CANNON_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Cursed Staff",
        itemId: "T5_MAIN_CURSEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Great Cursed Staff",
        itemId: "T4_2H_CURSEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Cursed Staff",
        itemId: "T7_MAIN_CURSEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Cursed Staff",
        itemId: "T6_MAIN_CURSEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Great Cursed Staff",
        itemId: "T5_2H_CURSEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Cursed Staff",
        itemId: "T8_MAIN_CURSEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Great Cursed Staff",
        itemId: "T7_2H_CURSEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Great Cursed Staff",
        itemId: "T8_2H_CURSEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Demonic Staff",
        itemId: "T4_2H_DEMONICSTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Great Cursed Staff",
        itemId: "T6_2H_CURSEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Demonic Staff",
        itemId: "T7_2H_DEMONICSTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Demonic Staff",
        itemId: "T6_2H_DEMONICSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Demonic Staff",
        itemId: "T8_2H_DEMONICSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Demonic Staff",
        itemId: "T5_2H_DEMONICSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Lifecurse Staff",
        itemId: "T4_MAIN_CURSEDSTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Lifecurse Staff",
        itemId: "T7_MAIN_CURSEDSTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Lifecurse Staff",
        itemId: "T6_MAIN_CURSEDSTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Lifecurse Staff",
        itemId: "T5_MAIN_CURSEDSTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Cursed Skull",
        itemId: "T4_2H_SKULLORB_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Lifecurse Staff",
        itemId: "T8_MAIN_CURSEDSTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Cursed Skull",
        itemId: "T6_2H_SKULLORB_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Cursed Skull",
        itemId: "T8_2H_SKULLORB_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Cursed Skull",
        itemId: "T7_2H_SKULLORB_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Damnation Staff",
        itemId: "T6_2H_CURSEDSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Damnation Staff",
        itemId: "T4_2H_CURSEDSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Damnation Staff",
        itemId: "T7_2H_CURSEDSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Damnation Staff",
        itemId: "T5_2H_CURSEDSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Damnation Staff",
        itemId: "T8_2H_CURSEDSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Cursed Skull",
        itemId: "T5_2H_SKULLORB_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Shadowcaller",
        itemId: "T4_MAIN_CURSEDSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Shadowcaller",
        itemId: "T6_MAIN_CURSEDSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Shadowcaller",
        itemId: "T8_MAIN_CURSEDSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Shadowcaller",
        itemId: "T5_MAIN_CURSEDSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Fire Staff",
        itemId: "T4_MAIN_FIRESTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Shadowcaller",
        itemId: "T7_MAIN_CURSEDSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Fire Staff",
        itemId: "T5_MAIN_FIRESTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Fire Staff",
        itemId: "T7_MAIN_FIRESTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Fire Staff",
        itemId: "T6_MAIN_FIRESTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Great Fire Staff",
        itemId: "T4_2H_FIRESTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Great Fire Staff",
        itemId: "T7_2H_FIRESTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Great Fire Staff",
        itemId: "T6_2H_FIRESTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Fire Staff",
        itemId: "T8_MAIN_FIRESTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Great Fire Staff",
        itemId: "T5_2H_FIRESTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Infernal Staff",
        itemId: "T6_2H_INFERNOSTAFF",
        canEnchant: true
    },
{
        itemName: "Vendetta's Wrath",
        itemId: "T8_2H_FIRESTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Infernal Staff",
        itemId: "T4_2H_INFERNOSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Infernal Staff",
        itemId: "T7_2H_INFERNOSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Wildfire Staff",
        itemId: "T5_MAIN_FIRESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Infernal Staff",
        itemId: "T5_2H_INFERNOSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Wildfire Staff",
        itemId: "T4_MAIN_FIRESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Wildfire Staff",
        itemId: "T6_MAIN_FIRESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Infernal Staff",
        itemId: "T8_2H_INFERNOSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Brimstone Staff",
        itemId: "T4_2H_FIRESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Wildfire Staff",
        itemId: "T7_MAIN_FIRESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Brimstone Staff",
        itemId: "T5_2H_FIRESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Wildfire Staff",
        itemId: "T8_MAIN_FIRESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Brimstone Staff",
        itemId: "T7_2H_FIRESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Brimstone Staff",
        itemId: "T6_2H_FIRESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Blazing Staff",
        itemId: "T5_2H_INFERNOSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Brimstone Staff",
        itemId: "T8_2H_FIRESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Blazing Staff",
        itemId: "T6_2H_INFERNOSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Blazing Staff",
        itemId: "T7_2H_INFERNOSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Blazing Staff",
        itemId: "T4_2H_INFERNOSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Dawnsong",
        itemId: "T6_2H_FIRE_RINGPAIR_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Blazing Staff",
        itemId: "T8_2H_INFERNOSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Dawnsong",
        itemId: "T4_2H_FIRE_RINGPAIR_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Dawnsong",
        itemId: "T7_2H_FIRE_RINGPAIR_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Frost Staff",
        itemId: "T4_MAIN_FROSTSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Dawnsong",
        itemId: "T8_2H_FIRE_RINGPAIR_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Dawnsong",
        itemId: "T5_2H_FIRE_RINGPAIR_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Frost Staff",
        itemId: "T5_MAIN_FROSTSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Frost Staff",
        itemId: "T7_MAIN_FROSTSTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Frost Staff",
        itemId: "T6_MAIN_FROSTSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Great Frost Staff",
        itemId: "T4_2H_FROSTSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Great Frost Staff",
        itemId: "T7_2H_FROSTSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Frost Staff",
        itemId: "T8_MAIN_FROSTSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Glacial Staff",
        itemId: "T4_2H_GLACIALSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Great Frost Staff",
        itemId: "T5_2H_FROSTSTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Great Frost Staff",
        itemId: "T6_2H_FROSTSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Great Frost Staff",
        itemId: "T8_2H_FROSTSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Glacial Staff",
        itemId: "T7_2H_GLACIALSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Glacial Staff",
        itemId: "T8_2H_GLACIALSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Glacial Staff",
        itemId: "T5_2H_GLACIALSTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Glacial Staff",
        itemId: "T6_2H_GLACIALSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Hoarfrost Staff",
        itemId: "T4_MAIN_FROSTSTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Hoarfrost Staff",
        itemId: "T6_MAIN_FROSTSTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Hoarfrost Staff",
        itemId: "T5_MAIN_FROSTSTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hoarfrost Staff",
        itemId: "T7_MAIN_FROSTSTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Hoarfrost Staff",
        itemId: "T8_MAIN_FROSTSTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Icicle Staff",
        itemId: "T4_2H_ICEGAUNTLETS_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Icicle Staff",
        itemId: "T7_2H_ICEGAUNTLETS_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Icicle Staff",
        itemId: "T6_2H_ICEGAUNTLETS_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Icicle Staff",
        itemId: "T8_2H_ICEGAUNTLETS_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Permafrost Prism",
        itemId: "T4_2H_ICECRYSTAL_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Permafrost Prism",
        itemId: "T5_2H_ICECRYSTAL_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Icicle Staff",
        itemId: "T5_2H_ICEGAUNTLETS_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Permafrost Prism",
        itemId: "T6_2H_ICECRYSTAL_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Permafrost Prism",
        itemId: "T7_2H_ICECRYSTAL_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Chillhowl",
        itemId: "T5_MAIN_FROSTSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Permafrost Prism",
        itemId: "T8_2H_ICECRYSTAL_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Chillhowl",
        itemId: "T6_MAIN_FROSTSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Chillhowl",
        itemId: "T7_MAIN_FROSTSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Chillhowl",
        itemId: "T8_MAIN_FROSTSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Chillhowl",
        itemId: "T4_MAIN_FROSTSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Arcane Staff",
        itemId: "T5_MAIN_ARCANESTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Arcane Staff",
        itemId: "T7_MAIN_ARCANESTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Arcane Staff",
        itemId: "T4_MAIN_ARCANESTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Arcane Staff",
        itemId: "T6_MAIN_ARCANESTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Great Arcane Staff",
        itemId: "T5_2H_ARCANESTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Arcane Staff",
        itemId: "T8_MAIN_ARCANESTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Great Arcane Staff",
        itemId: "T4_2H_ARCANESTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Great Arcane Staff",
        itemId: "T6_2H_ARCANESTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Enigmatic Staff",
        itemId: "T6_2H_ENIGMATICSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Enigmatic Staff",
        itemId: "T5_2H_ENIGMATICSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Great Arcane Staff",
        itemId: "T8_2H_ARCANESTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Great Arcane Staff",
        itemId: "T7_2H_ARCANESTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Enigmatic Staff",
        itemId: "T4_2H_ENIGMATICSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Enigmatic Staff",
        itemId: "T7_2H_ENIGMATICSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Witchwork Staff",
        itemId: "T4_MAIN_ARCANESTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Enigmatic Staff",
        itemId: "T8_2H_ENIGMATICSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Witchwork Staff",
        itemId: "T7_MAIN_ARCANESTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Witchwork Staff",
        itemId: "T5_MAIN_ARCANESTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Witchwork Staff",
        itemId: "T8_MAIN_ARCANESTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Witchwork Staff",
        itemId: "T6_MAIN_ARCANESTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Occult Staff",
        itemId: "T5_2H_ARCANESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Occult Staff",
        itemId: "T6_2H_ARCANESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Occult Staff",
        itemId: "T4_2H_ARCANESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Occult Staff",
        itemId: "T7_2H_ARCANESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Malevolent Locus",
        itemId: "T4_2H_ENIGMATICORB_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Malevolent Locus",
        itemId: "T5_2H_ENIGMATICORB_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Occult Staff",
        itemId: "T8_2H_ARCANESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Malevolent Locus",
        itemId: "T6_2H_ENIGMATICORB_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Malevolent Locus",
        itemId: "T7_2H_ENIGMATICORB_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Malevolent Locus",
        itemId: "T8_2H_ENIGMATICORB_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Evensong",
        itemId: "T7_2H_ARCANE_RINGPAIR_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Evensong",
        itemId: "T4_2H_ARCANE_RINGPAIR_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Evensong",
        itemId: "T5_2H_ARCANE_RINGPAIR_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Evensong",
        itemId: "T6_2H_ARCANE_RINGPAIR_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Evensong",
        itemId: "T8_2H_ARCANE_RINGPAIR_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Holy Staff",
        itemId: "T5_MAIN_HOLYSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Holy Staff",
        itemId: "T7_MAIN_HOLYSTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Holy Staff",
        itemId: "T6_MAIN_HOLYSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Holy Staff",
        itemId: "T4_MAIN_HOLYSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Great Holy Staff",
        itemId: "T4_2H_HOLYSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Great Holy Staff",
        itemId: "T5_2H_HOLYSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Great Holy Staff",
        itemId: "T7_2H_HOLYSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Great Holy Staff",
        itemId: "T8_2H_HOLYSTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Great Holy Staff",
        itemId: "T6_2H_HOLYSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Divine Staff",
        itemId: "T4_2H_DIVINESTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Holy Staff",
        itemId: "T8_MAIN_HOLYSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Divine Staff",
        itemId: "T5_2H_DIVINESTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Lifetouch Staff",
        itemId: "T4_MAIN_HOLYSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Divine Staff",
        itemId: "T6_2H_DIVINESTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Divine Staff",
        itemId: "T8_2H_DIVINESTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Lifetouch Staff",
        itemId: "T5_MAIN_HOLYSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Lifetouch Staff",
        itemId: "T7_MAIN_HOLYSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Lifetouch Staff",
        itemId: "T8_MAIN_HOLYSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Lifetouch Staff",
        itemId: "T6_MAIN_HOLYSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Divine Staff",
        itemId: "T7_2H_DIVINESTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Fallen Staff",
        itemId: "T7_2H_HOLYSTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Fallen Staff",
        itemId: "T4_2H_HOLYSTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Fallen Staff",
        itemId: "T6_2H_HOLYSTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Fallen Staff",
        itemId: "T8_2H_HOLYSTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Fallen Staff",
        itemId: "T5_2H_HOLYSTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Redemption Staff",
        itemId: "T6_2H_HOLYSTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Redemption Staff",
        itemId: "T7_2H_HOLYSTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Redemption Staff",
        itemId: "T5_2H_HOLYSTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Redemption Staff",
        itemId: "T4_2H_HOLYSTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Redemption Staff",
        itemId: "T8_2H_HOLYSTAFF_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hallowfall",
        itemId: "T7_MAIN_HOLYSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Hallowfall",
        itemId: "T4_MAIN_HOLYSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Hallowfall",
        itemId: "T5_MAIN_HOLYSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Hallowfall",
        itemId: "T6_MAIN_HOLYSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Hallowfall",
        itemId: "T8_MAIN_HOLYSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Nature Staff",
        itemId: "T4_MAIN_NATURESTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Nature Staff",
        itemId: "T5_MAIN_NATURESTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Nature Staff",
        itemId: "T7_MAIN_NATURESTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Great Nature Staff",
        itemId: "T4_2H_NATURESTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Great Nature Staff",
        itemId: "T5_2H_NATURESTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Nature Staff",
        itemId: "T6_MAIN_NATURESTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Great Nature Staff",
        itemId: "T7_2H_NATURESTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Great Nature Staff",
        itemId: "T6_2H_NATURESTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Nature Staff",
        itemId: "T8_MAIN_NATURESTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Wild Staff",
        itemId: "T4_2H_WILDSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Great Nature Staff",
        itemId: "T8_2H_NATURESTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Wild Staff",
        itemId: "T6_2H_WILDSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Wild Staff",
        itemId: "T5_2H_WILDSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Wild Staff",
        itemId: "T7_2H_WILDSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Druidic Staff",
        itemId: "T4_MAIN_NATURESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Druidic Staff",
        itemId: "T5_MAIN_NATURESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Wild Staff",
        itemId: "T8_2H_WILDSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Druidic Staff",
        itemId: "T7_MAIN_NATURESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Druidic Staff",
        itemId: "T6_MAIN_NATURESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Blight Staff",
        itemId: "T4_2H_NATURESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Druidic Staff",
        itemId: "T8_MAIN_NATURESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Blight Staff",
        itemId: "T7_2H_NATURESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Blight Staff",
        itemId: "T6_2H_NATURESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Rampant Staff",
        itemId: "T4_2H_NATURESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Blight Staff",
        itemId: "T5_2H_NATURESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Rampant Staff",
        itemId: "T5_2H_NATURESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Rampant Staff",
        itemId: "T7_2H_NATURESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Rampant Staff",
        itemId: "T6_2H_NATURESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Ironroot Staff",
        itemId: "T5_MAIN_NATURESTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Ironroot Staff",
        itemId: "T4_MAIN_NATURESTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Rampant Staff",
        itemId: "T8_2H_NATURESTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Ironroot Staff",
        itemId: "T7_MAIN_NATURESTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Blight Staff",
        itemId: "T8_2H_NATURESTAFF_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Dagger",
        itemId: "T4_MAIN_DAGGER",
        canEnchant: true
    },
{
        itemName: "Elder's Ironroot Staff",
        itemId: "T8_MAIN_NATURESTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Ironroot Staff",
        itemId: "T6_MAIN_NATURESTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Dagger",
        itemId: "T5_MAIN_DAGGER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Dagger",
        itemId: "T7_MAIN_DAGGER",
        canEnchant: true
    },
{
        itemName: "Elder's Dagger",
        itemId: "T8_MAIN_DAGGER",
        canEnchant: true
    },
{
        itemName: "Master's Dagger",
        itemId: "T6_MAIN_DAGGER",
        canEnchant: true
    },
{
        itemName: "Expert's Dagger Pair",
        itemId: "T5_2H_DAGGERPAIR",
        canEnchant: true
    },
{
        itemName: "Master's Dagger Pair",
        itemId: "T6_2H_DAGGERPAIR",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Dagger Pair",
        itemId: "T7_2H_DAGGERPAIR",
        canEnchant: true
    },
{
        itemName: "Adept's Dagger Pair",
        itemId: "T4_2H_DAGGERPAIR",
        canEnchant: true
    },
{
        itemName: "Elder's Dagger Pair",
        itemId: "T8_2H_DAGGERPAIR",
        canEnchant: true
    },
{
        itemName: "Expert's Claws",
        itemId: "T5_2H_CLAWPAIR",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Claws",
        itemId: "T7_2H_CLAWPAIR",
        canEnchant: true
    },
{
        itemName: "Master's Claws",
        itemId: "T6_2H_CLAWPAIR",
        canEnchant: true
    },
{
        itemName: "Adept's Bloodletter",
        itemId: "T4_MAIN_RAPIER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Bloodletter",
        itemId: "T6_MAIN_RAPIER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Claws",
        itemId: "T8_2H_CLAWPAIR",
        canEnchant: true
    },
{
        itemName: "Expert's Bloodletter",
        itemId: "T5_MAIN_RAPIER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Bloodletter",
        itemId: "T7_MAIN_RAPIER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Bloodletter",
        itemId: "T8_MAIN_RAPIER_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Demonfang",
        itemId: "T6_MAIN_DAGGER_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Claws",
        itemId: "T4_2H_CLAWPAIR",
        canEnchant: true
    },
{
        itemName: "Expert's Demonfang",
        itemId: "T5_MAIN_DAGGER_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Demonfang",
        itemId: "T7_MAIN_DAGGER_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Black Hands",
        itemId: "T4_2H_IRONGAUNTLETS_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Black Hands",
        itemId: "T5_2H_IRONGAUNTLETS_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Demonfang",
        itemId: "T4_MAIN_DAGGER_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Demonfang",
        itemId: "T8_MAIN_DAGGER_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Black Hands",
        itemId: "T7_2H_IRONGAUNTLETS_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Deathgivers",
        itemId: "T4_2H_DUALSICKLE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Black Hands",
        itemId: "T6_2H_IRONGAUNTLETS_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Black Hands",
        itemId: "T8_2H_IRONGAUNTLETS_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Deathgivers",
        itemId: "T5_2H_DUALSICKLE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Deathgivers",
        itemId: "T8_2H_DUALSICKLE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Deathgivers",
        itemId: "T6_2H_DUALSICKLE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Bridled Fury",
        itemId: "T4_2H_DAGGER_KATAR_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Bridled Fury",
        itemId: "T5_2H_DAGGER_KATAR_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Deathgivers",
        itemId: "T7_2H_DUALSICKLE_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Bridled Fury",
        itemId: "T7_2H_DAGGER_KATAR_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Spear",
        itemId: "T5_MAIN_SPEAR",
        canEnchant: true
    },
{
        itemName: "Master's Bridled Fury",
        itemId: "T6_2H_DAGGER_KATAR_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Bridled Fury",
        itemId: "T8_2H_DAGGER_KATAR_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Spear",
        itemId: "T4_MAIN_SPEAR",
        canEnchant: true
    },
{
        itemName: "Master's Spear",
        itemId: "T6_MAIN_SPEAR",
        canEnchant: true
    },
{
        itemName: "Expert's Pike",
        itemId: "T5_2H_SPEAR",
        canEnchant: true
    },
{
        itemName: "Elder's Spear",
        itemId: "T8_MAIN_SPEAR",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Spear",
        itemId: "T7_MAIN_SPEAR",
        canEnchant: true
    },
{
        itemName: "Adept's Pike",
        itemId: "T4_2H_SPEAR",
        canEnchant: true
    },
{
        itemName: "Elder's Pike",
        itemId: "T8_2H_SPEAR",
        canEnchant: true
    },
{
        itemName: "Adept's Glaive",
        itemId: "T4_2H_GLAIVE",
        canEnchant: true
    },
{
        itemName: "Master's Pike",
        itemId: "T6_2H_SPEAR",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Pike",
        itemId: "T7_2H_SPEAR",
        canEnchant: true
    },
{
        itemName: "Master's Glaive",
        itemId: "T6_2H_GLAIVE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Glaive",
        itemId: "T7_2H_GLAIVE",
        canEnchant: true
    },
{
        itemName: "Expert's Glaive",
        itemId: "T5_2H_GLAIVE",
        canEnchant: true
    },
{
        itemName: "Adept's Heron Spear",
        itemId: "T4_MAIN_SPEAR_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Heron Spear",
        itemId: "T5_MAIN_SPEAR_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Glaive",
        itemId: "T8_2H_GLAIVE",
        canEnchant: true
    },
{
        itemName: "Elder's Heron Spear",
        itemId: "T8_MAIN_SPEAR_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Heron Spear",
        itemId: "T7_MAIN_SPEAR_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Heron Spear",
        itemId: "T6_MAIN_SPEAR_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Spirithunter",
        itemId: "T5_2H_HARPOON_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Spirithunter",
        itemId: "T7_2H_HARPOON_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Spirithunter",
        itemId: "T4_2H_HARPOON_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Spirithunter",
        itemId: "T6_2H_HARPOON_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Trinity Spear",
        itemId: "T4_2H_TRIDENT_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Trinity Spear",
        itemId: "T7_2H_TRIDENT_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Trinity Spear",
        itemId: "T5_2H_TRIDENT_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Spirithunter",
        itemId: "T8_2H_HARPOON_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Trinity Spear",
        itemId: "T6_2H_TRIDENT_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Daybreaker",
        itemId: "T6_MAIN_SPEAR_LANCE_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Daybreaker",
        itemId: "T4_MAIN_SPEAR_LANCE_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Daybreaker",
        itemId: "T5_MAIN_SPEAR_LANCE_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Daybreaker",
        itemId: "T7_MAIN_SPEAR_LANCE_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Battleaxe",
        itemId: "T5_MAIN_AXE",
        canEnchant: true
    },
{
        itemName: "Elder's Trinity Spear",
        itemId: "T8_2H_TRIDENT_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Battleaxe",
        itemId: "T6_MAIN_AXE",
        canEnchant: true
    },
{
        itemName: "Elder's Battleaxe",
        itemId: "T8_MAIN_AXE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Battleaxe",
        itemId: "T7_MAIN_AXE",
        canEnchant: true
    },
{
        itemName: "Adept's Battleaxe",
        itemId: "T4_MAIN_AXE",
        canEnchant: true
    },
{
        itemName: "Elder's Daybreaker",
        itemId: "T8_MAIN_SPEAR_LANCE_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Greataxe",
        itemId: "T5_2H_AXE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Greataxe",
        itemId: "T7_2H_AXE",
        canEnchant: true
    },
{
        itemName: "Adept's Greataxe",
        itemId: "T4_2H_AXE",
        canEnchant: true
    },
{
        itemName: "Master's Greataxe",
        itemId: "T6_2H_AXE",
        canEnchant: true
    },
{
        itemName: "The Hand of Khor",
        itemId: "T8_2H_AXE",
        canEnchant: true
    },
{
        itemName: "Adept's Halberd",
        itemId: "T4_2H_HALBERD",
        canEnchant: true
    },
{
        itemName: "Expert's Halberd",
        itemId: "T5_2H_HALBERD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Halberd",
        itemId: "T7_2H_HALBERD",
        canEnchant: true
    },
{
        itemName: "Expert's Carrioncaller",
        itemId: "T5_2H_HALBERD_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Halberd",
        itemId: "T6_2H_HALBERD",
        canEnchant: true
    },
{
        itemName: "Master's Carrioncaller",
        itemId: "T6_2H_HALBERD_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Halberd",
        itemId: "T8_2H_HALBERD",
        canEnchant: true
    },
{
        itemName: "Adept's Infernal Scythe",
        itemId: "T4_2H_SCYTHE_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Carrioncaller",
        itemId: "T7_2H_HALBERD_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Infernal Scythe",
        itemId: "T5_2H_SCYTHE_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Infernal Scythe",
        itemId: "T7_2H_SCYTHE_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Carrioncaller",
        itemId: "T8_2H_HALBERD_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Carrioncaller",
        itemId: "T4_2H_HALBERD_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Infernal Scythe",
        itemId: "T8_2H_SCYTHE_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Infernal Scythe",
        itemId: "T6_2H_SCYTHE_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Bear Paws",
        itemId: "T6_2H_DUALAXE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Bear Paws",
        itemId: "T4_2H_DUALAXE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Bear Paws",
        itemId: "T7_2H_DUALAXE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Bear Paws",
        itemId: "T8_2H_DUALAXE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Bear Paws",
        itemId: "T5_2H_DUALAXE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Realmbreaker",
        itemId: "T4_2H_AXE_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Realmbreaker",
        itemId: "T5_2H_AXE_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Realmbreaker",
        itemId: "T7_2H_AXE_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Realmbreaker",
        itemId: "T6_2H_AXE_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Realmbreaker",
        itemId: "T8_2H_AXE_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Broadsword",
        itemId: "T4_MAIN_SWORD",
        canEnchant: true
    },
{
        itemName: "Master's Broadsword",
        itemId: "T6_MAIN_SWORD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Broadsword",
        itemId: "T7_MAIN_SWORD",
        canEnchant: true
    },
{
        itemName: "Expert's Broadsword",
        itemId: "T5_MAIN_SWORD",
        canEnchant: true
    },
{
        itemName: "Adept's Claymore",
        itemId: "T4_2H_CLAYMORE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Claymore",
        itemId: "T7_2H_CLAYMORE",
        canEnchant: true
    },
{
        itemName: "Elder's Broadsword",
        itemId: "T8_MAIN_SWORD",
        canEnchant: true
    },
{
        itemName: "Adept's Dual Swords",
        itemId: "T4_2H_DUALSWORD",
        canEnchant: true
    },
{
        itemName: "Master's Claymore",
        itemId: "T6_2H_CLAYMORE",
        canEnchant: true
    },
{
        itemName: "Expert's Claymore",
        itemId: "T5_2H_CLAYMORE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Dual Swords",
        itemId: "T7_2H_DUALSWORD",
        canEnchant: true
    },
{
        itemName: "Expert's Dual Swords",
        itemId: "T5_2H_DUALSWORD",
        canEnchant: true
    },
{
        itemName: "Elder's Claymore",
        itemId: "T8_2H_CLAYMORE",
        canEnchant: true
    },
{
        itemName: "Master's Dual Swords",
        itemId: "T6_2H_DUALSWORD",
        canEnchant: true
    },
{
        itemName: "Adept's Clarent Blade",
        itemId: "T4_MAIN_SCIMITAR_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Clarent Blade",
        itemId: "T5_MAIN_SCIMITAR_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Dual Swords",
        itemId: "T8_2H_DUALSWORD",
        canEnchant: true
    },
{
        itemName: "Master's Clarent Blade",
        itemId: "T6_MAIN_SCIMITAR_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Carving Sword",
        itemId: "T4_2H_CLEAVER_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Clarent Blade",
        itemId: "T7_MAIN_SCIMITAR_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Clarent Blade",
        itemId: "T8_MAIN_SCIMITAR_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Carving Sword",
        itemId: "T7_2H_CLEAVER_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Carving Sword",
        itemId: "T5_2H_CLEAVER_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Carving Sword",
        itemId: "T6_2H_CLEAVER_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Galatine Pair",
        itemId: "T5_2H_DUALSCIMITAR_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Galatine Pair",
        itemId: "T4_2H_DUALSCIMITAR_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Carving Sword",
        itemId: "T8_2H_CLEAVER_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Galatine Pair",
        itemId: "T6_2H_DUALSCIMITAR_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Kingmaker",
        itemId: "T4_2H_CLAYMORE_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Kingmaker",
        itemId: "T5_2H_CLAYMORE_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Galatine Pair",
        itemId: "T7_2H_DUALSCIMITAR_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Kingmaker",
        itemId: "T8_2H_CLAYMORE_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Kingmaker",
        itemId: "T7_2H_CLAYMORE_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Kingmaker",
        itemId: "T6_2H_CLAYMORE_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Galatine Pair",
        itemId: "T8_2H_DUALSCIMITAR_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Adept's Quarterstaff",
        itemId: "T4_2H_QUARTERSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Quarterstaff",
        itemId: "T5_2H_QUARTERSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Iron-clad Staff",
        itemId: "T5_2H_IRONCLADEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Quarterstaff",
        itemId: "T6_2H_QUARTERSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Quarterstaff",
        itemId: "T7_2H_QUARTERSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Iron-clad Staff",
        itemId: "T7_2H_IRONCLADEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Iron-clad Staff",
        itemId: "T6_2H_IRONCLADEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Iron-clad Staff",
        itemId: "T4_2H_IRONCLADEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Quarterstaff",
        itemId: "T8_2H_QUARTERSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Double Bladed Staff",
        itemId: "T4_2H_DOUBLEBLADEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Expert's Double Bladed Staff",
        itemId: "T5_2H_DOUBLEBLADEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Double Bladed Staff",
        itemId: "T7_2H_DOUBLEBLADEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Master's Double Bladed Staff",
        itemId: "T6_2H_DOUBLEBLADEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Double Bladed Staff",
        itemId: "T8_2H_DOUBLEBLADEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Elder's Iron-clad Staff",
        itemId: "T8_2H_IRONCLADEDSTAFF",
        canEnchant: true
    },
{
        itemName: "Adept's Black Monk Stave",
        itemId: "T4_2H_COMBATSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Black Monk Stave",
        itemId: "T5_2H_COMBATSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Black Monk Stave",
        itemId: "T8_2H_COMBATSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Black Monk Stave",
        itemId: "T6_2H_COMBATSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Black Monk Stave",
        itemId: "T7_2H_COMBATSTAFF_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Soulscythe",
        itemId: "T4_2H_TWINSCYTHE_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Soulscythe",
        itemId: "T5_2H_TWINSCYTHE_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Soulscythe",
        itemId: "T6_2H_TWINSCYTHE_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Staff of Balance",
        itemId: "T4_2H_ROCKSTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Staff of Balance",
        itemId: "T5_2H_ROCKSTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Soulscythe",
        itemId: "T8_2H_TWINSCYTHE_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Soulscythe",
        itemId: "T7_2H_TWINSCYTHE_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Staff of Balance",
        itemId: "T7_2H_ROCKSTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Staff of Balance",
        itemId: "T8_2H_ROCKSTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Staff of Balance",
        itemId: "T6_2H_ROCKSTAFF_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Grailseeker",
        itemId: "T5_2H_QUARTERSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Grailseeker",
        itemId: "T4_2H_QUARTERSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Grailseeker",
        itemId: "T7_2H_QUARTERSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Hammer",
        itemId: "T4_MAIN_HAMMER",
        canEnchant: true
    },
{
        itemName: "Elder's Grailseeker",
        itemId: "T8_2H_QUARTERSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Grailseeker",
        itemId: "T6_2H_QUARTERSTAFF_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Hammer",
        itemId: "T5_MAIN_HAMMER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hammer",
        itemId: "T7_MAIN_HAMMER",
        canEnchant: true
    },
{
        itemName: "Master's Hammer",
        itemId: "T6_MAIN_HAMMER",
        canEnchant: true
    },
{
        itemName: "Expert's Polehammer",
        itemId: "T5_2H_POLEHAMMER",
        canEnchant: true
    },
{
        itemName: "Adept's Polehammer",
        itemId: "T4_2H_POLEHAMMER",
        canEnchant: true
    },
{
        itemName: "Master's Polehammer",
        itemId: "T6_2H_POLEHAMMER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Polehammer",
        itemId: "T7_2H_POLEHAMMER",
        canEnchant: true
    },
{
        itemName: "Elder's Hammer",
        itemId: "T8_MAIN_HAMMER",
        canEnchant: true
    },
{
        itemName: "Elder's Polehammer",
        itemId: "T8_2H_POLEHAMMER",
        canEnchant: true
    },
{
        itemName: "Adept's Great Hammer",
        itemId: "T4_2H_HAMMER",
        canEnchant: true
    },
{
        itemName: "Expert's Great Hammer",
        itemId: "T5_2H_HAMMER",
        canEnchant: true
    },
{
        itemName: "Master's Great Hammer",
        itemId: "T6_2H_HAMMER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Great Hammer",
        itemId: "T7_2H_HAMMER",
        canEnchant: true
    },
{
        itemName: "Adept's Tombhammer",
        itemId: "T4_2H_HAMMER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Tombhammer",
        itemId: "T5_2H_HAMMER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Master's Tombhammer",
        itemId: "T6_2H_HAMMER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Tombhammer",
        itemId: "T7_2H_HAMMER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Elder's Great Hammer",
        itemId: "T8_2H_HAMMER",
        canEnchant: true
    },
{
        itemName: "Elder's Tombhammer",
        itemId: "T8_2H_HAMMER_UNDEAD",
        canEnchant: true
    },
{
        itemName: "Expert's Forge Hammers",
        itemId: "T5_2H_DUALHAMMER_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Forge Hammers",
        itemId: "T4_2H_DUALHAMMER_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Forge Hammers",
        itemId: "T7_2H_DUALHAMMER_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Forge Hammers",
        itemId: "T6_2H_DUALHAMMER_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Grovekeeper",
        itemId: "T4_2H_RAM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Forge Hammers",
        itemId: "T8_2H_DUALHAMMER_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Grovekeeper",
        itemId: "T5_2H_RAM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Grovekeeper",
        itemId: "T7_2H_RAM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Hand of Justice",
        itemId: "T4_2H_HAMMER_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Hand of Justice",
        itemId: "T5_2H_HAMMER_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Hand of Justice",
        itemId: "T6_2H_HAMMER_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Grovekeeper",
        itemId: "T6_2H_RAM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hand of Justice",
        itemId: "T7_2H_HAMMER_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Grovekeeper",
        itemId: "T8_2H_RAM_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Hand of Justice",
        itemId: "T8_2H_HAMMER_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Mace",
        itemId: "T5_MAIN_MACE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Mace",
        itemId: "T7_MAIN_MACE",
        canEnchant: true
    },
{
        itemName: "Adept's Mace",
        itemId: "T4_MAIN_MACE",
        canEnchant: true
    },
{
        itemName: "Master's Mace",
        itemId: "T6_MAIN_MACE",
        canEnchant: true
    },
{
        itemName: "Adept's Heavy Mace",
        itemId: "T4_2H_MACE",
        canEnchant: true
    },
{
        itemName: "Expert's Heavy Mace",
        itemId: "T5_2H_MACE",
        canEnchant: true
    },
{
        itemName: "Master's Heavy Mace",
        itemId: "T6_2H_MACE",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Heavy Mace",
        itemId: "T7_2H_MACE",
        canEnchant: true
    },
{
        itemName: "Elder's Heavy Mace",
        itemId: "T8_2H_MACE",
        canEnchant: true
    },
{
        itemName: "Elder's Mace",
        itemId: "T8_MAIN_MACE",
        canEnchant: true
    },
{
        itemName: "Adept's Morning Star",
        itemId: "T4_2H_FLAIL",
        canEnchant: true
    },
{
        itemName: "Master's Morning Star",
        itemId: "T6_2H_FLAIL",
        canEnchant: true
    },
{
        itemName: "Elder's Morning Star",
        itemId: "T8_2H_FLAIL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Morning Star",
        itemId: "T7_2H_FLAIL",
        canEnchant: true
    },
{
        itemName: "Expert's Bedrock Mace",
        itemId: "T5_MAIN_ROCKMACE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Master's Bedrock Mace",
        itemId: "T6_MAIN_ROCKMACE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Bedrock Mace",
        itemId: "T7_MAIN_ROCKMACE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Bedrock Mace",
        itemId: "T4_MAIN_ROCKMACE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Incubus Mace",
        itemId: "T4_MAIN_MACE_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Bedrock Mace",
        itemId: "T8_MAIN_ROCKMACE_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Incubus Mace",
        itemId: "T7_MAIN_MACE_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Morning Star",
        itemId: "T5_2H_FLAIL",
        canEnchant: true
    },
{
        itemName: "Expert's Incubus Mace",
        itemId: "T5_MAIN_MACE_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Incubus Mace",
        itemId: "T6_MAIN_MACE_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Incubus Mace",
        itemId: "T8_MAIN_MACE_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Camlann Mace",
        itemId: "T4_2H_MACE_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Camlann Mace",
        itemId: "T6_2H_MACE_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Camlann Mace",
        itemId: "T5_2H_MACE_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Oathkeepers",
        itemId: "T4_2H_DUALMACE_AVALON",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Camlann Mace",
        itemId: "T7_2H_MACE_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Oathkeepers",
        itemId: "T7_2H_DUALMACE_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Oathkeepers",
        itemId: "T5_2H_DUALMACE_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Camlann Mace",
        itemId: "T8_2H_MACE_MORGANA",
        canEnchant: true
    },
{
        itemName: "Adept's Brawler Gloves",
        itemId: "T4_2H_KNUCKLES_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Oathkeepers",
        itemId: "T6_2H_DUALMACE_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Oathkeepers",
        itemId: "T8_2H_DUALMACE_AVALON",
        canEnchant: true
    },
{
        itemName: "Expert's Brawler Gloves",
        itemId: "T5_2H_KNUCKLES_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Brawler Gloves",
        itemId: "T6_2H_KNUCKLES_SET1",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Brawler Gloves",
        itemId: "T7_2H_KNUCKLES_SET1",
        canEnchant: true
    },
{
        itemName: "Expert's Battle Bracers",
        itemId: "T5_2H_KNUCKLES_SET2",
        canEnchant: true
    },
{
        itemName: "Elder's Brawler Gloves",
        itemId: "T8_2H_KNUCKLES_SET1",
        canEnchant: true
    },
{
        itemName: "Master's Battle Bracers",
        itemId: "T6_2H_KNUCKLES_SET2",
        canEnchant: true
    },
{
        itemName: "Adept's Battle Bracers",
        itemId: "T4_2H_KNUCKLES_SET2",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Battle Bracers",
        itemId: "T7_2H_KNUCKLES_SET2",
        canEnchant: true
    },
{
        itemName: "Adept's Spiked Gauntlets",
        itemId: "T4_2H_KNUCKLES_SET3",
        canEnchant: true
    },
{
        itemName: "Expert's Spiked Gauntlets",
        itemId: "T5_2H_KNUCKLES_SET3",
        canEnchant: true
    },
{
        itemName: "Elder's Battle Bracers",
        itemId: "T8_2H_KNUCKLES_SET2",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Spiked Gauntlets",
        itemId: "T7_2H_KNUCKLES_SET3",
        canEnchant: true
    },
{
        itemName: "Master's Spiked Gauntlets",
        itemId: "T6_2H_KNUCKLES_SET3",
        canEnchant: true
    },
{
        itemName: "Expert's Ursine Maulers",
        itemId: "T5_2H_KNUCKLES_KEEPER",
        canEnchant: true
    },
{
        itemName: "Elder's Spiked Gauntlets",
        itemId: "T8_2H_KNUCKLES_SET3",
        canEnchant: true
    },
{
        itemName: "Master's Ursine Maulers",
        itemId: "T6_2H_KNUCKLES_KEEPER",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Ursine Maulers",
        itemId: "T7_2H_KNUCKLES_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Ursine Maulers",
        itemId: "T4_2H_KNUCKLES_KEEPER",
        canEnchant: true
    },
{
        itemName: "Adept's Hellfire Hands",
        itemId: "T4_2H_KNUCKLES_HELL",
        canEnchant: true
    },
{
        itemName: "Elder's Ursine Maulers",
        itemId: "T8_2H_KNUCKLES_KEEPER",
        canEnchant: true
    },
{
        itemName: "Expert's Hellfire Hands",
        itemId: "T5_2H_KNUCKLES_HELL",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Hellfire Hands",
        itemId: "T7_2H_KNUCKLES_HELL",
        canEnchant: true
    },
{
        itemName: "Adept's Ravenstrike Cestus",
        itemId: "T4_2H_KNUCKLES_MORGANA",
        canEnchant: true
    },
{
        itemName: "Expert's Ravenstrike Cestus",
        itemId: "T5_2H_KNUCKLES_MORGANA",
        canEnchant: true
    },
{
        itemName: "Master's Hellfire Hands",
        itemId: "T6_2H_KNUCKLES_HELL",
        canEnchant: true
    },
{
        itemName: "Master's Ravenstrike Cestus",
        itemId: "T6_2H_KNUCKLES_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Ravenstrike Cestus",
        itemId: "T7_2H_KNUCKLES_MORGANA",
        canEnchant: true
    },
{
        itemName: "Elder's Ravenstrike Cestus",
        itemId: "T8_2H_KNUCKLES_MORGANA",
        canEnchant: true
    },
{
        itemName: "Grandmaster's Fists of Avalon",
        itemId: "T7_2H_KNUCKLES_AVALON",
        canEnchant: true
    },
{
        itemName: "Elder's Hellfire Hands",
        itemId: "T8_2H_KNUCKLES_HELL",
        canEnchant: true
    },
{
        itemName: "Expert's Fists of Avalon",
        itemId: "T5_2H_KNUCKLES_AVALON",
        canEnchant: true
    },
{
        itemName: "Adept's Fists of Avalon",
        itemId: "T4_2H_KNUCKLES_AVALON",
        canEnchant: true
    },
{
        itemName: "Master's Fists of Avalon",
        itemId: "T6_2H_KNUCKLES_AVALON",
        canEnchant: true
    },
{
        itemName: "Uncommon Master's Dungeon Map (Large Group)",
        itemId: "T6_RANDOM_DUNGEON_ELITE_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Uncommon Grandmaster's Dungeon Map (Large Group)",
        itemId: "T7_RANDOM_DUNGEON_ELITE_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Rare Grandmaster's Dungeon Map (Large Group)",
        itemId: "T7_RANDOM_DUNGEON_ELITE_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Elder's Fists of Avalon",
        itemId: "T8_2H_KNUCKLES_AVALON",
        canEnchant: true
    },
{
        itemName: "Uncommon Elder's Dungeon Map (Large Group)",
        itemId: "T8_RANDOM_DUNGEON_ELITE_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Exceptional Elder's Dungeon Map (Large Group)",
        itemId: "T8_RANDOM_DUNGEON_ELITE_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Exceptional Master's Dungeon Map (Large Group)",
        itemId: "T6_RANDOM_DUNGEON_ELITE_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Rare Master's Dungeon Map (Large Group)",
        itemId: "T6_RANDOM_DUNGEON_ELITE_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Exceptional Grandmaster's Dungeon Map (Large Group)",
        itemId: "T7_RANDOM_DUNGEON_ELITE_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Uncommon Adept's Dungeon Map (Solo)",
        itemId: "T4_RANDOM_DUNGEON_SOLO_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Rare Elder's Dungeon Map (Large Group)",
        itemId: "T8_RANDOM_DUNGEON_ELITE_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Uncommon Grandmaster's Dungeon Map (Solo)",
        itemId: "T7_RANDOM_DUNGEON_SOLO_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Uncommon Master's Dungeon Map (Solo)",
        itemId: "T6_RANDOM_DUNGEON_SOLO_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Uncommon Expert's Dungeon Map (Solo)",
        itemId: "T5_RANDOM_DUNGEON_SOLO_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Uncommon Elder's Dungeon Map (Solo)",
        itemId: "T8_RANDOM_DUNGEON_SOLO_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Rare Grandmaster's Dungeon Map (Solo)",
        itemId: "T7_RANDOM_DUNGEON_SOLO_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Rare Expert's Dungeon Map (Solo)",
        itemId: "T5_RANDOM_DUNGEON_SOLO_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Exceptional Expert's Dungeon Map (Solo)",
        itemId: "T5_RANDOM_DUNGEON_SOLO_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Rare Master's Dungeon Map (Solo)",
        itemId: "T6_RANDOM_DUNGEON_SOLO_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Exceptional Adept's Dungeon Map (Solo)",
        itemId: "T4_RANDOM_DUNGEON_SOLO_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Exceptional Master's Dungeon Map (Solo)",
        itemId: "T6_RANDOM_DUNGEON_SOLO_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Rare Adept's Dungeon Map (Solo)",
        itemId: "T4_RANDOM_DUNGEON_SOLO_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Exceptional Elder's Dungeon Map (Solo)",
        itemId: "T8_RANDOM_DUNGEON_SOLO_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Exceptional Grandmaster's Dungeon Map (Solo)",
        itemId: "T7_RANDOM_DUNGEON_SOLO_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Rare Elder's Dungeon Map (Solo)",
        itemId: "T8_RANDOM_DUNGEON_SOLO_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Uncommon Expert's Dungeon Map (Group)",
        itemId: "T5_RANDOM_DUNGEON_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Uncommon Grandmaster's Dungeon Map (Group)",
        itemId: "T7_RANDOM_DUNGEON_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Uncommon Elder's Dungeon Map (Group)",
        itemId: "T8_RANDOM_DUNGEON_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Uncommon Master's Dungeon Map (Group)",
        itemId: "T6_RANDOM_DUNGEON_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Rare Adept's Dungeon Map (Group)",
        itemId: "T4_RANDOM_DUNGEON_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Rare Master's Dungeon Map (Group)",
        itemId: "T6_RANDOM_DUNGEON_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Rare Grandmaster's Dungeon Map (Group)",
        itemId: "T7_RANDOM_DUNGEON_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Exceptional Expert's Dungeon Map (Group)",
        itemId: "T5_RANDOM_DUNGEON_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Uncommon Adept's Dungeon Map (Group)",
        itemId: "T4_RANDOM_DUNGEON_TOKEN_2",
        canEnchant: true
    },
{
        itemName: "Exceptional Adept's Dungeon Map (Group)",
        itemId: "T4_RANDOM_DUNGEON_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Exceptional Master's Dungeon Map (Group)",
        itemId: "T6_RANDOM_DUNGEON_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Rare Expert's Dungeon Map (Group)",
        itemId: "T5_RANDOM_DUNGEON_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Rare Elder's Dungeon Map (Group)",
        itemId: "T8_RANDOM_DUNGEON_TOKEN_3",
        canEnchant: true
    },
{
        itemName: "Exceptional Elder's Dungeon Map (Group)",
        itemId: "T8_RANDOM_DUNGEON_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "Exceptional Grandmaster's Dungeon Map (Group)",
        itemId: "T7_RANDOM_DUNGEON_TOKEN_4",
        canEnchant: true
    },
{
        itemName: "undefined",
        itemId: "T7_MAIN_SUMMONERSTAFF_PROTOTYPE",
        canEnchant: true
    },
{
        itemName: "Wheat Seeds",
        itemId: "T3_FARM_WHEAT_SEED",
        canEnchant: false
    },
{
        itemName: "Hideout Construction Kit",
        itemId: "UNIQUE_HIDEOUT",
        canEnchant: false
    },
{
        itemName: "Carrot Seeds",
        itemId: "T1_FARM_CARROT_SEED",
        canEnchant: false
    },
{
        itemName: "Bean Seeds",
        itemId: "T2_FARM_BEAN_SEED",
        canEnchant: false
    },
{
        itemName: "Turnip Seeds",
        itemId: "T4_FARM_TURNIP_SEED",
        canEnchant: false
    },
{
        itemName: "Cabbage Seeds",
        itemId: "T5_FARM_CABBAGE_SEED",
        canEnchant: false
    },
{
        itemName: "Pumpkin Seeds",
        itemId: "T8_FARM_PUMPKIN_SEED",
        canEnchant: false
    },
{
        itemName: "Potato Seeds",
        itemId: "T6_FARM_POTATO_SEED",
        canEnchant: false
    },
{
        itemName: "Arcane Agaric Seeds",
        itemId: "T2_FARM_AGARIC_SEED",
        canEnchant: false
    },
{
        itemName: "Brightleaf Comfrey Seeds",
        itemId: "T3_FARM_COMFREY_SEED",
        canEnchant: false
    },
{
        itemName: "Crenellated Burdock Seeds",
        itemId: "T4_FARM_BURDOCK_SEED",
        canEnchant: false
    },
{
        itemName: "Corn Seeds",
        itemId: "T7_FARM_CORN_SEED",
        canEnchant: false
    },
{
        itemName: "Elusive Foxglove Seeds",
        itemId: "T6_FARM_FOXGLOVE_SEED",
        canEnchant: false
    },
{
        itemName: "Firetouched Mullein Seeds",
        itemId: "T7_FARM_MULLEIN_SEED",
        canEnchant: false
    },
{
        itemName: "Dragon Teasel Seeds",
        itemId: "T5_FARM_TEASEL_SEED",
        canEnchant: false
    },
{
        itemName: "Ghoul Yarrow Seeds",
        itemId: "T8_FARM_YARROW_SEED",
        canEnchant: false
    },
{
        itemName: "Journeyman's Ox Calf",
        itemId: "T3_FARM_OX_BABY",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ox Calf",
        itemId: "T7_FARM_OX_BABY",
        canEnchant: false
    },
{
        itemName: "Adept's Ox Calf",
        itemId: "T4_FARM_OX_BABY",
        canEnchant: false
    },
{
        itemName: "Master's Ox Calf",
        itemId: "T6_FARM_OX_BABY",
        canEnchant: false
    },
{
        itemName: "Elder's Ox Calf",
        itemId: "T8_FARM_OX_BABY",
        canEnchant: false
    },
{
        itemName: "Journeyman's Ox",
        itemId: "T3_FARM_OX_GROWN",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ox",
        itemId: "T7_FARM_OX_GROWN",
        canEnchant: false
    },
{
        itemName: "Expert's Ox Calf",
        itemId: "T5_FARM_OX_BABY",
        canEnchant: false
    },
{
        itemName: "Elder's Ox",
        itemId: "T8_FARM_OX_GROWN",
        canEnchant: false
    },
{
        itemName: "Master's Ox",
        itemId: "T6_FARM_OX_GROWN",
        canEnchant: false
    },
{
        itemName: "Journeyman's Foal",
        itemId: "T3_FARM_HORSE_BABY",
        canEnchant: false
    },
{
        itemName: "Adept's Ox",
        itemId: "T4_FARM_OX_GROWN",
        canEnchant: false
    },
{
        itemName: "Expert's Ox",
        itemId: "T5_FARM_OX_GROWN",
        canEnchant: false
    },
{
        itemName: "Adept's Foal",
        itemId: "T4_FARM_HORSE_BABY",
        canEnchant: false
    },
{
        itemName: "Master's Foal",
        itemId: "T6_FARM_HORSE_BABY",
        canEnchant: false
    },
{
        itemName: "Adept's Horse",
        itemId: "T4_FARM_HORSE_GROWN",
        canEnchant: false
    },
{
        itemName: "Expert's Horse",
        itemId: "T5_FARM_HORSE_GROWN",
        canEnchant: false
    },
{
        itemName: "Expert's Foal",
        itemId: "T5_FARM_HORSE_BABY",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Foal",
        itemId: "T7_FARM_HORSE_BABY",
        canEnchant: false
    },
{
        itemName: "Journeyman's Horse",
        itemId: "T3_FARM_HORSE_GROWN",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Horse",
        itemId: "T7_FARM_HORSE_GROWN",
        canEnchant: false
    },
{
        itemName: "Master's Horse",
        itemId: "T6_FARM_HORSE_GROWN",
        canEnchant: false
    },
{
        itemName: "Elder's Foal",
        itemId: "T8_FARM_HORSE_BABY",
        canEnchant: false
    },
{
        itemName: "Direboar Piglet",
        itemId: "T7_FARM_DIREBOAR_BABY",
        canEnchant: false
    },
{
        itemName: "Elder's Horse",
        itemId: "T8_FARM_HORSE_GROWN",
        canEnchant: false
    },
{
        itemName: "Swamp Dragon Pup",
        itemId: "T7_FARM_SWAMPDRAGON_BABY",
        canEnchant: false
    },
{
        itemName: "Adept's Fawn",
        itemId: "T4_FARM_GIANTSTAG_BABY",
        canEnchant: false
    },
{
        itemName: "Direwolf Pup",
        itemId: "T6_FARM_DIREWOLF_BABY",
        canEnchant: false
    },
{
        itemName: "Direbear Cub",
        itemId: "T8_FARM_DIREBEAR_BABY",
        canEnchant: false
    },
{
        itemName: "Master's Fawn",
        itemId: "T6_FARM_GIANTSTAG_BABY",
        canEnchant: false
    },
{
        itemName: "Swiftclaw Cub",
        itemId: "T5_FARM_COUGAR_BABY",
        canEnchant: false
    },
{
        itemName: "Ghostwolf Pup",
        itemId: "T8_FARM_DIREWOLF_BABY",
        canEnchant: false
    },
{
        itemName: "Baby Moabird",
        itemId: "T5_FARM_MOABIRD_FW_BRIDGEWATCH_BABY",
        canEnchant: false
    },
{
        itemName: "Mammoth Calf",
        itemId: "T8_FARM_MAMMOTH_BABY",
        canEnchant: false
    },
{
        itemName: "Wild Boarlet",
        itemId: "T5_FARM_DIREBOAR_FW_LYMHURST_BABY",
        canEnchant: false
    },
{
        itemName: "Baby Swamp Salamander",
        itemId: "T5_FARM_SWAMPDRAGON_FW_THETFORD_BABY",
        canEnchant: false
    },
{
        itemName: "Caerleon Greywolf Pup",
        itemId: "T5_FARM_GREYWOLF_FW_CAERLEON_BABY",
        canEnchant: false
    },
{
        itemName: "Winter Bear Cub",
        itemId: "T5_FARM_DIREBEAR_FW_FORTSTERLING_BABY",
        canEnchant: false
    },
{
        itemName: "Baby Elite Terrorbird",
        itemId: "T8_FARM_MOABIRD_FW_BRIDGEWATCH_BABY",
        canEnchant: false
    },
{
        itemName: "Moose Calf",
        itemId: "T6_FARM_GIANTSTAG_MOOSE_BABY",
        canEnchant: false
    },
{
        itemName: "Bighorn Ram Lamb",
        itemId: "T5_FARM_RAM_FW_MARTLOCK_BABY",
        canEnchant: false
    },
{
        itemName: "Elite Wild Boarlet",
        itemId: "T8_FARM_DIREBOAR_FW_LYMHURST_BABY",
        canEnchant: false
    },
{
        itemName: "Elite Winter Bear Cub",
        itemId: "T8_FARM_DIREBEAR_FW_FORTSTERLING_BABY",
        canEnchant: false
    },
{
        itemName: "Elite Greywolf Pup",
        itemId: "T8_FARM_GREYWOLF_FW_CAERLEON_BABY",
        canEnchant: false
    },
{
        itemName: "Baby Elite Swamp Salamander",
        itemId: "T8_FARM_SWAMPDRAGON_FW_THETFORD_BABY",
        canEnchant: false
    },
{
        itemName: "Elite Bighorn Ram Lamb",
        itemId: "T8_FARM_RAM_FW_MARTLOCK_BABY",
        canEnchant: false
    },
{
        itemName: "Tame Direboar",
        itemId: "T7_FARM_DIREBOAR_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Direwolf",
        itemId: "T6_FARM_DIREWOLF_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Direbear",
        itemId: "T8_FARM_DIREBEAR_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Swamp Dragon",
        itemId: "T7_FARM_SWAMPDRAGON_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Swiftclaw",
        itemId: "T5_FARM_COUGAR_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Ghostwolf",
        itemId: "T8_FARM_DIREWOLF_GROWN",
        canEnchant: false
    },
{
        itemName: "Adept's Tame Giant Stag",
        itemId: "T4_FARM_GIANTSTAG_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Moabird",
        itemId: "T5_FARM_MOABIRD_FW_BRIDGEWATCH_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Winter Bear",
        itemId: "T5_FARM_DIREBEAR_FW_FORTSTERLING_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Wild Boar",
        itemId: "T5_FARM_DIREBOAR_FW_LYMHURST_GROWN",
        canEnchant: false
    },
{
        itemName: "Master's Tame Giant Stag",
        itemId: "T6_FARM_GIANTSTAG_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Mammoth",
        itemId: "T8_FARM_MAMMOTH_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Moose",
        itemId: "T6_FARM_GIANTSTAG_MOOSE_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Swamp Salamander",
        itemId: "T5_FARM_SWAMPDRAGON_FW_THETFORD_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Greywolf",
        itemId: "T5_FARM_GREYWOLF_FW_CAERLEON_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Bighorn Ram",
        itemId: "T5_FARM_RAM_FW_MARTLOCK_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Elite Wild Boar",
        itemId: "T8_FARM_DIREBOAR_FW_LYMHURST_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Elite Winter Bear",
        itemId: "T8_FARM_DIREBEAR_FW_FORTSTERLING_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Elite Swamp Salamander",
        itemId: "T8_FARM_SWAMPDRAGON_FW_THETFORD_GROWN",
        canEnchant: false
    },
{
        itemName: "Kid",
        itemId: "T4_FARM_GOAT_BABY",
        canEnchant: false
    },
{
        itemName: "Tame Elite Terrorbird",
        itemId: "T8_FARM_MOABIRD_FW_BRIDGEWATCH_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Elite Greywolf",
        itemId: "T8_FARM_GREYWOLF_FW_CAERLEON_GROWN",
        canEnchant: false
    },
{
        itemName: "Tame Elite Bighorn Ram",
        itemId: "T8_FARM_RAM_FW_MARTLOCK_GROWN",
        canEnchant: false
    },
{
        itemName: "Baby Chickens",
        itemId: "T3_FARM_CHICKEN_BABY",
        canEnchant: false
    },
{
        itemName: "Gosling",
        itemId: "T5_FARM_GOOSE_BABY",
        canEnchant: false
    },
{
        itemName: "Piglet",
        itemId: "T7_FARM_PIG_BABY",
        canEnchant: false
    },
{
        itemName: "Chicken",
        itemId: "T3_FARM_CHICKEN_GROWN",
        canEnchant: false
    },
{
        itemName: "Pig",
        itemId: "T7_FARM_PIG_GROWN",
        canEnchant: false
    },
{
        itemName: "Lamb",
        itemId: "T6_FARM_SHEEP_BABY",
        canEnchant: false
    },
{
        itemName: "Goose",
        itemId: "T5_FARM_GOOSE_GROWN",
        canEnchant: false
    },
{
        itemName: "Calf",
        itemId: "T8_FARM_COW_BABY",
        canEnchant: false
    },
{
        itemName: "Goat",
        itemId: "T4_FARM_GOAT_GROWN",
        canEnchant: false
    },
{
        itemName: "Sheep",
        itemId: "T6_FARM_SHEEP_GROWN",
        canEnchant: false
    },
{
        itemName: "Decorative Ram Bridle",
        itemId: "UNIQUE_MOUNTUPGRADE_RAM_XMAS",
        canEnchant: false
    },
{
        itemName: "Decorative Stag Bridle",
        itemId: "T6_MOUNTUPGRADE_GIANTSTAG_XMAS",
        canEnchant: false
    },
{
        itemName: "Morgana Mare Saddle",
        itemId: "T5_MOUNTUPGRADE_HORSE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Cow",
        itemId: "T8_FARM_COW_GROWN",
        canEnchant: false
    },
{
        itemName: "Necromantic Elixir",
        itemId: "T5_MOUNTUPGRADE_HORSE_CURSE",
        canEnchant: false
    },
{
        itemName: "Infernal Horseshoes",
        itemId: "T8_MOUNTUPGRADE_HORSE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Sacred Bone Marrow",
        itemId: "T8_MOUNTUPGRADE_COUGAR_KEEPER",
        canEnchant: false
    },
{
        itemName: "Carrots",
        itemId: "T1_CARROT",
        canEnchant: false
    },
{
        itemName: "Spectral Mask",
        itemId: "T8_MOUNTUPGRADE_HORSE_CURSE",
        canEnchant: false
    },
{
        itemName: "Beans",
        itemId: "T2_BEAN",
        canEnchant: false
    },
{
        itemName: "Sheaf of Wheat",
        itemId: "T3_WHEAT",
        canEnchant: false
    },
{
        itemName: "Cabbage",
        itemId: "T5_CABBAGE",
        canEnchant: false
    },
{
        itemName: "Turnips",
        itemId: "T4_TURNIP",
        canEnchant: false
    },
{
        itemName: "Bundle of Corn",
        itemId: "T7_CORN",
        canEnchant: false
    },
{
        itemName: "Brightleaf Comfrey",
        itemId: "T3_COMFREY",
        canEnchant: false
    },
{
        itemName: "Arcane Agaric",
        itemId: "T2_AGARIC",
        canEnchant: false
    },
{
        itemName: "Potatoes",
        itemId: "T6_POTATO",
        canEnchant: false
    },
{
        itemName: "Crenellated Burdock",
        itemId: "T4_BURDOCK",
        canEnchant: false
    },
{
        itemName: "Pumpkin",
        itemId: "T8_PUMPKIN",
        canEnchant: false
    },
{
        itemName: "Firetouched Mullein",
        itemId: "T7_MULLEIN",
        canEnchant: false
    },
{
        itemName: "Elusive Foxglove",
        itemId: "T6_FOXGLOVE",
        canEnchant: false
    },
{
        itemName: "Dragon Teasel",
        itemId: "T5_TEASEL",
        canEnchant: false
    },
{
        itemName: "Goat's Milk",
        itemId: "T4_MILK",
        canEnchant: false
    },
{
        itemName: "Ghoul Yarrow",
        itemId: "T8_YARROW",
        canEnchant: false
    },
{
        itemName: "Hen Eggs",
        itemId: "T3_EGG",
        canEnchant: false
    },
{
        itemName: "Cow's Milk",
        itemId: "T8_MILK",
        canEnchant: false
    },
{
        itemName: "Sheep's Milk",
        itemId: "T6_MILK",
        canEnchant: false
    },
{
        itemName: "Common Rudd",
        itemId: "T1_FISH_FRESHWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Striped Carp",
        itemId: "T2_FISH_FRESHWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Albion Perch",
        itemId: "T3_FISH_FRESHWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Goose Eggs",
        itemId: "T5_EGG",
        canEnchant: false
    },
{
        itemName: "Bluescale Pike",
        itemId: "T4_FISH_FRESHWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Danglemouth Catfish",
        itemId: "T7_FISH_FRESHWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Spotted Trout",
        itemId: "T5_FISH_FRESHWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Brightscale Zander",
        itemId: "T6_FISH_FRESHWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "River Sturgeon",
        itemId: "T8_FISH_FRESHWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Striped Mackerel",
        itemId: "T2_FISH_SALTWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Flatshore Plaice",
        itemId: "T3_FISH_SALTWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Common Herring",
        itemId: "T1_FISH_SALTWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Spotted Wolffish",
        itemId: "T5_FISH_SALTWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Strongfin Salmon",
        itemId: "T6_FISH_SALTWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Steelscale Swordfish",
        itemId: "T8_FISH_SALTWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Bluescale Cod",
        itemId: "T4_FISH_SALTWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Redspring Eel",
        itemId: "T5_FISH_FRESHWATER_FOREST_RARE",
        canEnchant: false
    },
{
        itemName: "Upland Coldeye",
        itemId: "T3_FISH_FRESHWATER_MOUNTAIN_RARE",
        canEnchant: false
    },
{
        itemName: "Mountain Blindeye",
        itemId: "T5_FISH_FRESHWATER_MOUNTAIN_RARE",
        canEnchant: false
    },
{
        itemName: "Stonestream Lurcher",
        itemId: "T3_FISH_FRESHWATER_HIGHLANDS_RARE",
        canEnchant: false
    },
{
        itemName: "Rushwater Lurcher",
        itemId: "T5_FISH_FRESHWATER_HIGHLANDS_RARE",
        canEnchant: false
    },
{
        itemName: "Deadwater Eel",
        itemId: "T7_FISH_FRESHWATER_FOREST_RARE",
        canEnchant: false
    },
{
        itemName: "Thunderfall Lurcher",
        itemId: "T7_FISH_FRESHWATER_HIGHLANDS_RARE",
        canEnchant: false
    },
{
        itemName: "Bluefin Tuna",
        itemId: "T7_FISH_SALTWATER_ALL_COMMON",
        canEnchant: false
    },
{
        itemName: "Frostpeak Deadeye",
        itemId: "T7_FISH_FRESHWATER_MOUNTAIN_RARE",
        canEnchant: false
    },
{
        itemName: "Lowriver Crab",
        itemId: "T3_FISH_FRESHWATER_STEPPE_RARE",
        canEnchant: false
    },
{
        itemName: "Greenriver Eel",
        itemId: "T3_FISH_FRESHWATER_FOREST_RARE",
        canEnchant: false
    },
{
        itemName: "Dusthole Crab",
        itemId: "T7_FISH_FRESHWATER_STEPPE_RARE",
        canEnchant: false
    },
{
        itemName: "Drybrook Crab",
        itemId: "T5_FISH_FRESHWATER_STEPPE_RARE",
        canEnchant: false
    },
{
        itemName: "Blackbog Clam",
        itemId: "T7_FISH_FRESHWATER_SWAMP_RARE",
        canEnchant: false
    },
{
        itemName: "Murkwater Clam",
        itemId: "T5_FISH_FRESHWATER_SWAMP_RARE",
        canEnchant: false
    },
{
        itemName: "Midwater Octopus",
        itemId: "T5_FISH_SALTWATER_ALL_RARE",
        canEnchant: false
    },
{
        itemName: "Greenmoor Clam",
        itemId: "T3_FISH_FRESHWATER_SWAMP_RARE",
        canEnchant: false
    },
{
        itemName: "Deepwater Kraken",
        itemId: "T7_FISH_SALTWATER_ALL_RARE",
        canEnchant: false
    },
{
        itemName: "Whitefog Snapper",
        itemId: "T3_FISH_FRESHWATER_AVALON_RARE",
        canEnchant: false
    },
{
        itemName: "Shallowshore Squid",
        itemId: "T3_FISH_SALTWATER_ALL_RARE",
        canEnchant: false
    },
{
        itemName: "Puremist Snapper",
        itemId: "T7_FISH_FRESHWATER_AVALON_RARE",
        canEnchant: false
    },
{
        itemName: "Clearhaze Snapper",
        itemId: "T5_FISH_FRESHWATER_AVALON_RARE",
        canEnchant: false
    },
{
        itemName: "Chopped Fish",
        itemId: "T1_FISHCHOPS",
        canEnchant: false
    },
{
        itemName: "Seaweed",
        itemId: "T1_SEAWEED",
        canEnchant: false
    },
{
        itemName: "Shark",
        itemId: "T8_FISH_SALTWATER_ALL_BOSS_SHARK",
        canEnchant: false
    },
{
        itemName: "Corrupted Scroll",
        itemId: "TREASURE_KNOWLEDGE_RARITY1",
        canEnchant: false
    },
{
        itemName: "Thin Booklet",
        itemId: "TREASURE_KNOWLEDGE_RARITY2",
        canEnchant: false
    },
{
        itemName: "Silver Mirror",
        itemId: "TREASURE_SILVERWARE_RARITY2",
        canEnchant: false
    },
{
        itemName: "Special Fish Sauce",
        itemId: "T1_FISHSAUCE_LEVEL3",
        canEnchant: false
    },
{
        itemName: "Ancient Tome",
        itemId: "TREASURE_KNOWLEDGE_RARITY3",
        canEnchant: false
    },
{
        itemName: "Silver Candelabrum",
        itemId: "TREASURE_SILVERWARE_RARITY3",
        canEnchant: false
    },
{
        itemName: "Silver Cup",
        itemId: "TREASURE_SILVERWARE_RARITY1",
        canEnchant: false
    },
{
        itemName: "Simple Stone Toy",
        itemId: "TREASURE_DECORATIVE_RARITY1",
        canEnchant: false
    },
{
        itemName: "Stone Mask",
        itemId: "TREASURE_DECORATIVE_RARITY2",
        canEnchant: false
    },
{
        itemName: "Fancy Fish Sauce",
        itemId: "T1_FISHSAUCE_LEVEL2",
        canEnchant: false
    },
{
        itemName: "Stone Idol",
        itemId: "TREASURE_DECORATIVE_RARITY3",
        canEnchant: false
    },
{
        itemName: "Basic Fish Sauce",
        itemId: "T1_FISHSAUCE_LEVEL1",
        canEnchant: false
    },
{
        itemName: "Ornamental Scepter",
        itemId: "TREASURE_CEREMONIAL_RARITY1",
        canEnchant: false
    },
{
        itemName: "Holy Fetish",
        itemId: "TREASURE_TRIBAL_RARITY3",
        canEnchant: false
    },
{
        itemName: "Globus Cruciger",
        itemId: "TREASURE_CEREMONIAL_RARITY2",
        canEnchant: false
    },
{
        itemName: "Feather Talisman",
        itemId: "TREASURE_TRIBAL_RARITY1",
        canEnchant: false
    },
{
        itemName: "Sacrificial Dagger",
        itemId: "TREASURE_RITUAL_RARITY3",
        canEnchant: false
    },
{
        itemName: "Ritual Candles",
        itemId: "TREASURE_RITUAL_RARITY1",
        canEnchant: false
    },
{
        itemName: "Dreamcatcher",
        itemId: "TREASURE_TRIBAL_RARITY2",
        canEnchant: false
    },
{
        itemName: "Golden Crown",
        itemId: "TREASURE_CEREMONIAL_RARITY3",
        canEnchant: false
    },
{
        itemName: "Golden Sextant",
        itemId: "TREASURE_AVALON_RARITY3",
        canEnchant: false
    },
{
        itemName: "Letter of Transfer",
        itemId: "QUESTITEM_TRANSFER_LETTER",
        canEnchant: false
    },
{
        itemName: "Blood Chalice",
        itemId: "TREASURE_RITUAL_RARITY2",
        canEnchant: false
    },
{
        itemName: "Delivery: Blueprints",
        itemId: "QUESTITEM_LIGHT_BLUEPRINTS",
        canEnchant: false
    },
{
        itemName: "Delivery: Artistic Manuscripts",
        itemId: "QUESTITEM_LIGHT_MANUSCRIPTS",
        canEnchant: false
    },
{
        itemName: "Delivery: Mortar",
        itemId: "QUESTITEM_HEAVY_MORTAR",
        canEnchant: false
    },
{
        itemName: "Golden Frame",
        itemId: "TREASURE_AVALON_RARITY1",
        canEnchant: false
    },
{
        itemName: "Delivery: Geomantic Surveys",
        itemId: "QUESTITEM_LIGHT_SURVEYS",
        canEnchant: false
    },
{
        itemName: "Delivery: Heavy Fur",
        itemId: "QUESTITEM_LIGHT_FUR",
        canEnchant: false
    },
{
        itemName: "Delivery: Barrels",
        itemId: "QUESTITEM_HEAVY_BARREL",
        canEnchant: false
    },
{
        itemName: "Delivery: The Package",
        itemId: "QUESTITEM_LIGHT_THEPACKAGE",
        canEnchant: false
    },
{
        itemName: "Delivery: Crates",
        itemId: "QUESTITEM_HEAVY_CRATE",
        canEnchant: false
    },
{
        itemName: "Golden Gyroscope",
        itemId: "TREASURE_AVALON_RARITY2",
        canEnchant: false
    },
{
        itemName: "Delivery: Patrol Route",
        itemId: "QUESTITEM_LIGHT_PATROLROUTE",
        canEnchant: false
    },
{
        itemName: "Delivery: Sack of Kittens",
        itemId: "QUESTITEM_LIGHT_KITTENS",
        canEnchant: false
    },
{
        itemName: "Delivery: Geoff the Brigand's All-Natural Enriched Moonshine",
        itemId: "QUESTITEM_HEAVY_MOONSHINE",
        canEnchant: false
    },
{
        itemName: "Delivery: Old Clothes",
        itemId: "QUESTITEM_LIGHT_OLDCLOTHES",
        canEnchant: false
    },
{
        itemName: "Delivery: Pile of Manure",
        itemId: "QUESTITEM_HEAVY_MANURE",
        canEnchant: false
    },
{
        itemName: "Delivery: Casualty Report",
        itemId: "QUESTITEM_LIGHT_CASUALTIES",
        canEnchant: false
    },
{
        itemName: "Delivery: Beehives",
        itemId: "QUESTITEM_LIGHT_BEES",
        canEnchant: false
    },
{
        itemName: "Delivery: Farmyard Tools",
        itemId: "QUESTITEM_HEAVY_FARMTOOLS",
        canEnchant: false
    },
{
        itemName: "Delivery: Assassination Order",
        itemId: "QUESTITEM_LIGHT_ASSASSINATION",
        canEnchant: false
    },
{
        itemName: "Delivery: Regimental Rings",
        itemId: "QUESTITEM_LIGHT_RINGS",
        canEnchant: false
    },
{
        itemName: "Delivery: Sensitive Barrels",
        itemId: "QUESTITEM_HEAVY_FIREBARREL",
        canEnchant: false
    },
{
        itemName: "Arena Sigil",
        itemId: "QUESTITEM_TOKEN_ARENA_UNRANKED",
        canEnchant: false
    },
{
        itemName: "Delivery: Medical Supplies",
        itemId: "QUESTITEM_HEAVY_MEDICAL",
        canEnchant: false
    },
{
        itemName: "Royal Horse Token",
        itemId: "QUESTITEM_TOKEN_ROYAL_HORSE",
        canEnchant: false
    },
{
        itemName: "Adept's Royal Sigil",
        itemId: "QUESTITEM_TOKEN_ROYAL_T4",
        canEnchant: false
    },
{
        itemName: "Expert's Royal Sigil",
        itemId: "QUESTITEM_TOKEN_ROYAL_T5",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Royal Sigil",
        itemId: "QUESTITEM_TOKEN_ROYAL_T7",
        canEnchant: false
    },
{
        itemName: "Avalonian Energy",
        itemId: "QUESTITEM_TOKEN_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Royal Sigil",
        itemId: "QUESTITEM_TOKEN_ROYAL_T6",
        canEnchant: false
    },
{
        itemName: "Elder's Royal Sigil",
        itemId: "QUESTITEM_TOKEN_ROYAL_T8",
        canEnchant: false
    },
{
        itemName: "Pumpkin Pip",
        itemId: "QUESTITEM_TOKEN_EVENT_HALLOWEEN_2017",
        canEnchant: false
    },
{
        itemName: "Undead Knucklebone",
        itemId: "QUESTITEM_TOKEN_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Fool's Golden Egg",
        itemId: "QUESTITEM_TOKEN_EVENT_EASTER_2018",
        canEnchant: false
    },
{
        itemName: "Keeper Totem",
        itemId: "QUESTITEM_TOKEN_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adventurer Token",
        itemId: "QUESTITEM_TOKEN_ADC_FRAME",
        canEnchant: false
    },
{
        itemName: "Beginner's Tome of Insight",
        itemId: "T1_SKILLBOOK_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Journeyman's Tome of Insight",
        itemId: "T3_SKILLBOOK_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Adept's Tome of Insight",
        itemId: "T4_SKILLBOOK_STANDARD",
        canEnchant: false
    },
{
        itemName: "Novice's Tome of Insight",
        itemId: "T2_SKILLBOOK_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Expert's Tome of Insight",
        itemId: "T5_SKILLBOOK_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Morgana's Favor",
        itemId: "QUESTITEM_TOKEN_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Tome of Insight",
        itemId: "T6_SKILLBOOK_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Tome of Insight",
        itemId: "T7_SKILLBOOK_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Three Days of Premium",
        itemId: "T3_PREMIUMITEM_3_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Journeyman's Bag of Silver",
        itemId: "T3_SILVERBAG_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Bag of Silver",
        itemId: "T7_SILVERBAG_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Elder's Tome of Insight",
        itemId: "T8_SKILLBOOK_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Novice's Bag of Silver",
        itemId: "T2_SILVERBAG_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Master's Bag of Silver",
        itemId: "T6_SILVERBAG_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Beginner's Bag of Silver",
        itemId: "T1_SILVERBAG_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Adept's Bag of Silver",
        itemId: "T4_SILVERBAG_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Expert's Bag of Silver",
        itemId: "T5_SILVERBAG_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Minor Healing Potion",
        itemId: "T2_POTION_HEAL",
        canEnchant: false
    },
{
        itemName: "Elder's Bag of Silver",
        itemId: "T8_SILVERBAG_NONTRADABLE",
        canEnchant: false
    },
{
        itemName: "Minor Resistance Potion",
        itemId: "T3_POTION_STONESKIN",
        canEnchant: false
    },
{
        itemName: "Minor Gigantify Potion",
        itemId: "T3_POTION_REVIVE",
        canEnchant: false
    },
{
        itemName: "Minor Energy Potion",
        itemId: "T2_POTION_ENERGY",
        canEnchant: false
    },
{
        itemName: "Minor Sticky Potion",
        itemId: "T3_POTION_SLOWFIELD",
        canEnchant: false
    },
{
        itemName: "Earthworm",
        itemId: "T1_WORM",
        canEnchant: false
    },
{
        itemName: "Special Fish Bait",
        itemId: "T5_FISHINGBAIT",
        canEnchant: false
    },
{
        itemName: "Simple Fish Bait",
        itemId: "T1_FISHINGBAIT",
        canEnchant: false
    },
{
        itemName: "Grilled Fish",
        itemId: "T1_MEAL_GRILLEDFISH",
        canEnchant: false
    },
{
        itemName: "Fancy Fish Bait",
        itemId: "T3_FISHINGBAIT",
        canEnchant: false
    },
{
        itemName: "Seaweed Salad",
        itemId: "T1_MEAL_SEAWEEDSALAD",
        canEnchant: false
    },
{
        itemName: "Raw Chicken",
        itemId: "T3_MEAT",
        canEnchant: false
    },
{
        itemName: "Raw Goose",
        itemId: "T5_MEAT",
        canEnchant: false
    },
{
        itemName: "Raw Mutton",
        itemId: "T6_MEAT",
        canEnchant: false
    },
{
        itemName: "Goat's Butter",
        itemId: "T4_BUTTER",
        canEnchant: false
    },
{
        itemName: "Raw Goat",
        itemId: "T4_MEAT",
        canEnchant: false
    },
{
        itemName: "Raw Pork",
        itemId: "T7_MEAT",
        canEnchant: false
    },
{
        itemName: "Sheep's Butter",
        itemId: "T6_BUTTER",
        canEnchant: false
    },
{
        itemName: "Pumpkin Moonshine",
        itemId: "T8_ALCOHOL",
        canEnchant: false
    },
{
        itemName: "Potato Schnapps",
        itemId: "T6_ALCOHOL",
        canEnchant: false
    },
{
        itemName: "Rough Logs",
        itemId: "T1_WOOD",
        canEnchant: false
    },
{
        itemName: "Cow's Butter",
        itemId: "T8_BUTTER",
        canEnchant: false
    },
{
        itemName: "Raw Beef",
        itemId: "T8_MEAT",
        canEnchant: false
    },
{
        itemName: "Corn Hooch",
        itemId: "T7_ALCOHOL",
        canEnchant: false
    },
{
        itemName: "Bread",
        itemId: "T4_BREAD",
        canEnchant: false
    },
{
        itemName: "Birch Logs",
        itemId: "T2_WOOD",
        canEnchant: false
    },
{
        itemName: "Chestnut Logs",
        itemId: "T3_WOOD",
        canEnchant: false
    },
{
        itemName: "Cedar Logs",
        itemId: "T5_WOOD",
        canEnchant: false
    },
{
        itemName: "Bloodoak Logs",
        itemId: "T6_WOOD",
        canEnchant: false
    },
{
        itemName: "Flour",
        itemId: "T3_FLOUR",
        canEnchant: false
    },
{
        itemName: "Ashenbark Logs",
        itemId: "T7_WOOD",
        canEnchant: false
    },
{
        itemName: "Rough Stone",
        itemId: "T1_ROCK",
        canEnchant: false
    },
{
        itemName: "Pine Logs",
        itemId: "T4_WOOD",
        canEnchant: false
    },
{
        itemName: "Whitewood Logs",
        itemId: "T8_WOOD",
        canEnchant: false
    },
{
        itemName: "Limestone",
        itemId: "T2_ROCK",
        canEnchant: false
    },
{
        itemName: "Travertine",
        itemId: "T4_ROCK",
        canEnchant: false
    },
{
        itemName: "Granite",
        itemId: "T5_ROCK",
        canEnchant: false
    },
{
        itemName: "Marble",
        itemId: "T8_ROCK",
        canEnchant: false
    },
{
        itemName: "Sandstone",
        itemId: "T3_ROCK",
        canEnchant: false
    },
{
        itemName: "Slate",
        itemId: "T6_ROCK",
        canEnchant: false
    },
{
        itemName: "Copper Ore",
        itemId: "T2_ORE",
        canEnchant: false
    },
{
        itemName: "Titanium Ore",
        itemId: "T5_ORE",
        canEnchant: false
    },
{
        itemName: "Tin Ore",
        itemId: "T3_ORE",
        canEnchant: false
    },
{
        itemName: "Meteorite Ore",
        itemId: "T7_ORE",
        canEnchant: false
    },
{
        itemName: "Basalt",
        itemId: "T7_ROCK",
        canEnchant: false
    },
{
        itemName: "Iron Ore",
        itemId: "T4_ORE",
        canEnchant: false
    },
{
        itemName: "Runite Ore",
        itemId: "T6_ORE",
        canEnchant: false
    },
{
        itemName: "Scraps of Hide",
        itemId: "T1_HIDE",
        canEnchant: false
    },
{
        itemName: "Rugged Hide",
        itemId: "T2_HIDE",
        canEnchant: false
    },
{
        itemName: "Adamantium Ore",
        itemId: "T8_ORE",
        canEnchant: false
    },
{
        itemName: "Heavy Hide",
        itemId: "T5_HIDE",
        canEnchant: false
    },
{
        itemName: "Robust Hide",
        itemId: "T6_HIDE",
        canEnchant: false
    },
{
        itemName: "Thin Hide",
        itemId: "T3_HIDE",
        canEnchant: false
    },
{
        itemName: "Medium Hide",
        itemId: "T4_HIDE",
        canEnchant: false
    },
{
        itemName: "Cotton",
        itemId: "T2_FIBER",
        canEnchant: false
    },
{
        itemName: "Thick Hide",
        itemId: "T7_HIDE",
        canEnchant: false
    },
{
        itemName: "Resilient Hide",
        itemId: "T8_HIDE",
        canEnchant: false
    },
{
        itemName: "Flax",
        itemId: "T3_FIBER",
        canEnchant: false
    },
{
        itemName: "Skyflower",
        itemId: "T5_FIBER",
        canEnchant: false
    },
{
        itemName: "Amberleaf Cotton",
        itemId: "T6_FIBER",
        canEnchant: false
    },
{
        itemName: "Ghost Hemp",
        itemId: "T8_FIBER",
        canEnchant: false
    },
{
        itemName: "Sunflax",
        itemId: "T7_FIBER",
        canEnchant: false
    },
{
        itemName: "Chestnut Planks",
        itemId: "T3_PLANKS",
        canEnchant: false
    },
{
        itemName: "Hemp",
        itemId: "T4_FIBER",
        canEnchant: false
    },
{
        itemName: "Birch Planks",
        itemId: "T2_PLANKS",
        canEnchant: false
    },
{
        itemName: "Bloodoak Planks",
        itemId: "T6_PLANKS",
        canEnchant: false
    },
{
        itemName: "Ashenbark Planks",
        itemId: "T7_PLANKS",
        canEnchant: false
    },
{
        itemName: "Pine Planks",
        itemId: "T4_PLANKS",
        canEnchant: false
    },
{
        itemName: "Cedar Planks",
        itemId: "T5_PLANKS",
        canEnchant: false
    },
{
        itemName: "Whitewood Planks",
        itemId: "T8_PLANKS",
        canEnchant: false
    },
{
        itemName: "Limestone Block",
        itemId: "T2_STONEBLOCK",
        canEnchant: false
    },
{
        itemName: "Travertine Block",
        itemId: "T4_STONEBLOCK",
        canEnchant: false
    },
{
        itemName: "Sandstone Block",
        itemId: "T3_STONEBLOCK",
        canEnchant: false
    },
{
        itemName: "Granite Block",
        itemId: "T5_STONEBLOCK",
        canEnchant: false
    },
{
        itemName: "Slate Block",
        itemId: "T6_STONEBLOCK",
        canEnchant: false
    },
{
        itemName: "Basalt Block",
        itemId: "T7_STONEBLOCK",
        canEnchant: false
    },
{
        itemName: "Marble Block",
        itemId: "T8_STONEBLOCK",
        canEnchant: false
    },
{
        itemName: "Titanium Steel Bar",
        itemId: "T5_METALBAR",
        canEnchant: false
    },
{
        itemName: "Bronze Bar",
        itemId: "T3_METALBAR",
        canEnchant: false
    },
{
        itemName: "Runite Steel Bar",
        itemId: "T6_METALBAR",
        canEnchant: false
    },
{
        itemName: "Adamantium Steel Bar",
        itemId: "T8_METALBAR",
        canEnchant: false
    },
{
        itemName: "Copper Bar",
        itemId: "T2_METALBAR",
        canEnchant: false
    },
{
        itemName: "Meteorite Steel Bar",
        itemId: "T7_METALBAR",
        canEnchant: false
    },
{
        itemName: "Steel Bar",
        itemId: "T4_METALBAR",
        canEnchant: false
    },
{
        itemName: "Stiff Leather",
        itemId: "T2_LEATHER",
        canEnchant: false
    },
{
        itemName: "Hardened Leather",
        itemId: "T6_LEATHER",
        canEnchant: false
    },
{
        itemName: "Thick Leather",
        itemId: "T3_LEATHER",
        canEnchant: false
    },
{
        itemName: "Cured Leather",
        itemId: "T5_LEATHER",
        canEnchant: false
    },
{
        itemName: "Reinforced Leather",
        itemId: "T7_LEATHER",
        canEnchant: false
    },
{
        itemName: "Neat Cloth",
        itemId: "T3_CLOTH",
        canEnchant: false
    },
{
        itemName: "Fortified Leather",
        itemId: "T8_LEATHER",
        canEnchant: false
    },
{
        itemName: "Ornate Cloth",
        itemId: "T5_CLOTH",
        canEnchant: false
    },
{
        itemName: "Simple Cloth",
        itemId: "T2_CLOTH",
        canEnchant: false
    },
{
        itemName: "Lavish Cloth",
        itemId: "T6_CLOTH",
        canEnchant: false
    },
{
        itemName: "Opulent Cloth",
        itemId: "T7_CLOTH",
        canEnchant: false
    },
{
        itemName: "Fine Cloth",
        itemId: "T4_CLOTH",
        canEnchant: false
    },
{
        itemName: "Worked Leather",
        itemId: "T4_LEATHER",
        canEnchant: false
    },
{
        itemName: "Baroque Cloth",
        itemId: "T8_CLOTH",
        canEnchant: false
    },
{
        itemName: "Adept's Carved bone",
        itemId: "T4_ARTEFACT_2H_BOW_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Occult Orb",
        itemId: "T4_ARTEFACT_2H_ARCANESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Demonic Arrowheads",
        itemId: "T4_ARTEFACT_2H_BOW_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Alluring Bolts",
        itemId: "T4_ARTEFACT_2H_CROSSBOWLARGE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Reinforced Morgana Pole",
        itemId: "T4_ARTEFACT_2H_COMBATSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Demonic Blade",
        itemId: "T4_ARTEFACT_2H_CLEAVER_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Bloodforged Catalyst",
        itemId: "T5_ARTEFACT_2H_CURSEDSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Bloodforged Catalyst",
        itemId: "T7_ARTEFACT_2H_CURSEDSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Bloodforged Catalyst",
        itemId: "T4_ARTEFACT_2H_CURSEDSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Bloodforged Catalyst",
        itemId: "T6_ARTEFACT_2H_CURSEDSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Keeper Axeheads",
        itemId: "T4_ARTEFACT_2H_DUALAXE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Bloodforged Catalyst",
        itemId: "T8_ARTEFACT_2H_CURSEDSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Cursed Blades",
        itemId: "T4_ARTEFACT_2H_DUALSCIMITAR_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Ghastly Blades",
        itemId: "T4_ARTEFACT_2H_DUALSICKLE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Hellish Hammer Heads",
        itemId: "T4_ARTEFACT_2H_DUALHAMMER_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Hellish Bolts",
        itemId: "T4_ARTEFACT_2H_DUALCROSSBOW_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Ancient Hammer Head",
        itemId: "T4_ARTEFACT_2H_HAMMER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Possessed Scroll",
        itemId: "T4_ARTEFACT_MAIN_HOLYSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Burning Orb",
        itemId: "T4_ARTEFACT_2H_FIRESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Morgana Halberd Head",
        itemId: "T4_ARTEFACT_2H_HALBERD_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Possessed Catalyst",
        itemId: "T4_ARTEFACT_2H_ENIGMATICORB_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Infernal Harpoon Tip",
        itemId: "T4_ARTEFACT_2H_HARPOON_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Cursed Frozen Crystal",
        itemId: "T4_ARTEFACT_2H_ICECRYSTAL_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Icicle Orb",
        itemId: "T4_ARTEFACT_2H_ICEGAUNTLETS_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Ghastly Scroll",
        itemId: "T4_ARTEFACT_2H_HOLYSTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Infernal Scroll",
        itemId: "T4_ARTEFACT_2H_HOLYSTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Black Leather",
        itemId: "T4_ARTEFACT_2H_IRONGAUNTLETS_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Unholy Scroll",
        itemId: "T4_ARTEFACT_2H_INFERNOSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Symbol of Blight",
        itemId: "T4_ARTEFACT_2H_NATURESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Preserved Log",
        itemId: "T4_ARTEFACT_2H_NATURESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Imbued Mace Head",
        itemId: "T4_ARTEFACT_2H_MACE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Preserved Rocks",
        itemId: "T4_ARTEFACT_2H_ROCKSTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Ghastly Arrows",
        itemId: "T4_ARTEFACT_2H_LONGBOW_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Cursed Jawbone",
        itemId: "T4_ARTEFACT_2H_SKULLORB_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Cursed Barbs",
        itemId: "T4_ARTEFACT_2H_TRIDENT_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Hellish Sicklehead Pair",
        itemId: "T4_ARTEFACT_2H_TWINSCYTHE_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Engraved Log",
        itemId: "T4_ARTEFACT_2H_RAM_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Lost Cursed Crystal",
        itemId: "T4_ARTEFACT_MAIN_CURSEDSTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Lost Crossbow Mechanism",
        itemId: "T4_ARTEFACT_2H_REPEATINGCROSSBOW_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Lost Arcane Crystal",
        itemId: "T4_ARTEFACT_MAIN_ARCANESTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Wildfire Orb",
        itemId: "T4_ARTEFACT_MAIN_FIRESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Hoarfrost Orb",
        itemId: "T4_ARTEFACT_MAIN_FROSTSTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Druidic Inscriptions",
        itemId: "T4_ARTEFACT_MAIN_NATURESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Hardened Debole",
        itemId: "T4_ARTEFACT_MAIN_RAPIER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Runed Rock",
        itemId: "T4_ARTEFACT_MAIN_ROCKMACE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Infernal Mace Head",
        itemId: "T4_ARTEFACT_MAIN_MACE_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Keeper Spearhead",
        itemId: "T4_ARTEFACT_MAIN_SPEAR_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Bloodforged Blade",
        itemId: "T4_ARTEFACT_MAIN_SCIMITAR_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Occult Orb",
        itemId: "T5_ARTEFACT_2H_ARCANESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Reinforced Morgana Pole",
        itemId: "T5_ARTEFACT_2H_COMBATSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Carved bone",
        itemId: "T5_ARTEFACT_2H_BOW_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Demonic Arrowheads",
        itemId: "T5_ARTEFACT_2H_BOW_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Alluring Bolts",
        itemId: "T5_ARTEFACT_2H_CROSSBOWLARGE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Possessed Catalyst",
        itemId: "T5_ARTEFACT_2H_ENIGMATICORB_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Demonic Blade",
        itemId: "T5_ARTEFACT_2H_CLEAVER_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Keeper Axeheads",
        itemId: "T5_ARTEFACT_2H_DUALAXE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Hellish Bolts",
        itemId: "T5_ARTEFACT_2H_DUALCROSSBOW_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Cursed Blades",
        itemId: "T5_ARTEFACT_2H_DUALSCIMITAR_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Hellish Hammer Heads",
        itemId: "T5_ARTEFACT_2H_DUALHAMMER_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Morgana Halberd Head",
        itemId: "T5_ARTEFACT_2H_HALBERD_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Ghastly Blades",
        itemId: "T5_ARTEFACT_2H_DUALSICKLE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Possessed Scroll",
        itemId: "T5_ARTEFACT_MAIN_HOLYSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Cursed Frozen Crystal",
        itemId: "T5_ARTEFACT_2H_ICECRYSTAL_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Burning Orb",
        itemId: "T5_ARTEFACT_2H_FIRESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Infernal Harpoon Tip",
        itemId: "T5_ARTEFACT_2H_HARPOON_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Ancient Hammer Head",
        itemId: "T5_ARTEFACT_2H_HAMMER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Ghastly Arrows",
        itemId: "T5_ARTEFACT_2H_LONGBOW_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Unholy Scroll",
        itemId: "T5_ARTEFACT_2H_INFERNOSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Preserved Log",
        itemId: "T5_ARTEFACT_2H_NATURESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Symbol of Blight",
        itemId: "T5_ARTEFACT_2H_NATURESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Infernal Scroll",
        itemId: "T5_ARTEFACT_2H_HOLYSTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Lost Crossbow Mechanism",
        itemId: "T5_ARTEFACT_2H_REPEATINGCROSSBOW_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Icicle Orb",
        itemId: "T5_ARTEFACT_2H_ICEGAUNTLETS_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Imbued Mace Head",
        itemId: "T5_ARTEFACT_2H_MACE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Preserved Rocks",
        itemId: "T5_ARTEFACT_2H_ROCKSTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Hellish Sicklehead",
        itemId: "T4_ARTEFACT_2H_SCYTHE_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Black Leather",
        itemId: "T5_ARTEFACT_2H_IRONGAUNTLETS_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Engraved Log",
        itemId: "T5_ARTEFACT_2H_RAM_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Hellish Sicklehead",
        itemId: "T5_ARTEFACT_2H_SCYTHE_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Hellish Sicklehead",
        itemId: "T7_ARTEFACT_2H_SCYTHE_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Hellish Sicklehead",
        itemId: "T6_ARTEFACT_2H_SCYTHE_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Cursed Jawbone",
        itemId: "T5_ARTEFACT_2H_SKULLORB_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Cursed Barbs",
        itemId: "T5_ARTEFACT_2H_TRIDENT_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Ghastly Scroll",
        itemId: "T5_ARTEFACT_2H_HOLYSTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Hellish Sicklehead Pair",
        itemId: "T5_ARTEFACT_2H_TWINSCYTHE_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Lost Cursed Crystal",
        itemId: "T5_ARTEFACT_MAIN_CURSEDSTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Lost Arcane Crystal",
        itemId: "T5_ARTEFACT_MAIN_ARCANESTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Hellish Sicklehead",
        itemId: "T8_ARTEFACT_2H_SCYTHE_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Wildfire Orb",
        itemId: "T5_ARTEFACT_MAIN_FIRESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Hoarfrost Orb",
        itemId: "T5_ARTEFACT_MAIN_FROSTSTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Druidic Inscriptions",
        itemId: "T5_ARTEFACT_MAIN_NATURESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Bloodforged Blade",
        itemId: "T5_ARTEFACT_MAIN_SCIMITAR_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Infernal Mace Head",
        itemId: "T5_ARTEFACT_MAIN_MACE_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Runed Rock",
        itemId: "T5_ARTEFACT_MAIN_ROCKMACE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Reinforced Morgana Pole",
        itemId: "T6_ARTEFACT_2H_COMBATSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Hardened Debole",
        itemId: "T5_ARTEFACT_MAIN_RAPIER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Demonic Arrowheads",
        itemId: "T6_ARTEFACT_2H_BOW_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Keeper Spearhead",
        itemId: "T5_ARTEFACT_MAIN_SPEAR_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Demonic Blade",
        itemId: "T6_ARTEFACT_2H_CLEAVER_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Occult Orb",
        itemId: "T6_ARTEFACT_2H_ARCANESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Hellish Bolts",
        itemId: "T6_ARTEFACT_2H_DUALCROSSBOW_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Hellish Hammer Heads",
        itemId: "T6_ARTEFACT_2H_DUALHAMMER_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Cursed Blades",
        itemId: "T6_ARTEFACT_2H_DUALSCIMITAR_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Alluring Bolts",
        itemId: "T6_ARTEFACT_2H_CROSSBOWLARGE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Ghastly Blades",
        itemId: "T6_ARTEFACT_2H_DUALSICKLE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Keeper Axeheads",
        itemId: "T6_ARTEFACT_2H_DUALAXE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Possessed Catalyst",
        itemId: "T6_ARTEFACT_2H_ENIGMATICORB_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Carved bone",
        itemId: "T6_ARTEFACT_2H_BOW_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Burning Orb",
        itemId: "T6_ARTEFACT_2H_FIRESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Morgana Halberd Head",
        itemId: "T6_ARTEFACT_2H_HALBERD_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Ancient Hammer Head",
        itemId: "T6_ARTEFACT_2H_HAMMER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Possessed Scroll",
        itemId: "T6_ARTEFACT_MAIN_HOLYSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Ghastly Scroll",
        itemId: "T6_ARTEFACT_2H_HOLYSTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Infernal Harpoon Tip",
        itemId: "T6_ARTEFACT_2H_HARPOON_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Cursed Frozen Crystal",
        itemId: "T6_ARTEFACT_2H_ICECRYSTAL_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Icicle Orb",
        itemId: "T6_ARTEFACT_2H_ICEGAUNTLETS_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Infernal Scroll",
        itemId: "T6_ARTEFACT_2H_HOLYSTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Unholy Scroll",
        itemId: "T6_ARTEFACT_2H_INFERNOSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Black Leather",
        itemId: "T6_ARTEFACT_2H_IRONGAUNTLETS_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Symbol of Blight",
        itemId: "T6_ARTEFACT_2H_NATURESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Engraved Log",
        itemId: "T6_ARTEFACT_2H_RAM_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Imbued Mace Head",
        itemId: "T6_ARTEFACT_2H_MACE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Lost Crossbow Mechanism",
        itemId: "T6_ARTEFACT_2H_REPEATINGCROSSBOW_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Ghastly Arrows",
        itemId: "T6_ARTEFACT_2H_LONGBOW_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Preserved Rocks",
        itemId: "T6_ARTEFACT_2H_ROCKSTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Preserved Log",
        itemId: "T6_ARTEFACT_2H_NATURESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Hellish Sicklehead Pair",
        itemId: "T6_ARTEFACT_2H_TWINSCYTHE_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Lost Arcane Crystal",
        itemId: "T6_ARTEFACT_MAIN_ARCANESTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Cursed Jawbone",
        itemId: "T6_ARTEFACT_2H_SKULLORB_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Wildfire Orb",
        itemId: "T6_ARTEFACT_MAIN_FIRESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Hoarfrost Orb",
        itemId: "T6_ARTEFACT_MAIN_FROSTSTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Lost Cursed Crystal",
        itemId: "T6_ARTEFACT_MAIN_CURSEDSTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Druidic Inscriptions",
        itemId: "T6_ARTEFACT_MAIN_NATURESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Cursed Barbs",
        itemId: "T6_ARTEFACT_2H_TRIDENT_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Infernal Mace Head",
        itemId: "T6_ARTEFACT_MAIN_MACE_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Hardened Debole",
        itemId: "T6_ARTEFACT_MAIN_RAPIER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Bloodforged Blade",
        itemId: "T6_ARTEFACT_MAIN_SCIMITAR_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Keeper Spearhead",
        itemId: "T6_ARTEFACT_MAIN_SPEAR_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Occult Orb",
        itemId: "T7_ARTEFACT_2H_ARCANESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Runed Rock",
        itemId: "T6_ARTEFACT_MAIN_ROCKMACE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Demonic Arrowheads",
        itemId: "T7_ARTEFACT_2H_BOW_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Carved Bone",
        itemId: "T7_ARTEFACT_2H_BOW_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Demonic Blade",
        itemId: "T7_ARTEFACT_2H_CLEAVER_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Alluring Bolts",
        itemId: "T7_ARTEFACT_2H_CROSSBOWLARGE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Reinforced Morgana Pole",
        itemId: "T7_ARTEFACT_2H_COMBATSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Keeper Axeheads",
        itemId: "T7_ARTEFACT_2H_DUALAXE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Hellish Bolts",
        itemId: "T7_ARTEFACT_2H_DUALCROSSBOW_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ghastly Blades",
        itemId: "T7_ARTEFACT_2H_DUALSICKLE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Hellish Hammer Heads",
        itemId: "T7_ARTEFACT_2H_DUALHAMMER_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Possessed Catalyst",
        itemId: "T7_ARTEFACT_2H_ENIGMATICORB_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Morgana Halberd Head",
        itemId: "T7_ARTEFACT_2H_HALBERD_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Cursed Blades",
        itemId: "T7_ARTEFACT_2H_DUALSCIMITAR_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ancient Hammer Head",
        itemId: "T7_ARTEFACT_2H_HAMMER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Infernal Scroll",
        itemId: "T7_ARTEFACT_2H_HOLYSTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Infernal Harpoon Tip",
        itemId: "T7_ARTEFACT_2H_HARPOON_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Possessed Scroll",
        itemId: "T7_ARTEFACT_MAIN_HOLYSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Burning Orb",
        itemId: "T7_ARTEFACT_2H_FIRESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Cursed Frozen Crystal",
        itemId: "T7_ARTEFACT_2H_ICECRYSTAL_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Icicle Orb",
        itemId: "T7_ARTEFACT_2H_ICEGAUNTLETS_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Unholy Scroll",
        itemId: "T7_ARTEFACT_2H_INFERNOSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Symbol of Blight",
        itemId: "T7_ARTEFACT_2H_NATURESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Imbued Mace Head",
        itemId: "T7_ARTEFACT_2H_MACE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Black Leather",
        itemId: "T7_ARTEFACT_2H_IRONGAUNTLETS_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Lost Crossbow Mechanism",
        itemId: "T7_ARTEFACT_2H_REPEATINGCROSSBOW_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Preserved Log",
        itemId: "T7_ARTEFACT_2H_NATURESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ghastly Arrows",
        itemId: "T7_ARTEFACT_2H_LONGBOW_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Preserved Rocks",
        itemId: "T7_ARTEFACT_2H_ROCKSTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ghastly Scroll",
        itemId: "T7_ARTEFACT_2H_HOLYSTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Engraved Log",
        itemId: "T7_ARTEFACT_2H_RAM_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Cursed Jawbone",
        itemId: "T7_ARTEFACT_2H_SKULLORB_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Lost Arcane Crystal",
        itemId: "T7_ARTEFACT_MAIN_ARCANESTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Hellish Sicklehead Pair",
        itemId: "T7_ARTEFACT_2H_TWINSCYTHE_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Lost Cursed Crystal",
        itemId: "T7_ARTEFACT_MAIN_CURSEDSTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Druidic Inscriptions",
        itemId: "T7_ARTEFACT_MAIN_NATURESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Wildfire Orb",
        itemId: "T7_ARTEFACT_MAIN_FIRESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Cursed Barbs",
        itemId: "T7_ARTEFACT_2H_TRIDENT_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Infernal Mace Head",
        itemId: "T7_ARTEFACT_MAIN_MACE_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Hoarfrost Orb",
        itemId: "T7_ARTEFACT_MAIN_FROSTSTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Bloodforged Blade",
        itemId: "T7_ARTEFACT_MAIN_SCIMITAR_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Runed Rock",
        itemId: "T7_ARTEFACT_MAIN_ROCKMACE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Hardened Debole",
        itemId: "T7_ARTEFACT_MAIN_RAPIER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Carved bone",
        itemId: "T8_ARTEFACT_2H_BOW_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Occult Orb",
        itemId: "T8_ARTEFACT_2H_ARCANESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Keeper Spearhead",
        itemId: "T7_ARTEFACT_MAIN_SPEAR_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Reinforced Morgana Pole",
        itemId: "T8_ARTEFACT_2H_COMBATSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Demonic Arrowheads",
        itemId: "T8_ARTEFACT_2H_BOW_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Alluring Bolts",
        itemId: "T8_ARTEFACT_2H_CROSSBOWLARGE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Keeper Axeheads",
        itemId: "T8_ARTEFACT_2H_DUALAXE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Hellish Hammer Heads",
        itemId: "T8_ARTEFACT_2H_DUALHAMMER_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Demonic Blade",
        itemId: "T8_ARTEFACT_2H_CLEAVER_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Hellish Bolts",
        itemId: "T8_ARTEFACT_2H_DUALCROSSBOW_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Ghastly Blades",
        itemId: "T8_ARTEFACT_2H_DUALSICKLE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Cursed Blades",
        itemId: "T8_ARTEFACT_2H_DUALSCIMITAR_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Morgana Halberd Head",
        itemId: "T8_ARTEFACT_2H_HALBERD_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Burning Orb",
        itemId: "T8_ARTEFACT_2H_FIRESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Infernal Harpoon Tip",
        itemId: "T8_ARTEFACT_2H_HARPOON_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Possessed Catalyst",
        itemId: "T8_ARTEFACT_2H_ENIGMATICORB_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Ancient Hammer Head",
        itemId: "T8_ARTEFACT_2H_HAMMER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Possessed Scroll",
        itemId: "T8_ARTEFACT_MAIN_HOLYSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Cursed Frozen Crystal",
        itemId: "T8_ARTEFACT_2H_ICECRYSTAL_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Infernal Scroll",
        itemId: "T8_ARTEFACT_2H_HOLYSTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Unholy Scroll",
        itemId: "T8_ARTEFACT_2H_INFERNOSTAFF_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Ghastly Scroll",
        itemId: "T8_ARTEFACT_2H_HOLYSTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Black Leather",
        itemId: "T8_ARTEFACT_2H_IRONGAUNTLETS_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Ghastly Arrows",
        itemId: "T8_ARTEFACT_2H_LONGBOW_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Preserved Log",
        itemId: "T8_ARTEFACT_2H_NATURESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Icicle Orb",
        itemId: "T8_ARTEFACT_2H_ICEGAUNTLETS_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Symbol of Blight",
        itemId: "T8_ARTEFACT_2H_NATURESTAFF_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Lost Crossbow Mechanism",
        itemId: "T8_ARTEFACT_2H_REPEATINGCROSSBOW_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Imbued Mace Head",
        itemId: "T8_ARTEFACT_2H_MACE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Engraved Log",
        itemId: "T8_ARTEFACT_2H_RAM_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Preserved Rocks",
        itemId: "T8_ARTEFACT_2H_ROCKSTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Hellish Sicklehead Pair",
        itemId: "T8_ARTEFACT_2H_TWINSCYTHE_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Lost Arcane Crystal",
        itemId: "T8_ARTEFACT_MAIN_ARCANESTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Cursed Jawbone",
        itemId: "T8_ARTEFACT_2H_SKULLORB_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Lost Cursed Crystal",
        itemId: "T8_ARTEFACT_MAIN_CURSEDSTAFF_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Wildfire Orb",
        itemId: "T8_ARTEFACT_MAIN_FIRESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Druidic Inscriptions",
        itemId: "T8_ARTEFACT_MAIN_NATURESTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Hoarfrost Orb",
        itemId: "T8_ARTEFACT_MAIN_FROSTSTAFF_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Hardened Debole",
        itemId: "T8_ARTEFACT_MAIN_RAPIER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Infernal Mace Head",
        itemId: "T8_ARTEFACT_MAIN_MACE_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Cursed Barbs",
        itemId: "T8_ARTEFACT_2H_TRIDENT_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Runed Rock",
        itemId: "T8_ARTEFACT_MAIN_ROCKMACE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Bloodforged Blade",
        itemId: "T8_ARTEFACT_MAIN_SCIMITAR_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Bloodstained Antiquities",
        itemId: "T4_ARTEFACT_2H_DAGGER_KATAR_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Ruined Ancestral Vamplate",
        itemId: "T4_ARTEFACT_MAIN_SPEAR_LANCE_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Keeper Spearhead",
        itemId: "T8_ARTEFACT_MAIN_SPEAR_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Remnants of the Old King",
        itemId: "T4_ARTEFACT_2H_CLAYMORE_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Avalonian Battle Memoir",
        itemId: "T4_ARTEFACT_2H_AXE_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Timeworn Walking Staff",
        itemId: "T4_ARTEFACT_2H_QUARTERSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Humming Avalonian Whirligig",
        itemId: "T4_ARTEFACT_2H_CROSSBOW_CANNON_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Immaculately Crafted Riser",
        itemId: "T4_ARTEFACT_2H_BOW_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Massive Metallic Hand",
        itemId: "T4_ARTEFACT_2H_HAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Chilled Crystalline Shard",
        itemId: "T4_ARTEFACT_MAIN_FROSTSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Broken Oaths",
        itemId: "T4_ARTEFACT_2H_DUALMACE_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Fractured Opaque Orb",
        itemId: "T4_ARTEFACT_MAIN_CURSEDSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Uprooted Perennial Sapling",
        itemId: "T4_ARTEFACT_MAIN_NATURESTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Glowing Harmonic Ring",
        itemId: "T4_ARTEFACT_2H_FIRE_RINGPAIR_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Hypnotic Harmonic Ring",
        itemId: "T4_ARTEFACT_2H_ARCANE_RINGPAIR_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Ruined Ancestral Vamplate",
        itemId: "T5_ARTEFACT_MAIN_SPEAR_LANCE_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Messianic Curio",
        itemId: "T4_ARTEFACT_MAIN_HOLYSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Bloodstained Antiquities",
        itemId: "T5_ARTEFACT_2H_DAGGER_KATAR_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Timeworn Walking Staff",
        itemId: "T5_ARTEFACT_2H_QUARTERSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Massive Metallic Hand",
        itemId: "T5_ARTEFACT_2H_HAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Avalonian Battle Memoir",
        itemId: "T5_ARTEFACT_2H_AXE_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Remnants of the Old King",
        itemId: "T5_ARTEFACT_2H_CLAYMORE_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Immaculately Crafted Riser",
        itemId: "T5_ARTEFACT_2H_BOW_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Broken Oaths",
        itemId: "T5_ARTEFACT_2H_DUALMACE_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Humming Avalonian Whirligig",
        itemId: "T5_ARTEFACT_2H_CROSSBOW_CANNON_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Fractured Opaque Orb",
        itemId: "T5_ARTEFACT_MAIN_CURSEDSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Chilled Crystalline Shard",
        itemId: "T5_ARTEFACT_MAIN_FROSTSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Hypnotic Harmonic Ring",
        itemId: "T5_ARTEFACT_2H_ARCANE_RINGPAIR_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Uprooted Perennial Sapling",
        itemId: "T5_ARTEFACT_MAIN_NATURESTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Glowing Harmonic Ring",
        itemId: "T5_ARTEFACT_2H_FIRE_RINGPAIR_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Bloodstained Antiquities",
        itemId: "T6_ARTEFACT_2H_DAGGER_KATAR_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Ruined Ancestral Vamplate",
        itemId: "T6_ARTEFACT_MAIN_SPEAR_LANCE_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Messianic Curio",
        itemId: "T5_ARTEFACT_MAIN_HOLYSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Remnants of the Old King",
        itemId: "T6_ARTEFACT_2H_CLAYMORE_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Timeworn Walking Staff",
        itemId: "T6_ARTEFACT_2H_QUARTERSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Avalonian Battle Memoir",
        itemId: "T6_ARTEFACT_2H_AXE_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Massive Metallic Hand",
        itemId: "T6_ARTEFACT_2H_HAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Immaculately Crafted Riser",
        itemId: "T6_ARTEFACT_2H_BOW_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Broken Oaths",
        itemId: "T6_ARTEFACT_2H_DUALMACE_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Humming Avalonian Whirligig",
        itemId: "T6_ARTEFACT_2H_CROSSBOW_CANNON_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Chilled Crystalline Shard",
        itemId: "T6_ARTEFACT_MAIN_FROSTSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Uprooted Perennial Sapling",
        itemId: "T6_ARTEFACT_MAIN_NATURESTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Fractured Opaque Orb",
        itemId: "T6_ARTEFACT_MAIN_CURSEDSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Glowing Harmonic Ring",
        itemId: "T6_ARTEFACT_2H_FIRE_RINGPAIR_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Hypnotic Harmonic Ring",
        itemId: "T6_ARTEFACT_2H_ARCANE_RINGPAIR_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Bloodstained Antiquities",
        itemId: "T7_ARTEFACT_2H_DAGGER_KATAR_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Timeworn Walking Staff",
        itemId: "T7_ARTEFACT_2H_QUARTERSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Avalonian Battle Memoir",
        itemId: "T7_ARTEFACT_2H_AXE_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ruined Ancestral Vamplate",
        itemId: "T7_ARTEFACT_MAIN_SPEAR_LANCE_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Messianic Curio",
        itemId: "T6_ARTEFACT_MAIN_HOLYSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Remnants of the Old King",
        itemId: "T7_ARTEFACT_2H_CLAYMORE_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Immaculately Crafted Riser",
        itemId: "T7_ARTEFACT_2H_BOW_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Massive Metallic Hand",
        itemId: "T7_ARTEFACT_2H_HAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Broken Oaths",
        itemId: "T7_ARTEFACT_2H_DUALMACE_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Glowing Harmonic Ring",
        itemId: "T7_ARTEFACT_2H_FIRE_RINGPAIR_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Humming Avalonian Whirligig",
        itemId: "T7_ARTEFACT_2H_CROSSBOW_CANNON_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Hypnotic Harmonic Ring",
        itemId: "T7_ARTEFACT_2H_ARCANE_RINGPAIR_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Fractured Opaque Orb",
        itemId: "T7_ARTEFACT_MAIN_CURSEDSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Uprooted Perennial Sapling",
        itemId: "T7_ARTEFACT_MAIN_NATURESTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Chilled Crystalline Shard",
        itemId: "T7_ARTEFACT_MAIN_FROSTSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Bloodstained Antiquities",
        itemId: "T8_ARTEFACT_2H_DAGGER_KATAR_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Ruined Ancestral Vamplate",
        itemId: "T8_ARTEFACT_MAIN_SPEAR_LANCE_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Messianic Curio",
        itemId: "T7_ARTEFACT_MAIN_HOLYSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Avalonian Battle Memoir",
        itemId: "T8_ARTEFACT_2H_AXE_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Remnants of the Old King",
        itemId: "T8_ARTEFACT_2H_CLAYMORE_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Timeworn Walking Staff",
        itemId: "T8_ARTEFACT_2H_QUARTERSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Broken Oaths",
        itemId: "T8_ARTEFACT_2H_DUALMACE_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Immaculately Crafted Riser",
        itemId: "T8_ARTEFACT_2H_BOW_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Humming Avalonian Whirligig",
        itemId: "T8_ARTEFACT_2H_CROSSBOW_CANNON_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Fractured Opaque Orb",
        itemId: "T8_ARTEFACT_MAIN_CURSEDSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Glowing Harmonic Ring",
        itemId: "T8_ARTEFACT_2H_FIRE_RINGPAIR_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Massive Metallic Hand",
        itemId: "T8_ARTEFACT_2H_HAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Chilled Crystalline Shard",
        itemId: "T8_ARTEFACT_MAIN_FROSTSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Uprooted Perennial Sapling",
        itemId: "T8_ARTEFACT_MAIN_NATURESTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Hypnotic Harmonic Ring",
        itemId: "T8_ARTEFACT_2H_ARCANE_RINGPAIR_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Ursine Guardian Remains",
        itemId: "T4_ARTEFACT_2H_KNUCKLES_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Ursine Guardian Remains",
        itemId: "T5_ARTEFACT_2H_KNUCKLES_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ursine Guardian Remains",
        itemId: "T7_ARTEFACT_2H_KNUCKLES_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Messianic Curio",
        itemId: "T8_ARTEFACT_MAIN_HOLYSTAFF_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Ursine Guardian Remains",
        itemId: "T8_ARTEFACT_2H_KNUCKLES_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Severed Demonic Horns",
        itemId: "T5_ARTEFACT_2H_KNUCKLES_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Severed Demonic Horns",
        itemId: "T7_ARTEFACT_2H_KNUCKLES_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Ursine Guardian Remains",
        itemId: "T6_ARTEFACT_2H_KNUCKLES_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Severed Demonic Horns",
        itemId: "T6_ARTEFACT_2H_KNUCKLES_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Warped Raven Plate",
        itemId: "T4_ARTEFACT_2H_KNUCKLES_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Warped Raven Plate",
        itemId: "T5_ARTEFACT_2H_KNUCKLES_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Warped Raven Plate",
        itemId: "T7_ARTEFACT_2H_KNUCKLES_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Severed Demonic Horns",
        itemId: "T4_ARTEFACT_2H_KNUCKLES_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Warped Raven Plate",
        itemId: "T6_ARTEFACT_2H_KNUCKLES_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Severed Demonic Horns",
        itemId: "T8_ARTEFACT_2H_KNUCKLES_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Warped Raven Plate",
        itemId: "T8_ARTEFACT_2H_KNUCKLES_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Damaged Avalonian Gauntlet",
        itemId: "T7_ARTEFACT_2H_KNUCKLES_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Damaged Avalonian Gauntlet",
        itemId: "T4_ARTEFACT_2H_KNUCKLES_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Damaged Avalonian Gauntlet",
        itemId: "T6_ARTEFACT_2H_KNUCKLES_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Broken Demonic Fang",
        itemId: "T4_ARTEFACT_MAIN_DAGGER_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Damaged Avalonian Gauntlet",
        itemId: "T5_ARTEFACT_2H_KNUCKLES_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Damaged Avalonian Gauntlet",
        itemId: "T8_ARTEFACT_2H_KNUCKLES_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Broken Demonic Fang",
        itemId: "T7_ARTEFACT_MAIN_DAGGER_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Broken Demonic Fang",
        itemId: "T6_ARTEFACT_MAIN_DAGGER_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Broken Demonic Fang",
        itemId: "T5_ARTEFACT_MAIN_DAGGER_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Ancient Shield Core",
        itemId: "T4_ARTEFACT_OFF_TOWERSHIELD_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Ancient Shield Core",
        itemId: "T5_ARTEFACT_OFF_TOWERSHIELD_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ancient Shield Core",
        itemId: "T7_ARTEFACT_OFF_TOWERSHIELD_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Broken Demonic Fang",
        itemId: "T8_ARTEFACT_MAIN_DAGGER_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Ancient Shield Core",
        itemId: "T6_ARTEFACT_OFF_TOWERSHIELD_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Ancient Shield Core",
        itemId: "T8_ARTEFACT_OFF_TOWERSHIELD_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Infernal Shield Core",
        itemId: "T5_ARTEFACT_OFF_SHIELD_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Infernal Shield Core",
        itemId: "T6_ARTEFACT_OFF_SHIELD_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Infernal Shield Core",
        itemId: "T4_ARTEFACT_OFF_SHIELD_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Infernal Shield Core",
        itemId: "T7_ARTEFACT_OFF_SHIELD_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Bloodforged Spikes",
        itemId: "T5_ARTEFACT_OFF_SPIKEDSHIELD_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Bloodforged Spikes",
        itemId: "T4_ARTEFACT_OFF_SPIKEDSHIELD_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Bloodforged Spikes",
        itemId: "T7_ARTEFACT_OFF_SPIKEDSHIELD_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Bloodforged Spikes",
        itemId: "T6_ARTEFACT_OFF_SPIKEDSHIELD_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Crushed Avalonian Heirloom",
        itemId: "T5_ARTEFACT_OFF_SHIELD_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Bloodforged Spikes",
        itemId: "T8_ARTEFACT_OFF_SPIKEDSHIELD_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Crushed Avalonian Heirloom",
        itemId: "T4_ARTEFACT_OFF_SHIELD_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Crushed Avalonian Heirloom",
        itemId: "T7_ARTEFACT_OFF_SHIELD_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Crushed Avalonian Heirloom",
        itemId: "T6_ARTEFACT_OFF_SHIELD_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Infernal Shield Core",
        itemId: "T8_ARTEFACT_OFF_SHIELD_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Crushed Avalonian Heirloom",
        itemId: "T8_ARTEFACT_OFF_SHIELD_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Alluring Crystal",
        itemId: "T4_ARTEFACT_OFF_ORB_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Alluring Crystal",
        itemId: "T7_ARTEFACT_OFF_ORB_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Alluring Crystal",
        itemId: "T5_ARTEFACT_OFF_ORB_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Alluring Crystal",
        itemId: "T6_ARTEFACT_OFF_ORB_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Demonic Jawbone",
        itemId: "T5_ARTEFACT_OFF_DEMONSKULL_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Alluring Crystal",
        itemId: "T8_ARTEFACT_OFF_ORB_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Demonic Jawbone",
        itemId: "T6_ARTEFACT_OFF_DEMONSKULL_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Demonic Jawbone",
        itemId: "T7_ARTEFACT_OFF_DEMONSKULL_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Demonic Jawbone",
        itemId: "T4_ARTEFACT_OFF_DEMONSKULL_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Inscribed Stone",
        itemId: "T4_ARTEFACT_OFF_TOTEM_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Demonic Jawbone",
        itemId: "T8_ARTEFACT_OFF_DEMONSKULL_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Severed Celestial Keepsake",
        itemId: "T4_ARTEFACT_OFF_CENSER_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Inscribed Stone",
        itemId: "T6_ARTEFACT_OFF_TOTEM_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Inscribed Stone",
        itemId: "T7_ARTEFACT_OFF_TOTEM_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Severed Celestial Keepsake",
        itemId: "T6_ARTEFACT_OFF_CENSER_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Severed Celestial Keepsake",
        itemId: "T7_ARTEFACT_OFF_CENSER_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Severed Celestial Keepsake",
        itemId: "T5_ARTEFACT_OFF_CENSER_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Severed Celestial Keepsake",
        itemId: "T8_ARTEFACT_OFF_CENSER_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Runed Horn",
        itemId: "T5_ARTEFACT_OFF_HORN_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Inscribed Stone",
        itemId: "T5_ARTEFACT_OFF_TOTEM_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Runed Horn",
        itemId: "T6_ARTEFACT_OFF_HORN_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Inscribed Stone",
        itemId: "T8_ARTEFACT_OFF_TOTEM_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Runed Horn",
        itemId: "T4_ARTEFACT_OFF_HORN_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Hellish Handle",
        itemId: "T6_ARTEFACT_OFF_JESTERCANE_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Runed Horn",
        itemId: "T8_ARTEFACT_OFF_HORN_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Runed Horn",
        itemId: "T7_ARTEFACT_OFF_HORN_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Hellish Handle",
        itemId: "T7_ARTEFACT_OFF_JESTERCANE_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Hellish Handle",
        itemId: "T8_ARTEFACT_OFF_JESTERCANE_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Hellish Handle",
        itemId: "T5_ARTEFACT_OFF_JESTERCANE_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Hellish Handle",
        itemId: "T4_ARTEFACT_OFF_JESTERCANE_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Ghastly Candle",
        itemId: "T4_ARTEFACT_OFF_LAMP_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Shattered Avalonian Memento",
        itemId: "T4_ARTEFACT_OFF_TALISMAN_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ghastly Candle",
        itemId: "T7_ARTEFACT_OFF_LAMP_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Shattered Avalonian Memento",
        itemId: "T5_ARTEFACT_OFF_TALISMAN_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Ghastly Candle",
        itemId: "T8_ARTEFACT_OFF_LAMP_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Ghastly Candle",
        itemId: "T6_ARTEFACT_OFF_LAMP_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Shattered Avalonian Memento",
        itemId: "T6_ARTEFACT_OFF_TALISMAN_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Shattered Avalonian Memento",
        itemId: "T7_ARTEFACT_OFF_TALISMAN_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Shattered Avalonian Memento",
        itemId: "T8_ARTEFACT_OFF_TALISMAN_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Ancient Padding",
        itemId: "T4_ARTEFACT_HEAD_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Ancient Padding",
        itemId: "T5_ARTEFACT_HEAD_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Ancient Padding",
        itemId: "T8_ARTEFACT_HEAD_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Ancient Padding",
        itemId: "T6_ARTEFACT_HEAD_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Ancient Chain Rings",
        itemId: "T4_ARTEFACT_ARMOR_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ancient Chain Rings",
        itemId: "T7_ARTEFACT_ARMOR_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Ancient Chain Rings",
        itemId: "T5_ARTEFACT_ARMOR_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Ghastly Candle",
        itemId: "T5_ARTEFACT_OFF_LAMP_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ancient Padding",
        itemId: "T7_ARTEFACT_HEAD_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Ancient Chain Rings",
        itemId: "T8_ARTEFACT_ARMOR_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ancient Bindings",
        itemId: "T7_ARTEFACT_SHOES_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Ancient Chain Rings",
        itemId: "T6_ARTEFACT_ARMOR_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Ancient Bindings",
        itemId: "T4_ARTEFACT_SHOES_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Ancient Bindings",
        itemId: "T5_ARTEFACT_SHOES_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Ancient Bindings",
        itemId: "T6_ARTEFACT_SHOES_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Demonic Scraps",
        itemId: "T4_ARTEFACT_HEAD_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Demonic Scraps",
        itemId: "T5_ARTEFACT_HEAD_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Demonic Scraps",
        itemId: "T7_ARTEFACT_HEAD_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Demonic Scraps",
        itemId: "T8_ARTEFACT_HEAD_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Ancient Bindings",
        itemId: "T8_ARTEFACT_SHOES_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Demonic Plates",
        itemId: "T6_ARTEFACT_ARMOR_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Demonic Plates",
        itemId: "T5_ARTEFACT_ARMOR_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Demonic Scraps",
        itemId: "T6_ARTEFACT_HEAD_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Demonic Plates",
        itemId: "T7_ARTEFACT_ARMOR_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Demonic Plates",
        itemId: "T4_ARTEFACT_ARMOR_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Demonic Filling",
        itemId: "T4_ARTEFACT_SHOES_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Demonic Filling",
        itemId: "T7_ARTEFACT_SHOES_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Demonic Plates",
        itemId: "T8_ARTEFACT_ARMOR_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Demonic Filling",
        itemId: "T5_ARTEFACT_SHOES_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Carved Skull Padding",
        itemId: "T4_ARTEFACT_HEAD_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Demonic Filling",
        itemId: "T6_ARTEFACT_SHOES_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Carved Skull Padding",
        itemId: "T5_ARTEFACT_HEAD_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Carved Skull Padding",
        itemId: "T7_ARTEFACT_HEAD_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Carved Skull Padding",
        itemId: "T6_ARTEFACT_HEAD_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Demonic Filling",
        itemId: "T8_ARTEFACT_SHOES_PLATE_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Preserved Animal Fur",
        itemId: "T5_ARTEFACT_ARMOR_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Preserved Animal Fur",
        itemId: "T7_ARTEFACT_ARMOR_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Preserved Animal Fur",
        itemId: "T4_ARTEFACT_ARMOR_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Preserved Animal Fur",
        itemId: "T8_ARTEFACT_ARMOR_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Inscribed Bindings",
        itemId: "T4_ARTEFACT_SHOES_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Preserved Animal Fur",
        itemId: "T6_ARTEFACT_ARMOR_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Carved Skull Padding",
        itemId: "T8_ARTEFACT_HEAD_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Inscribed Bindings",
        itemId: "T6_ARTEFACT_SHOES_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Inscribed Bindings",
        itemId: "T7_ARTEFACT_SHOES_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Inscribed Bindings",
        itemId: "T5_ARTEFACT_SHOES_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Exalted Visor",
        itemId: "T7_ARTEFACT_HEAD_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Inscribed Bindings",
        itemId: "T8_ARTEFACT_SHOES_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Exalted Plating",
        itemId: "T5_ARTEFACT_ARMOR_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Exalted Visor",
        itemId: "T4_ARTEFACT_HEAD_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Exalted Visor",
        itemId: "T6_ARTEFACT_HEAD_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Exalted Plating",
        itemId: "T4_ARTEFACT_ARMOR_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Exalted Visor",
        itemId: "T8_ARTEFACT_HEAD_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Exalted Plating",
        itemId: "T7_ARTEFACT_ARMOR_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Exalted Visor",
        itemId: "T5_ARTEFACT_HEAD_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Exalted Plating",
        itemId: "T8_ARTEFACT_ARMOR_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Exalted Plating",
        itemId: "T6_ARTEFACT_ARMOR_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Exalted Greave",
        itemId: "T4_ARTEFACT_SHOES_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Exalted Greave",
        itemId: "T5_ARTEFACT_SHOES_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Exalted Greave",
        itemId: "T7_ARTEFACT_SHOES_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Imbued Visor",
        itemId: "T5_ARTEFACT_HEAD_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Exalted Greave",
        itemId: "T6_ARTEFACT_SHOES_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Imbued Visor",
        itemId: "T7_ARTEFACT_HEAD_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Exalted Greave",
        itemId: "T8_ARTEFACT_SHOES_PLATE_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Imbued Visor",
        itemId: "T6_ARTEFACT_HEAD_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Imbued Leather Folds",
        itemId: "T4_ARTEFACT_ARMOR_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Imbued Visor",
        itemId: "T4_ARTEFACT_HEAD_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Imbued Leather Folds",
        itemId: "T6_ARTEFACT_ARMOR_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Imbued Visor",
        itemId: "T8_ARTEFACT_HEAD_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Imbued Leather Folds",
        itemId: "T5_ARTEFACT_ARMOR_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Imbued Leather Folds",
        itemId: "T7_ARTEFACT_ARMOR_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Imbued Soles",
        itemId: "T4_ARTEFACT_SHOES_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Imbued Leather Folds",
        itemId: "T8_ARTEFACT_ARMOR_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Imbued Soles",
        itemId: "T7_ARTEFACT_SHOES_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Imbued Soles",
        itemId: "T5_ARTEFACT_SHOES_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Demonhide Padding",
        itemId: "T5_ARTEFACT_HEAD_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Imbued Soles",
        itemId: "T6_ARTEFACT_SHOES_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Imbued Soles",
        itemId: "T8_ARTEFACT_SHOES_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Demonhide Padding",
        itemId: "T4_ARTEFACT_HEAD_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Demonhide Padding",
        itemId: "T7_ARTEFACT_HEAD_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Demonhide Padding",
        itemId: "T6_ARTEFACT_HEAD_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Demonhide Padding",
        itemId: "T8_ARTEFACT_HEAD_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Demonhide Leather",
        itemId: "T6_ARTEFACT_ARMOR_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Demonhide Leather",
        itemId: "T7_ARTEFACT_ARMOR_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Demonhide Leather",
        itemId: "T8_ARTEFACT_ARMOR_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Demonhide Leather",
        itemId: "T4_ARTEFACT_ARMOR_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Demonhide Leather",
        itemId: "T5_ARTEFACT_ARMOR_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Demonhide Bindings",
        itemId: "T6_ARTEFACT_SHOES_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Demonhide Bindings",
        itemId: "T4_ARTEFACT_SHOES_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Demonhide Bindings",
        itemId: "T5_ARTEFACT_SHOES_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Ghastly Visor",
        itemId: "T5_ARTEFACT_HEAD_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Demonhide Bindings",
        itemId: "T8_ARTEFACT_SHOES_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Demonhide Bindings",
        itemId: "T7_ARTEFACT_SHOES_LEATHER_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Ghastly Visor",
        itemId: "T4_ARTEFACT_HEAD_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ghastly Visor",
        itemId: "T7_ARTEFACT_HEAD_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Ghastly Leather",
        itemId: "T4_ARTEFACT_ARMOR_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Ghastly Visor",
        itemId: "T6_ARTEFACT_HEAD_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Ghastly Leather",
        itemId: "T5_ARTEFACT_ARMOR_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ghastly Leather",
        itemId: "T7_ARTEFACT_ARMOR_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Ghastly Leather",
        itemId: "T8_ARTEFACT_ARMOR_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Ghastly Leather",
        itemId: "T6_ARTEFACT_ARMOR_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Master's Ghastly Bindings",
        itemId: "T6_ARTEFACT_SHOES_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Ghastly Bindings",
        itemId: "T4_ARTEFACT_SHOES_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Ghastly Visor",
        itemId: "T8_ARTEFACT_HEAD_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Expert's Ghastly Bindings",
        itemId: "T5_ARTEFACT_SHOES_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Ghastly Bindings",
        itemId: "T7_ARTEFACT_SHOES_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Elder's Ghastly Bindings",
        itemId: "T8_ARTEFACT_SHOES_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Adept's Augured Padding",
        itemId: "T4_ARTEFACT_HEAD_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Augured Padding",
        itemId: "T5_ARTEFACT_HEAD_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Augured Padding",
        itemId: "T7_ARTEFACT_HEAD_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Augured Padding",
        itemId: "T8_ARTEFACT_HEAD_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Augured Padding",
        itemId: "T6_ARTEFACT_HEAD_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Augured Sash",
        itemId: "T4_ARTEFACT_ARMOR_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Augured Sash",
        itemId: "T6_ARTEFACT_ARMOR_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Augured Sash",
        itemId: "T5_ARTEFACT_ARMOR_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Augured Sash",
        itemId: "T7_ARTEFACT_ARMOR_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Augured Fasteners",
        itemId: "T5_ARTEFACT_SHOES_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Augured Fasteners",
        itemId: "T4_ARTEFACT_SHOES_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Augured Fasteners",
        itemId: "T7_ARTEFACT_SHOES_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Augured Sash",
        itemId: "T8_ARTEFACT_ARMOR_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Augured Fasteners",
        itemId: "T8_ARTEFACT_SHOES_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Druidic Preserved Beak",
        itemId: "T7_ARTEFACT_HEAD_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Druidic Preserved Beak",
        itemId: "T4_ARTEFACT_HEAD_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Druidic Preserved Beak",
        itemId: "T5_ARTEFACT_HEAD_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Druidic Preserved Beak",
        itemId: "T6_ARTEFACT_HEAD_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Augured Fasteners",
        itemId: "T6_ARTEFACT_SHOES_LEATHER_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Druidic Preserved Beak",
        itemId: "T8_ARTEFACT_HEAD_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Druidic Feathers",
        itemId: "T6_ARTEFACT_ARMOR_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Druidic Feathers",
        itemId: "T7_ARTEFACT_ARMOR_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Druidic Feathers",
        itemId: "T8_ARTEFACT_ARMOR_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Druidic Feathers",
        itemId: "T5_ARTEFACT_ARMOR_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Druidic Bindings",
        itemId: "T6_ARTEFACT_SHOES_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Expert's Druidic Bindings",
        itemId: "T5_ARTEFACT_SHOES_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Adept's Infernal Cloth Visor",
        itemId: "T4_ARTEFACT_HEAD_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Druidic Feathers",
        itemId: "T4_ARTEFACT_ARMOR_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Elder's Druidic Bindings",
        itemId: "T8_ARTEFACT_SHOES_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Druidic Bindings",
        itemId: "T7_ARTEFACT_SHOES_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Infernal Cloth Visor",
        itemId: "T6_ARTEFACT_HEAD_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Infernal Cloth Visor",
        itemId: "T5_ARTEFACT_HEAD_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Infernal Cloth Visor",
        itemId: "T7_ARTEFACT_HEAD_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Infernal Cloth Visor",
        itemId: "T8_ARTEFACT_HEAD_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Infernal Cloth Folds",
        itemId: "T5_ARTEFACT_ARMOR_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Infernal Cloth Folds",
        itemId: "T7_ARTEFACT_ARMOR_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Druidic Bindings",
        itemId: "T4_ARTEFACT_SHOES_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Master's Infernal Cloth Folds",
        itemId: "T6_ARTEFACT_ARMOR_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Master's Infernal Cloth Bindings",
        itemId: "T6_ARTEFACT_SHOES_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Infernal Cloth Folds",
        itemId: "T4_ARTEFACT_ARMOR_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Expert's Infernal Cloth Bindings",
        itemId: "T5_ARTEFACT_SHOES_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Adept's Infernal Cloth Bindings",
        itemId: "T4_ARTEFACT_SHOES_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Infernal Cloth Bindings",
        itemId: "T8_ARTEFACT_SHOES_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Elder's Infernal Cloth Folds",
        itemId: "T8_ARTEFACT_ARMOR_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Infernal Cloth Bindings",
        itemId: "T7_ARTEFACT_SHOES_CLOTH_HELL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Alluring Padding",
        itemId: "T7_ARTEFACT_HEAD_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Alluring Padding",
        itemId: "T8_ARTEFACT_HEAD_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Alluring Padding",
        itemId: "T4_ARTEFACT_HEAD_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Alluring Padding",
        itemId: "T6_ARTEFACT_HEAD_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Alluring Padding",
        itemId: "T5_ARTEFACT_HEAD_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Alluring Amulet",
        itemId: "T4_ARTEFACT_ARMOR_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Alluring Amulet",
        itemId: "T7_ARTEFACT_ARMOR_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Alluring Amulet",
        itemId: "T5_ARTEFACT_ARMOR_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Expert's Alluring Bindings",
        itemId: "T5_ARTEFACT_SHOES_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Alluring Amulet",
        itemId: "T6_ARTEFACT_ARMOR_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Adept's Alluring Bindings",
        itemId: "T4_ARTEFACT_SHOES_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Alluring Bindings",
        itemId: "T7_ARTEFACT_SHOES_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Master's Alluring Bindings",
        itemId: "T6_ARTEFACT_SHOES_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Alluring Amulet",
        itemId: "T8_ARTEFACT_ARMOR_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Elder's Alluring Bindings",
        itemId: "T8_ARTEFACT_SHOES_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Sanctified Mask",
        itemId: "T7_ARTEFACT_HEAD_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Sanctified Mask",
        itemId: "T4_ARTEFACT_HEAD_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Sanctified Mask",
        itemId: "T6_ARTEFACT_HEAD_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Sanctified Mask",
        itemId: "T5_ARTEFACT_HEAD_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Sanctified Belt",
        itemId: "T4_ARTEFACT_ARMOR_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Sanctified Belt",
        itemId: "T5_ARTEFACT_ARMOR_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Sanctified Belt",
        itemId: "T7_ARTEFACT_ARMOR_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Sanctified Belt",
        itemId: "T8_ARTEFACT_ARMOR_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Sanctified Mask",
        itemId: "T8_ARTEFACT_HEAD_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Sanctified Belt",
        itemId: "T6_ARTEFACT_ARMOR_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Sanctified Bindings",
        itemId: "T4_ARTEFACT_SHOES_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Sanctified Bindings",
        itemId: "T7_ARTEFACT_SHOES_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Sanctified Bindings",
        itemId: "T8_ARTEFACT_SHOES_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Sanctified Bindings",
        itemId: "T5_ARTEFACT_SHOES_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Sanctified Bindings",
        itemId: "T6_ARTEFACT_SHOES_CLOTH_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Crystallized Spirit",
        itemId: "T4_ARTEFACT_TOKEN_FAVOR_1",
        canEnchant: false
    },
{
        itemName: "Expert's Crystallized Spirit",
        itemId: "T5_ARTEFACT_TOKEN_FAVOR_1",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Crystallized Spirit",
        itemId: "T7_ARTEFACT_TOKEN_FAVOR_1",
        canEnchant: false
    },
{
        itemName: "Elder's Crystallized Spirit",
        itemId: "T8_ARTEFACT_TOKEN_FAVOR_1",
        canEnchant: false
    },
{
        itemName: "Master's Crystallized Spirit",
        itemId: "T6_ARTEFACT_TOKEN_FAVOR_1",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Crystallized Dread",
        itemId: "T7_ARTEFACT_TOKEN_FAVOR_2",
        canEnchant: false
    },
{
        itemName: "Adept's Crystallized Dread",
        itemId: "T4_ARTEFACT_TOKEN_FAVOR_2",
        canEnchant: false
    },
{
        itemName: "Master's Crystallized Dread",
        itemId: "T6_ARTEFACT_TOKEN_FAVOR_2",
        canEnchant: false
    },
{
        itemName: "Elder's Crystallized Dread",
        itemId: "T8_ARTEFACT_TOKEN_FAVOR_2",
        canEnchant: false
    },
{
        itemName: "Master's Crystallized Magic",
        itemId: "T6_ARTEFACT_TOKEN_FAVOR_3",
        canEnchant: false
    },
{
        itemName: "Adept's Crystallized Magic",
        itemId: "T4_ARTEFACT_TOKEN_FAVOR_3",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Crystallized Magic",
        itemId: "T7_ARTEFACT_TOKEN_FAVOR_3",
        canEnchant: false
    },
{
        itemName: "Expert's Crystallized Magic",
        itemId: "T5_ARTEFACT_TOKEN_FAVOR_3",
        canEnchant: false
    },
{
        itemName: "Adept's Crystallized Divinity",
        itemId: "T4_ARTEFACT_TOKEN_FAVOR_4",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Crystallized Divinity",
        itemId: "T7_ARTEFACT_TOKEN_FAVOR_4",
        canEnchant: false
    },
{
        itemName: "Elder's Crystallized Magic",
        itemId: "T8_ARTEFACT_TOKEN_FAVOR_3",
        canEnchant: false
    },
{
        itemName: "Master's Crystallized Divinity",
        itemId: "T6_ARTEFACT_TOKEN_FAVOR_4",
        canEnchant: false
    },
{
        itemName: "Expert's Crystallized Dread",
        itemId: "T5_ARTEFACT_TOKEN_FAVOR_2",
        canEnchant: false
    },
{
        itemName: "Elder's Crystallized Divinity",
        itemId: "T8_ARTEFACT_TOKEN_FAVOR_4",
        canEnchant: false
    },
{
        itemName: "Adept's Faded Essence",
        itemId: "T4_ESSENCE",
        canEnchant: false
    },
{
        itemName: "Expert's Crystallized Divinity",
        itemId: "T5_ARTEFACT_TOKEN_FAVOR_4",
        canEnchant: false
    },
{
        itemName: "Adept's Soul",
        itemId: "T4_SOUL",
        canEnchant: false
    },
{
        itemName: "Adept's Arcane Essence",
        itemId: "T4_ESSENCE_POTION",
        canEnchant: false
    },
{
        itemName: "Adept's Avalonian Shard",
        itemId: "T4_SHARD_AVALONIAN",
        canEnchant: false
    },
{
        itemName: "Adept's Relic",
        itemId: "T4_RELIC",
        canEnchant: false
    },
{
        itemName: "Expert's Faded Essence",
        itemId: "T5_ESSENCE",
        canEnchant: false
    },
{
        itemName: "Expert's Arcane Essence",
        itemId: "T5_ESSENCE_POTION",
        canEnchant: false
    },
{
        itemName: "Expert's Avalonian Shard",
        itemId: "T5_SHARD_AVALONIAN",
        canEnchant: false
    },
{
        itemName: "Adept's Rune",
        itemId: "T4_RUNE",
        canEnchant: false
    },
{
        itemName: "Master's Arcane Essence",
        itemId: "T6_ESSENCE_POTION",
        canEnchant: false
    },
{
        itemName: "Expert's Relic",
        itemId: "T5_RELIC",
        canEnchant: false
    },
{
        itemName: "Master's Rune",
        itemId: "T6_RUNE",
        canEnchant: false
    },
{
        itemName: "Master's Faded Essence",
        itemId: "T6_ESSENCE",
        canEnchant: false
    },
{
        itemName: "Expert's Rune",
        itemId: "T5_RUNE",
        canEnchant: false
    },
{
        itemName: "Master's Avalonian Shard",
        itemId: "T6_SHARD_AVALONIAN",
        canEnchant: false
    },
{
        itemName: "Expert's Soul",
        itemId: "T5_SOUL",
        canEnchant: false
    },
{
        itemName: "Master's Relic",
        itemId: "T6_RELIC",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Faded Essence",
        itemId: "T7_ESSENCE",
        canEnchant: false
    },
{
        itemName: "Master's Soul",
        itemId: "T6_SOUL",
        canEnchant: false
    },
{
        itemName: "Elder's Faded Essence",
        itemId: "T8_ESSENCE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Rune",
        itemId: "T7_RUNE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Arcane Essence",
        itemId: "T7_ESSENCE_POTION",
        canEnchant: false
    },
{
        itemName: "Elder's Arcane Essence",
        itemId: "T8_ESSENCE_POTION",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Avalonian Shard",
        itemId: "T7_SHARD_AVALONIAN",
        canEnchant: false
    },
{
        itemName: "Elder's Rune",
        itemId: "T8_RUNE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Relic",
        itemId: "T7_RELIC",
        canEnchant: false
    },
{
        itemName: "Elder's Relic",
        itemId: "T8_RELIC",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Soul",
        itemId: "T7_SOUL",
        canEnchant: false
    },
{
        itemName: "Elder's Soul",
        itemId: "T8_SOUL",
        canEnchant: false
    },
{
        itemName: "Elder's Avalonian Shard",
        itemId: "T8_SHARD_AVALONIAN",
        canEnchant: false
    },
{
        itemName: "Beginner's Shield",
        itemId: "T1_OFF_SHIELD",
        canEnchant: false
    },
{
        itemName: "Journeyman's Shield",
        itemId: "T3_OFF_SHIELD",
        canEnchant: false
    },
{
        itemName: "Trash",
        itemId: "T2_TRASH",
        canEnchant: false
    },
{
        itemName: "Novice's Shield",
        itemId: "T2_OFF_SHIELD",
        canEnchant: false
    },
{
        itemName: "Journeyman's Tome of Spells",
        itemId: "T3_OFF_BOOK",
        canEnchant: false
    },
{
        itemName: "Novice's Tome of Spells",
        itemId: "T2_OFF_BOOK",
        canEnchant: false
    },
{
        itemName: "Novice's Cape",
        itemId: "T2_CAPE",
        canEnchant: false
    },
{
        itemName: "Journeyman's Cape",
        itemId: "T3_CAPE",
        canEnchant: false
    },
{
        itemName: "Journeyman's Torch",
        itemId: "T3_OFF_TORCH",
        canEnchant: false
    },
{
        itemName: "Recruiter's Pile of Tomes",
        itemId: "UNIQUE_LOOTCHEST_FIRSTREFERRAL",
        canEnchant: false
    },
{
        itemName: "Pile of Tomes",
        itemId: "UNIQUE_LOOTCHEST_SKILLBOOKS_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Journeyman's Bag",
        itemId: "T3_BAG",
        canEnchant: false
    },
{
        itemName: "Journeyman's Pickaxe",
        itemId: "T3_2H_TOOL_PICK",
        canEnchant: false
    },
{
        itemName: "Novice's Bag",
        itemId: "T2_BAG",
        canEnchant: false
    },
{
        itemName: "Beginner's Pickaxe",
        itemId: "T1_2H_TOOL_PICK",
        canEnchant: false
    },
{
        itemName: "Expert's Pickaxe",
        itemId: "T5_2H_TOOL_PICK",
        canEnchant: false
    },
{
        itemName: "Novice's Pickaxe",
        itemId: "T2_2H_TOOL_PICK",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Pickaxe",
        itemId: "T7_2H_TOOL_PICK",
        canEnchant: false
    },
{
        itemName: "Expert's Avalonian Pickaxe",
        itemId: "T5_2H_TOOL_PICK_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Pickaxe",
        itemId: "T4_2H_TOOL_PICK",
        canEnchant: false
    },
{
        itemName: "Master's Pickaxe",
        itemId: "T6_2H_TOOL_PICK",
        canEnchant: false
    },
{
        itemName: "Adept's Avalonian Pickaxe",
        itemId: "T4_2H_TOOL_PICK_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Avalonian Pickaxe",
        itemId: "T6_2H_TOOL_PICK_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Pickaxe",
        itemId: "T8_2H_TOOL_PICK",
        canEnchant: false
    },
{
        itemName: "Elder's Avalonian Pickaxe",
        itemId: "T8_2H_TOOL_PICK_AVALON",
        canEnchant: false
    },
{
        itemName: "Novice's Stone Hammer",
        itemId: "T2_2H_TOOL_HAMMER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Avalonian Pickaxe",
        itemId: "T7_2H_TOOL_PICK_AVALON",
        canEnchant: false
    },
{
        itemName: "Journeyman's Stone Hammer",
        itemId: "T3_2H_TOOL_HAMMER",
        canEnchant: false
    },
{
        itemName: "Beginner's Stone Hammer",
        itemId: "T1_2H_TOOL_HAMMER",
        canEnchant: false
    },
{
        itemName: "Adept's Stone Hammer",
        itemId: "T4_2H_TOOL_HAMMER",
        canEnchant: false
    },
{
        itemName: "Elder's Stone Hammer",
        itemId: "T8_2H_TOOL_HAMMER",
        canEnchant: false
    },
{
        itemName: "Expert's Stone Hammer",
        itemId: "T5_2H_TOOL_HAMMER",
        canEnchant: false
    },
{
        itemName: "Expert's Avalonian Stone Hammer",
        itemId: "T5_2H_TOOL_HAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Stone Hammer",
        itemId: "T7_2H_TOOL_HAMMER",
        canEnchant: false
    },
{
        itemName: "Master's Stone Hammer",
        itemId: "T6_2H_TOOL_HAMMER",
        canEnchant: false
    },
{
        itemName: "Adept's Avalonian Stone Hammer",
        itemId: "T4_2H_TOOL_HAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Avalonian Stone Hammer",
        itemId: "T6_2H_TOOL_HAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Avalonian Stone Hammer",
        itemId: "T7_2H_TOOL_HAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Avalonian Stone Hammer",
        itemId: "T8_2H_TOOL_HAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Novice's Axe",
        itemId: "T2_2H_TOOL_AXE",
        canEnchant: false
    },
{
        itemName: "Journeyman's Axe",
        itemId: "T3_2H_TOOL_AXE",
        canEnchant: false
    },
{
        itemName: "Expert's Axe",
        itemId: "T5_2H_TOOL_AXE",
        canEnchant: false
    },
{
        itemName: "Beginner's Axe",
        itemId: "T1_2H_TOOL_AXE",
        canEnchant: false
    },
{
        itemName: "Adept's Avalonian Axe",
        itemId: "T4_2H_TOOL_AXE_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Axe",
        itemId: "T6_2H_TOOL_AXE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Axe",
        itemId: "T7_2H_TOOL_AXE",
        canEnchant: false
    },
{
        itemName: "Expert's Avalonian Axe",
        itemId: "T5_2H_TOOL_AXE_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Axe",
        itemId: "T4_2H_TOOL_AXE",
        canEnchant: false
    },
{
        itemName: "Elder's Axe",
        itemId: "T8_2H_TOOL_AXE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Avalonian Axe",
        itemId: "T7_2H_TOOL_AXE_AVALON",
        canEnchant: false
    },
{
        itemName: "Novice's Sickle",
        itemId: "T2_2H_TOOL_SICKLE",
        canEnchant: false
    },
{
        itemName: "Master's Avalonian Axe",
        itemId: "T6_2H_TOOL_AXE_AVALON",
        canEnchant: false
    },
{
        itemName: "Journeyman's Sickle",
        itemId: "T3_2H_TOOL_SICKLE",
        canEnchant: false
    },
{
        itemName: "Elder's Avalonian Axe",
        itemId: "T8_2H_TOOL_AXE_AVALON",
        canEnchant: false
    },
{
        itemName: "Beginner's Sickle",
        itemId: "T1_2H_TOOL_SICKLE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Sickle",
        itemId: "T7_2H_TOOL_SICKLE",
        canEnchant: false
    },
{
        itemName: "Master's Sickle",
        itemId: "T6_2H_TOOL_SICKLE",
        canEnchant: false
    },
{
        itemName: "Adept's Sickle",
        itemId: "T4_2H_TOOL_SICKLE",
        canEnchant: false
    },
{
        itemName: "Adept's Avalonian Sickle",
        itemId: "T4_2H_TOOL_SICKLE_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Avalonian Sickle",
        itemId: "T7_2H_TOOL_SICKLE_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Sickle",
        itemId: "T5_2H_TOOL_SICKLE",
        canEnchant: false
    },
{
        itemName: "Expert's Avalonian Sickle",
        itemId: "T5_2H_TOOL_SICKLE_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Avalonian Sickle",
        itemId: "T6_2H_TOOL_SICKLE_AVALON",
        canEnchant: false
    },
{
        itemName: "Beginner's Skinning Knife",
        itemId: "T1_2H_TOOL_KNIFE",
        canEnchant: false
    },
{
        itemName: "Elder's Avalonian Sickle",
        itemId: "T8_2H_TOOL_SICKLE_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Skinning Knife",
        itemId: "T5_2H_TOOL_KNIFE",
        canEnchant: false
    },
{
        itemName: "Elder's Sickle",
        itemId: "T8_2H_TOOL_SICKLE",
        canEnchant: false
    },
{
        itemName: "Adept's Skinning Knife",
        itemId: "T4_2H_TOOL_KNIFE",
        canEnchant: false
    },
{
        itemName: "Novice's Skinning Knife",
        itemId: "T2_2H_TOOL_KNIFE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Skinning Knife",
        itemId: "T7_2H_TOOL_KNIFE",
        canEnchant: false
    },
{
        itemName: "Elder's Skinning Knife",
        itemId: "T8_2H_TOOL_KNIFE",
        canEnchant: false
    },
{
        itemName: "Master's Skinning Knife",
        itemId: "T6_2H_TOOL_KNIFE",
        canEnchant: false
    },
{
        itemName: "Journeyman's Skinning Knife",
        itemId: "T3_2H_TOOL_KNIFE",
        canEnchant: false
    },
{
        itemName: "Adept's Avalonian Skinning Knife",
        itemId: "T4_2H_TOOL_KNIFE_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Avalonian Skinning Knife",
        itemId: "T7_2H_TOOL_KNIFE_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Avalonian Skinning Knife",
        itemId: "T6_2H_TOOL_KNIFE_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Avalonian Skinning Knife",
        itemId: "T8_2H_TOOL_KNIFE_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Avalonian Skinning Knife",
        itemId: "T5_2H_TOOL_KNIFE_AVALON",
        canEnchant: false
    },
{
        itemName: "Journeyman's Demolition Hammer",
        itemId: "T3_2H_TOOL_SIEGEHAMMER",
        canEnchant: false
    },
{
        itemName: "Novice's Demolition Hammer",
        itemId: "T2_2H_TOOL_SIEGEHAMMER",
        canEnchant: false
    },
{
        itemName: "Expert's Demolition Hammer",
        itemId: "T5_2H_TOOL_SIEGEHAMMER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Demolition Hammer",
        itemId: "T7_2H_TOOL_SIEGEHAMMER",
        canEnchant: false
    },
{
        itemName: "Adept's Demolition Hammer",
        itemId: "T4_2H_TOOL_SIEGEHAMMER",
        canEnchant: false
    },
{
        itemName: "Master's Demolition Hammer",
        itemId: "T6_2H_TOOL_SIEGEHAMMER",
        canEnchant: false
    },
{
        itemName: "Expert's Avalonian Demolition Hammer",
        itemId: "T5_2H_TOOL_SIEGEHAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Elder's Demolition Hammer",
        itemId: "T8_2H_TOOL_SIEGEHAMMER",
        canEnchant: false
    },
{
        itemName: "Adept's Avalonian Demolition Hammer",
        itemId: "T4_2H_TOOL_SIEGEHAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Avalonian Demolition Hammer",
        itemId: "T7_2H_TOOL_SIEGEHAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Fishing Rod",
        itemId: "T4_2H_TOOL_FISHINGROD",
        canEnchant: false
    },
{
        itemName: "Master's Avalonian Demolition Hammer",
        itemId: "T6_2H_TOOL_SIEGEHAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Journeyman's Fishing Rod",
        itemId: "T3_2H_TOOL_FISHINGROD",
        canEnchant: false
    },
{
        itemName: "Elder's Avalonian Demolition Hammer",
        itemId: "T8_2H_TOOL_SIEGEHAMMER_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Fishing Rod",
        itemId: "T7_2H_TOOL_FISHINGROD",
        canEnchant: false
    },
{
        itemName: "Expert's Fishing Rod",
        itemId: "T5_2H_TOOL_FISHINGROD",
        canEnchant: false
    },
{
        itemName: "Master's Fishing Rod",
        itemId: "T6_2H_TOOL_FISHINGROD",
        canEnchant: false
    },
{
        itemName: "Elder's Fishing Rod",
        itemId: "T8_2H_TOOL_FISHINGROD",
        canEnchant: false
    },
{
        itemName: "Expert's Avalonian Fishing Rod",
        itemId: "T5_2H_TOOL_FISHINGROD_AVALON",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Avalonian Fishing Rod",
        itemId: "T7_2H_TOOL_FISHINGROD_AVALON",
        canEnchant: false
    },
{
        itemName: "Master's Avalonian Fishing Rod",
        itemId: "T6_2H_TOOL_FISHINGROD_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Avalonian Fishing Rod",
        itemId: "T4_2H_TOOL_FISHINGROD_AVALON",
        canEnchant: false
    },
{
        itemName: "Expert's Riding Horse",
        itemId: "T5_MOUNT_HORSE",
        canEnchant: false
    },
{
        itemName: "Elder's Avalonian Fishing Rod",
        itemId: "T8_2H_TOOL_FISHINGROD_AVALON",
        canEnchant: false
    },
{
        itemName: "Adept's Riding Horse",
        itemId: "T4_MOUNT_HORSE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Riding Horse",
        itemId: "T7_MOUNT_HORSE",
        canEnchant: false
    },
{
        itemName: "Novice's Mule",
        itemId: "T2_MOUNT_MULE",
        canEnchant: false
    },
{
        itemName: "Journeyman's Riding Horse",
        itemId: "T3_MOUNT_HORSE",
        canEnchant: false
    },
{
        itemName: "Master's Riding Horse",
        itemId: "T6_MOUNT_HORSE",
        canEnchant: false
    },
{
        itemName: "Elder's Armored Horse",
        itemId: "T8_MOUNT_ARMORED_HORSE",
        canEnchant: false
    },
{
        itemName: "Master's Armored Horse",
        itemId: "T6_MOUNT_ARMORED_HORSE",
        canEnchant: false
    },
{
        itemName: "Elder's Riding Horse",
        itemId: "T8_MOUNT_HORSE",
        canEnchant: false
    },
{
        itemName: "Expert's Armored Horse",
        itemId: "T5_MOUNT_ARMORED_HORSE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Armored Horse",
        itemId: "T7_MOUNT_ARMORED_HORSE",
        canEnchant: false
    },
{
        itemName: "Expert's Transport Ox",
        itemId: "T5_MOUNT_OX",
        canEnchant: false
    },
{
        itemName: "Journeyman's Transport Ox",
        itemId: "T3_MOUNT_OX",
        canEnchant: false
    },
{
        itemName: "Master's Transport Ox",
        itemId: "T6_MOUNT_OX",
        canEnchant: false
    },
{
        itemName: "Adept's Giant Stag",
        itemId: "T4_MOUNT_GIANTSTAG",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Transport Ox",
        itemId: "T7_MOUNT_OX",
        canEnchant: false
    },
{
        itemName: "Moose",
        itemId: "T6_MOUNT_GIANTSTAG_MOOSE",
        canEnchant: false
    },
{
        itemName: "Adept's Transport Ox",
        itemId: "T4_MOUNT_OX",
        canEnchant: false
    },
{
        itemName: "Saddled Swamp Dragon",
        itemId: "T7_MOUNT_SWAMPDRAGON",
        canEnchant: false
    },
{
        itemName: "Direwolf",
        itemId: "T6_MOUNT_DIREWOLF",
        canEnchant: false
    },
{
        itemName: "Saddled Direboar",
        itemId: "T7_MOUNT_DIREBOAR",
        canEnchant: false
    },
{
        itemName: "Elder's Transport Ox",
        itemId: "T8_MOUNT_OX",
        canEnchant: false
    },
{
        itemName: "Elder's Transport Mammoth",
        itemId: "T8_MOUNT_MAMMOTH_TRANSPORT",
        canEnchant: false
    },
{
        itemName: "Saddled Winter Bear",
        itemId: "T5_MOUNT_DIREBEAR_FW_FORTSTERLING",
        canEnchant: false
    },
{
        itemName: "Saddled Moabird",
        itemId: "T5_MOUNT_MOABIRD_FW_BRIDGEWATCH",
        canEnchant: false
    },
{
        itemName: "Saddled Swamp Salamander",
        itemId: "T5_MOUNT_SWAMPDRAGON_FW_THETFORD",
        canEnchant: false
    },
{
        itemName: "Saddled Bighorn Ram",
        itemId: "T5_MOUNT_RAM_FW_MARTLOCK",
        canEnchant: false
    },
{
        itemName: "Saddled Direbear",
        itemId: "T8_MOUNT_DIREBEAR",
        canEnchant: false
    },
{
        itemName: "Elite Terrorbird",
        itemId: "T8_MOUNT_MOABIRD_FW_BRIDGEWATCH_ELITE",
        canEnchant: false
    },
{
        itemName: "Saddled Wild Boar",
        itemId: "T5_MOUNT_DIREBOAR_FW_LYMHURST",
        canEnchant: false
    },
{
        itemName: "Saddled Greywolf",
        itemId: "T5_MOUNT_GREYWOLF_FW_CAERLEON",
        canEnchant: false
    },
{
        itemName: "Elite Winter Bear",
        itemId: "T8_MOUNT_DIREBEAR_FW_FORTSTERLING_ELITE",
        canEnchant: false
    },
{
        itemName: "Elite Swamp Salamander",
        itemId: "T8_MOUNT_SWAMPDRAGON_FW_THETFORD_ELITE",
        canEnchant: false
    },
{
        itemName: "Elite Wild Boar",
        itemId: "T8_MOUNT_DIREBOAR_FW_LYMHURST_ELITE",
        canEnchant: false
    },
{
        itemName: "Elite Bighorn Ram",
        itemId: "T8_MOUNT_RAM_FW_MARTLOCK_ELITE",
        canEnchant: false
    },
{
        itemName: "Elite Greywolf",
        itemId: "T8_MOUNT_GREYWOLF_FW_CAERLEON_ELITE",
        canEnchant: false
    },
{
        itemName: "Siege Ballista",
        itemId: "T6_MOUNT_SIEGE_BALLISTA",
        canEnchant: false
    },
{
        itemName: "Venom Basilisk",
        itemId: "T7_MOUNT_ARMORED_SWAMPDRAGON_BATTLE",
        canEnchant: false
    },
{
        itemName: "Flame Basilisk",
        itemId: "T7_MOUNT_SWAMPDRAGON_BATTLE",
        canEnchant: false
    },
{
        itemName: "Avalonian Basilisk",
        itemId: "T7_MOUNT_SWAMPDRAGON_AVALON_BASILISK",
        canEnchant: false
    },
{
        itemName: "Yule Ram",
        itemId: "UNIQUE_MOUNT_RAM_XMAS",
        canEnchant: false
    },
{
        itemName: "Recruiter's Moabird",
        itemId: "UNIQUE_MOUNT_MOABIRD_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Giant Frog",
        itemId: "UNIQUE_MOUNT_GIANTTOAD_02_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Toad",
        itemId: "UNIQUE_MOUNT_GIANTTOAD_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Saddled Bat",
        itemId: "UNIQUE_MOUNT_BAT_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Ram",
        itemId: "UNIQUE_MOUNT_RAM_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Expert's Warhorse",
        itemId: "T5_MOUNT_ARMORED_HORSE_SKIN_01",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Warhorse",
        itemId: "T7_MOUNT_ARMORED_HORSE_SKIN_01",
        canEnchant: false
    },
{
        itemName: "Pest Lizard",
        itemId: "T7_MOUNT_MONITORLIZARD_ADC",
        canEnchant: false
    },
{
        itemName: "Master's Warhorse",
        itemId: "T6_MOUNT_ARMORED_HORSE_SKIN_01",
        canEnchant: false
    },
{
        itemName: "Spectral Bat",
        itemId: "UNIQUE_MOUNT_BAT_PERSONAL",
        canEnchant: false
    },
{
        itemName: "Elder's Warhorse",
        itemId: "T8_MOUNT_ARMORED_HORSE_SKIN_01",
        canEnchant: false
    },
{
        itemName: "Frost Ram",
        itemId: "T6_MOUNT_FROSTRAM_ADC",
        canEnchant: false
    },
{
        itemName: "Saddled Terrorbird",
        itemId: "T7_MOUNT_TERRORBIRD_ADC",
        canEnchant: false
    },
{
        itemName: "Morgana Raven",
        itemId: "UNIQUE_MOUNT_MORGANA_RAVEN_ADC",
        canEnchant: false
    },
{
        itemName: "Grizzly Bear",
        itemId: "UNIQUE_MOUNT_BEAR_KEEPER_ADC",
        canEnchant: false
    },
{
        itemName: "Black Panther",
        itemId: "UNIQUE_MOUNT_BLACK_PANTHER_ADC",
        canEnchant: false
    },
{
        itemName: "Snow Husky",
        itemId: "T7_MOUNT_HUSKY_ADC",
        canEnchant: false
    },
{
        itemName: "Gallant Horse",
        itemId: "UNIQUE_MOUNT_GIANT_HORSE_ADC",
        canEnchant: false
    },
{
        itemName: "Spectral Direboar",
        itemId: "UNIQUE_MOUNT_UNDEAD_DIREBOAR_ADC",
        canEnchant: false
    },
{
        itemName: "Crystal Battle Rhino",
        itemId: "UNIQUE_MOUNT_RHINO_SEASON_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Heretic Combat Mule",
        itemId: "UNIQUE_MOUNT_HERETIC_MULE_ADC",
        canEnchant: false
    },
{
        itemName: "Gold Battle Rhino",
        itemId: "UNIQUE_MOUNT_RHINO_SEASON_GOLD",
        canEnchant: false
    },
{
        itemName: "Crystal Tower Chariot",
        itemId: "UNIQUE_MOUNT_TOWER_CHARIOT_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Divine Owl",
        itemId: "UNIQUE_MOUNT_DIVINE_OWL_ADC",
        canEnchant: false
    },
{
        itemName: "Silver Battle Rhino",
        itemId: "UNIQUE_MOUNT_RHINO_SEASON_SILVER",
        canEnchant: false
    },
{
        itemName: "Gold Tower Chariot",
        itemId: "UNIQUE_MOUNT_TOWER_CHARIOT_GOLD",
        canEnchant: false
    },
{
        itemName: "Crystal Battle Eagle",
        itemId: "UNIQUE_MOUNT_ARMORED_EAGLE_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Bronze Battle Rhino",
        itemId: "UNIQUE_MOUNT_RHINO_SEASON_BRONZE",
        canEnchant: false
    },
{
        itemName: "Silver Tower Chariot",
        itemId: "UNIQUE_MOUNT_TOWER_CHARIOT_SILVER",
        canEnchant: false
    },
{
        itemName: "Gold Battle Eagle",
        itemId: "UNIQUE_MOUNT_ARMORED_EAGLE_GOLD",
        canEnchant: false
    },
{
        itemName: "Silver Battle Eagle",
        itemId: "UNIQUE_MOUNT_ARMORED_EAGLE_SILVER",
        canEnchant: false
    },
{
        itemName: "Silver Colossus Beetle",
        itemId: "UNIQUE_MOUNT_BEETLE_SILVER",
        canEnchant: false
    },
{
        itemName: "Crystal Colossus Beetle",
        itemId: "UNIQUE_MOUNT_BEETLE_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Silver Behemoth",
        itemId: "UNIQUE_MOUNT_BEHEMOTH_SILVER",
        canEnchant: false
    },
{
        itemName: "Gold Colossus Beetle",
        itemId: "UNIQUE_MOUNT_BEETLE_GOLD",
        canEnchant: false
    },
{
        itemName: "Gold Ancient Ent",
        itemId: "UNIQUE_MOUNT_ENT_GOLD",
        canEnchant: false
    },
{
        itemName: "Crystal Ancient Ent",
        itemId: "UNIQUE_MOUNT_ENT_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Gold Behemoth",
        itemId: "UNIQUE_MOUNT_BEHEMOTH_GOLD",
        canEnchant: false
    },
{
        itemName: "Silver Ancient Ent",
        itemId: "UNIQUE_MOUNT_ENT_SILVER",
        canEnchant: false
    },
{
        itemName: "Crystal Behemoth",
        itemId: "UNIQUE_MOUNT_BEHEMOTH_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Silver Goliath Horseeater",
        itemId: "UNIQUE_MOUNT_BATTLESPIDER_SILVER",
        canEnchant: false
    },
{
        itemName: "Crystal Goliath Horseeater",
        itemId: "UNIQUE_MOUNT_BATTLESPIDER_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Gold Roving Bastion",
        itemId: "UNIQUE_MOUNT_BASTION_GOLD",
        canEnchant: false
    },
{
        itemName: "Crystal Roving Bastion",
        itemId: "UNIQUE_MOUNT_BASTION_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Silver Roving Bastion",
        itemId: "UNIQUE_MOUNT_BASTION_SILVER",
        canEnchant: false
    },
{
        itemName: "Crystal Phalanx Beetle",
        itemId: "UNIQUE_MOUNT_TANKBEETLE_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Gold Goliath Horseeater",
        itemId: "UNIQUE_MOUNT_BATTLESPIDER_GOLD",
        canEnchant: false
    },
{
        itemName: "Gold Juggernaut",
        itemId: "UNIQUE_MOUNT_JUGGERNAUT_GOLD",
        canEnchant: false
    },
{
        itemName: "Silver Juggernaut",
        itemId: "UNIQUE_MOUNT_JUGGERNAUT_SILVER",
        canEnchant: false
    },
{
        itemName: "Crystal Juggernaut",
        itemId: "UNIQUE_MOUNT_JUGGERNAUT_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Epic Explorer's Giant Stag",
        itemId: "UNIQUE_MOUNT_GIANTSTAG_FOUNDER_EPIC",
        canEnchant: false
    },
{
        itemName: "Silver Phalanx Beetle",
        itemId: "UNIQUE_MOUNT_TANKBEETLE_SILVER",
        canEnchant: false
    },
{
        itemName: "Gold Phalanx Beetle",
        itemId: "UNIQUE_MOUNT_TANKBEETLE_GOLD",
        canEnchant: false
    },
{
        itemName: "Expert's Repair Kit",
        itemId: "T5_FURNITUREITEM_REPAIRKIT",
        canEnchant: false
    },
{
        itemName: "Master's Repair Kit",
        itemId: "T6_FURNITUREITEM_REPAIRKIT",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Repair Kit",
        itemId: "T7_FURNITUREITEM_REPAIRKIT",
        canEnchant: false
    },
{
        itemName: "Adept's Repair Kit",
        itemId: "T4_FURNITUREITEM_REPAIRKIT",
        canEnchant: false
    },
{
        itemName: "Guild Banner on Fabric",
        itemId: "T2_FURNITUREITEM_GUILDBANNER_FABRIC",
        canEnchant: false
    },
{
        itemName: "Elder's Repair Kit",
        itemId: "T8_FURNITUREITEM_REPAIRKIT",
        canEnchant: false
    },
{
        itemName: "Anniversary Banner - Red",
        itemId: "T3_FURNITUREITEM_ANNIVERSARYBANNER_2020",
        canEnchant: false
    },
{
        itemName: "Recruiter's Deer Statue",
        itemId: "UNIQUE_FURNITUREITEM_TELLAFRIEND_DEER_STATUE",
        canEnchant: false
    },
{
        itemName: "Anniversary Banner - White",
        itemId: "T3_FURNITUREITEM_ANNIVERSARYBANNER",
        canEnchant: false
    },
{
        itemName: "Recruiter's Sarcophagus Chest",
        itemId: "UNIQUE_FURNITUREITEM_TELLAFRIEND_CHEST_SARCOPHAGUS",
        canEnchant: false
    },
{
        itemName: "Recruiter's Hunter Statue",
        itemId: "UNIQUE_FURNITUREITEM_TELLAFRIEND_HUNTER_STATUE",
        canEnchant: false
    },
{
        itemName: "Anniversary Banner - Blue",
        itemId: "T3_FURNITUREITEM_ANNIVERSARYBANNER_2021",
        canEnchant: false
    },
{
        itemName: "Recruiter's Guild Banner",
        itemId: "UNIQUE_FURNITUREITEM_TELLAFRIEND_BANNER_A",
        canEnchant: false
    },
{
        itemName: "Guild Banner on Shield",
        itemId: "T2_FURNITUREITEM_GUILDBANNER_SHIELD",
        canEnchant: false
    },
{
        itemName: "Journeyman's Bed",
        itemId: "T3_FURNITUREITEM_BED",
        canEnchant: false
    },
{
        itemName: "Novice's Bed",
        itemId: "T2_FURNITUREITEM_BED",
        canEnchant: false
    },
{
        itemName: "Master's Bed",
        itemId: "T6_FURNITUREITEM_BED",
        canEnchant: false
    },
{
        itemName: "Expert's Bed",
        itemId: "T5_FURNITUREITEM_BED",
        canEnchant: false
    },
{
        itemName: "Adept's Bed",
        itemId: "T4_FURNITUREITEM_BED",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Bed",
        itemId: "T7_FURNITUREITEM_BED",
        canEnchant: false
    },
{
        itemName: "Journeyman's Chest",
        itemId: "T3_FURNITUREITEM_CHEST",
        canEnchant: false
    },
{
        itemName: "Novice's Chest",
        itemId: "T2_FURNITUREITEM_CHEST",
        canEnchant: false
    },
{
        itemName: "Royal Green Fireworks",
        itemId: "T3_VANITY_CONSUMABLE_FIREWORKS_GREEN",
        canEnchant: false
    },
{
        itemName: "Elder's Bed",
        itemId: "T8_FURNITUREITEM_BED",
        canEnchant: false
    },
{
        itemName: "Expert's Chest",
        itemId: "T5_FURNITUREITEM_CHEST",
        canEnchant: false
    },
{
        itemName: "Adept's Chest",
        itemId: "T4_FURNITUREITEM_CHEST",
        canEnchant: false
    },
{
        itemName: "Royal Blue Fireworks",
        itemId: "T3_VANITY_CONSUMABLE_FIREWORKS_BLUE",
        canEnchant: false
    },
{
        itemName: "Royal Yellow Fireworks",
        itemId: "T3_VANITY_CONSUMABLE_FIREWORKS_YELLOW",
        canEnchant: false
    },
{
        itemName: "Surprise Egg",
        itemId: "UNIQUE_CONSUMABLE_EVENT_EASTER_2020_EGG",
        canEnchant: false
    },
{
        itemName: "Royal Red Fireworks",
        itemId: "T3_VANITY_CONSUMABLE_FIREWORKS_RED",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Table",
        itemId: "T7_FURNITUREITEM_TABLE",
        canEnchant: false
    },
{
        itemName: "Chocolate",
        itemId: "UNIQUE_CONSUMABLE_EVENT_EASTER_2020_CHOCOLATE",
        canEnchant: false
    },
{
        itemName: "Snowball",
        itemId: "UNIQUE_CONSUMABLE_EVENT_WINTER_2017",
        canEnchant: false
    },
{
        itemName: "Journeyman's Table",
        itemId: "T3_FURNITUREITEM_TABLE",
        canEnchant: false
    },
{
        itemName: "Adept's Table",
        itemId: "T4_FURNITUREITEM_TABLE",
        canEnchant: false
    },
{
        itemName: "Expert's Table",
        itemId: "T5_FURNITUREITEM_TABLE",
        canEnchant: false
    },
{
        itemName: "Novice's Table",
        itemId: "T2_FURNITUREITEM_TABLE",
        canEnchant: false
    },
{
        itemName: "Elder's Table",
        itemId: "T8_FURNITUREITEM_TABLE",
        canEnchant: false
    },
{
        itemName: "Master's Table",
        itemId: "T6_FURNITUREITEM_TABLE",
        canEnchant: false
    },
{
        itemName: "Grand Arena Display",
        itemId: "UNIQUE_FURNITUREITEM_VANITY_ARENA_BANNER_02",
        canEnchant: false
    },
{
        itemName: "Modest Arena Display",
        itemId: "UNIQUE_FURNITUREITEM_VANITY_ARENA_BANNER_01",
        canEnchant: false
    },
{
        itemName: "Glorious Arena Display",
        itemId: "UNIQUE_FURNITUREITEM_VANITY_ARENA_BANNER_03",
        canEnchant: false
    },
{
        itemName: "Egg-shaped Chest",
        itemId: "UNIQUE_FURNITUREITEM_EASTER_CHEST",
        canEnchant: false
    },
{
        itemName: "Haystack and cart",
        itemId: "PLAYERISLAND_FURNITUREITEM_FARM_DECO_C",
        canEnchant: false
    },
{
        itemName: "Tree stump with pumpkins",
        itemId: "PLAYERISLAND_FURNITUREITEM_FARM_DECO_D",
        canEnchant: false
    },
{
        itemName: "Haystack",
        itemId: "PLAYERISLAND_FURNITUREITEM_FARM_DECO_B",
        canEnchant: false
    },
{
        itemName: "Small arcane stone sigil",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_MAGIC_EMBLEM_GROUND_A",
        canEnchant: false
    },
{
        itemName: "Small nature stone sigil",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_NATURE_EMBLEM_GROUND_A",
        canEnchant: false
    },
{
        itemName: "Fire bowl",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_FIREBOWL_A",
        canEnchant: false
    },
{
        itemName: "Arcane stone sigil",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_MAGIC_EMBLEM_GROUND_B",
        canEnchant: false
    },
{
        itemName: "Nature stone sigil",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_NATURE_EMBLEM_GROUND_B",
        canEnchant: false
    },
{
        itemName: "Broken scholar statue",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_STATUE_A_BROKEN",
        canEnchant: false
    },
{
        itemName: "Hunter statue",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_STATUE_HUNTER_B",
        canEnchant: false
    },
{
        itemName: "Hunting sculpture",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_STATUE_HUNTER_A",
        canEnchant: false
    },
{
        itemName: "Scholar statue",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_STATUE_A",
        canEnchant: false
    },
{
        itemName: "Magician statue",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_STATUE_MAGE_B",
        canEnchant: false
    },
{
        itemName: "Small sword sculpture",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_STATUE_SWORD_A",
        canEnchant: false
    },
{
        itemName: "Book sculpture",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_STATUE_MAGE_A",
        canEnchant: false
    },
{
        itemName: "Sword sculpture",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_STATUE_SWORD_B",
        canEnchant: false
    },
{
        itemName: "Fire bowl with pedestal",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_FIREBOWL_B",
        canEnchant: false
    },
{
        itemName: "Warrior statue",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_STATUE_WARRIOR_B",
        canEnchant: false
    },
{
        itemName: "Small valorous stone sigil",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_VALOR_EMBLEM_GROUND_A",
        canEnchant: false
    },
{
        itemName: "Stone well",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_WELL_A",
        canEnchant: false
    },
{
        itemName: "Autumn tree",
        itemId: "PLAYERISLAND_FURNITUREITEM_VEGETATION_TREE_DECO_A",
        canEnchant: false
    },
{
        itemName: "Summer tree",
        itemId: "PLAYERISLAND_FURNITUREITEM_VEGETATION_TREE_DECO_B",
        canEnchant: false
    },
{
        itemName: "Valorous stone sigil",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_VALOR_EMBLEM_GROUND_B",
        canEnchant: false
    },
{
        itemName: "Small fruit tree",
        itemId: "PLAYERISLAND_FURNITUREITEM_VEGETATION_TREE_DOMESTIC_A",
        canEnchant: false
    },
{
        itemName: "Fruit tree",
        itemId: "PLAYERISLAND_FURNITUREITEM_VEGETATION_TREE_DOMESTIC_B",
        canEnchant: false
    },
{
        itemName: "Bunting portal",
        itemId: "PLAYERISLAND_FURNITUREITEM_WOOD_BUNTING_A",
        canEnchant: false
    },
{
        itemName: "Spring tree",
        itemId: "PLAYERISLAND_FURNITUREITEM_VEGETATION_TREE_DECO_C",
        canEnchant: false
    },
{
        itemName: "Wooden watchtower",
        itemId: "PLAYERISLAND_FURNITUREITEM_WOOD_FENCE_WATCHTOWER_A",
        canEnchant: false
    },
{
        itemName: "Wooden sign",
        itemId: "PLAYERISLAND_FURNITUREITEM_WOOD_FLOOR_SIGN_A",
        canEnchant: false
    },
{
        itemName: "Sword and shield sculpture",
        itemId: "PLAYERISLAND_FURNITUREITEM_STONE_STATUE_WARRIOR_A",
        canEnchant: false
    },
{
        itemName: "Clothes line",
        itemId: "PLAYERISLAND_FURNITUREITEM_WOOD_LAUNDRY_A",
        canEnchant: false
    },
{
        itemName: "Corner lantern",
        itemId: "PLAYERISLAND_FURNITUREITEM_WOOD_LANTERN_CORNER_A",
        canEnchant: false
    },
{
        itemName: "Wooden entrance",
        itemId: "PLAYERISLAND_FURNITUREITEM_WOOD_GATE_A",
        canEnchant: false
    },
{
        itemName: "Flower vase",
        itemId: "PLAYERISLAND_FURNITUREITEM_VEGETATION_FLOWER_A",
        canEnchant: false
    },
{
        itemName: "Wooden gate",
        itemId: "PLAYERISLAND_FURNITUREITEM_WOOD_GATE_BIG_B",
        canEnchant: false
    },
{
        itemName: "Simple lantern",
        itemId: "PLAYERISLAND_FURNITUREITEM_WOOD_LANTERN_A",
        canEnchant: false
    },
{
        itemName: "Fish line",
        itemId: "PLAYERISLAND_FURNITUREITEM_WOOD_FISH_A",
        canEnchant: false
    },
{
        itemName: "Barrel with candle",
        itemId: "PLAYERISLAND_FURNITUREITEM_WOOD_BARREL_A",
        canEnchant: false
    },
{
        itemName: "Simple Brazier (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_FIREBOWL_B",
        canEnchant: false
    },
{
        itemName: "Flambeau (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_TORCH_A",
        canEnchant: false
    },
{
        itemName: "Raven Standard Shrine (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_SACRIFICE_ALTAR_A",
        canEnchant: false
    },
{
        itemName: "Candelabra",
        itemId: "PLAYERISLAND_FURNITUREITEM_WOOD_CANDELABRA_A",
        canEnchant: false
    },
{
        itemName: "Raven Standard (Disciples of Morgana)",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_STANDARD_A",
        canEnchant: false
    },
{
        itemName: "Morgana Candle Stand",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_CANDLESTAND_A",
        canEnchant: false
    },
{
        itemName: "Morgana Cultist Statue",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_STATUE_A",
        canEnchant: false
    },
{
        itemName: "Morgana Stone Archway",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_ARCHWAY_A",
        canEnchant: false
    },
{
        itemName: "Morgana Carpet",
        itemId: "UNIQUE_FURNITUREITEM_MORGANA_CARPET_A",
        canEnchant: false
    },
{
        itemName: "Keeper Ceremonial Candle",
        itemId: "UNIQUE_FURNITUREITEM_KEEPER_CANDLE_A",
        canEnchant: false
    },
{
        itemName: "Keeper Campfire",
        itemId: "UNIQUE_FURNITUREITEM_KEEPER_CAMP_FIRE_A",
        canEnchant: false
    },
{
        itemName: "Keeper Altar",
        itemId: "UNIQUE_FURNITUREITEM_KEEPER_ALTAR_A",
        canEnchant: false
    },
{
        itemName: "Keeper Symbol",
        itemId: "UNIQUE_FURNITUREITEM_KEEPER_SYMBOL_A",
        canEnchant: false
    },
{
        itemName: "Keeper Shrine",
        itemId: "UNIQUE_FURNITUREITEM_KEEPER_SHRINE_A",
        canEnchant: false
    },
{
        itemName: "Keeper Symbol of Power",
        itemId: "UNIQUE_FURNITUREITEM_KEEPER_SYMBOL_OF_POWER_A",
        canEnchant: false
    },
{
        itemName: "Keeper Star of Power",
        itemId: "UNIQUE_FURNITUREITEM_KEEPER_STAR_OF_POWER_A",
        canEnchant: false
    },
{
        itemName: "Keeper Flag",
        itemId: "UNIQUE_FURNITUREITEM_KEEPER_FLAG_A",
        canEnchant: false
    },
{
        itemName: "Heretic Food Stash",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_FOOD_PILE",
        canEnchant: false
    },
{
        itemName: "Keeper Rock Fireplace",
        itemId: "UNIQUE_FURNITUREITEM_KEEPER_HEATER",
        canEnchant: false
    },
{
        itemName: "Heretic Animal Cages",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_ANIMAL_CAGES",
        canEnchant: false
    },
{
        itemName: "Heretic Weapon Rack",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_WEAPON_RACK",
        canEnchant: false
    },
{
        itemName: "Heretic Training Dummy",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_TRAINING_DUMMY",
        canEnchant: false
    },
{
        itemName: "Keeper Cauldron",
        itemId: "UNIQUE_FURNITUREITEM_KEEPER_CAULDRON",
        canEnchant: false
    },
{
        itemName: "Keeper Fire Bowl",
        itemId: "UNIQUE_FURNITUREITEM_KEEPER_FIREBOWL",
        canEnchant: false
    },
{
        itemName: "Heretic Game Table",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_GAME_TABLE",
        canEnchant: false
    },
{
        itemName: "Heretic Chief's Table",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_PLANNING_TABLE",
        canEnchant: false
    },
{
        itemName: "Heretic Palisade",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_PALLISADE",
        canEnchant: false
    },
{
        itemName: "Heretic Flag",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_FLAG",
        canEnchant: false
    },
{
        itemName: "Heretic Tent",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_TENT",
        canEnchant: false
    },
{
        itemName: "Grim Gravestone",
        itemId: "UNIQUE_FURNITUREITEM_ADC_GRIM_HEADSTONE",
        canEnchant: false
    },
{
        itemName: "Tomb of the Unknown",
        itemId: "UNIQUE_FURNITUREITEM_ADC_GRAVE_A",
        canEnchant: false
    },
{
        itemName: "Grim Lantern",
        itemId: "UNIQUE_FURNITUREITEM_ADC_GRIM_LANTERN",
        canEnchant: false
    },
{
        itemName: "Weeping Woman Statue",
        itemId: "UNIQUE_FURNITUREITEM_ADC_GRIM_WEEPINGWOMAN",
        canEnchant: false
    },
{
        itemName: "Yuletide Candle",
        itemId: "UNIQUE_FURNITUREITEM_XMAS_BRANCH_A",
        canEnchant: false
    },
{
        itemName: "Empty Coffin",
        itemId: "UNIQUE_FURNITUREITEM_ADC_GRIM_COFFIN",
        canEnchant: false
    },
{
        itemName: "Yuletide Wreath",
        itemId: "UNIQUE_FURNITUREITEM_XMAS_BRANCH_B",
        canEnchant: false
    },
{
        itemName: "Decorated Pine Tree",
        itemId: "UNIQUE_FURNITUREITEM_XMAS_FILL_CITY_TREE_A",
        canEnchant: false
    },
{
        itemName: "Small Decorated Pine Tree",
        itemId: "UNIQUE_FURNITUREITEM_XMAS_FILL_CITY_TREE_B",
        canEnchant: false
    },
{
        itemName: "Yuletide Lantern",
        itemId: "UNIQUE_FURNITUREITEM_XMAS_LANTERN",
        canEnchant: false
    },
{
        itemName: "Present Box",
        itemId: "UNIQUE_FURNITUREITEM_XMAS_PRESENT",
        canEnchant: false
    },
{
        itemName: "Frost Snowman",
        itemId: "UNIQUE_FURNITUREITEM_ADC_FROST_SNOWMAN",
        canEnchant: false
    },
{
        itemName: "Ice Sculpture: Obsessed Cultist",
        itemId: "UNIQUE_FURNITUREITEM_ADC_ICESCULPTURE_C",
        canEnchant: false
    },
{
        itemName: "Ice Sculpture: Cursed Archer",
        itemId: "UNIQUE_FURNITUREITEM_ADC_ICESCULPTURE_B",
        canEnchant: false
    },
{
        itemName: "Ice Sculpture: Bonecrusher Berserker",
        itemId: "UNIQUE_FURNITUREITEM_ADC_ICESCULPTURE_A",
        canEnchant: false
    },
{
        itemName: "Frost Igloo",
        itemId: "UNIQUE_FURNITUREITEM_ADC_FROST_IGLOO",
        canEnchant: false
    },
{
        itemName: "Carnival Firework",
        itemId: "UNIQUE_FURNITUREITEM_ADC_CARNIVAL_FIREWORK_A",
        canEnchant: false
    },
{
        itemName: "Carnival Costume Cart",
        itemId: "UNIQUE_FURNITUREITEM_ADC_CARNIVAL_MASK_CART",
        canEnchant: false
    },
{
        itemName: "Wolf Rider Statue (L)",
        itemId: "UNIQUE_FURNITUREITEM_ADC_STATUE_MOUNTED_DIREWOLF_A",
        canEnchant: false
    },
{
        itemName: "Carnival Arch",
        itemId: "UNIQUE_FURNITUREITEM_ADC_CARNIVAL_ARCHWAY_A",
        canEnchant: false
    },
{
        itemName: "Wolf Rider Statue (R)",
        itemId: "UNIQUE_FURNITUREITEM_ADC_STATUE_MOUNTED_DIREWOLF_B",
        canEnchant: false
    },
{
        itemName: "Wolf Rug",
        itemId: "UNIQUE_FURNITUREITEM_ADC_RUG_WOLF",
        canEnchant: false
    },
{
        itemName: "Direbear Rug",
        itemId: "UNIQUE_FURNITUREITEM_ADC_RUG_DIREBEAR",
        canEnchant: false
    },
{
        itemName: "Memorial of the Fallen",
        itemId: "UNIQUE_FURNITUREITEM_ADC_GRAVE_B",
        canEnchant: false
    },
{
        itemName: "Regal Carpet",
        itemId: "UNIQUE_FURNITUREITEM_KNIGHT_CARPET_A",
        canEnchant: false
    },
{
        itemName: "Knight Statue",
        itemId: "UNIQUE_FURNITUREITEM_KNIGHT_STATUE_A",
        canEnchant: false
    },
{
        itemName: "Mage Statue",
        itemId: "UNIQUE_FURNITUREITEM_ADC_STATUE_MAGE_A",
        canEnchant: false
    },
{
        itemName: "Stone Throne",
        itemId: "UNIQUE_FURNITUREITEM_KNIGHT_THRONE_A",
        canEnchant: false
    },
{
        itemName: "Round Table",
        itemId: "UNIQUE_FURNITUREITEM_KNIGHT_ROUNDTABLE_A",
        canEnchant: false
    },
{
        itemName: "Magic Rune Circle",
        itemId: "UNIQUE_FURNITUREITEM_ADC_HEALING_CIRCLE_A",
        canEnchant: false
    },
{
        itemName: "Glass Sphere",
        itemId: "UNIQUE_FURNITUREITEM_ADC_GLASS_SPHERE_A",
        canEnchant: false
    },
{
        itemName: "Heretic Burning Barrel",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_BARREL_BURNING_A",
        canEnchant: false
    },
{
        itemName: "Heretic Toolboard",
        itemId: "UNIQUE_FURNITUREITEM_HERETICS_TOOL_BOARD_A",
        canEnchant: false
    },
{
        itemName: "Heretic Lantern",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_LANTERN",
        canEnchant: false
    },
{
        itemName: "Heretic Junkpile",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_JUNKPILE",
        canEnchant: false
    },
{
        itemName: "Heretic Scarecrow",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_CONSTRUCT",
        canEnchant: false
    },
{
        itemName: "Scary Pumpkin Lantern",
        itemId: "UNIQUE_FURNITUREITEM_ADC_HALLOWEEN_PUMPKIN_LANTERN_A",
        canEnchant: false
    },
{
        itemName: "Friendly Pumpkin Lantern",
        itemId: "UNIQUE_FURNITUREITEM_ADC_HALLOWEEN_PUMPKIN_LANTERN_B",
        canEnchant: false
    },
{
        itemName: "Halloween Scarecrow",
        itemId: "UNIQUE_FURNITUREITEM_ADC_HALLOWEEN_SCARECROW_A",
        canEnchant: false
    },
{
        itemName: "Halloween Cauldron",
        itemId: "UNIQUE_FURNITUREITEM_ADC_HALLOWEEN_CAULDRON_A",
        canEnchant: false
    },
{
        itemName: "Halloween Pyre",
        itemId: "UNIQUE_FURNITUREITEM_ADC_HALLOWEEN_SCARECROW_PYRE_A",
        canEnchant: false
    },
{
        itemName: "Halloween Lantern",
        itemId: "UNIQUE_FURNITUREITEM_ADC_HALLOWEEN_TREE_LANTERN_A",
        canEnchant: false
    },
{
        itemName: "Heretic Stove",
        itemId: "UNIQUE_FURNITUREITEM_HERETIC_STOVE_A",
        canEnchant: false
    },
{
        itemName: "Caerleon Realmgate",
        itemId: "UNIQUE_FURNITUREITEM_SEALED_CAERLEON_REALMGATE",
        canEnchant: false
    },
{
        itemName: "Explorer's Anchor",
        itemId: "UNIQUE_INGREDIENT_ANCHOR_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Founder's Statue",
        itemId: "UNIQUE_FURNITUREITEM_FOUNDER_STATUE",
        canEnchant: false
    },
{
        itemName: "Skull of $craftedby",
        itemId: "UNIQUE_FURNITUREITEM_VICTORY_TROPHY",
        canEnchant: false
    },
{
        itemName: "Explorer's Spyglass",
        itemId: "UNIQUE_FURNITUREITEM_FOUNDER_LOOKINGGLASS",
        canEnchant: false
    },
{
        itemName: "Rubberband Boots",
        itemId: "UNIQUE_SHOES_RUBBERBANDING",
        canEnchant: false
    },
{
        itemName: "Founder's Certificate",
        itemId: "UNIQUE_FURNITUREITEM_FOUNDER_CERTIFICATE",
        canEnchant: false
    },
{
        itemName: "Game Master's Doublet",
        itemId: "UNIQUE_INTERNAL_ARMOR_GAMEMASTER",
        canEnchant: false
    },
{
        itemName: "Game Master's Hat",
        itemId: "UNIQUE_INTERNAL_HEAD_GAMEMASTER",
        canEnchant: false
    },
{
        itemName: "Game Master's Boots",
        itemId: "UNIQUE_INTERNAL_SHOES_GAMEMASTER",
        canEnchant: false
    },
{
        itemName: "Outlands Map Carpet",
        itemId: "UNIQUE_FURNITUREITEM_OLD_OUTLAND_CARPET",
        canEnchant: false
    },
{
        itemName: "Novice's Soldier Helmet",
        itemId: "T2_HEAD_PLATE_SET1",
        canEnchant: false
    },
{
        itemName: "Scroll of the Law",
        itemId: "UNIQUE_INTERNAL_OFF_SCROLL_GAMEMASTER",
        canEnchant: false
    },
{
        itemName: "Novice's Soldier Armor",
        itemId: "T2_ARMOR_PLATE_SET1",
        canEnchant: false
    },
{
        itemName: "Journeyman's Soldier Helmet",
        itemId: "T3_HEAD_PLATE_SET1",
        canEnchant: false
    },
{
        itemName: "Novice's Soldier Boots",
        itemId: "T2_SHOES_PLATE_SET1",
        canEnchant: false
    },
{
        itemName: "Journeyman's Soldier Boots",
        itemId: "T3_SHOES_PLATE_SET1",
        canEnchant: false
    },
{
        itemName: "Journeyman's Soldier Armor",
        itemId: "T3_ARMOR_PLATE_SET1",
        canEnchant: false
    },
{
        itemName: "Journeyman's Mercenary Hood",
        itemId: "T3_HEAD_LEATHER_SET1",
        canEnchant: false
    },
{
        itemName: "Beginner's Mercenary Hood",
        itemId: "T1_HEAD_LEATHER_SET1",
        canEnchant: false
    },
{
        itemName: "Novice's Mercenary Hood",
        itemId: "T2_HEAD_LEATHER_SET1",
        canEnchant: false
    },
{
        itemName: "Beginner's Mercenary Jacket",
        itemId: "T1_ARMOR_LEATHER_SET1",
        canEnchant: false
    },
{
        itemName: "Novice's Mercenary Jacket",
        itemId: "T2_ARMOR_LEATHER_SET1",
        canEnchant: false
    },
{
        itemName: "Beginner's Mercenary Shoes",
        itemId: "T1_SHOES_LEATHER_SET1",
        canEnchant: false
    },
{
        itemName: "Journeyman's Mercenary Shoes",
        itemId: "T3_SHOES_LEATHER_SET1",
        canEnchant: false
    },
{
        itemName: "Journeyman's Mercenary Jacket",
        itemId: "T3_ARMOR_LEATHER_SET1",
        canEnchant: false
    },
{
        itemName: "Novice's Scholar Cowl",
        itemId: "T2_HEAD_CLOTH_SET1",
        canEnchant: false
    },
{
        itemName: "Novice's Mercenary Shoes",
        itemId: "T2_SHOES_LEATHER_SET1",
        canEnchant: false
    },
{
        itemName: "Journeyman's Scholar Cowl",
        itemId: "T3_HEAD_CLOTH_SET1",
        canEnchant: false
    },
{
        itemName: "Journeyman's Scholar Sandals",
        itemId: "T3_SHOES_CLOTH_SET1",
        canEnchant: false
    },
{
        itemName: "Novice's Scholar Robe",
        itemId: "T2_ARMOR_CLOTH_SET1",
        canEnchant: false
    },
{
        itemName: "Journeyman's Scholar Robe",
        itemId: "T3_ARMOR_CLOTH_SET1",
        canEnchant: false
    },
{
        itemName: "Novice Lumberjack's Journal (Partially Full)",
        itemId: "T2_JOURNAL_WOOD",
        canEnchant: false
    },
{
        itemName: "Novice's Scholar Sandals",
        itemId: "T2_SHOES_CLOTH_SET1",
        canEnchant: false
    },
{
        itemName: "Expert Lumberjack's Journal (Partially Full)",
        itemId: "T5_JOURNAL_WOOD",
        canEnchant: false
    },
{
        itemName: "Adept Lumberjack's Journal (Partially Full)",
        itemId: "T4_JOURNAL_WOOD",
        canEnchant: false
    },
{
        itemName: "Journeyman Lumberjack's Journal (Partially Full)",
        itemId: "T3_JOURNAL_WOOD",
        canEnchant: false
    },
{
        itemName: "Elder Lumberjack's Journal (Partially Full)",
        itemId: "T8_JOURNAL_WOOD",
        canEnchant: false
    },
{
        itemName: "Master Lumberjack's Journal (Partially Full)",
        itemId: "T6_JOURNAL_WOOD",
        canEnchant: false
    },
{
        itemName: "Grandmaster Lumberjack's Journal (Partially Full)",
        itemId: "T7_JOURNAL_WOOD",
        canEnchant: false
    },
{
        itemName: "Novice Stonecutter's Journal (Partially Full)",
        itemId: "T2_JOURNAL_STONE",
        canEnchant: false
    },
{
        itemName: "Journeyman Stonecutter's Journal (Partially Full)",
        itemId: "T3_JOURNAL_STONE",
        canEnchant: false
    },
{
        itemName: "Grandmaster Stonecutter's Journal (Partially Full)",
        itemId: "T7_JOURNAL_STONE",
        canEnchant: false
    },
{
        itemName: "Expert Stonecutter's Journal (Partially Full)",
        itemId: "T5_JOURNAL_STONE",
        canEnchant: false
    },
{
        itemName: "Adept Stonecutter's Journal (Partially Full)",
        itemId: "T4_JOURNAL_STONE",
        canEnchant: false
    },
{
        itemName: "Master Stonecutter's Journal (Partially Full)",
        itemId: "T6_JOURNAL_STONE",
        canEnchant: false
    },
{
        itemName: "Elder Stonecutter's Journal (Partially Full)",
        itemId: "T8_JOURNAL_STONE",
        canEnchant: false
    },
{
        itemName: "Journeyman Prospector's Journal (Partially Full)",
        itemId: "T3_JOURNAL_ORE",
        canEnchant: false
    },
{
        itemName: "Novice Prospector's Journal (Partially Full)",
        itemId: "T2_JOURNAL_ORE",
        canEnchant: false
    },
{
        itemName: "Grandmaster Prospector's Journal (Partially Full)",
        itemId: "T7_JOURNAL_ORE",
        canEnchant: false
    },
{
        itemName: "Master Prospector's Journal (Partially Full)",
        itemId: "T6_JOURNAL_ORE",
        canEnchant: false
    },
{
        itemName: "Expert Prospector's Journal (Partially Full)",
        itemId: "T5_JOURNAL_ORE",
        canEnchant: false
    },
{
        itemName: "Journeyman Cropper's Journal (Partially Full)",
        itemId: "T3_JOURNAL_FIBER",
        canEnchant: false
    },
{
        itemName: "Elder Prospector's Journal (Partially Full)",
        itemId: "T8_JOURNAL_ORE",
        canEnchant: false
    },
{
        itemName: "Adept Prospector's Journal (Partially Full)",
        itemId: "T4_JOURNAL_ORE",
        canEnchant: false
    },
{
        itemName: "Novice Cropper's Journal (Partially Full)",
        itemId: "T2_JOURNAL_FIBER",
        canEnchant: false
    },
{
        itemName: "Expert Cropper's Journal (Partially Full)",
        itemId: "T5_JOURNAL_FIBER",
        canEnchant: false
    },
{
        itemName: "Novice Gamekeeper's Journal (Partially Full)",
        itemId: "T2_JOURNAL_HIDE",
        canEnchant: false
    },
{
        itemName: "Elder Cropper's Journal (Partially Full)",
        itemId: "T8_JOURNAL_FIBER",
        canEnchant: false
    },
{
        itemName: "Adept Cropper's Journal (Partially Full)",
        itemId: "T4_JOURNAL_FIBER",
        canEnchant: false
    },
{
        itemName: "Grandmaster Cropper's Journal (Partially Full)",
        itemId: "T7_JOURNAL_FIBER",
        canEnchant: false
    },
{
        itemName: "Journeyman Gamekeeper's Journal (Partially Full)",
        itemId: "T3_JOURNAL_HIDE",
        canEnchant: false
    },
{
        itemName: "Master Cropper's Journal (Partially Full)",
        itemId: "T6_JOURNAL_FIBER",
        canEnchant: false
    },
{
        itemName: "Expert Gamekeeper's Journal (Partially Full)",
        itemId: "T5_JOURNAL_HIDE",
        canEnchant: false
    },
{
        itemName: "Novice Blacksmith's Journal (Partially Full)",
        itemId: "T2_JOURNAL_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Adept Gamekeeper's Journal (Partially Full)",
        itemId: "T4_JOURNAL_HIDE",
        canEnchant: false
    },
{
        itemName: "Master Gamekeeper's Journal (Partially Full)",
        itemId: "T6_JOURNAL_HIDE",
        canEnchant: false
    },
{
        itemName: "Grandmaster Gamekeeper's Journal (Partially Full)",
        itemId: "T7_JOURNAL_HIDE",
        canEnchant: false
    },
{
        itemName: "Journeyman Blacksmith's Journal (Partially Full)",
        itemId: "T3_JOURNAL_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Elder Gamekeeper's Journal (Partially Full)",
        itemId: "T8_JOURNAL_HIDE",
        canEnchant: false
    },
{
        itemName: "Adept Blacksmith's Journal (Partially Full)",
        itemId: "T4_JOURNAL_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Expert Blacksmith's Journal (Partially Full)",
        itemId: "T5_JOURNAL_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Grandmaster Blacksmith's Journal (Partially Full)",
        itemId: "T7_JOURNAL_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Elder Blacksmith's Journal (Partially Full)",
        itemId: "T8_JOURNAL_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Master Blacksmith's Journal (Partially Full)",
        itemId: "T6_JOURNAL_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Adept Fletcher's Journal (Partially Full)",
        itemId: "T4_JOURNAL_HUNTER",
        canEnchant: false
    },
{
        itemName: "Journeyman Fletcher's Journal (Partially Full)",
        itemId: "T3_JOURNAL_HUNTER",
        canEnchant: false
    },
{
        itemName: "Expert Fletcher's Journal (Partially Full)",
        itemId: "T5_JOURNAL_HUNTER",
        canEnchant: false
    },
{
        itemName: "Novice Fletcher's Journal (Partially Full)",
        itemId: "T2_JOURNAL_HUNTER",
        canEnchant: false
    },
{
        itemName: "Novice Imbuer's Journal (Partially Full)",
        itemId: "T2_JOURNAL_MAGE",
        canEnchant: false
    },
{
        itemName: "Journeyman Imbuer's Journal (Partially Full)",
        itemId: "T3_JOURNAL_MAGE",
        canEnchant: false
    },
{
        itemName: "Master Fletcher's Journal (Partially Full)",
        itemId: "T6_JOURNAL_HUNTER",
        canEnchant: false
    },
{
        itemName: "Grandmaster Fletcher's Journal (Partially Full)",
        itemId: "T7_JOURNAL_HUNTER",
        canEnchant: false
    },
{
        itemName: "Adept Imbuer's Journal (Partially Full)",
        itemId: "T4_JOURNAL_MAGE",
        canEnchant: false
    },
{
        itemName: "Elder Fletcher's Journal (Partially Full)",
        itemId: "T8_JOURNAL_HUNTER",
        canEnchant: false
    },
{
        itemName: "Elder Imbuer's Journal (Partially Full)",
        itemId: "T8_JOURNAL_MAGE",
        canEnchant: false
    },
{
        itemName: "Master Imbuer's Journal (Partially Full)",
        itemId: "T6_JOURNAL_MAGE",
        canEnchant: false
    },
{
        itemName: "Grandmaster Imbuer's Journal (Partially Full)",
        itemId: "T7_JOURNAL_MAGE",
        canEnchant: false
    },
{
        itemName: "Expert Imbuer's Journal (Partially Full)",
        itemId: "T5_JOURNAL_MAGE",
        canEnchant: false
    },
{
        itemName: "Adept Tinker's Journal (Partially Full)",
        itemId: "T4_JOURNAL_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Novice Tinker's Journal (Partially Full)",
        itemId: "T2_JOURNAL_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Journeyman Tinker's Journal (Partially Full)",
        itemId: "T3_JOURNAL_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Master Tinker's Journal (Partially Full)",
        itemId: "T6_JOURNAL_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Grandmaster Tinker's Journal (Partially Full)",
        itemId: "T7_JOURNAL_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Journeyman Mercenary's Journal (Partially Full)",
        itemId: "T3_JOURNAL_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Elder Tinker's Journal (Partially Full)",
        itemId: "T8_JOURNAL_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Expert Tinker's Journal (Partially Full)",
        itemId: "T5_JOURNAL_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Grandmaster Mercenary's Journal (Partially Full)",
        itemId: "T7_JOURNAL_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Adept Mercenary's Journal (Partially Full)",
        itemId: "T4_JOURNAL_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Novice Mercenary's Journal (Partially Full)",
        itemId: "T2_JOURNAL_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Expert Mercenary's Journal (Partially Full)",
        itemId: "T5_JOURNAL_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Adept's Generalist Trophy Journal (Partially Full)",
        itemId: "T4_JOURNAL_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Journeyman's Generalist Trophy Journal (Partially Full)",
        itemId: "T3_JOURNAL_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Master Mercenary's Journal (Partially Full)",
        itemId: "T6_JOURNAL_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Novice's Generalist Trophy Journal (Partially Full)",
        itemId: "T2_JOURNAL_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Elder Mercenary's Journal (Partially Full)",
        itemId: "T8_JOURNAL_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Master's Generalist Trophy Journal (Partially Full)",
        itemId: "T6_JOURNAL_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Elder's Generalist Trophy Journal (Partially Full)",
        itemId: "T8_JOURNAL_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Expert's Generalist Trophy Journal (Partially Full)",
        itemId: "T5_JOURNAL_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Novice Mercenary's Trophy Journal (Partially Full)",
        itemId: "T2_JOURNAL_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Journeyman Mercenary's Trophy Journal (Partially Full)",
        itemId: "T3_JOURNAL_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Generalist Trophy Journal (Partially Full)",
        itemId: "T7_JOURNAL_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Adept Mercenary's Trophy Journal (Partially Full)",
        itemId: "T4_JOURNAL_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Expert Mercenary's Trophy Journal (Partially Full)",
        itemId: "T5_JOURNAL_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Master Mercenary's Trophy Journal (Partially Full)",
        itemId: "T6_JOURNAL_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Mercenary's Trophy Journal (Partially Full)",
        itemId: "T7_JOURNAL_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Elder Mercenary's Trophy Journal (Partially Full)",
        itemId: "T8_JOURNAL_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Journeyman Gamekeeper's Trophy Journal (Partially Full)",
        itemId: "T3_JOURNAL_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Adept Gamekeeper's Trophy Journal (Partially Full)",
        itemId: "T4_JOURNAL_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Novice Gamekeeper's Trophy Journal (Partially Full)",
        itemId: "T2_JOURNAL_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Grandmaster Gamekeeper's Trophy Journal (Partially Full)",
        itemId: "T7_JOURNAL_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Expert Gamekeeper's Trophy Journal (Partially Full)",
        itemId: "T5_JOURNAL_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Master Gamekeeper's Trophy Journal (Partially Full)",
        itemId: "T6_JOURNAL_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Elder Gamekeeper's Trophy Journal (Partially Full)",
        itemId: "T8_JOURNAL_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Adept Lumberjack's Trophy Journal (Partially Full)",
        itemId: "T4_JOURNAL_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Journeyman Lumberjack's Trophy Journal (Partially Full)",
        itemId: "T3_JOURNAL_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Master Lumberjack's Trophy Journal (Partially Full)",
        itemId: "T6_JOURNAL_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Expert Lumberjack's Trophy Journal (Partially Full)",
        itemId: "T5_JOURNAL_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Novice Lumberjack's Trophy Journal (Partially Full)",
        itemId: "T2_JOURNAL_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Grandmaster Lumberjack's Trophy Journal (Partially Full)",
        itemId: "T7_JOURNAL_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Adept Stonecutter's Trophy Journal (Partially Full)",
        itemId: "T4_JOURNAL_TROPHY_STONE",
        canEnchant: false
    },
{
        itemName: "Journeyman Stonecutter's Trophy Journal (Partially Full)",
        itemId: "T3_JOURNAL_TROPHY_STONE",
        canEnchant: false
    },
{
        itemName: "Grandmaster Stonecutter's Trophy Journal (Partially Full)",
        itemId: "T7_JOURNAL_TROPHY_STONE",
        canEnchant: false
    },
{
        itemName: "Expert Stonecutter's Trophy Journal (Partially Full)",
        itemId: "T5_JOURNAL_TROPHY_STONE",
        canEnchant: false
    },
{
        itemName: "Elder Stonecutter's Trophy Journal (Partially Full)",
        itemId: "T8_JOURNAL_TROPHY_STONE",
        canEnchant: false
    },
{
        itemName: "Elder Lumberjack's Trophy Journal (Partially Full)",
        itemId: "T8_JOURNAL_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Master Stonecutter's Trophy Journal (Partially Full)",
        itemId: "T6_JOURNAL_TROPHY_STONE",
        canEnchant: false
    },
{
        itemName: "Adept Prospector's Trophy Journal (Partially Full)",
        itemId: "T4_JOURNAL_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Journeyman Prospector's Trophy Journal (Partially Full)",
        itemId: "T3_JOURNAL_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Grandmaster Prospector's Trophy Journal (Partially Full)",
        itemId: "T7_JOURNAL_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Expert Prospector's Trophy Journal (Partially Full)",
        itemId: "T5_JOURNAL_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Novice Prospector's Trophy Journal (Partially Full)",
        itemId: "T2_JOURNAL_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Novice Cropper's Trophy Journal (Partially Full)",
        itemId: "T2_JOURNAL_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Master Prospector's Trophy Journal (Partially Full)",
        itemId: "T6_JOURNAL_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Elder Prospector's Trophy Journal (Partially Full)",
        itemId: "T8_JOURNAL_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Journeyman Cropper's Trophy Journal (Partially Full)",
        itemId: "T3_JOURNAL_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Elder Cropper's Trophy Journal (Partially Full)",
        itemId: "T8_JOURNAL_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Novice Stonecutter's Trophy Journal (Partially Full)",
        itemId: "T2_JOURNAL_TROPHY_STONE",
        canEnchant: false
    },
{
        itemName: "Master Cropper's Trophy Journal (Partially Full)",
        itemId: "T6_JOURNAL_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Novice Fisherman's Trophy Journal (Partially Full)",
        itemId: "T2_JOURNAL_TROPHY_FISHING",
        canEnchant: false
    },
{
        itemName: "Grandmaster Cropper's Trophy Journal (Partially Full)",
        itemId: "T7_JOURNAL_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Expert Cropper's Trophy Journal (Partially Full)",
        itemId: "T5_JOURNAL_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Journeyman Fisherman's Trophy Journal (Partially Full)",
        itemId: "T3_JOURNAL_TROPHY_FISHING",
        canEnchant: false
    },
{
        itemName: "Adept Cropper's Trophy Journal (Partially Full)",
        itemId: "T4_JOURNAL_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Expert Fisherman's Trophy Journal (Partially Full)",
        itemId: "T5_JOURNAL_TROPHY_FISHING",
        canEnchant: false
    },
{
        itemName: "Master Fisherman's Trophy Journal (Partially Full)",
        itemId: "T6_JOURNAL_TROPHY_FISHING",
        canEnchant: false
    },
{
        itemName: "Grandmaster Fisherman's Trophy Journal (Partially Full)",
        itemId: "T7_JOURNAL_TROPHY_FISHING",
        canEnchant: false
    },
{
        itemName: "Elder Fisherman's Trophy Journal (Partially Full)",
        itemId: "T8_JOURNAL_TROPHY_FISHING",
        canEnchant: false
    },
{
        itemName: "Adept Fisherman's Trophy Journal (Partially Full)",
        itemId: "T4_JOURNAL_TROPHY_FISHING",
        canEnchant: false
    },
{
        itemName: "Novice Fisherman's Journal (Partially Full)",
        itemId: "T2_JOURNAL_FISHING",
        canEnchant: false
    },
{
        itemName: "Journeyman Fisherman's Journal (Partially Full)",
        itemId: "T3_JOURNAL_FISHING",
        canEnchant: false
    },
{
        itemName: "Adept Fisherman's Journal (Partially Full)",
        itemId: "T4_JOURNAL_FISHING",
        canEnchant: false
    },
{
        itemName: "Master Fisherman's Journal (Partially Full)",
        itemId: "T6_JOURNAL_FISHING",
        canEnchant: false
    },
{
        itemName: "Grandmaster Fisherman's Journal (Partially Full)",
        itemId: "T7_JOURNAL_FISHING",
        canEnchant: false
    },
{
        itemName: "Expert Fisherman's Journal (Partially Full)",
        itemId: "T5_JOURNAL_FISHING",
        canEnchant: false
    },
{
        itemName: "Novice Lumberjack Contract",
        itemId: "T2_LABOURER_CONTRACT_WOOD",
        canEnchant: false
    },
{
        itemName: "Elder Fisherman's Journal (Partially Full)",
        itemId: "T8_JOURNAL_FISHING",
        canEnchant: false
    },
{
        itemName: "Adept Lumberjack Contract",
        itemId: "T4_LABOURER_CONTRACT_WOOD",
        canEnchant: false
    },
{
        itemName: "Journeyman Lumberjack Contract",
        itemId: "T3_LABOURER_CONTRACT_WOOD",
        canEnchant: false
    },
{
        itemName: "Grandmaster Lumberjack Contract",
        itemId: "T7_LABOURER_CONTRACT_WOOD",
        canEnchant: false
    },
{
        itemName: "Expert Lumberjack Contract",
        itemId: "T5_LABOURER_CONTRACT_WOOD",
        canEnchant: false
    },
{
        itemName: "Master Lumberjack Contract",
        itemId: "T6_LABOURER_CONTRACT_WOOD",
        canEnchant: false
    },
{
        itemName: "Adept Stonecutter Contract",
        itemId: "T4_LABOURER_CONTRACT_STONE",
        canEnchant: false
    },
{
        itemName: "Novice Stonecutter Contract",
        itemId: "T2_LABOURER_CONTRACT_STONE",
        canEnchant: false
    },
{
        itemName: "Journeyman Stonecutter Contract",
        itemId: "T3_LABOURER_CONTRACT_STONE",
        canEnchant: false
    },
{
        itemName: "Master Stonecutter Contract",
        itemId: "T6_LABOURER_CONTRACT_STONE",
        canEnchant: false
    },
{
        itemName: "Expert Stonecutter Contract",
        itemId: "T5_LABOURER_CONTRACT_STONE",
        canEnchant: false
    },
{
        itemName: "Elder Lumberjack Contract",
        itemId: "T8_LABOURER_CONTRACT_WOOD",
        canEnchant: false
    },
{
        itemName: "Grandmaster Stonecutter Contract",
        itemId: "T7_LABOURER_CONTRACT_STONE",
        canEnchant: false
    },
{
        itemName: "Elder Stonecutter Contract",
        itemId: "T8_LABOURER_CONTRACT_STONE",
        canEnchant: false
    },
{
        itemName: "Novice Cropper Contract",
        itemId: "T2_LABOURER_CONTRACT_FIBER",
        canEnchant: false
    },
{
        itemName: "Expert Cropper Contract",
        itemId: "T5_LABOURER_CONTRACT_FIBER",
        canEnchant: false
    },
{
        itemName: "Journeyman Cropper Contract",
        itemId: "T3_LABOURER_CONTRACT_FIBER",
        canEnchant: false
    },
{
        itemName: "Adept Cropper Contract",
        itemId: "T4_LABOURER_CONTRACT_FIBER",
        canEnchant: false
    },
{
        itemName: "Master Cropper Contract",
        itemId: "T6_LABOURER_CONTRACT_FIBER",
        canEnchant: false
    },
{
        itemName: "Grandmaster Cropper Contract",
        itemId: "T7_LABOURER_CONTRACT_FIBER",
        canEnchant: false
    },
{
        itemName: "Journeyman Gamekeeper Contract",
        itemId: "T3_LABOURER_CONTRACT_HIDE",
        canEnchant: false
    },
{
        itemName: "Elder Cropper Contract",
        itemId: "T8_LABOURER_CONTRACT_FIBER",
        canEnchant: false
    },
{
        itemName: "Novice Gamekeeper Contract",
        itemId: "T2_LABOURER_CONTRACT_HIDE",
        canEnchant: false
    },
{
        itemName: "Adept Gamekeeper Contract",
        itemId: "T4_LABOURER_CONTRACT_HIDE",
        canEnchant: false
    },
{
        itemName: "Expert Gamekeeper Contract",
        itemId: "T5_LABOURER_CONTRACT_HIDE",
        canEnchant: false
    },
{
        itemName: "Master Gamekeeper Contract",
        itemId: "T6_LABOURER_CONTRACT_HIDE",
        canEnchant: false
    },
{
        itemName: "Grandmaster Gamekeeper Contract",
        itemId: "T7_LABOURER_CONTRACT_HIDE",
        canEnchant: false
    },
{
        itemName: "Elder Gamekeeper Contract",
        itemId: "T8_LABOURER_CONTRACT_HIDE",
        canEnchant: false
    },
{
        itemName: "Expert Prospector Contract",
        itemId: "T5_LABOURER_CONTRACT_ORE",
        canEnchant: false
    },
{
        itemName: "Novice Prospector Contract",
        itemId: "T2_LABOURER_CONTRACT_ORE",
        canEnchant: false
    },
{
        itemName: "Adept Prospector Contract",
        itemId: "T4_LABOURER_CONTRACT_ORE",
        canEnchant: false
    },
{
        itemName: "Journeyman Prospector Contract",
        itemId: "T3_LABOURER_CONTRACT_ORE",
        canEnchant: false
    },
{
        itemName: "Grandmaster Prospector Contract",
        itemId: "T7_LABOURER_CONTRACT_ORE",
        canEnchant: false
    },
{
        itemName: "Elder Prospector Contract",
        itemId: "T8_LABOURER_CONTRACT_ORE",
        canEnchant: false
    },
{
        itemName: "Master Prospector Contract",
        itemId: "T6_LABOURER_CONTRACT_ORE",
        canEnchant: false
    },
{
        itemName: "Novice Mercenary Contract",
        itemId: "T2_LABOURER_CONTRACT_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Journeyman Mercenary Contract",
        itemId: "T3_LABOURER_CONTRACT_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Expert Mercenary Contract",
        itemId: "T5_LABOURER_CONTRACT_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Mercenary Contract",
        itemId: "T7_LABOURER_CONTRACT_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Novice Fisherman Contract",
        itemId: "T2_LABOURER_CONTRACT_FISHERMAN",
        canEnchant: false
    },
{
        itemName: "Master Mercenary Contract",
        itemId: "T6_LABOURER_CONTRACT_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Master Fisherman Contract",
        itemId: "T6_LABOURER_CONTRACT_FISHERMAN",
        canEnchant: false
    },
{
        itemName: "Adept Mercenary Contract",
        itemId: "T4_LABOURER_CONTRACT_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Adept Fisherman Contract",
        itemId: "T4_LABOURER_CONTRACT_FISHERMAN",
        canEnchant: false
    },
{
        itemName: "Grandmaster Fisherman Contract",
        itemId: "T7_LABOURER_CONTRACT_FISHERMAN",
        canEnchant: false
    },
{
        itemName: "Elder Mercenary Contract",
        itemId: "T8_LABOURER_CONTRACT_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Journeyman Fisherman Contract",
        itemId: "T3_LABOURER_CONTRACT_FISHERMAN",
        canEnchant: false
    },
{
        itemName: "Journeyman Fletcher Contract",
        itemId: "T3_LABOURER_CONTRACT_HUNTER",
        canEnchant: false
    },
{
        itemName: "Expert Fisherman Contract",
        itemId: "T5_LABOURER_CONTRACT_FISHERMAN",
        canEnchant: false
    },
{
        itemName: "Grandmaster Fletcher Contract",
        itemId: "T7_LABOURER_CONTRACT_HUNTER",
        canEnchant: false
    },
{
        itemName: "Novice Fletcher Contract",
        itemId: "T2_LABOURER_CONTRACT_HUNTER",
        canEnchant: false
    },
{
        itemName: "Elder Fisherman Contract",
        itemId: "T8_LABOURER_CONTRACT_FISHERMAN",
        canEnchant: false
    },
{
        itemName: "Master Fletcher Contract",
        itemId: "T6_LABOURER_CONTRACT_HUNTER",
        canEnchant: false
    },
{
        itemName: "Adept Fletcher Contract",
        itemId: "T4_LABOURER_CONTRACT_HUNTER",
        canEnchant: false
    },
{
        itemName: "Novice Imbuer Contract",
        itemId: "T2_LABOURER_CONTRACT_MAGE",
        canEnchant: false
    },
{
        itemName: "Adept Imbuer Contract",
        itemId: "T4_LABOURER_CONTRACT_MAGE",
        canEnchant: false
    },
{
        itemName: "Master Imbuer Contract",
        itemId: "T6_LABOURER_CONTRACT_MAGE",
        canEnchant: false
    },
{
        itemName: "Expert Fletcher Contract",
        itemId: "T5_LABOURER_CONTRACT_HUNTER",
        canEnchant: false
    },
{
        itemName: "Elder Fletcher Contract",
        itemId: "T8_LABOURER_CONTRACT_HUNTER",
        canEnchant: false
    },
{
        itemName: "Journeyman Imbuer Contract",
        itemId: "T3_LABOURER_CONTRACT_MAGE",
        canEnchant: false
    },
{
        itemName: "Elder Imbuer Contract",
        itemId: "T8_LABOURER_CONTRACT_MAGE",
        canEnchant: false
    },
{
        itemName: "Expert Imbuer Contract",
        itemId: "T5_LABOURER_CONTRACT_MAGE",
        canEnchant: false
    },
{
        itemName: "Grandmaster Imbuer Contract",
        itemId: "T7_LABOURER_CONTRACT_MAGE",
        canEnchant: false
    },
{
        itemName: "Expert Blacksmith Contract",
        itemId: "T5_LABOURER_CONTRACT_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Journeyman Blacksmith Contract",
        itemId: "T3_LABOURER_CONTRACT_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Grandmaster Blacksmith Contract",
        itemId: "T7_LABOURER_CONTRACT_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Novice Blacksmith Contract",
        itemId: "T2_LABOURER_CONTRACT_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Master Blacksmith Contract",
        itemId: "T6_LABOURER_CONTRACT_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Elder Blacksmith Contract",
        itemId: "T8_LABOURER_CONTRACT_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Adept Blacksmith Contract",
        itemId: "T4_LABOURER_CONTRACT_WARRIOR",
        canEnchant: false
    },
{
        itemName: "Expert Tinker Contract",
        itemId: "T5_LABOURER_CONTRACT_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Adept Tinker Contract",
        itemId: "T4_LABOURER_CONTRACT_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Journeyman Tinker Contract",
        itemId: "T3_LABOURER_CONTRACT_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Novice Tinker Contract",
        itemId: "T2_LABOURER_CONTRACT_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Grandmaster Tinker Contract",
        itemId: "T7_LABOURER_CONTRACT_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Elder Tinker Contract",
        itemId: "T8_LABOURER_CONTRACT_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Master Tinker Contract",
        itemId: "T6_LABOURER_CONTRACT_TOOLMAKER",
        canEnchant: false
    },
{
        itemName: "Novice's Bow",
        itemId: "T2_2H_BOW",
        canEnchant: false
    },
{
        itemName: "Journeyman's Bow",
        itemId: "T3_2H_BOW",
        canEnchant: false
    },
{
        itemName: "Journeyman's Crossbow",
        itemId: "T3_2H_CROSSBOW",
        canEnchant: false
    },
{
        itemName: "Journeyman's Fire Staff",
        itemId: "T3_MAIN_FIRESTAFF",
        canEnchant: false
    },
{
        itemName: "Journeyman's Cursed Staff",
        itemId: "T3_MAIN_CURSEDSTAFF",
        canEnchant: false
    },
{
        itemName: "Journeyman's Frost Staff",
        itemId: "T3_MAIN_FROSTSTAFF",
        canEnchant: false
    },
{
        itemName: "Novice's Fire Staff",
        itemId: "T2_MAIN_FIRESTAFF",
        canEnchant: false
    },
{
        itemName: "Journeyman's Arcane Staff",
        itemId: "T3_MAIN_ARCANESTAFF",
        canEnchant: false
    },
{
        itemName: "Journeyman's Holy Staff",
        itemId: "T3_MAIN_HOLYSTAFF",
        canEnchant: false
    },
{
        itemName: "Journeyman's Nature Staff",
        itemId: "T3_MAIN_NATURESTAFF",
        canEnchant: false
    },
{
        itemName: "Journeyman's Dagger",
        itemId: "T3_MAIN_DAGGER",
        canEnchant: false
    },
{
        itemName: "Journeyman's Spear",
        itemId: "T3_MAIN_SPEAR",
        canEnchant: false
    },
{
        itemName: "Journeyman's Battleaxe",
        itemId: "T3_MAIN_AXE",
        canEnchant: false
    },
{
        itemName: "Journeyman's Broadsword",
        itemId: "T3_MAIN_SWORD",
        canEnchant: false
    },
{
        itemName: "Novice's Broadsword",
        itemId: "T2_MAIN_SWORD",
        canEnchant: false
    },
{
        itemName: "Beginner's Broadsword",
        itemId: "T1_MAIN_SWORD",
        canEnchant: false
    },
{
        itemName: "Journeyman's Quarterstaff",
        itemId: "T3_2H_QUARTERSTAFF",
        canEnchant: false
    },
{
        itemName: "Journeyman's Hammer",
        itemId: "T3_MAIN_HAMMER",
        canEnchant: false
    },
{
        itemName: "Journeyman's Brawler Gloves",
        itemId: "T3_2H_KNUCKLES_SET1",
        canEnchant: false
    },
{
        itemName: "Adventurer's Handbook",
        itemId: "T2_FURNITUREITEM_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Journeyman's Mace",
        itemId: "T3_MAIN_MACE",
        canEnchant: false
    },
{
        itemName: "Encyclopedia of Power",
        itemId: "T6_FURNITUREITEM_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Tome of Knowledge",
        itemId: "T5_FURNITUREITEM_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Ancient Scripture",
        itemId: "T4_FURNITUREITEM_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Ledger of Truths",
        itemId: "T8_FURNITUREITEM_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Trophy Shark",
        itemId: "T8_FURNITUREITEM_TROPHY_FISHING_BOSS",
        canEnchant: false
    },
{
        itemName: "Expert Mercenary's Trophy",
        itemId: "T5_FURNITUREITEM_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Magical Tome",
        itemId: "T3_FURNITUREITEM_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Novice Mercenary's Trophy",
        itemId: "T2_FURNITUREITEM_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Occult Octavo",
        itemId: "T7_FURNITUREITEM_TROPHY_GENERAL",
        canEnchant: false
    },
{
        itemName: "Journeyman Mercenary's Trophy",
        itemId: "T3_FURNITUREITEM_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Mercenary's Trophy",
        itemId: "T7_FURNITUREITEM_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Elder Mercenary's Trophy",
        itemId: "T8_FURNITUREITEM_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Master Mercenary's Trophy",
        itemId: "T6_FURNITUREITEM_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Adept Mercenary's Trophy",
        itemId: "T4_FURNITUREITEM_TROPHY_MERCENARY",
        canEnchant: false
    },
{
        itemName: "Stuffed Wolf Head",
        itemId: "T3_FURNITUREITEM_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Stuffed Bear Head",
        itemId: "T5_FURNITUREITEM_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Stuffed Boar Head",
        itemId: "T4_FURNITUREITEM_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Stuffed Direbear Head",
        itemId: "T8_FURNITUREITEM_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Copper Ore Sample",
        itemId: "T2_FURNITUREITEM_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Stuffed Fox Head",
        itemId: "T2_FURNITUREITEM_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Stuffed Direwolf Head",
        itemId: "T6_FURNITUREITEM_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Stuffed Direboar Head",
        itemId: "T7_FURNITUREITEM_TROPHY_HIDE",
        canEnchant: false
    },
{
        itemName: "Iron Ore Sample",
        itemId: "T4_FURNITUREITEM_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Titanium Ore Sample",
        itemId: "T5_FURNITUREITEM_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Tin Ore Sample",
        itemId: "T3_FURNITUREITEM_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Runite Ore Sample",
        itemId: "T6_FURNITUREITEM_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Comfy Cotton Trophy",
        itemId: "T2_FURNITUREITEM_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Adamantium Ore Sample",
        itemId: "T8_FURNITUREITEM_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Meteorite Ore Sample",
        itemId: "T7_FURNITUREITEM_TROPHY_ORE",
        canEnchant: false
    },
{
        itemName: "Exquisite Hemp Trophy",
        itemId: "T4_FURNITUREITEM_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Exquisite Ghost Hemp Trophy",
        itemId: "T8_FURNITUREITEM_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Fine Flax Trophy",
        itemId: "T3_FURNITUREITEM_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Fine Sunflax Trophy",
        itemId: "T7_FURNITUREITEM_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Comfy Amberleaf Cotton Trophy",
        itemId: "T6_FURNITUREITEM_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Soft Skyflower Trophy",
        itemId: "T5_FURNITUREITEM_TROPHY_FIBER",
        canEnchant: false
    },
{
        itemName: "Granite Fragment",
        itemId: "T5_FURNITUREITEM_TROPHY_ROCK",
        canEnchant: false
    },
{
        itemName: "Sandstone Fragment",
        itemId: "T3_FURNITUREITEM_TROPHY_ROCK",
        canEnchant: false
    },
{
        itemName: "Travertine Fragment",
        itemId: "T4_FURNITUREITEM_TROPHY_ROCK",
        canEnchant: false
    },
{
        itemName: "Basalt Fragment",
        itemId: "T7_FURNITUREITEM_TROPHY_ROCK",
        canEnchant: false
    },
{
        itemName: "Limestone Fragment",
        itemId: "T2_FURNITUREITEM_TROPHY_ROCK",
        canEnchant: false
    },
{
        itemName: "Chestnut Bonsai",
        itemId: "T3_FURNITUREITEM_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Slate Fragment",
        itemId: "T6_FURNITUREITEM_TROPHY_ROCK",
        canEnchant: false
    },
{
        itemName: "Marble Fragment",
        itemId: "T8_FURNITUREITEM_TROPHY_ROCK",
        canEnchant: false
    },
{
        itemName: "Cedar Bonsai",
        itemId: "T5_FURNITUREITEM_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Pine Bonsai",
        itemId: "T4_FURNITUREITEM_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Ashenbark Bonsai",
        itemId: "T7_FURNITUREITEM_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Bloodoak Bonsai",
        itemId: "T6_FURNITUREITEM_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Whitewood Bonsai",
        itemId: "T8_FURNITUREITEM_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Catfish Trophy",
        itemId: "T7_FURNITUREITEM_TROPHY_FISH",
        canEnchant: false
    },
{
        itemName: "Perch Trophy",
        itemId: "T3_FURNITUREITEM_TROPHY_FISH",
        canEnchant: false
    },
{
        itemName: "Carp Trophy",
        itemId: "T2_FURNITUREITEM_TROPHY_FISH",
        canEnchant: false
    },
{
        itemName: "Pike Trophy",
        itemId: "T4_FURNITUREITEM_TROPHY_FISH",
        canEnchant: false
    },
{
        itemName: "Zander Trophy",
        itemId: "T6_FURNITUREITEM_TROPHY_FISH",
        canEnchant: false
    },
{
        itemName: "Swordfish Trophy",
        itemId: "T8_FURNITUREITEM_TROPHY_FISH",
        canEnchant: false
    },
{
        itemName: "Trout Trophy",
        itemId: "T5_FURNITUREITEM_TROPHY_FISH",
        canEnchant: false
    },
{
        itemName: "Adept's Bridgewatch Crest",
        itemId: "T4_CAPEITEM_FW_BRIDGEWATCH_BP",
        canEnchant: false
    },
{
        itemName: "Expert's Bridgewatch Crest",
        itemId: "T5_CAPEITEM_FW_BRIDGEWATCH_BP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Bridgewatch Crest",
        itemId: "T7_CAPEITEM_FW_BRIDGEWATCH_BP",
        canEnchant: false
    },
{
        itemName: "Master's Bridgewatch Crest",
        itemId: "T6_CAPEITEM_FW_BRIDGEWATCH_BP",
        canEnchant: false
    },
{
        itemName: "Siphoned Energy",
        itemId: "UNIQUE_GVGTOKEN_GENERIC",
        canEnchant: false
    },
{
        itemName: "Elder's Bridgewatch Crest",
        itemId: "T8_CAPEITEM_FW_BRIDGEWATCH_BP",
        canEnchant: false
    },
{
        itemName: "Birch Bonsai",
        itemId: "T2_FURNITUREITEM_TROPHY_WOOD",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Fort Sterling Crest",
        itemId: "T7_CAPEITEM_FW_FORTSTERLING_BP",
        canEnchant: false
    },
{
        itemName: "Expert's Fort Sterling Crest",
        itemId: "T5_CAPEITEM_FW_FORTSTERLING_BP",
        canEnchant: false
    },
{
        itemName: "Adept's Fort Sterling Crest",
        itemId: "T4_CAPEITEM_FW_FORTSTERLING_BP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Lymhurst Crest",
        itemId: "T7_CAPEITEM_FW_LYMHURST_BP",
        canEnchant: false
    },
{
        itemName: "Master's Fort Sterling Crest",
        itemId: "T6_CAPEITEM_FW_FORTSTERLING_BP",
        canEnchant: false
    },
{
        itemName: "Elder's Fort Sterling Crest",
        itemId: "T8_CAPEITEM_FW_FORTSTERLING_BP",
        canEnchant: false
    },
{
        itemName: "Adept's Lymhurst Crest",
        itemId: "T4_CAPEITEM_FW_LYMHURST_BP",
        canEnchant: false
    },
{
        itemName: "Expert's Lymhurst Crest",
        itemId: "T5_CAPEITEM_FW_LYMHURST_BP",
        canEnchant: false
    },
{
        itemName: "Elder's Lymhurst Crest",
        itemId: "T8_CAPEITEM_FW_LYMHURST_BP",
        canEnchant: false
    },
{
        itemName: "Master's Lymhurst Crest",
        itemId: "T6_CAPEITEM_FW_LYMHURST_BP",
        canEnchant: false
    },
{
        itemName: "Expert's Martlock Crest",
        itemId: "T5_CAPEITEM_FW_MARTLOCK_BP",
        canEnchant: false
    },
{
        itemName: "Master's Martlock Crest",
        itemId: "T6_CAPEITEM_FW_MARTLOCK_BP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Martlock Crest",
        itemId: "T7_CAPEITEM_FW_MARTLOCK_BP",
        canEnchant: false
    },
{
        itemName: "Expert's Thetford Crest",
        itemId: "T5_CAPEITEM_FW_THETFORD_BP",
        canEnchant: false
    },
{
        itemName: "Elder's Martlock Crest",
        itemId: "T8_CAPEITEM_FW_MARTLOCK_BP",
        canEnchant: false
    },
{
        itemName: "Adept's Thetford Crest",
        itemId: "T4_CAPEITEM_FW_THETFORD_BP",
        canEnchant: false
    },
{
        itemName: "Adept's Martlock Crest",
        itemId: "T4_CAPEITEM_FW_MARTLOCK_BP",
        canEnchant: false
    },
{
        itemName: "Master's Thetford Crest",
        itemId: "T6_CAPEITEM_FW_THETFORD_BP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Thetford Crest",
        itemId: "T7_CAPEITEM_FW_THETFORD_BP",
        canEnchant: false
    },
{
        itemName: "Elder's Thetford Crest",
        itemId: "T8_CAPEITEM_FW_THETFORD_BP",
        canEnchant: false
    },
{
        itemName: "Expert's Caerleon Crest",
        itemId: "T5_CAPEITEM_FW_CAERLEON_BP",
        canEnchant: false
    },
{
        itemName: "Master's Caerleon Crest",
        itemId: "T6_CAPEITEM_FW_CAERLEON_BP",
        canEnchant: false
    },
{
        itemName: "Adept's Caerleon Crest",
        itemId: "T4_CAPEITEM_FW_CAERLEON_BP",
        canEnchant: false
    },
{
        itemName: "Elder's Caerleon Crest",
        itemId: "T8_CAPEITEM_FW_CAERLEON_BP",
        canEnchant: false
    },
{
        itemName: "Master's Heretic Crest",
        itemId: "T6_CAPEITEM_HERETIC_BP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Caerleon Crest",
        itemId: "T7_CAPEITEM_FW_CAERLEON_BP",
        canEnchant: false
    },
{
        itemName: "Adept's Heretic Crest",
        itemId: "T4_CAPEITEM_HERETIC_BP",
        canEnchant: false
    },
{
        itemName: "Expert's Heretic Crest",
        itemId: "T5_CAPEITEM_HERETIC_BP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Heretic Crest",
        itemId: "T7_CAPEITEM_HERETIC_BP",
        canEnchant: false
    },
{
        itemName: "Adept's Undead Crest",
        itemId: "T4_CAPEITEM_UNDEAD_BP",
        canEnchant: false
    },
{
        itemName: "Elder's Heretic Crest",
        itemId: "T8_CAPEITEM_HERETIC_BP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Undead Crest",
        itemId: "T7_CAPEITEM_UNDEAD_BP",
        canEnchant: false
    },
{
        itemName: "Master's Undead Crest",
        itemId: "T6_CAPEITEM_UNDEAD_BP",
        canEnchant: false
    },
{
        itemName: "Adept's Keeper Crest",
        itemId: "T4_CAPEITEM_KEEPER_BP",
        canEnchant: false
    },
{
        itemName: "Expert's Undead Crest",
        itemId: "T5_CAPEITEM_UNDEAD_BP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Keeper Crest",
        itemId: "T7_CAPEITEM_KEEPER_BP",
        canEnchant: false
    },
{
        itemName: "Elder's Undead Crest",
        itemId: "T8_CAPEITEM_UNDEAD_BP",
        canEnchant: false
    },
{
        itemName: "Master's Keeper Crest",
        itemId: "T6_CAPEITEM_KEEPER_BP",
        canEnchant: false
    },
{
        itemName: "Expert's Keeper Crest",
        itemId: "T5_CAPEITEM_KEEPER_BP",
        canEnchant: false
    },
{
        itemName: "Expert's Morgana Crest",
        itemId: "T5_CAPEITEM_MORGANA_BP",
        canEnchant: false
    },
{
        itemName: "Master's Morgana Crest",
        itemId: "T6_CAPEITEM_MORGANA_BP",
        canEnchant: false
    },
{
        itemName: "Elder's Keeper Crest",
        itemId: "T8_CAPEITEM_KEEPER_BP",
        canEnchant: false
    },
{
        itemName: "Adept's Morgana Crest",
        itemId: "T4_CAPEITEM_MORGANA_BP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Morgana Crest",
        itemId: "T7_CAPEITEM_MORGANA_BP",
        canEnchant: false
    },
{
        itemName: "Master's Demon Crest",
        itemId: "T6_CAPEITEM_DEMON_BP",
        canEnchant: false
    },
{
        itemName: "Elder's Morgana Crest",
        itemId: "T8_CAPEITEM_MORGANA_BP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Demon Crest",
        itemId: "T7_CAPEITEM_DEMON_BP",
        canEnchant: false
    },
{
        itemName: "Adept's Demon Crest",
        itemId: "T4_CAPEITEM_DEMON_BP",
        canEnchant: false
    },
{
        itemName: "Expert's Demon Crest",
        itemId: "T5_CAPEITEM_DEMON_BP",
        canEnchant: false
    },
{
        itemName: "Rockheart",
        itemId: "T1_FACTION_HIGHLAND_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Elder's Demon Crest",
        itemId: "T8_CAPEITEM_DEMON_BP",
        canEnchant: false
    },
{
        itemName: "Beastheart",
        itemId: "T1_FACTION_STEPPE_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Vineheart",
        itemId: "T1_FACTION_SWAMP_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Treeheart",
        itemId: "T1_FACTION_FOREST_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Shadowheart",
        itemId: "T1_FACTION_CAERLEON_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Adept's Crystal League Chest",
        itemId: "T4_LOOTCHEST_CRYSTAL_LEAGUE",
        canEnchant: false
    },
{
        itemName: "Mountainheart",
        itemId: "T1_FACTION_MOUNTAIN_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Expert's Crystal League Chest",
        itemId: "T5_LOOTCHEST_CRYSTAL_LEAGUE",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Crystal League Chest",
        itemId: "T7_LOOTCHEST_CRYSTAL_LEAGUE",
        canEnchant: false
    },
{
        itemName: "Master's Crystal League Chest",
        itemId: "T6_LOOTCHEST_CRYSTAL_LEAGUE",
        canEnchant: false
    },
{
        itemName: "Elder's Crystal League Chest",
        itemId: "T8_LOOTCHEST_CRYSTAL_LEAGUE",
        canEnchant: false
    },
{
        itemName: "Adventurer's Tome",
        itemId: "UNIQUE_SKILLBOOK_ADC_GENERAL_01",
        canEnchant: false
    },
{
        itemName: "Diluted Focus Restoration Potion",
        itemId: "UNIQUE_FOCUSPOTION_TUTORIAL_01",
        canEnchant: false
    },
{
        itemName: "Bag of Silver",
        itemId: "UNIQUE_SILVERBAG_ADC_GENERAL_01",
        canEnchant: false
    },
{
        itemName: "Focus Restoration Potion",
        itemId: "UNIQUE_FOCUSPOTION_ADC_NONTRADABLE_01",
        canEnchant: false
    },
{
        itemName: "Scroll of Repair",
        itemId: "UNIQUE_REPAIRPOWDER_ADC_GENERAL_01",
        canEnchant: false
    },
{
        itemName: "Harvest Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_OCT2018_01",
        canEnchant: false
    },
{
        itemName: "Carnival Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_FEB2019",
        canEnchant: false
    },
{
        itemName: "Yuletide Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_DEC2018",
        canEnchant: false
    },
{
        itemName: "Frost Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_JAN2019",
        canEnchant: false
    },
{
        itemName: "Keeper Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_MAR2019",
        canEnchant: false
    },
{
        itemName: "Morgana Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_MAY2019",
        canEnchant: false
    },
{
        itemName: "Grim Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_NOV2018",
        canEnchant: false
    },
{
        itemName: "Hunter Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_APR2019",
        canEnchant: false
    },
{
        itemName: "Knight Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_JUN2019",
        canEnchant: false
    },
{
        itemName: "Heretic Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_SEP2019",
        canEnchant: false
    },
{
        itemName: "Divine Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_AUG2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Grim Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_NOV2018",
        canEnchant: false
    },
{
        itemName: "Undead Challenge Chest",
        itemId: "UNIQUE_LOOTCHEST_ADC_JUL2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Carnival Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_FEB2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Frost Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_JAN2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Keeper Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_MAR2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Morgana Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_MAY2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Yuletide Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_DEC2018",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Hunter Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_APR2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Heretic Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_SEP2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Undead Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_JUL2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Adventurer",
        itemId: "UNIQUE_AVATARRING_ADC_TOKENLOCKED_01",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Knight Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_JUN2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Divine Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_AUG2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Nature Spirit",
        itemId: "UNIQUE_AVATARRING_ADC_TOKENLOCKED_NATURE",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Harvest Challenge",
        itemId: "UNIQUE_AVATARRING_ADC_OCT2019",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Staff of Hermes",
        itemId: "UNIQUE_AVATARRING_CHARITY_MARCH2020",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Crossed Blades",
        itemId: "UNIQUE_AVATARRING_ADC_TOKENLOCKED_SWORDS",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Enigma",
        itemId: "UNIQUE_AVATARRING_ADC_TOKENLOCKED_ARCANE",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Inferno",
        itemId: "UNIQUE_AVATARRING_ADC_TOKENLOCKED_FIRE",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Farmer",
        itemId: "UNIQUE_AVATARRING_ADC_TOKENLOCKED_FARMING",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Crossed Axes",
        itemId: "UNIQUE_AVATARRING_ADC_TOKENLOCKED_AXES",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Necromancer",
        itemId: "UNIQUE_AVATARRING_ADC_TOKENLOCKED_NECROMANCER",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Knight's Vow",
        itemId: "T7_GVGSEASONREWARD_FAMEBUFF",
        canEnchant: false
    },
{
        itemName: "Elder's Knight's Vow",
        itemId: "T8_GVGSEASONREWARD_FAMEBUFF",
        canEnchant: false
    },
{
        itemName: "Avatar: Adventurer",
        itemId: "UNIQUE_AVATAR_ADC_TOKENLOCKED_01",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Fisherman",
        itemId: "UNIQUE_AVATARRING_ADC_TOKENLOCKED_FISHING",
        canEnchant: false
    },
{
        itemName: "Bronze Campaign Chest: Thetford",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_SWAMP_02",
        canEnchant: false
    },
{
        itemName: "Expert's Knight's Vow",
        itemId: "T5_GVGSEASONREWARD_FAMEBUFF",
        canEnchant: false
    },
{
        itemName: "Adept's Knight's Vow",
        itemId: "T4_GVGSEASONREWARD_FAMEBUFF",
        canEnchant: false
    },
{
        itemName: "Master's Knight's Vow",
        itemId: "T6_GVGSEASONREWARD_FAMEBUFF",
        canEnchant: false
    },
{
        itemName: "Iron Campaign Chest: Thetford",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_SWAMP_01",
        canEnchant: false
    },
{
        itemName: "Silver Campaign Chest: Thetford",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_SWAMP_03",
        canEnchant: false
    },
{
        itemName: "Iron Campaign Chest: Fort Sterling",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_MOUNTAIN_01",
        canEnchant: false
    },
{
        itemName: "Gold Campaign Chest: Thetford",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_SWAMP_04",
        canEnchant: false
    },
{
        itemName: "Iron Campaign Chest: Lymhurst",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_FOREST_01",
        canEnchant: false
    },
{
        itemName: "Bronze Campaign Chest: Fort Sterling",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_MOUNTAIN_02",
        canEnchant: false
    },
{
        itemName: "Silver Campaign Chest: Fort Sterling",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_MOUNTAIN_03",
        canEnchant: false
    },
{
        itemName: "Silver Campaign Chest: Lymhurst",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_FOREST_03",
        canEnchant: false
    },
{
        itemName: "Gold Campaign Chest: Fort Sterling",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_MOUNTAIN_04",
        canEnchant: false
    },
{
        itemName: "Iron Campaign Chest: Bridgewatch",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_STEPPE_01",
        canEnchant: false
    },
{
        itemName: "Bronze Campaign Chest: Lymhurst",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_FOREST_02",
        canEnchant: false
    },
{
        itemName: "Iron Campaign Chest: Martlock",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_HIGHLAND_01",
        canEnchant: false
    },
{
        itemName: "Silver Campaign Chest: Bridgewatch",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_STEPPE_03",
        canEnchant: false
    },
{
        itemName: "Gold Campaign Chest: Lymhurst",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_FOREST_04",
        canEnchant: false
    },
{
        itemName: "Bronze Campaign Chest: Bridgewatch",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_STEPPE_02",
        canEnchant: false
    },
{
        itemName: "Gold Campaign Chest: Bridgewatch",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_STEPPE_04",
        canEnchant: false
    },
{
        itemName: "Silver Campaign Chest: Martlock",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_HIGHLAND_03",
        canEnchant: false
    },
{
        itemName: "Bronze Campaign Chest: Martlock",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_HIGHLAND_02",
        canEnchant: false
    },
{
        itemName: "Iron Campaign Chest: Caerleon",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_CAERLEON_01",
        canEnchant: false
    },
{
        itemName: "Gold Campaign Chest: Martlock",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_HIGHLAND_04",
        canEnchant: false
    },
{
        itemName: "Gold Campaign Chest: Caerleon",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_CAERLEON_04",
        canEnchant: false
    },
{
        itemName: "Bronze Campaign Chest: Caerleon",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_CAERLEON_02",
        canEnchant: false
    },
{
        itemName: "Silver Campaign Chest: Caerleon",
        itemId: "UNIQUE_LOOTCHEST_FACTIONCAMPAIGN_REWARD_CAERLEON_03",
        canEnchant: false
    },
{
        itemName: "Grand Conqueror's Chest",
        itemId: "UNIQUE_LOOTCHEST_CONQUEROR_WEEKLY_REWARD",
        canEnchant: false
    },
{
        itemName: "Conqueror's Chest",
        itemId: "UNIQUE_LOOTCHEST_CONQUEROR_FAVOR_PURCHASE",
        canEnchant: false
    },
{
        itemName: "Silver Battle Mount Chest",
        itemId: "UNIQUE_LOOTCHEST_BATTLEMOUNT_SILVER",
        canEnchant: false
    },
{
        itemName: "Crystal Battle Mount Chest",
        itemId: "UNIQUE_LOOTCHEST_BATTLEMOUNT_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "1st Place Statue - Season 10",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_10_1ST",
        canEnchant: false
    },
{
        itemName: "Bronze Battle Mount Chest",
        itemId: "UNIQUE_LOOTCHEST_BATTLEMOUNT_BRONZE",
        canEnchant: false
    },
{
        itemName: "2nd Place Statue - Season 9",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_09_2ND",
        canEnchant: false
    },
{
        itemName: "1st Place Statue - Season 9",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_09_1ST",
        canEnchant: false
    },
{
        itemName: "2nd Place Statue - Season 11",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_11_2ND",
        canEnchant: false
    },
{
        itemName: "Gold Battle Mount Chest",
        itemId: "UNIQUE_LOOTCHEST_BATTLEMOUNT_GOLD",
        canEnchant: false
    },
{
        itemName: "2nd Place Statue - Season 10",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_10_2ND",
        canEnchant: false
    },
{
        itemName: "3rd Place Statue - Season 10",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_10_3RD",
        canEnchant: false
    },
{
        itemName: "3rd Place Statue - Season 9",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_09_3RD",
        canEnchant: false
    },
{
        itemName: "1st Place Statue - Season 11",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_11_1ST",
        canEnchant: false
    },
{
        itemName: "3rd Place Statue - Season 11",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_11_3RD",
        canEnchant: false
    },
{
        itemName: "1st Place Statue - Season 13",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_13_1ST",
        canEnchant: false
    },
{
        itemName: "1st Place Statue - Season 12",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_12_1ST",
        canEnchant: false
    },
{
        itemName: "2nd Place Statue - Season 12",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_12_2ND",
        canEnchant: false
    },
{
        itemName: "2nd Place Statue - Energy Surge Season",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_ENERGY_RUSH_2ND",
        canEnchant: false
    },
{
        itemName: "3rd Place Statue - Season 13",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_13_3RD",
        canEnchant: false
    },
{
        itemName: "1st Place Statue - Energy Surge Season",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_ENERGY_RUSH_1ST",
        canEnchant: false
    },
{
        itemName: "3rd Place Statue - Season 12",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_12_3RD",
        canEnchant: false
    },
{
        itemName: "1st Place Statue - Season 14",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_14_1ST",
        canEnchant: false
    },
{
        itemName: "3rd Place Statue - Energy Surge Season",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_ENERGY_RUSH_3RD",
        canEnchant: false
    },
{
        itemName: "2nd Place Statue - Season 13",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_13_2ND",
        canEnchant: false
    },
{
        itemName: "3rd Place Statue - Season 14",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_14_3RD",
        canEnchant: false
    },
{
        itemName: "2nd Place Statue - Season 14",
        itemId: "UNIQUE_FURNITUREITEM_GVG_SEASON_14_2ND",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Season 1st Place",
        itemId: "UNIQUE_AVATARRING_GVGSEASONREWARD_1ST",
        canEnchant: false
    },
{
        itemName: "Avatar Ring Set: Season Crystal Rank",
        itemId: "UNIQUE_AVATARRING_GVGSEASONREWARD_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Avatar Ring Set: Season Gold Rank",
        itemId: "UNIQUE_AVATARRING_GVGSEASONREWARD_GOLD",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Season 2nd Place",
        itemId: "UNIQUE_AVATARRING_GVGSEASONREWARD_2ND",
        canEnchant: false
    },
{
        itemName: "Avatar Ring Set: Season Bronze Rank",
        itemId: "UNIQUE_AVATARRING_GVGSEASONREWARD_BRONZE",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Season Iron Rank",
        itemId: "UNIQUE_AVATARRING_GVGSEASONREWARD_IRON",
        canEnchant: false
    },
{
        itemName: "Avatar Ring Set: Season Silver Rank",
        itemId: "UNIQUE_AVATARRING_GVGSEASONREWARD_SILVER",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Season 3rd Place",
        itemId: "UNIQUE_AVATARRING_GVGSEASONREWARD_3RD",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Avalonian Invasion",
        itemId: "UNIQUE_AVATARRING_GVGSEASONREWARD_AVALON_INVASION",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Recruiter",
        itemId: "UNIQUE_AVATARRING_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Avatar: Guild Season 4",
        itemId: "UNIQUE_AVATAR_GVGSEASON_04",
        canEnchant: false
    },
{
        itemName: "Avatar: Guild Season 5",
        itemId: "UNIQUE_AVATAR_GVGSEASON_05",
        canEnchant: false
    },
{
        itemName: "Avatar Ring: Seasoned Adventurer",
        itemId: "UNIQUE_AVATARRING_ORIGINAL_PLAYER",
        canEnchant: false
    },
{
        itemName: "Avatar: Guild Season 6",
        itemId: "UNIQUE_AVATAR_GVGSEASON_06",
        canEnchant: false
    },
{
        itemName: "Avatar: Avalonian Invasion",
        itemId: "UNIQUE_AVATAR_GVGSEASON_AVALON_INVASION",
        canEnchant: false
    },
{
        itemName: "Avatar: Guild Season 7",
        itemId: "UNIQUE_AVATAR_GVGSEASON_07",
        canEnchant: false
    },
{
        itemName: "Avatar: Guild Season 10",
        itemId: "UNIQUE_AVATAR_GVGSEASON_10",
        canEnchant: false
    },
{
        itemName: "Avatar: Guild Season 9",
        itemId: "UNIQUE_AVATAR_GVGSEASON_09",
        canEnchant: false
    },
{
        itemName: "Avatar: Guild Season 12",
        itemId: "UNIQUE_AVATAR_GVGSEASON_12",
        canEnchant: false
    },
{
        itemName: "Avatar Set: Energy Surge Silver Rank",
        itemId: "UNIQUE_AVATAR_GVGSEASON_ENERGY_RUSH_SILVER",
        canEnchant: false
    },
{
        itemName: "Avatar: Guild Season 11",
        itemId: "UNIQUE_AVATAR_GVGSEASON_11",
        canEnchant: false
    },
{
        itemName: "Avatar Set: Energy Surge Crystal Rank",
        itemId: "UNIQUE_AVATAR_GVGSEASON_ENERGY_RUSH_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Avatar: Guild Season 8",
        itemId: "UNIQUE_AVATAR_GVGSEASON_08",
        canEnchant: false
    },
{
        itemName: "Avatar Set: Energy Surge Gold Rank",
        itemId: "UNIQUE_AVATAR_GVGSEASON_ENERGY_RUSH_GOLD",
        canEnchant: false
    },
{
        itemName: "Avatar: Guild Season 13",
        itemId: "UNIQUE_AVATAR_GVGSEASON_13",
        canEnchant: false
    },
{
        itemName: "Avatar: Energy Surge Bronze Rank",
        itemId: "UNIQUE_AVATAR_GVGSEASON_ENERGY_RUSH_BRONZE",
        canEnchant: false
    },
{
        itemName: "Avatar Set: Season 14 Silver Rank",
        itemId: "UNIQUE_AVATAR_GVGSEASON_14_SILVER",
        canEnchant: false
    },
{
        itemName: "Avatar Set: Season 14 Crystal Rank",
        itemId: "UNIQUE_AVATAR_GVGSEASON_14_CRYSTAL",
        canEnchant: false
    },
{
        itemName: "Avatar: Season 14 Bronze Rank",
        itemId: "UNIQUE_AVATAR_GVGSEASON_14_BRONZE",
        canEnchant: false
    },
{
        itemName: "Master's Hellgate Ritual (2v2 - Lethal)",
        itemId: "T6_HELLGATE_2V2_LETHAL_1_MAP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Hellgate Ritual (5v5 - Lethal)",
        itemId: "T7_HELLGATE_5V5_LETHAL_1_MAP",
        canEnchant: false
    },
{
        itemName: "Expert's Hellgate Ritual (2v2 - Nonlethal)",
        itemId: "T5_HELLGATE_2V2_NON_LETHAL_1_MAP",
        canEnchant: false
    },
{
        itemName: "Avatar Set: Season 14 Gold Rank",
        itemId: "UNIQUE_AVATAR_GVGSEASON_14_GOLD",
        canEnchant: false
    },
{
        itemName: "Elder's Hellgate Ritual (10v10 - Lethal)",
        itemId: "T8_HELLGATE_10V10_LETHAL_1_MAP",
        canEnchant: false
    },
{
        itemName: "Elder's Dungeon Map (Large Group)",
        itemId: "T8_RANDOM_DUNGEON_ELITE_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Expert's Hellgate Ritual (5v5 - Nonlethal)",
        itemId: "T5_HELLGATE_5V5_NON_LETHAL_1_MAP",
        canEnchant: false
    },
{
        itemName: "Expert's Hellgate Ritual (10v10 - Nonlethal)",
        itemId: "T5_HELLGATE_10V10_NON_LETHAL_1_MAP",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Dungeon Map (Large Group)",
        itemId: "T7_RANDOM_DUNGEON_ELITE_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Expert's Dungeon Map (Solo)",
        itemId: "T5_RANDOM_DUNGEON_SOLO_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Master's Dungeon Map (Large Group)",
        itemId: "T6_RANDOM_DUNGEON_ELITE_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Journeyman's Dungeon Map (Solo)",
        itemId: "T3_RANDOM_DUNGEON_SOLO_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Master's Dungeon Map (Solo)",
        itemId: "T6_RANDOM_DUNGEON_SOLO_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Adept's Dungeon Map (Solo)",
        itemId: "T4_RANDOM_DUNGEON_SOLO_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Dungeon Map (Solo)",
        itemId: "T7_RANDOM_DUNGEON_SOLO_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Elder's Dungeon Map (Solo)",
        itemId: "T8_RANDOM_DUNGEON_SOLO_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Dungeon Map (Group)",
        itemId: "T7_RANDOM_DUNGEON_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Expert's Dungeon Map (Group)",
        itemId: "T5_RANDOM_DUNGEON_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Adept's Dungeon Map (Group)",
        itemId: "T4_RANDOM_DUNGEON_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Elder's Dungeon Map (Group)",
        itemId: "T8_RANDOM_DUNGEON_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Master's Dungeon Map (Group)",
        itemId: "T6_RANDOM_DUNGEON_TOKEN_1",
        canEnchant: false
    },
{
        itemName: "Riding Horse Skin: Legendary Adventurer",
        itemId: "UNIQUE_UNLOCK_SKIN_HORSE_STARTERPACK",
        canEnchant: false
    },
{
        itemName: "Riding Horse Skin: Legendary Explorer",
        itemId: "UNIQUE_UNLOCK_SKIN_HORSE_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Legendary Explorer's Horse",
        itemId: "SKIN_HORSE_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Riding Horse Skin: Recruiter",
        itemId: "UNIQUE_UNLOCK_SKIN_HORSE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Riding Horse Skin: Recruiter's Pony",
        itemId: "UNIQUE_UNLOCK_SKIN_HORSE_PONY_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Riding Horse Skin: Bonehorse",
        itemId: "UNIQUE_UNLOCK_SKIN_HORSE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Recruiter's Horse",
        itemId: "SKIN_HORSE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Legendary Adventurer's Horse",
        itemId: "SKIN_HORSE_STARTERPACK",
        canEnchant: false
    },
{
        itemName: "Recruiter's Pony",
        itemId: "SKIN_HORSE_PONY_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Horse Macabre",
        itemId: "SKIN_HORSE_UNDEAD_HALLOWEEN",
        canEnchant: false
    },
{
        itemName: "Jousting Horse",
        itemId: "SKIN_HORSE_GUILDBANNER",
        canEnchant: false
    },
{
        itemName: "Brown Mare",
        itemId: "SKIN_HORSE_BROWN",
        canEnchant: false
    },
{
        itemName: "Riding Horse Skin: Horse Macabre",
        itemId: "UNIQUE_UNLOCK_SKIN_HORSE_UNDEAD_HALLOWEEN",
        canEnchant: false
    },
{
        itemName: "Bonehorse",
        itemId: "SKIN_HORSE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Riding Horse Skin: Jousting Horse",
        itemId: "UNIQUE_UNLOCK_SKIN_HORSE_GUILDBANNER",
        canEnchant: false
    },
{
        itemName: "Nightshade Unicorn",
        itemId: "SKIN_HORSE_UNICORN",
        canEnchant: false
    },
{
        itemName: "Keeper Horse",
        itemId: "SKIN_HORSE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Chimera",
        itemId: "SKIN_HORSE_QUESTING_BEAST",
        canEnchant: false
    },
{
        itemName: "Unicorn",
        itemId: "SKIN_HORSE_UNICORN_WHITE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Jester Horse",
        itemId: "SKIN_HORSE_JESTER_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Riding Horse Skin: Jester Horse",
        itemId: "UNIQUE_UNLOCK_SKIN_HORSE_JESTER_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Riding Horse Skin: Unicorn",
        itemId: "UNIQUE_UNLOCK_SKIN_HORSE_UNICORN_WHITE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Riding Horse Skin: Chimera",
        itemId: "UNIQUE_UNLOCK_SKIN_HORSE_QUESTING_BEAST",
        canEnchant: false
    },
{
        itemName: "Armored Horse Skin: Arena Veteran",
        itemId: "UNIQUE_UNLOCK_SKIN_ARMORED_HORSE_ARENA",
        canEnchant: false
    },
{
        itemName: "Morgana Mare",
        itemId: "SKIN_ARMORED_HORSE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Armored Bonehorse",
        itemId: "SKIN_ARMORED_HORSE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Armored Horse Skin: Morgana Mare",
        itemId: "UNIQUE_UNLOCK_SKIN_ARMORED_HORSE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Guild Warhorse",
        itemId: "SKIN_ARMORED_HORSE_T7_MOUNT_GUILD",
        canEnchant: false
    },
{
        itemName: "Armored Horse Skin: Armored Bonehorse",
        itemId: "UNIQUE_UNLOCK_SKIN_ARMORED_HORSE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Arena Veteran's Armored Horse",
        itemId: "SKIN_ARMORED_HORSE_ARENA",
        canEnchant: false
    },
{
        itemName: "Master's Guild Warhorse",
        itemId: "SKIN_ARMORED_HORSE_T6_MOUNT_GUILD",
        canEnchant: false
    },
{
        itemName: "Elder's Guild Warhorse",
        itemId: "SKIN_ARMORED_HORSE_T8_MOUNT_GUILD",
        canEnchant: false
    },
{
        itemName: "Expert's Guild Warhorse",
        itemId: "SKIN_ARMORED_HORSE_T5_MOUNT_GUILD",
        canEnchant: false
    },
{
        itemName: "Transport Ox Skin: Legendary Explorer",
        itemId: "UNIQUE_UNLOCK_SKIN_OX_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Legendary Adventurer's Cart",
        itemId: "SKIN_OX_CART_STARTERPACK",
        canEnchant: false
    },
{
        itemName: "Legendary Explorer's Ox",
        itemId: "SKIN_OX_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Armored Pony",
        itemId: "SKIN_ARMORED_HORSE_PONY_NATIVE_CLIENT",
        canEnchant: false
    },
{
        itemName: "Transport Ox Skin: Legendary Adventurer's Cart",
        itemId: "UNIQUE_UNLOCK_SKIN_OX_CART_STARTERPACK",
        canEnchant: false
    },
{
        itemName: "Recruiter's Yak",
        itemId: "SKIN_OX_YAK_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Black Market Ox",
        itemId: "SKIN_OX_BLACKMARKET",
        canEnchant: false
    },
{
        itemName: "Recruiter's Bighorn Ram",
        itemId: "SKIN_OX_TRANSPORT_RAM_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Transport Ox Skin: Recruiter's Bighorn Ram",
        itemId: "UNIQUE_UNLOCK_SKIN_OX_TRANSPORT_RAM_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Transport Ox Skin: Recruiter's Yak",
        itemId: "UNIQUE_UNLOCK_SKIN_OX_YAK_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Royal Ox",
        itemId: "SKIN_OX_BISON_ROYAL",
        canEnchant: false
    },
{
        itemName: "Auction House Ox",
        itemId: "SKIN_OX_BISON_AH",
        canEnchant: false
    },
{
        itemName: "Heretic Cart",
        itemId: "SKIN_OX_CART_HERETIC",
        canEnchant: false
    },
{
        itemName: "Luxury Cart",
        itemId: "SKIN_OX_CART_LUXUS_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Transport Ox Skin: Luxury Cart",
        itemId: "UNIQUE_UNLOCK_SKIN_OX_CART_LUXUS_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Transport Ox Skin: Heretic Cart",
        itemId: "UNIQUE_UNLOCK_SKIN_OX_CART_HERETIC",
        canEnchant: false
    },
{
        itemName: "Ghostwolf",
        itemId: "SKIN_DIREWOLF_WHITE",
        canEnchant: false
    },
{
        itemName: "Direwolf Skin: Ghostwolf",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREWOLF_WHITE",
        canEnchant: false
    },
{
        itemName: "Direwolf Skin: Specter Wolf",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREWOLF_SPECTER",
        canEnchant: false
    },
{
        itemName: "Recruiter's Grey Wolf",
        itemId: "SKIN_DIREWOLF_GREY_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Direwolf Skin: Recruiter's Rottweiler",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREWOLF_BLOODHOUND_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Direwolf Skin: Recruiter's Grey Wolf",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREWOLF_GREY_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Specter Wolf",
        itemId: "SKIN_DIREWOLF_SPECTER",
        canEnchant: false
    },
{
        itemName: "Recruiter's Rottweiler",
        itemId: "SKIN_DIREWOLF_BLOODHOUND_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Husky Sled",
        itemId: "SKIN_DIREWOLF_HUSKYSLEIGH_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Direwolf Skin: Recruiter's Saint Bernard",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREWOLF_BERNARD_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Dire Fox",
        itemId: "SKIN_DIREWOLF_DIREFOX_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Saint Bernard",
        itemId: "SKIN_DIREWOLF_BERNARD_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Direwolf Skin: Recruiter's Dire Fox",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREWOLF_DIREFOX_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Sheepdog",
        itemId: "SKIN_DIREWOLF_BOBTAIL",
        canEnchant: false
    },
{
        itemName: "Direwolf Skin: Sheepdog",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREWOLF_BOBTAIL",
        canEnchant: false
    },
{
        itemName: "Ironjaw Hyena",
        itemId: "SKIN_DIREWOLF_HYENA_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Direwolf Skin: Shepherd",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREWOLF_SHEPHERD_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Direwolf Skin: Recruiter's Husky Sled",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREWOLF_HUSKYSLEIGH_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Snow Fox",
        itemId: "SKIN_DIREWOLF_SNOWFOX_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Shepherd",
        itemId: "SKIN_DIREWOLF_SHEPHERD_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Direwolf Skin: Snow Fox",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREWOLF_SNOWFOX_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Master's Giant Stag",
        itemId: "SKIN_GIANTSTAG_WHITE",
        canEnchant: false
    },
{
        itemName: "Direwolf Skin: Ironjaw Hyena",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREWOLF_HYENA_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Giant Stag",
        itemId: "SKIN_GIANTSTAG_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Stag Skin: Yule Stag",
        itemId: "UNIQUE_UNLOCK_SKIN_GIANTSTAG_XMAS",
        canEnchant: false
    },
{
        itemName: "Stag Skin: Recruiter's Giant Stag",
        itemId: "UNIQUE_UNLOCK_SKIN_GIANTSTAG_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Stag Skin: Recruiter's Impala",
        itemId: "UNIQUE_UNLOCK_SKIN_GIANTSTAG_IMPALA_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Yule Stag",
        itemId: "SKIN_GIANTSTAG_XMAS",
        canEnchant: false
    },
{
        itemName: "Recruiter's Impala",
        itemId: "SKIN_GIANTSTAG_IMPALA_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Stag Skin: Divine Stag",
        itemId: "UNIQUE_UNLOCK_SKIN_GIANTSTAG_DIVINE",
        canEnchant: false
    },
{
        itemName: "Stag Skin: Master's Giant Stag",
        itemId: "UNIQUE_UNLOCK_SKIN_GIANTSTAG_WHITE",
        canEnchant: false
    },
{
        itemName: "Stag Skin: Alpaca",
        itemId: "UNIQUE_UNLOCK_SKIN_GIANTSTAG_ALPACA",
        canEnchant: false
    },
{
        itemName: "Festive Reindeer",
        itemId: "SKIN_GIANTSTAG_REINDEER_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Stag Skin: Festive Reindeer",
        itemId: "UNIQUE_UNLOCK_SKIN_GIANTSTAG_REINDEER_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Tiger",
        itemId: "SKIN_COUGAR_TIGER_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Divine Stag",
        itemId: "SKIN_GIANTSTAG_DIVINE",
        canEnchant: false
    },
{
        itemName: "Recruiter's White Tiger",
        itemId: "SKIN_COUGAR_TIGER_WHITE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Swiftclaw Skin: Recruiter's White Tiger",
        itemId: "UNIQUE_UNLOCK_SKIN_COUGAR_TIGER_WHITE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Arena Veteran's Armored Sabertooth",
        itemId: "SKIN_COUGAR_ARENA",
        canEnchant: false
    },
{
        itemName: "Swiftclaw Skin: Recruiter's Tiger",
        itemId: "UNIQUE_UNLOCK_SKIN_COUGAR_TIGER_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Swiftclaw Skin: Lynx",
        itemId: "UNIQUE_UNLOCK_SKIN_COUGAR_LYNX_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Swiftclaw Skin: Arena Veteran's Armored Sabertooth",
        itemId: "UNIQUE_UNLOCK_SKIN_COUGAR_ARENA",
        canEnchant: false
    },
{
        itemName: "Swiftclaw Skin: Saber Tiger Rex",
        itemId: "UNIQUE_UNLOCK_SKIN_COUGAR_TOURNAMENT_02",
        canEnchant: false
    },
{
        itemName: "Lynx",
        itemId: "SKIN_COUGAR_LYNX_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Sabertooth Rex",
        itemId: "SKIN_COUGAR_TOURNAMENT",
        canEnchant: false
    },
{
        itemName: "Occult Cougar",
        itemId: "SKIN_COUGAR_OCCULT",
        canEnchant: false
    },
{
        itemName: "Swiftclaw Skin: Sabertooth Rex",
        itemId: "UNIQUE_UNLOCK_SKIN_COUGAR_TOURNAMENT",
        canEnchant: false
    },
{
        itemName: "Swiftclaw Skin: Steelplate Cougar",
        itemId: "UNIQUE_UNLOCK_SKIN_COUGAR_ARMORED_GREY",
        canEnchant: false
    },
{
        itemName: "Saber Tiger Rex",
        itemId: "SKIN_COUGAR_TOURNAMENT_02",
        canEnchant: false
    },
{
        itemName: "Swiftclaw Skin: Snow Leopard",
        itemId: "UNIQUE_UNLOCK_SKIN_COUGAR_SNOWLEOPARD_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Swiftclaw Skin: Occult Cougar",
        itemId: "UNIQUE_UNLOCK_SKIN_COUGAR_OCCULT",
        canEnchant: false
    },
{
        itemName: "Snow Leopard",
        itemId: "SKIN_COUGAR_SNOWLEOPARD_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Steelplate Cougar",
        itemId: "SKIN_COUGAR_ARMORED_GREY",
        canEnchant: false
    },
{
        itemName: "Direboar Skin: Domesticated Hog",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREBOAR_HOUSEPIG",
        canEnchant: false
    },
{
        itemName: "Direboar Skin: White Direboar",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREBOAR_WHITE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Pig",
        itemId: "SKIN_DIREBOAR_PIG_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Panda",
        itemId: "SKIN_DIREBEAR_PANDA_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Domesticated Hog",
        itemId: "SKIN_DIREBOAR_HOUSEPIG",
        canEnchant: false
    },
{
        itemName: "White Direboar",
        itemId: "SKIN_DIREBOAR_WHITE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Direboar Skin: Recruiter's Pig",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREBOAR_PIG_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Swamp Dragon Skin: Recruiter's Sand Salamander",
        itemId: "UNIQUE_UNLOCK_SKIN_LIZARD_SAND_SALAMANDER_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Direbear Skin: Panda",
        itemId: "UNIQUE_UNLOCK_SKIN_DIREBEAR_PANDA_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Sand Salamander",
        itemId: "SKIN_LIZARD_SAND_SALAMANDER_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Jack o' Donkey",
        itemId: "SKIN_DONKEY_HALLOWEEN",
        canEnchant: false
    },
{
        itemName: "Mule Skin: Jack o' Donkey",
        itemId: "UNIQUE_UNLOCK_SKIN_DONKEY_HALLOWEEN",
        canEnchant: false
    },
{
        itemName: "Mule Skin: Recruiter's Donkey",
        itemId: "UNIQUE_UNLOCK_SKIN_DONKEY_UNIQUE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Hide Helmet",
        itemId: "UNIQUE_HEAD_VANITY_NO_HELMET",
        canEnchant: false
    },
{
        itemName: "Recruiter's Donkey",
        itemId: "SKIN_DONKEY_UNIQUE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Jester Mask",
        itemId: "UNIQUE_HEAD_VANITY_JESTER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Jester Mask",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_JESTER",
        canEnchant: false
    },
{
        itemName: "Hide Main Hand",
        itemId: "UNIQUE_HEAD_VANITY_NO_MAIN_HAND",
        canEnchant: false
    },
{
        itemName: "Hide Cape",
        itemId: "UNIQUE_HEAD_VANITY_NO_CAPE",
        canEnchant: false
    },
{
        itemName: "Hide Off-Hand",
        itemId: "UNIQUE_HEAD_VANITY_NO_OFF_HAND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Jester Shoes",
        itemId: "UNIQUE_UNLOCK_SHOES_VANITY_JESTER",
        canEnchant: false
    },
{
        itemName: "Jester Costume",
        itemId: "UNIQUE_ARMOR_VANITY_JESTER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Jester Costume",
        itemId: "UNIQUE_UNLOCK_ARMOR_VANITY_JESTER",
        canEnchant: false
    },
{
        itemName: "Red Tulip Hat",
        itemId: "UNIQUE_HEAD_VANITY_DRESS_RED",
        canEnchant: false
    },
{
        itemName: "Jester Shoes",
        itemId: "UNIQUE_SHOES_VANITY_JESTER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Red Tulip Dress",
        itemId: "UNIQUE_UNLOCK_ARMOR_VANITY_DRESS_RED",
        canEnchant: false
    },
{
        itemName: "Red Tulip Dress",
        itemId: "UNIQUE_ARMOR_VANITY_DRESS_RED",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Red Tulip Shoes",
        itemId: "UNIQUE_UNLOCK_SHOES_VANITY_DRESS_RED",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Red Tulip Hat",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_DRESS_RED",
        canEnchant: false
    },
{
        itemName: "Noblewoman's Dress",
        itemId: "UNIQUE_ARMOR_VANITY_DRESS_BLACK",
        canEnchant: false
    },
{
        itemName: "Noblewoman's Jewelry",
        itemId: "UNIQUE_HEAD_VANITY_DRESS_BLACK",
        canEnchant: false
    },
{
        itemName: "Red Tulip Shoes",
        itemId: "UNIQUE_SHOES_VANITY_DRESS_RED",
        canEnchant: false
    },
{
        itemName: "Noblewoman's Shoes",
        itemId: "UNIQUE_SHOES_VANITY_DRESS_BLACK",
        canEnchant: false
    },
{
        itemName: "Blue Princess Shoes",
        itemId: "UNIQUE_SHOES_VANITY_DRESS_BLUE",
        canEnchant: false
    },
{
        itemName: "Blue Princess Dress",
        itemId: "UNIQUE_ARMOR_VANITY_DRESS_BLUE",
        canEnchant: false
    },
{
        itemName: "Rich Noble's Doublet",
        itemId: "UNIQUE_ARMOR_VANITY_RICH_NOBLE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Rich Noble's Hat",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_RICH_NOBLE",
        canEnchant: false
    },
{
        itemName: "Rich Noble's Footwear",
        itemId: "UNIQUE_SHOES_VANITY_RICH_NOBLE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Rich Noble's Doublet",
        itemId: "UNIQUE_UNLOCK_ARMOR_VANITY_RICH_NOBLE",
        canEnchant: false
    },
{
        itemName: "Blue Princess Hat",
        itemId: "UNIQUE_HEAD_VANITY_DRESS_BLUE",
        canEnchant: false
    },
{
        itemName: "Yule Hat",
        itemId: "UNIQUE_HEAD_VANITY_SANTACLAUS",
        canEnchant: false
    },
{
        itemName: "Rich Noble's Hat",
        itemId: "UNIQUE_HEAD_VANITY_RICH_NOBLE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Rich Noble's Footwear",
        itemId: "UNIQUE_UNLOCK_SHOES_VANITY_RICH_NOBLE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Yule Coat",
        itemId: "UNIQUE_UNLOCK_ARMOR_VANITY_SANTACLAUS",
        canEnchant: false
    },
{
        itemName: "Yule Coat",
        itemId: "UNIQUE_ARMOR_VANITY_SANTACLAUS",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Yule Shoes",
        itemId: "UNIQUE_UNLOCK_SHOES_VANITY_SANTACLAUS",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Yule Hat",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_SANTACLAUS",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Yule Backpack",
        itemId: "UNIQUE_UNLOCK_BACKPACK_VANITY_SANTACLAUS",
        canEnchant: false
    },
{
        itemName: "Yule Shoes",
        itemId: "UNIQUE_SHOES_VANITY_SANTACLAUS",
        canEnchant: false
    },
{
        itemName: "Yule Backpack",
        itemId: "UNIQUE_BACKPACK_VANITY_SANTACLAUS",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Bridal Dress",
        itemId: "UNIQUE_UNLOCK_ARMOR_VANITY_WEDDING_DRESS",
        canEnchant: false
    },
{
        itemName: "Bridal Veil",
        itemId: "UNIQUE_HEAD_VANITY_WEDDING_DRESS",
        canEnchant: false
    },
{
        itemName: "Bridal Dress",
        itemId: "UNIQUE_ARMOR_VANITY_WEDDING_DRESS",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Bridal Shoes",
        itemId: "UNIQUE_UNLOCK_SHOES_VANITY_WEDDING_DRESS",
        canEnchant: false
    },
{
        itemName: "Bridal Shoes",
        itemId: "UNIQUE_SHOES_VANITY_WEDDING_DRESS",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Bridal Bouquet",
        itemId: "UNIQUE_UNLOCK_OFF_VANITY_WEDDING_DRESS",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Bridal Veil",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_WEDDING_DRESS",
        canEnchant: false
    },
{
        itemName: "Bridal Bouquet",
        itemId: "UNIQUE_OFF_VANITY_WEDDING_DRESS",
        canEnchant: false
    },
{
        itemName: "Groom Hat",
        itemId: "UNIQUE_HEAD_VANITY_WEDDING_TUXEDO",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Groom Hat",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_WEDDING_TUXEDO",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Groom Shoes",
        itemId: "UNIQUE_UNLOCK_SHOES_VANITY_WEDDING_TUXEDO",
        canEnchant: false
    },
{
        itemName: "Groom Shoes",
        itemId: "UNIQUE_SHOES_VANITY_WEDDING_TUXEDO",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Groom Suit",
        itemId: "UNIQUE_UNLOCK_ARMOR_VANITY_WEDDING_TUXEDO",
        canEnchant: false
    },
{
        itemName: "Groom Cape",
        itemId: "UNIQUE_CAPE_VANITY_WEDDING_TUXEDO",
        canEnchant: false
    },
{
        itemName: "Groom Suit",
        itemId: "UNIQUE_ARMOR_VANITY_WEDDING_TUXEDO",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Groom Cape",
        itemId: "UNIQUE_UNLOCK_CAPE_VANITY_WEDDING_TUXEDO",
        canEnchant: false
    },
{
        itemName: "Bard's Hat",
        itemId: "UNIQUE_HEAD_VANITY_BARD",
        canEnchant: false
    },
{
        itemName: "Wedding Ring",
        itemId: "UNIQUE_OFF_VANITY_WEDDING_TUXEDO",
        canEnchant: false
    },
{
        itemName: "Monk's Hood",
        itemId: "UNIQUE_HEAD_VANITY_PRIEST",
        canEnchant: false
    },
{
        itemName: "Bard's Shoes",
        itemId: "UNIQUE_SHOES_VANITY_BARD",
        canEnchant: false
    },
{
        itemName: "Bard's Suit",
        itemId: "UNIQUE_ARMOR_VANITY_BARD",
        canEnchant: false
    },
{
        itemName: "Monk's Robe",
        itemId: "UNIQUE_ARMOR_VANITY_PRIEST",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Wedding Ring",
        itemId: "UNIQUE_UNLOCK_OFF_VANITY_WEDDING_TUXEDO",
        canEnchant: false
    },
{
        itemName: "Innkeeper's Hat",
        itemId: "UNIQUE_HEAD_VANITY_INNKEEPER",
        canEnchant: false
    },
{
        itemName: "Monk's Sandals",
        itemId: "UNIQUE_SHOES_VANITY_PRIEST",
        canEnchant: false
    },
{
        itemName: "Innkeeper's Shirt",
        itemId: "UNIQUE_ARMOR_VANITY_INNKEEPER",
        canEnchant: false
    },
{
        itemName: "Navigator's Coat",
        itemId: "UNIQUE_ARMOR_VANITY_PIRATE",
        canEnchant: false
    },
{
        itemName: "Monk's Walking Staff",
        itemId: "UNIQUE_OFF_VANITY_PRIEST",
        canEnchant: false
    },
{
        itemName: "Navigator's Hat",
        itemId: "UNIQUE_HEAD_VANITY_PIRATE",
        canEnchant: false
    },
{
        itemName: "Innkeeper's Beer Mug",
        itemId: "UNIQUE_OFF_VANITY_INNKEEPER",
        canEnchant: false
    },
{
        itemName: "Innkeeper's Shoes",
        itemId: "UNIQUE_SHOES_VANITY_INNKEEPER",
        canEnchant: false
    },
{
        itemName: "Navigator's Parrot Cage",
        itemId: "UNIQUE_OFF_VANITY_PIRATE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Staff of Hermes",
        itemId: "UNIQUE_UNLOCK_OFF_VANITY_CHARITY_MARCH2020",
        canEnchant: false
    },
{
        itemName: "Staff of Hermes",
        itemId: "UNIQUE_OFF_VANITY_CHARITY_MARCH2020",
        canEnchant: false
    },
{
        itemName: "Navigator's Boots",
        itemId: "UNIQUE_SHOES_VANITY_PIRATE",
        canEnchant: false
    },
{
        itemName: "Bridgewatch Warbanner",
        itemId: "UNIQUE_UNLOCK_VANITY_2H_FW_BRIDGEWATCH_BANNER",
        canEnchant: false
    },
{
        itemName: "Thetford Warbanner",
        itemId: "UNIQUE_UNLOCK_VANITY_2H_FW_THETFORD_BANNER",
        canEnchant: false
    },
{
        itemName: "Fort Sterling Warbanner",
        itemId: "UNIQUE_UNLOCK_VANITY_2H_FW_FORTSTERLING_BANNER",
        canEnchant: false
    },
{
        itemName: "Lymhurst Warbanner",
        itemId: "UNIQUE_UNLOCK_VANITY_2H_FW_LYMHURST_BANNER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Arena Veteran's Circlet",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_ARENA_SET_01",
        canEnchant: false
    },
{
        itemName: "Arena Veteran's Circlet",
        itemId: "UNIQUE_HEAD_VANITY_ARENA_SET_01",
        canEnchant: false
    },
{
        itemName: "Martlock Warbanner",
        itemId: "UNIQUE_UNLOCK_VANITY_2H_FW_MARTLOCK_BANNER",
        canEnchant: false
    },
{
        itemName: "Arena Veteran's Boots",
        itemId: "UNIQUE_SHOES_VANITY_ARENA_SET_01",
        canEnchant: false
    },
{
        itemName: "Arena Veteran's Cloak",
        itemId: "UNIQUE_ARMOR_VANITY_ARENA_SET_01",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Arena Veteran's Boots",
        itemId: "UNIQUE_UNLOCK_SHOES_VANITY_ARENA_SET_01",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Arena Veteran's Cape",
        itemId: "UNIQUE_UNLOCK_CAPE_VANITY_ARENA_SET_01",
        canEnchant: false
    },
{
        itemName: "Arena Veteran's Cape",
        itemId: "UNIQUE_CAPE_VANITY_ARENA_SET_01",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Arena Veteran's Cloak",
        itemId: "UNIQUE_UNLOCK_ARMOR_VANITY_ARENA_SET_01",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Arena Veteran's Eyepatch",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_ARENA_EYEPATCH",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Arena Veteran's Small Banner",
        itemId: "UNIQUE_UNLOCK_T4_CAPE_ARENA_BANNER",
        canEnchant: false
    },
{
        itemName: "Arena Veteran's Eyepatch",
        itemId: "UNIQUE_HEAD_VANITY_ARENA_EYEPATCH",
        canEnchant: false
    },
{
        itemName: "Arena Veteran's Large Banner",
        itemId: "T8_CAPE_ARENA_BANNER",
        canEnchant: false
    },
{
        itemName: "Caerleon Warbanner",
        itemId: "UNIQUE_UNLOCK_VANITY_2H_FW_CAERLEON_BANNER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Arena Veteran's Large Banner",
        itemId: "UNIQUE_UNLOCK_T8_CAPE_ARENA_BANNER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Master of Bats Helmet",
        itemId: "UNIQUE_UNLOCK_HEAD_TELLAFRIEND_BATRIDER",
        canEnchant: false
    },
{
        itemName: "Arena Veteran's Medium Banner",
        itemId: "T6_CAPE_ARENA_BANNER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Arena Veteran's Medium Banner",
        itemId: "UNIQUE_UNLOCK_T6_CAPE_ARENA_BANNER",
        canEnchant: false
    },
{
        itemName: "Arena Veteran's Small Banner",
        itemId: "T4_CAPE_ARENA_BANNER",
        canEnchant: false
    },
{
        itemName: "Snow Bunny Stalker Hat",
        itemId: "UNIQUE_HEAD_VANITY_EASTER_WHITE",
        canEnchant: false
    },
{
        itemName: "Master of Bats Helmet",
        itemId: "UNIQUE_HEAD_TELLAFRIEND_BATRIDER",
        canEnchant: false
    },
{
        itemName: "Bunny Stalker Overalls",
        itemId: "UNIQUE_ARMOR_VANITY_EASTER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Bunny Stalker Overalls",
        itemId: "UNIQUE_UNLOCK_ARMOR_VANITY_EASTER",
        canEnchant: false
    },
{
        itemName: "Bunny Stalker Hat",
        itemId: "UNIQUE_HEAD_VANITY_EASTER_BROWN",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Bunny Stalker Hat",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_EASTER_BROWN",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Snow Bunny Stalker Hat",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_EASTER_WHITE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Bunny Stalker Shoes",
        itemId: "UNIQUE_UNLOCK_SHOES_VANITY_EASTER",
        canEnchant: false
    },
{
        itemName: "Bunny Stalker Basket",
        itemId: "UNIQUE_BACKPACK_VANITY_EASTER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Bunny Stalker Basket",
        itemId: "UNIQUE_UNLOCK_BACKPACK_VANITY_EASTER",
        canEnchant: false
    },
{
        itemName: "Hygienic Mask",
        itemId: "UNIQUE_HEAD_VANITY_PLAGUEDOC",
        canEnchant: false
    },
{
        itemName: "Bunny Stalker Shoes",
        itemId: "UNIQUE_SHOES_VANITY_EASTER",
        canEnchant: false
    },
{
        itemName: "Hygienic Boots",
        itemId: "UNIQUE_SHOES_VANITY_PLAGUEDOC",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Hygienic Coat",
        itemId: "UNIQUE_UNLOCK_ARMOR_VANITY_PLAGUEDOC",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Hygienic Mask",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_PLAGUEDOC",
        canEnchant: false
    },
{
        itemName: "Ribcage",
        itemId: "UNIQUE_ARMOR_VANITY_SKELETON",
        canEnchant: false
    },
{
        itemName: "Hygienic Coat",
        itemId: "UNIQUE_ARMOR_VANITY_PLAGUEDOC",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Laughing Skull",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_SKELETON",
        canEnchant: false
    },
{
        itemName: "Legbones",
        itemId: "UNIQUE_SHOES_VANITY_SKELETON",
        canEnchant: false
    },
{
        itemName: "Laughing Skull",
        itemId: "UNIQUE_HEAD_VANITY_SKELETON",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Ribcage",
        itemId: "UNIQUE_UNLOCK_ARMOR_VANITY_SKELETON",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Hygienic Boots",
        itemId: "UNIQUE_UNLOCK_SHOES_VANITY_PLAGUEDOC",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Legbones",
        itemId: "UNIQUE_UNLOCK_SHOES_VANITY_SKELETON",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Grinning Pumpkin Head",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_PUMPKIN_01",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Ragged Cape",
        itemId: "UNIQUE_UNLOCK_CAPE_VANITY_SKELETON",
        canEnchant: false
    },
{
        itemName: "Grinning Pumpkin Head",
        itemId: "UNIQUE_HEAD_VANITY_PUMPKIN_01",
        canEnchant: false
    },
{
        itemName: "Angry Pumpkin Head",
        itemId: "UNIQUE_HEAD_VANITY_PUMPKIN_03",
        canEnchant: false
    },
{
        itemName: "Sad Pumpkin Head",
        itemId: "UNIQUE_HEAD_VANITY_PUMPKIN_02",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Angry Pumpkin Head",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_PUMPKIN_03",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Sad Pumpkin Head",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_PUMPKIN_02",
        canEnchant: false
    },
{
        itemName: "Uncle Frost's Hat",
        itemId: "UNIQUE_HEAD_XMAS",
        canEnchant: false
    },
{
        itemName: "Ragged Cape",
        itemId: "UNIQUE_CAPE_VANITY_SKELETON",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Uncle Frost's Hat",
        itemId: "UNIQUE_UNLOCK_HEAD_XMAS",
        canEnchant: false
    },
{
        itemName: "Recruiter's Portal Cannon",
        itemId: "UNIQUE_VANITY_2H_PORTALGUN_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Portal Cannon",
        itemId: "UNIQUE_UNLOCK_VANITY_2H_PORTALGUN_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "The Eggsecutioner",
        itemId: "UNIQUE_VANITY_2H_CHICKENGUN_EASTER",
        canEnchant: false
    },
{
        itemName: "Recruiter's Beer Mug",
        itemId: "UNIQUE_VANITY_MAIN_BEERMUG_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: The Eggsecutioner",
        itemId: "UNIQUE_UNLOCK_UNIQUE_VANITY_2H_CHICKENGUN_EASTER",
        canEnchant: false
    },
{
        itemName: "Recruiter's Fox Crop",
        itemId: "UNIQUE_VANITY_MAIN_FOXCROP_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Beer Mug",
        itemId: "UNIQUE_UNLOCK_VANITY_MAIN_BEERMUG_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Trumpet",
        itemId: "UNIQUE_UNLOCK_VANITY_MAIN_TRUMPET_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Fox Crop",
        itemId: "UNIQUE_UNLOCK_VANITY_MAIN_FOXCROP_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Hunter Horn",
        itemId: "UNIQUE_VANITY_MAIN_HORN_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Ale Mug",
        itemId: "UNIQUE_VANITY_MAIN_BEERMUG_02_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Ale Mug",
        itemId: "UNIQUE_UNLOCK_VANITY_MAIN_BEERMUG_02_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Legendary Explorer's Cloak",
        itemId: "UNIQUE_UNLOCK_CAPE_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Recruiter's Trumpet",
        itemId: "UNIQUE_VANITY_MAIN_TRUMPET_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Legendary Explorer's Cloak",
        itemId: "UNIQUE_CAPE_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Legendary Explorer's Armor",
        itemId: "UNIQUE_ARMOR_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Legendary Explorer's Hat",
        itemId: "UNIQUE_UNLOCK_HEAD_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Legendary Explorer's Hat",
        itemId: "UNIQUE_HEAD_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Legendary Explorer's Boots",
        itemId: "UNIQUE_SHOES_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Legendary Explorer's Armor",
        itemId: "UNIQUE_UNLOCK_ARMOR_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Hunter Horn",
        itemId: "UNIQUE_UNLOCK_VANITY_MAIN_HORN_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Legendary Explorer's Boots",
        itemId: "UNIQUE_UNLOCK_SHOES_FOUNDER_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Explorer's Armor",
        itemId: "UNIQUE_ARMOR_FOUNDER_ELITE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Explorer's Hat",
        itemId: "UNIQUE_UNLOCK_HEAD_FOUNDER_ELITE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Explorer's Armor",
        itemId: "UNIQUE_UNLOCK_ARMOR_FOUNDER_ELITE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Explorer's Boots",
        itemId: "UNIQUE_UNLOCK_SHOES_FOUNDER_ELITE",
        canEnchant: false
    },
{
        itemName: "Explorer's Boots",
        itemId: "UNIQUE_SHOES_FOUNDER_ELITE",
        canEnchant: false
    },
{
        itemName: "Explorer's Hat",
        itemId: "UNIQUE_HEAD_FOUNDER_ELITE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Legendary Adventurer's Cloak",
        itemId: "UNIQUE_UNLOCK_CAPE_STARTERPACK_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Legendary Adventurer's Cloak",
        itemId: "UNIQUE_CAPE_STARTERPACK_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Legendary Adventurer's Hat",
        itemId: "UNIQUE_UNLOCK_HEAD_STARTERPACK_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Legendary Adventurer's Armor",
        itemId: "UNIQUE_UNLOCK_ARMOR_STARTERPACK_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Legendary Adventurer's Hat",
        itemId: "UNIQUE_HEAD_STARTERPACK_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Legendary Adventurer's Boots",
        itemId: "UNIQUE_SHOES_STARTERPACK_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Legendary Adventurer's Armor",
        itemId: "UNIQUE_ARMOR_STARTERPACK_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Adventurer's Helmet",
        itemId: "UNIQUE_UNLOCK_HEAD_STARTERPACK_ELITE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Legendary Adventurer's Boots",
        itemId: "UNIQUE_UNLOCK_SHOES_STARTERPACK_LEGENDARY",
        canEnchant: false
    },
{
        itemName: "Adventurer's Helmet",
        itemId: "UNIQUE_HEAD_STARTERPACK_ELITE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Adventurer's Jacket",
        itemId: "UNIQUE_UNLOCK_ARMOR_STARTERPACK_ELITE",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Adventurer's Shoes",
        itemId: "UNIQUE_UNLOCK_SHOES_STARTERPACK_ELITE",
        canEnchant: false
    },
{
        itemName: "Adventurer's Shoes",
        itemId: "UNIQUE_SHOES_STARTERPACK_ELITE",
        canEnchant: false
    },
{
        itemName: "Adventurer's Jacket",
        itemId: "UNIQUE_ARMOR_STARTERPACK_ELITE",
        canEnchant: false
    },
{
        itemName: "Undead Ribcage",
        itemId: "UNIQUE_ARMOR_VANITY_SKELETON_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Undead Ribcage",
        itemId: "UNIQUE_UNLOCK_ARMOR_VANITY_SKELETON_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Undead Skull",
        itemId: "UNIQUE_HEAD_VANITY_SKELETON_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Undead Legs",
        itemId: "UNIQUE_SHOES_VANITY_SKELETON_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Ragged Undead Cape",
        itemId: "UNIQUE_UNLOCK_CAPE_VANITY_SKELETON_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Undead Legs",
        itemId: "UNIQUE_UNLOCK_SHOES_VANITY_SKELETON_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Undead Skull",
        itemId: "UNIQUE_UNLOCK_HEAD_VANITY_SKELETON_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Ragged Undead Cape",
        itemId: "UNIQUE_CAPE_VANITY_SKELETON_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Cape",
        itemId: "UNIQUE_UNLOCK_CAPE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Cape",
        itemId: "UNIQUE_CAPE_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Ogronios Banner",
        itemId: "UNIQUE_CAPE_TELLAFRIEND_BANNER_02",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Riuros Cape",
        itemId: "UNIQUE_UNLOCK_CAPE_TELLAFRIEND_02",
        canEnchant: false
    },
{
        itemName: "Riuros Cape",
        itemId: "UNIQUE_CAPE_TELLAFRIEND_02",
        canEnchant: false
    },
{
        itemName: "Master of Bats Cape",
        itemId: "UNIQUE_CAPE_TELLAFRIEND_BATRIDER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Ogronios Banner",
        itemId: "UNIQUE_UNLOCK_CAPE_TELLAFRIEND_BANNER_02",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Master of Bats Cape",
        itemId: "UNIQUE_UNLOCK_CAPE_TELLAFRIEND_BATRIDER",
        canEnchant: false
    },
{
        itemName: "Recruiter's Cape - Toad",
        itemId: "UNIQUE_CAPE_TOAD_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Banner",
        itemId: "UNIQUE_UNLOCK_CAPE_TELLAFRIEND_BANNER",
        canEnchant: false
    },
{
        itemName: "Recruiter's Banner",
        itemId: "UNIQUE_CAPE_TELLAFRIEND_BANNER",
        canEnchant: false
    },
{
        itemName: "Recruiter's Cape - Rottweiler",
        itemId: "UNIQUE_CAPE_BLOODHOUND_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Cape - Rottweiler",
        itemId: "UNIQUE_UNLOCK_CAPE_BLOODHOUND_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Cape - Toad",
        itemId: "UNIQUE_UNLOCK_CAPE_TOAD_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Tiger Cape",
        itemId: "UNIQUE_UNLOCK_CAPE_TIGER_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Tiger Cape",
        itemId: "UNIQUE_CAPE_TIGER_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Grey Wolf Cape",
        itemId: "UNIQUE_CAPE_WOLF_GREY_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Recruiter's Fur Cape",
        itemId: "UNIQUE_CAPE_RAM_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Grey Wolf Cape",
        itemId: "UNIQUE_UNLOCK_CAPE_WOLF_GREY_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Recruiter's Fur Cape",
        itemId: "UNIQUE_UNLOCK_CAPE_RAM_TELLAFRIEND",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Decorative Undead Leather Cape",
        itemId: "UNIQUE_UNLOCK_T6_CAPE_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Decorative Undead Leather Cape",
        itemId: "T6_CAPE_LEATHER_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Decorative Undead Platemail Cape",
        itemId: "UNIQUE_UNLOCK_T6_CAPE_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Decorative Undead Cloth Cape",
        itemId: "UNIQUE_UNLOCK_T6_CAPE_CLOTH_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Decorative Undead Cloth Cape",
        itemId: "T6_CAPE_CLOTH_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Decorative Undead Platemail Cape",
        itemId: "T6_CAPE_PLATE_UNDEAD",
        canEnchant: false
    },
{
        itemName: "Decorative Keeper Platemail Cape",
        itemId: "T6_CAPE_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Decorative Keeper Cloth Cape",
        itemId: "T6_CAPE_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Decorative Keeper Cloth Cape",
        itemId: "UNIQUE_UNLOCK_T6_CAPE_CLOTH_KEEPER",
        canEnchant: false
    },
{
        itemName: "Decorative Keeper Leather Cape",
        itemId: "T6_CAPE_LEATHER_KEEPER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Decorative Keeper Platemail Cape",
        itemId: "UNIQUE_UNLOCK_T6_CAPE_PLATE_KEEPER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Decorative Morgana Platemail Cape",
        itemId: "UNIQUE_UNLOCK_T6_CAPE_PLATE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Decorative Keeper Leather Cape",
        itemId: "UNIQUE_UNLOCK_T6_CAPE_LEATHER_KEEPER",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Decorative Morgana Leather Cape",
        itemId: "UNIQUE_UNLOCK_T6_CAPE_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Decorative Morgana Leather Cape",
        itemId: "T6_CAPE_LEATHER_MORGANA",
        canEnchant: false
    },
{
        itemName: "Wardrobe Skin: Decorative Morgana Cloth Cape",
        itemId: "UNIQUE_UNLOCK_T6_CAPE_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Decorative Morgana Platemail Cape",
        itemId: "T6_CAPE_PLATE_MORGANA",
        canEnchant: false
    },
{
        itemName: "Decorative Morgana Cloth Cape",
        itemId: "T6_CAPE_CLOTH_MORGANA",
        canEnchant: false
    },
{
        itemName: "Rogue Adventurer's Boots",
        itemId: "UNIQUE_SHOES_VANITY_ROGUE",
        canEnchant: false
    },
{
        itemName: "Rogue Adventurer's Hood",
        itemId: "UNIQUE_HEAD_VANITY_ROGUE",
        canEnchant: false
    },
{
        itemName: "Rogue Adventurer's Poison Bottle",
        itemId: "UNIQUE_VANITY_MAIN_POISONBOTTLE_ROGUE",
        canEnchant: false
    },
{
        itemName: "Rogue Adventurer's Armor",
        itemId: "UNIQUE_ARMOR_VANITY_ROGUE",
        canEnchant: false
    },
{
        itemName: "Rogue Adventurer's Cape",
        itemId: "UNIQUE_CAPE_VANITY_ROGUE",
        canEnchant: false
    },
{
        itemName: "Rogue Adventurer's Guild Armor",
        itemId: "UNIQUE_ARMOR_VANITY_ROGUE_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Rogue Adventurer's Guild Cape",
        itemId: "UNIQUE_CAPE_VANITY_ROGUE_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Rogue Adventurer's Guild Armored Horse",
        itemId: "SKIN_ARMORED_HORSE_ROGUE_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Knight Adventurer's Armor",
        itemId: "UNIQUE_ARMOR_VANITY_KNIGHT",
        canEnchant: false
    },
{
        itemName: "Knight Adventurer's Warbanner",
        itemId: "UNIQUE_VANITY_2H_BANNER_KNIGHT_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Rogue Adventurer's Armored Horse",
        itemId: "SKIN_ARMORED_HORSE_ROGUE",
        canEnchant: false
    },
{
        itemName: "Knight Adventurer's Boots",
        itemId: "UNIQUE_SHOES_VANITY_KNIGHT",
        canEnchant: false
    },
{
        itemName: "Knight Adventurer's Helmet",
        itemId: "UNIQUE_HEAD_VANITY_KNIGHT",
        canEnchant: false
    },
{
        itemName: "Knight Adventurer's Armored Horse",
        itemId: "SKIN_ARMORED_HORSE_KNIGHT",
        canEnchant: false
    },
{
        itemName: "Knight Adventurer's Cape",
        itemId: "UNIQUE_CAPE_VANITY_KNIGHT",
        canEnchant: false
    },
{
        itemName: "Knight Adventurer's Guild Armor",
        itemId: "UNIQUE_ARMOR_VANITY_KNIGHT_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Knight Adventurer's Guild Cape",
        itemId: "UNIQUE_CAPE_VANITY_KNIGHT_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Knight Adventurer's Guild Helmet",
        itemId: "UNIQUE_HEAD_VANITY_KNIGHT_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Knight Adventurer's Guild Armored Horse",
        itemId: "SKIN_ARMORED_HORSE_KNIGHT_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Mage Adventurer's Armor",
        itemId: "UNIQUE_ARMOR_VANITY_MAGE",
        canEnchant: false
    },
{
        itemName: "Mage Adventurer's Boots",
        itemId: "UNIQUE_SHOES_VANITY_MAGE",
        canEnchant: false
    },
{
        itemName: "Mage Adventurer's Guild Cape",
        itemId: "UNIQUE_CAPE_VANITY_MAGE_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Mage Adventurer's Spellbook",
        itemId: "UNIQUE_VANITY_2H_SPELLBOOK_MAGE",
        canEnchant: false
    },
{
        itemName: "Mage Adventurer's Cape",
        itemId: "UNIQUE_CAPE_VANITY_MAGE",
        canEnchant: false
    },
{
        itemName: "Mage Adventurer's Guild Armor",
        itemId: "UNIQUE_ARMOR_VANITY_MAGE_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Mage Adventurer's Guild Armored Horse",
        itemId: "SKIN_ARMORED_HORSE_MAGE_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Mage Adventurer's Guild Hat",
        itemId: "UNIQUE_HEAD_VANITY_MAGE_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Mage Adventurer's Armored Horse",
        itemId: "SKIN_ARMORED_HORSE_MAGE",
        canEnchant: false
    },
{
        itemName: "Barbarian's Harness",
        itemId: "UNIQUE_ARMOR_VANITY_BARBARIAN",
        canEnchant: false
    },
{
        itemName: "Mage Adventurer's Hat",
        itemId: "UNIQUE_HEAD_VANITY_MAGE",
        canEnchant: false
    },
{
        itemName: "Barbarian's Helmet",
        itemId: "UNIQUE_HEAD_VANITY_BARBARIAN",
        canEnchant: false
    },
{
        itemName: "Miststalker",
        itemId: "SKIN_COUGAR_MIST",
        canEnchant: false
    },
{
        itemName: "Barbarian's Cape",
        itemId: "UNIQUE_CAPE_VANITY_BARBARIAN",
        canEnchant: false
    },
{
        itemName: "Barbarian's Boots",
        itemId: "UNIQUE_SHOES_VANITY_BARBARIAN",
        canEnchant: false
    },
{
        itemName: "Keeper of Souls Cowl",
        itemId: "UNIQUE_HEAD_VANITY_SOULKEEPER",
        canEnchant: false
    },
{
        itemName: "Keeper of Souls Armor",
        itemId: "UNIQUE_ARMOR_VANITY_SOULKEEPER",
        canEnchant: false
    },
{
        itemName: "War Beast",
        itemId: "SKIN_DIREWOLF_BARBARIAN",
        canEnchant: false
    },
{
        itemName: "Keeper of Souls Cape",
        itemId: "UNIQUE_CAPE_VANITY_SOULKEEPER",
        canEnchant: false
    },
{
        itemName: "Keeper of Souls Boots",
        itemId: "UNIQUE_SHOES_VANITY_SOULKEEPER",
        canEnchant: false
    },
{
        itemName: "Phylactery of Souls",
        itemId: "UNIQUE_VANITY_2H_PHYLACTERY_SOULKEEPER",
        canEnchant: false
    },
{
        itemName: "Keeper of Souls Stag",
        itemId: "SKIN_STAG_SOULKEEPER",
        canEnchant: false
    },
{
        itemName: "Hell Mare",
        itemId: "SKIN_HORSE_HELL",
        canEnchant: false
    },
{
        itemName: "Paladin's Boots",
        itemId: "UNIQUE_SHOES_VANITY_PALADIN",
        canEnchant: false
    },
{
        itemName: "Paladin's Cape",
        itemId: "UNIQUE_CAPE_VANITY_PALADIN",
        canEnchant: false
    },
{
        itemName: "Darkfang",
        itemId: "SKIN_COUGAR_DARK",
        canEnchant: false
    },
{
        itemName: "Paladin's Helmet",
        itemId: "UNIQUE_HEAD_VANITY_PALADIN",
        canEnchant: false
    },
{
        itemName: "Paladin's Guild Cape",
        itemId: "UNIQUE_CAPE_VANITY_PALADIN_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Paladin's Armor",
        itemId: "UNIQUE_ARMOR_VANITY_PALADIN",
        canEnchant: false
    },
{
        itemName: "Paladin's Warhorse",
        itemId: "SKIN_ARMORED_HORSE_PALADIN",
        canEnchant: false
    },
{
        itemName: "Mistbison",
        itemId: "SKIN_OX_MIST",
        canEnchant: false
    },
{
        itemName: "Paladin's Guild Warhorse",
        itemId: "SKIN_ARMORED_HORSE_PALADIN_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Demon Hunter's Hat",
        itemId: "UNIQUE_HEAD_VANITY_DEMONHUNTER",
        canEnchant: false
    },
{
        itemName: "Paladin's Guild Armor",
        itemId: "UNIQUE_ARMOR_VANITY_PALADIN_GUILD_COLORED",
        canEnchant: false
    },
{
        itemName: "Demon Hunter's Horse",
        itemId: "SKIN_HORSE_DEMONHUNTER",
        canEnchant: false
    },
{
        itemName: "Demon Hunter's Boots",
        itemId: "UNIQUE_SHOES_VANITY_DEMONHUNTER",
        canEnchant: false
    },
{
        itemName: "Demon Hunter's Coat",
        itemId: "UNIQUE_ARMOR_VANITY_DEMONHUNTER",
        canEnchant: false
    },
{
        itemName: "Druid's Horns",
        itemId: "UNIQUE_HEAD_VANITY_DRUID",
        canEnchant: false
    },
{
        itemName: "Demon Hunter's Cape",
        itemId: "UNIQUE_CAPE_VANITY_DEMONHUNTER",
        canEnchant: false
    },
{
        itemName: "Druid's Shoes",
        itemId: "UNIQUE_SHOES_VANITY_DRUID",
        canEnchant: false
    },
{
        itemName: "Mistwolf",
        itemId: "SKIN_DIREWOLF_MIST",
        canEnchant: false
    },
{
        itemName: "Demonic Warrior's Armor",
        itemId: "UNIQUE_ARMOR_VANITY_DEMONICWARRIOR",
        canEnchant: false
    },
{
        itemName: "Druid's Vestments",
        itemId: "UNIQUE_ARMOR_VANITY_DRUID",
        canEnchant: false
    },
{
        itemName: "Demonic Warrior's Helmet",
        itemId: "UNIQUE_HEAD_VANITY_DEMONICWARRIOR",
        canEnchant: false
    },
{
        itemName: "Demonic Warrior's Boots",
        itemId: "UNIQUE_SHOES_VANITY_DEMONICWARRIOR",
        canEnchant: false
    },
{
        itemName: "Druid's Cape",
        itemId: "UNIQUE_CAPE_VANITY_DRUID",
        canEnchant: false
    },
{
        itemName: "Demonic Warrior's Cape",
        itemId: "UNIQUE_CAPE_VANITY_DEMONICWARRIOR",
        canEnchant: false
    },
{
        itemName: "Druid's Stag",
        itemId: "SKIN_STAG_DRUID",
        canEnchant: false
    },
{
        itemName: "Shadowcat",
        itemId: "SKIN_COUGAR_SHADOWCAT",
        canEnchant: false
    },
{
        itemName: "Saddled Hellhound",
        itemId: "SKIN_DIREWOLF_DEMONICWARRIOR",
        canEnchant: false
    },
{
        itemName: "Novice Lumberjack's Journal (Empty)",
        itemId: "T2_JOURNAL_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Lumberjack's Journal (Full)",
        itemId: "T2_JOURNAL_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Lumberjack's Journal (Empty)",
        itemId: "T3_JOURNAL_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Lumberjack's Journal (Empty)",
        itemId: "T6_JOURNAL_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Lumberjack's Journal (Full)",
        itemId: "T4_JOURNAL_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Lumberjack's Journal (Empty)",
        itemId: "T4_JOURNAL_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Lumberjack's Journal (Full)",
        itemId: "T3_JOURNAL_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Lumberjack's Journal (Empty)",
        itemId: "T5_JOURNAL_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Lumberjack's Journal (Full)",
        itemId: "T5_JOURNAL_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Lumberjack's Journal (Empty)",
        itemId: "T8_JOURNAL_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Lumberjack's Journal (Full)",
        itemId: "T6_JOURNAL_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Lumberjack's Journal (Empty)",
        itemId: "T7_JOURNAL_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Stonecutter's Journal (Full)",
        itemId: "T2_JOURNAL_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Lumberjack's Journal (Full)",
        itemId: "T7_JOURNAL_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Stonecutter's Journal (Empty)",
        itemId: "T3_JOURNAL_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Lumberjack's Journal (Full)",
        itemId: "T8_JOURNAL_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Stonecutter's Journal (Empty)",
        itemId: "T5_JOURNAL_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Stonecutter's Journal (Empty)",
        itemId: "T2_JOURNAL_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Stonecutter's Journal (Empty)",
        itemId: "T4_JOURNAL_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Stonecutter's Journal (Full)",
        itemId: "T3_JOURNAL_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Stonecutter's Journal (Empty)",
        itemId: "T7_JOURNAL_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Stonecutter's Journal (Full)",
        itemId: "T5_JOURNAL_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Stonecutter's Journal (Full)",
        itemId: "T4_JOURNAL_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Master Stonecutter's Journal (Full)",
        itemId: "T6_JOURNAL_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Stonecutter's Journal (Full)",
        itemId: "T7_JOURNAL_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Master Stonecutter's Journal (Empty)",
        itemId: "T6_JOURNAL_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Stonecutter's Journal (Empty)",
        itemId: "T8_JOURNAL_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Prospector's Journal (Empty)",
        itemId: "T2_JOURNAL_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Prospector's Journal (Full)",
        itemId: "T3_JOURNAL_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Prospector's Journal (Empty)",
        itemId: "T3_JOURNAL_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Stonecutter's Journal (Full)",
        itemId: "T8_JOURNAL_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Prospector's Journal (Empty)",
        itemId: "T4_JOURNAL_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Prospector's Journal (Full)",
        itemId: "T2_JOURNAL_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Prospector's Journal (Full)",
        itemId: "T4_JOURNAL_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Prospector's Journal (Empty)",
        itemId: "T7_JOURNAL_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Prospector's Journal (Full)",
        itemId: "T5_JOURNAL_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Prospector's Journal (Empty)",
        itemId: "T5_JOURNAL_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Prospector's Journal (Empty)",
        itemId: "T6_JOURNAL_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Prospector's Journal (Full)",
        itemId: "T6_JOURNAL_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Prospector's Journal (Full)",
        itemId: "T7_JOURNAL_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Prospector's Journal (Empty)",
        itemId: "T8_JOURNAL_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Cropper's Journal (Empty)",
        itemId: "T3_JOURNAL_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Prospector's Journal (Full)",
        itemId: "T8_JOURNAL_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Novice Cropper's Journal (Empty)",
        itemId: "T2_JOURNAL_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Cropper's Journal (Full)",
        itemId: "T3_JOURNAL_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Cropper's Journal (Empty)",
        itemId: "T5_JOURNAL_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Cropper's Journal (Full)",
        itemId: "T2_JOURNAL_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Master Cropper's Journal (Empty)",
        itemId: "T6_JOURNAL_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Cropper's Journal (Empty)",
        itemId: "T7_JOURNAL_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Cropper's Journal (Full)",
        itemId: "T5_JOURNAL_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Cropper's Journal (Empty)",
        itemId: "T4_JOURNAL_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Cropper's Journal (Full)",
        itemId: "T6_JOURNAL_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Cropper's Journal (Full)",
        itemId: "T4_JOURNAL_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Cropper's Journal (Full)",
        itemId: "T7_JOURNAL_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Gamekeeper's Journal (Empty)",
        itemId: "T3_JOURNAL_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Cropper's Journal (Empty)",
        itemId: "T8_JOURNAL_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Gamekeeper's Journal (Empty)",
        itemId: "T2_JOURNAL_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Cropper's Journal (Full)",
        itemId: "T8_JOURNAL_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Gamekeeper's Journal (Empty)",
        itemId: "T4_JOURNAL_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Gamekeeper's Journal (Empty)",
        itemId: "T5_JOURNAL_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Gamekeeper's Journal (Full)",
        itemId: "T3_JOURNAL_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Master Gamekeeper's Journal (Empty)",
        itemId: "T6_JOURNAL_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Gamekeeper's Journal (Full)",
        itemId: "T2_JOURNAL_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Gamekeeper's Journal (Full)",
        itemId: "T5_JOURNAL_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Gamekeeper's Journal (Empty)",
        itemId: "T7_JOURNAL_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Gamekeeper's Journal (Full)",
        itemId: "T4_JOURNAL_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Master Gamekeeper's Journal (Full)",
        itemId: "T6_JOURNAL_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Gamekeeper's Journal (Full)",
        itemId: "T7_JOURNAL_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Novice Blacksmith's Journal (Empty)",
        itemId: "T2_JOURNAL_WARRIOR_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Gamekeeper's Journal (Empty)",
        itemId: "T8_JOURNAL_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Blacksmith's Journal (Empty)",
        itemId: "T3_JOURNAL_WARRIOR_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Blacksmith's Journal (Empty)",
        itemId: "T4_JOURNAL_WARRIOR_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Gamekeeper's Journal (Full)",
        itemId: "T8_JOURNAL_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Blacksmith's Journal (Full)",
        itemId: "T3_JOURNAL_WARRIOR_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Blacksmith's Journal (Empty)",
        itemId: "T5_JOURNAL_WARRIOR_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Blacksmith's Journal (Full)",
        itemId: "T2_JOURNAL_WARRIOR_FULL",
        canEnchant: false
    },
{
        itemName: "Master Blacksmith's Journal (Empty)",
        itemId: "T6_JOURNAL_WARRIOR_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Blacksmith's Journal (Full)",
        itemId: "T5_JOURNAL_WARRIOR_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Blacksmith's Journal (Full)",
        itemId: "T4_JOURNAL_WARRIOR_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Blacksmith's Journal (Empty)",
        itemId: "T7_JOURNAL_WARRIOR_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Blacksmith's Journal (Full)",
        itemId: "T6_JOURNAL_WARRIOR_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Blacksmith's Journal (Full)",
        itemId: "T7_JOURNAL_WARRIOR_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Blacksmith's Journal (Empty)",
        itemId: "T8_JOURNAL_WARRIOR_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Blacksmith's Journal (Full)",
        itemId: "T8_JOURNAL_WARRIOR_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Fletcher's Journal (Empty)",
        itemId: "T4_JOURNAL_HUNTER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Fletcher's Journal (Empty)",
        itemId: "T2_JOURNAL_HUNTER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Fletcher's Journal (Empty)",
        itemId: "T3_JOURNAL_HUNTER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Fletcher's Journal (Full)",
        itemId: "T3_JOURNAL_HUNTER_FULL",
        canEnchant: false
    },
{
        itemName: "Novice Fletcher's Journal (Full)",
        itemId: "T2_JOURNAL_HUNTER_FULL",
        canEnchant: false
    },
{
        itemName: "Master Fletcher's Journal (Full)",
        itemId: "T6_JOURNAL_HUNTER_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Fletcher's Journal (Full)",
        itemId: "T4_JOURNAL_HUNTER_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Fletcher's Journal (Full)",
        itemId: "T5_JOURNAL_HUNTER_FULL",
        canEnchant: false
    },
{
        itemName: "Master Fletcher's Journal (Empty)",
        itemId: "T6_JOURNAL_HUNTER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Fletcher's Journal (Empty)",
        itemId: "T5_JOURNAL_HUNTER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Fletcher's Journal (Full)",
        itemId: "T7_JOURNAL_HUNTER_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Fletcher's Journal (Empty)",
        itemId: "T8_JOURNAL_HUNTER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Imbuer's Journal (Full)",
        itemId: "T2_JOURNAL_MAGE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Fletcher's Journal (Empty)",
        itemId: "T7_JOURNAL_HUNTER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Fletcher's Journal (Full)",
        itemId: "T8_JOURNAL_HUNTER_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Imbuer's Journal (Empty)",
        itemId: "T4_JOURNAL_MAGE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Imbuer's Journal (Empty)",
        itemId: "T2_JOURNAL_MAGE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Imbuer's Journal (Empty)",
        itemId: "T3_JOURNAL_MAGE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Imbuer's Journal (Full)",
        itemId: "T3_JOURNAL_MAGE_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Imbuer's Journal (Full)",
        itemId: "T4_JOURNAL_MAGE_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Imbuer's Journal (Full)",
        itemId: "T5_JOURNAL_MAGE_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Imbuer's Journal (Empty)",
        itemId: "T5_JOURNAL_MAGE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Imbuer's Journal (Empty)",
        itemId: "T8_JOURNAL_MAGE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Imbuer's Journal (Full)",
        itemId: "T6_JOURNAL_MAGE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Imbuer's Journal (Empty)",
        itemId: "T7_JOURNAL_MAGE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Tinker's Journal (Empty)",
        itemId: "T2_JOURNAL_TOOLMAKER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Imbuer's Journal (Full)",
        itemId: "T7_JOURNAL_MAGE_FULL",
        canEnchant: false
    },
{
        itemName: "Novice Tinker's Journal (Full)",
        itemId: "T2_JOURNAL_TOOLMAKER_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Tinker's Journal (Empty)",
        itemId: "T4_JOURNAL_TOOLMAKER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Tinker's Journal (Empty)",
        itemId: "T3_JOURNAL_TOOLMAKER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Tinker's Journal (Full)",
        itemId: "T4_JOURNAL_TOOLMAKER_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Tinker's Journal (Full)",
        itemId: "T5_JOURNAL_TOOLMAKER_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Tinker's Journal (Empty)",
        itemId: "T5_JOURNAL_TOOLMAKER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Tinker's Journal (Full)",
        itemId: "T6_JOURNAL_TOOLMAKER_FULL",
        canEnchant: false
    },
{
        itemName: "Master Imbuer's Journal (Empty)",
        itemId: "T6_JOURNAL_MAGE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Mercenary's Journal (Full)",
        itemId: "T2_JOURNAL_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Tinker's Journal (Full)",
        itemId: "T7_JOURNAL_TOOLMAKER_FULL",
        canEnchant: false
    },
{
        itemName: "Master Tinker's Journal (Empty)",
        itemId: "T6_JOURNAL_TOOLMAKER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Tinker's Journal (Full)",
        itemId: "T3_JOURNAL_TOOLMAKER_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Tinker's Journal (Empty)",
        itemId: "T8_JOURNAL_TOOLMAKER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Imbuer's Journal (Full)",
        itemId: "T8_JOURNAL_MAGE_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Mercenary's Journal (Empty)",
        itemId: "T3_JOURNAL_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Tinker's Journal (Full)",
        itemId: "T8_JOURNAL_TOOLMAKER_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Mercenary's Journal (Full)",
        itemId: "T3_JOURNAL_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Tinker's Journal (Empty)",
        itemId: "T7_JOURNAL_TOOLMAKER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Mercenary's Journal (Empty)",
        itemId: "T2_JOURNAL_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Mercenary's Journal (Empty)",
        itemId: "T4_JOURNAL_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Mercenary's Journal (Empty)",
        itemId: "T5_JOURNAL_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Mercenary's Journal (Full)",
        itemId: "T5_JOURNAL_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Master Mercenary's Journal (Empty)",
        itemId: "T6_JOURNAL_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Mercenary's Journal (Full)",
        itemId: "T4_JOURNAL_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Master Mercenary's Journal (Full)",
        itemId: "T6_JOURNAL_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Mercenary's Journal (Empty)",
        itemId: "T7_JOURNAL_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Mercenary's Journal (Full)",
        itemId: "T8_JOURNAL_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Mercenary's Journal (Empty)",
        itemId: "T8_JOURNAL_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice's Generalist Trophy Journal (Empty)",
        itemId: "T2_JOURNAL_TROPHY_GENERAL_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice's Generalist Trophy Journal (Full)",
        itemId: "T2_JOURNAL_TROPHY_GENERAL_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman's Generalist Trophy Journal (Empty)",
        itemId: "T3_JOURNAL_TROPHY_GENERAL_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert's Generalist Trophy Journal (Empty)",
        itemId: "T5_JOURNAL_TROPHY_GENERAL_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Mercenary's Journal (Full)",
        itemId: "T7_JOURNAL_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Adept's Generalist Trophy Journal (Full)",
        itemId: "T4_JOURNAL_TROPHY_GENERAL_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman's Generalist Trophy Journal (Full)",
        itemId: "T3_JOURNAL_TROPHY_GENERAL_FULL",
        canEnchant: false
    },
{
        itemName: "Master's Generalist Trophy Journal (Empty)",
        itemId: "T6_JOURNAL_TROPHY_GENERAL_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept's Generalist Trophy Journal (Empty)",
        itemId: "T4_JOURNAL_TROPHY_GENERAL_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert's Generalist Trophy Journal (Full)",
        itemId: "T5_JOURNAL_TROPHY_GENERAL_FULL",
        canEnchant: false
    },
{
        itemName: "Elder's Generalist Trophy Journal (Empty)",
        itemId: "T8_JOURNAL_TROPHY_GENERAL_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Generalist Trophy Journal (Empty)",
        itemId: "T7_JOURNAL_TROPHY_GENERAL_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder's Generalist Trophy Journal (Full)",
        itemId: "T8_JOURNAL_TROPHY_GENERAL_FULL",
        canEnchant: false
    },
{
        itemName: "Novice Mercenary's Trophy Journal (Full)",
        itemId: "T2_JOURNAL_TROPHY_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster's Generalist Trophy Journal (Full)",
        itemId: "T7_JOURNAL_TROPHY_GENERAL_FULL",
        canEnchant: false
    },
{
        itemName: "Master's Generalist Trophy Journal (Full)",
        itemId: "T6_JOURNAL_TROPHY_GENERAL_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Mercenary's Trophy Journal (Empty)",
        itemId: "T4_JOURNAL_TROPHY_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Mercenary's Trophy Journal (Empty)",
        itemId: "T2_JOURNAL_TROPHY_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Mercenary's Trophy Journal (Full)",
        itemId: "T3_JOURNAL_TROPHY_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Mercenary's Trophy Journal (Empty)",
        itemId: "T3_JOURNAL_TROPHY_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Mercenary's Trophy Journal (Empty)",
        itemId: "T5_JOURNAL_TROPHY_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Mercenary's Trophy Journal (Full)",
        itemId: "T5_JOURNAL_TROPHY_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Mercenary's Trophy Journal (Full)",
        itemId: "T4_JOURNAL_TROPHY_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Master Mercenary's Trophy Journal (Full)",
        itemId: "T6_JOURNAL_TROPHY_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Mercenary's Trophy Journal (Full)",
        itemId: "T7_JOURNAL_TROPHY_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Mercenary's Trophy Journal (Empty)",
        itemId: "T7_JOURNAL_TROPHY_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Gamekeeper's Trophy Journal (Empty)",
        itemId: "T2_JOURNAL_TROPHY_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Mercenary's Trophy Journal (Empty)",
        itemId: "T6_JOURNAL_TROPHY_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Mercenary's Trophy Journal (Full)",
        itemId: "T8_JOURNAL_TROPHY_MERCENARY_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Mercenary's Trophy Journal (Empty)",
        itemId: "T8_JOURNAL_TROPHY_MERCENARY_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Gamekeeper's Trophy Journal (Full)",
        itemId: "T2_JOURNAL_TROPHY_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Gamekeeper's Trophy Journal (Full)",
        itemId: "T3_JOURNAL_TROPHY_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Gamekeeper's Trophy Journal (Empty)",
        itemId: "T3_JOURNAL_TROPHY_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Gamekeeper's Trophy Journal (Full)",
        itemId: "T4_JOURNAL_TROPHY_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Gamekeeper's Trophy Journal (Empty)",
        itemId: "T5_JOURNAL_TROPHY_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Gamekeeper's Trophy Journal (Empty)",
        itemId: "T6_JOURNAL_TROPHY_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Gamekeeper's Trophy Journal (Full)",
        itemId: "T7_JOURNAL_TROPHY_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Gamekeeper's Trophy Journal (Full)",
        itemId: "T5_JOURNAL_TROPHY_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Gamekeeper's Trophy Journal (Empty)",
        itemId: "T4_JOURNAL_TROPHY_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Gamekeeper's Trophy Journal (Empty)",
        itemId: "T8_JOURNAL_TROPHY_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Gamekeeper's Trophy Journal (Full)",
        itemId: "T6_JOURNAL_TROPHY_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Novice Lumberjack's Trophy Journal (Empty)",
        itemId: "T2_JOURNAL_TROPHY_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Gamekeeper's Trophy Journal (Empty)",
        itemId: "T7_JOURNAL_TROPHY_HIDE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Lumberjack's Trophy Journal (Full)",
        itemId: "T2_JOURNAL_TROPHY_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Lumberjack's Trophy Journal (Empty)",
        itemId: "T3_JOURNAL_TROPHY_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Lumberjack's Trophy Journal (Empty)",
        itemId: "T5_JOURNAL_TROPHY_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Gamekeeper's Trophy Journal (Full)",
        itemId: "T8_JOURNAL_TROPHY_HIDE_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Lumberjack's Trophy Journal (Full)",
        itemId: "T3_JOURNAL_TROPHY_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Lumberjack's Trophy Journal (Full)",
        itemId: "T5_JOURNAL_TROPHY_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Lumberjack's Trophy Journal (Full)",
        itemId: "T4_JOURNAL_TROPHY_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Lumberjack's Trophy Journal (Empty)",
        itemId: "T7_JOURNAL_TROPHY_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Lumberjack's Trophy Journal (Empty)",
        itemId: "T6_JOURNAL_TROPHY_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Lumberjack's Trophy Journal (Empty)",
        itemId: "T4_JOURNAL_TROPHY_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Lumberjack's Trophy Journal (Full)",
        itemId: "T7_JOURNAL_TROPHY_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Master Lumberjack's Trophy Journal (Full)",
        itemId: "T6_JOURNAL_TROPHY_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Lumberjack's Trophy Journal (Empty)",
        itemId: "T8_JOURNAL_TROPHY_WOOD_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Lumberjack's Trophy Journal (Full)",
        itemId: "T8_JOURNAL_TROPHY_WOOD_FULL",
        canEnchant: false
    },
{
        itemName: "Novice Stonecutter's Trophy Journal (Full)",
        itemId: "T2_JOURNAL_TROPHY_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Novice Stonecutter's Trophy Journal (Empty)",
        itemId: "T2_JOURNAL_TROPHY_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Stonecutter's Trophy Journal (Empty)",
        itemId: "T3_JOURNAL_TROPHY_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Stonecutter's Trophy Journal (Full)",
        itemId: "T3_JOURNAL_TROPHY_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Stonecutter's Trophy Journal (Full)",
        itemId: "T4_JOURNAL_TROPHY_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Stonecutter's Trophy Journal (Full)",
        itemId: "T5_JOURNAL_TROPHY_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Stonecutter's Trophy Journal (Empty)",
        itemId: "T4_JOURNAL_TROPHY_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Stonecutter's Trophy Journal (Empty)",
        itemId: "T6_JOURNAL_TROPHY_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Stonecutter's Trophy Journal (Empty)",
        itemId: "T5_JOURNAL_TROPHY_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Stonecutter's Trophy Journal (Full)",
        itemId: "T6_JOURNAL_TROPHY_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Stonecutter's Trophy Journal (Full)",
        itemId: "T7_JOURNAL_TROPHY_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Stonecutter's Trophy Journal (Empty)",
        itemId: "T7_JOURNAL_TROPHY_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Prospector's Trophy Journal (Empty)",
        itemId: "T2_JOURNAL_TROPHY_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Stonecutter's Trophy Journal (Full)",
        itemId: "T8_JOURNAL_TROPHY_STONE_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Stonecutter's Trophy Journal (Empty)",
        itemId: "T8_JOURNAL_TROPHY_STONE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Prospector's Trophy Journal (Empty)",
        itemId: "T3_JOURNAL_TROPHY_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Prospector's Trophy Journal (Empty)",
        itemId: "T4_JOURNAL_TROPHY_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Prospector's Trophy Journal (Full)",
        itemId: "T2_JOURNAL_TROPHY_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Prospector's Trophy Journal (Full)",
        itemId: "T5_JOURNAL_TROPHY_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Prospector's Trophy Journal (Full)",
        itemId: "T3_JOURNAL_TROPHY_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Prospector's Trophy Journal (Empty)",
        itemId: "T7_JOURNAL_TROPHY_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Prospector's Trophy Journal (Full)",
        itemId: "T4_JOURNAL_TROPHY_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Master Prospector's Trophy Journal (Empty)",
        itemId: "T6_JOURNAL_TROPHY_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Prospector's Trophy Journal (Full)",
        itemId: "T7_JOURNAL_TROPHY_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Prospector's Trophy Journal (Empty)",
        itemId: "T5_JOURNAL_TROPHY_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Cropper's Trophy Journal (Empty)",
        itemId: "T3_JOURNAL_TROPHY_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Prospector's Trophy Journal (Full)",
        itemId: "T6_JOURNAL_TROPHY_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Novice Cropper's Trophy Journal (Empty)",
        itemId: "T2_JOURNAL_TROPHY_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Cropper's Trophy Journal (Full)",
        itemId: "T3_JOURNAL_TROPHY_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Prospector's Trophy Journal (Empty)",
        itemId: "T8_JOURNAL_TROPHY_ORE_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Cropper's Trophy Journal (Full)",
        itemId: "T2_JOURNAL_TROPHY_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Prospector's Trophy Journal (Full)",
        itemId: "T8_JOURNAL_TROPHY_ORE_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Cropper's Trophy Journal (Empty)",
        itemId: "T5_JOURNAL_TROPHY_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Cropper's Trophy Journal (Empty)",
        itemId: "T7_JOURNAL_TROPHY_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Cropper's Trophy Journal (Empty)",
        itemId: "T4_JOURNAL_TROPHY_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Cropper's Trophy Journal (Full)",
        itemId: "T5_JOURNAL_TROPHY_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Master Cropper's Trophy Journal (Empty)",
        itemId: "T6_JOURNAL_TROPHY_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Cropper's Trophy Journal (Full)",
        itemId: "T7_JOURNAL_TROPHY_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Cropper's Trophy Journal (Full)",
        itemId: "T8_JOURNAL_TROPHY_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Master Cropper's Trophy Journal (Full)",
        itemId: "T6_JOURNAL_TROPHY_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Cropper's Trophy Journal (Empty)",
        itemId: "T8_JOURNAL_TROPHY_FIBER_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Fisherman's Trophy Journal (Full)",
        itemId: "T2_JOURNAL_TROPHY_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Cropper's Trophy Journal (Full)",
        itemId: "T4_JOURNAL_TROPHY_FIBER_FULL",
        canEnchant: false
    },
{
        itemName: "Novice Fisherman's Trophy Journal (Empty)",
        itemId: "T2_JOURNAL_TROPHY_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Fisherman's Trophy Journal (Empty)",
        itemId: "T3_JOURNAL_TROPHY_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Journeyman Fisherman's Trophy Journal (Full)",
        itemId: "T3_JOURNAL_TROPHY_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Fisherman's Trophy Journal (Empty)",
        itemId: "T5_JOURNAL_TROPHY_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Fisherman's Trophy Journal (Empty)",
        itemId: "T4_JOURNAL_TROPHY_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Expert Fisherman's Trophy Journal (Full)",
        itemId: "T5_JOURNAL_TROPHY_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Adept Fisherman's Trophy Journal (Full)",
        itemId: "T4_JOURNAL_TROPHY_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Fisherman's Trophy Journal (Empty)",
        itemId: "T7_JOURNAL_TROPHY_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Fisherman's Trophy Journal (Full)",
        itemId: "T6_JOURNAL_TROPHY_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Fisherman's Trophy Journal (Full)",
        itemId: "T7_JOURNAL_TROPHY_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Master Fisherman's Trophy Journal (Empty)",
        itemId: "T6_JOURNAL_TROPHY_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Fisherman's Trophy Journal (Full)",
        itemId: "T8_JOURNAL_TROPHY_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Fisherman's Journal (Empty)",
        itemId: "T3_JOURNAL_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Fisherman's Journal (Empty)",
        itemId: "T2_JOURNAL_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Fisherman's Trophy Journal (Empty)",
        itemId: "T8_JOURNAL_TROPHY_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Novice Fisherman's Journal (Full)",
        itemId: "T2_JOURNAL_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Journeyman Fisherman's Journal (Full)",
        itemId: "T3_JOURNAL_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Fisherman's Journal (Empty)",
        itemId: "T5_JOURNAL_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Fisherman's Journal (Empty)",
        itemId: "T4_JOURNAL_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Adept Fisherman's Journal (Full)",
        itemId: "T4_JOURNAL_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Expert Fisherman's Journal (Full)",
        itemId: "T5_JOURNAL_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Master Fisherman's Journal (Empty)",
        itemId: "T6_JOURNAL_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Grandmaster Fisherman's Journal (Empty)",
        itemId: "T7_JOURNAL_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Elder Fisherman's Journal (Empty)",
        itemId: "T8_JOURNAL_FISHING_EMPTY",
        canEnchant: false
    },
{
        itemName: "Master Fisherman's Journal (Full)",
        itemId: "T6_JOURNAL_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Grandmaster Fisherman's Journal (Full)",
        itemId: "T7_JOURNAL_FISHING_FULL",
        canEnchant: false
    },
{
        itemName: "Elder Fisherman's Journal (Full)",
        itemId: "T8_JOURNAL_FISHING_FULL",
        canEnchant: false
    },

    ]
export default itemsList;